/* tslint:disable */
/* eslint-disable */
/**
 * Orchestrator v3 APIs documentation
 * Documentation of the entire APIs available of new Orchestrator.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@crispybacon.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "./base";

/**
 *
 * @export
 * @interface AccertifyData
 */
export interface AccertifyData {
  /**
   *
   * @type {string}
   * @memberof AccertifyData
   */
  payload?: string;
  /**
   *
   * @type {string}
   * @memberof AccertifyData
   */
  transactionId?: string;
  /**
   *
   * @type {string}
   * @memberof AccertifyData
   */
  customerData?: string;
  /**
   *
   * @type {string}
   * @memberof AccertifyData
   */
  httpHeaders?: string;
  /**
   *
   * @type {string}
   * @memberof AccertifyData
   */
  remoteAddress?: string;
  /**
   *
   * @type {string}
   * @memberof AccertifyData
   */
  requestTimestamp?: string;
  /**
   *
   * @type {string}
   * @memberof AccertifyData
   */
  requestMethod?: string;
}
/**
 *
 * @export
 * @interface AccertifyDataRequest
 */
export interface AccertifyDataRequest {
  /**
   *
   * @type {AccertifyData}
   * @memberof AccertifyDataRequest
   */
  accertifyData?: AccertifyData;
}
/**
 *
 * @export
 * @interface AccertifyResponse
 */
export interface AccertifyResponse {
  /**
   *
   * @type {string}
   * @memberof AccertifyResponse
   */
  applicationId?: string;
  /**
   *
   * @type {string}
   * @memberof AccertifyResponse
   */
  error?: string;
  /**
   *
   * @type {number}
   * @memberof AccertifyResponse
   */
  check_step?: number;
  /**
   *
   * @type {AccertifyTransactionResults}
   * @memberof AccertifyResponse
   */
  "transaction-results"?: AccertifyTransactionResults;
}
/**
 *
 * @export
 * @interface AccertifyResponseData
 */
export interface AccertifyResponseData {
  /**
   *
   * @type {AccertifyResponseTransactionData}
   * @memberof AccertifyResponseData
   */
  transaction?: AccertifyResponseTransactionData;
}
/**
 *
 * @export
 * @interface AccertifyResponseTransactionData
 */
export interface AccertifyResponseTransactionData {
  /**
   *
   * @type {string}
   * @memberof AccertifyResponseTransactionData
   */
  OrderNumber?: string;
  /**
   *
   * @type {string}
   * @memberof AccertifyResponseTransactionData
   */
  ActionCode?: string;
  /**
   *
   * @type {any}
   * @memberof AccertifyResponseTransactionData
   */
  "transaction-details"?: any;
}
/**
 *
 * @export
 * @interface AccertifyTransactionResults
 */
export interface AccertifyTransactionResults {
  /**
   *
   * @type {string}
   * @memberof AccertifyTransactionResults
   */
  remarks?: string;
  /**
   *
   * @type {AccertifyResponseData}
   * @memberof AccertifyTransactionResults
   */
  responseData?: AccertifyResponseData;
  /**
   *
   * @type {string}
   * @memberof AccertifyTransactionResults
   */
  "transaction-id"?: string;
  /**
   *
   * @type {string}
   * @memberof AccertifyTransactionResults
   */
  "cross-reference"?: string;
  /**
   *
   * @type {string}
   * @memberof AccertifyTransactionResults
   */
  "rules-tripped"?: string;
  /**
   *
   * @type {number}
   * @memberof AccertifyTransactionResults
   */
  "total-score"?: number;
  /**
   *
   * @type {string}
   * @memberof AccertifyTransactionResults
   */
  "recommendation-code"?: string;
}
/**
 *
 * @export
 * @interface ActionMadeBy
 */
export interface ActionMadeBy {
  /**
   *
   * @type {string}
   * @memberof ActionMadeBy
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof ActionMadeBy
   */
  fiscal_code?: string;
  /**
   *
   * @type {string}
   * @memberof ActionMadeBy
   */
  organization_path?: string;
}
/**
 *
 * @export
 * @interface Address
 */
export interface Address {
  /**
   *
   * @type {string}
   * @memberof Address
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  streetName?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  streetNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  zipCode?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  country?: string;
}
/**
 * Blocco indirizzo (intero blocco opzionale, ma se presente i campi required vanno valorizzati)
 * @export
 * @interface AddressAggregatorRequest
 */
export interface AddressAggregatorRequest {
  /**
   *
   * @type {string}
   * @memberof AddressAggregatorRequest
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof AddressAggregatorRequest
   */
  houseNumber: string;
  /**
   * Utilizzare la tabella dei codici istat aggiornata a gennaio 2026 prendendo il Codice Comune formato alfanumerico
   * @type {string}
   * @memberof AddressAggregatorRequest
   */
  city: string;
  /**
   *
   * @type {string}
   * @memberof AddressAggregatorRequest
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof AddressAggregatorRequest
   */
  provinceCode?: string;
  /**
   *
   * @type {string}
   * @memberof AddressAggregatorRequest
   */
  cap: string;
  /**
   *
   * @type {string}
   * @memberof AddressAggregatorRequest
   */
  nation: string;
  /**
   * ### 6.4 Tipo abitazione  | ID | Tipo | | :--- | :--- | | 1 | Affitto | | 2 | Proprietà | | 3 | Presso Parenti | | 4 | Altro | | 5 | Proprietà con mutuo |
   * @type {number}
   * @memberof AddressAggregatorRequest
   */
  houseState?: number;
  /**
   * importo dell\'affitto o del mutuo in caso di tipo abitazone affitto o proprieta con mutuo
   * @type {number}
   * @memberof AddressAggregatorRequest
   */
  mortgageRentAmount?: number;
}
/**
 *
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  zipCode?: string;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  streetName?: string;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  streetNumber?: string;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  type?: AddressDtoTypeEnum;
}

export const AddressDtoTypeEnum = {
  Home: "HOME",
  Residence: "RESIDENCE",
} as const;

export type AddressDtoTypeEnum =
  (typeof AddressDtoTypeEnum)[keyof typeof AddressDtoTypeEnum];

/**
 *
 * @export
 * @interface AddressInfo
 */
export interface AddressInfo {
  /**
   *
   * @type {Address}
   * @memberof AddressInfo
   */
  residence?: Address;
  /**
   *
   * @type {Address}
   * @memberof AddressInfo
   */
  domicile?: Address;
}
/**
 *
 * @export
 * @interface AddressRequest
 */
export interface AddressRequest {
  /**
   *
   * @type {Address}
   * @memberof AddressRequest
   */
  residence?: Address;
  /**
   *
   * @type {Address}
   * @memberof AddressRequest
   */
  domicile?: Address;
}
/**
 *
 * @export
 * @interface AggregatorOfferErrorResponse
 */
export interface AggregatorOfferErrorResponse {
  /**
   *
   * @type {string}
   * @memberof AggregatorOfferErrorResponse
   */
  contractBankId?: string;
  /**
   *
   * @type {Outcome}
   * @memberof AggregatorOfferErrorResponse
   */
  outcome?: Outcome;
}
/**
 * I campi obbligatori sono quelli disponibili al momento del salvataggio (savepoint). I blocchi opzionali vengono forniti quando il cliente completa i passi successivi del funnel.
 * @export
 * @interface AggregatorOfferRequest
 */
export interface AggregatorOfferRequest {
  /**
   * ID univoco richiesta (per idempotenza)
   * @type {string}
   * @memberof AggregatorOfferRequest
   */
  requestId: string;
  /**
   *
   * @type {OfferRequestCustomer}
   * @memberof AggregatorOfferRequest
   */
  customer: OfferRequestCustomer;
  /**
   * Indirizzo di domicilio (fornito se il cliente ha completato il passo indirizzo)
   * @type {AddressAggregatorRequest}
   * @memberof AggregatorOfferRequest
   */
  customerDomicile?: AddressAggregatorRequest;
  /**
   * Indirizzo di residenza (solo se diverso dal domicilio)
   * @type {AddressAggregatorRequest}
   * @memberof AggregatorOfferRequest
   */
  customerResidence: AddressAggregatorRequest;
  /**
   * Dati professionali (forniti se il cliente ha completato il passo professione)
   * @type {AggregatorOfferRequestProfession}
   * @memberof AggregatorOfferRequest
   */
  customerProfession?: AggregatorOfferRequestProfession;
  /**
   *
   * @type {AggregatorOfferRequestFinancing}
   * @memberof AggregatorOfferRequest
   */
  financing: AggregatorOfferRequestFinancing;
  /**
   * Consensi privacy (forniti se il cliente ha completato il passo privacy)
   * @type {Array<AggregatorOfferRequestPrivacyConsent>}
   * @memberof AggregatorOfferRequest
   */
  privacy?: Array<AggregatorOfferRequestPrivacyConsent>;
}
/**
 * Dati del finanziamento - sempre presenti
 * @export
 * @interface AggregatorOfferRequestFinancing
 */
export interface AggregatorOfferRequestFinancing {
  /**
   * Importo richiesto (€)
   * @type {number}
   * @memberof AggregatorOfferRequestFinancing
   */
  amount: number;
  /**
   * Durata in mesi
   * @type {number}
   * @memberof AggregatorOfferRequestFinancing
   */
  duration: number;
  /**
   * Codice finalita (tabella 6.1).  ### 6.1 Finalità prestito  | ID | Finalità | | :--- | :--- | | 1 | PC ed elettronica | | 2 | Formazione e università | | 4 | Arredamento | | 5 | Ristrutturazione casa | | 15 | Moto nuove/km0 | | 16 | Moto usate | | 24 | Viaggi e vacanze | | 26 | Spese mediche | | 27 | Matrimonio e cerimonie | | 29 | Auto nuove/km0 | | 30 | Auto usate | | 31 | Consolidamento debiti | | 32 | Acquisto immobile | | 33 | Liquidità |
   * @type {number}
   * @memberof AggregatorOfferRequestFinancing
   */
  purpose: number;
  /**
   * Con assicurazione CPI
   * @type {boolean}
   * @memberof AggregatorOfferRequestFinancing
   */
  cpi?: boolean;
  /**
   * Tabella finanziaria (dal listino CSV)
   * @type {string}
   * @memberof AggregatorOfferRequestFinancing
   */
  financialTable?: string;
}
/**
 *
 * @export
 * @interface AggregatorOfferRequestPrivacyConsent
 */
export interface AggregatorOfferRequestPrivacyConsent {
  /**
   * Codice consenso
   * @type {string}
   * @memberof AggregatorOfferRequestPrivacyConsent
   */
  id: string;
  /**
   *
   * @type {boolean}
   * @memberof AggregatorOfferRequestPrivacyConsent
   */
  value: boolean;
}
/**
 * Blocco professione (intero blocco opzionale, ma se presente profession e obbligatorio)
 * @export
 * @interface AggregatorOfferRequestProfession
 */
export interface AggregatorOfferRequestProfession {
  /**
   * ### 6.2 Professioni  | ID | Professione | | :--- | :--- | | 3 | Libero professionista | | 4 | Reddito non dimostrabile | | 5 | Studente | | 6 | Casalinga | | 7 | Pensionato | | 8 | Disoccupato | | 13 | Dipendente a tempo indeterminato | | 19 | Lavoratore autonomo | | 20 | Dipendente a tempo determinato | | 100 | Sindaco di comune > 15.000 abitanti | | 101 | Alto graduato delle forze armate |
   * @type {number}
   * @memberof AggregatorOfferRequestProfession
   */
  profession: number;
  /**
   * ### 6.5 Occupazione  | ID | Occupazione | | :--- | :--- | | 1 | Dirigente | | 2 | Quadro | | 3 | Impiegato | | 4 | Operaio | | 14 | Militare | | 24 | Architetto | | 25 | Avvocato | | 26 | Commercialista | | 27 | Ingegnere | | 28 | Medico | | 29 | Notaio | | 30 | Agente | | 34 | Autotrasportatore | | 35 | Artigiano | | 36 | Agricoltore/Allevatore | | 39 | Commerciante | | 40 | Geometra | | 41 | Imprenditore | | 48 | Pensione di anzianità | | 49 | Pensione sociale | | 51 | Contratto di inserimento | | 52 | Apprendista | | 53 | Insegnante non di ruolo | | 55 | Altro | | 56 | Dipendente Statale | | 57 | Dipendente Pubblico |
   * @type {number}
   * @memberof AggregatorOfferRequestProfession
   */
  occupation?: number;
  /**
   * ### 6.6 Inquadramento  | ID | Inquadramento | | :--- | :--- | | 1 | Operaio | | 2 | Impiegato | | 3 | Quadro | | 4 | Dirigente |
   * @type {number}
   * @memberof AggregatorOfferRequestProfession
   */
  position?: number;
  /**
   * nome azienda
   * @type {string}
   * @memberof AggregatorOfferRequestProfession
   */
  companyName?: string;
  /**
   * ### 6.7 Tipo azienda  | ID | Tipo azienda | | :--- | :--- | | 1 | S.p.a. | | 9 | Onlus o fondazioni private | | 10 | Snc, Sas o Altro | | 11 | S.r.l. fino a 30 dipendenti | | 12 | S.r.l. con più di 30 dipendenti | | 13 | Coop Fino a 200 dipendenti | | 14 | Coop con più di 200 dipendenti |
   * @type {number}
   * @memberof AggregatorOfferRequestProfession
   */
  companyType?: number;
  /**
   * ### 6.9 Settore attività  | ID | Settore attività | | :--- | :--- | | 1 | Trasporti | | 2 | Turismo | | 3 | Costruzioni | | 4 | Attività commerciali | | 5 | Ristorazione & intrattenimento | | 6 | Industria e produzione | | 7 | Servizi privati | | 8 | Aziende partecipazioni pubbliche | | 9 | Settore pubblico | | 10 | Forze dell\'ordine / armate | | 11 | Altro |
   * @type {number}
   * @memberof AggregatorOfferRequestProfession
   */
  businessSector?: number;
  /**
   * Reddito mensile netto (€)
   * @type {number}
   * @memberof AggregatorOfferRequestProfession
   */
  monthlyIncome?: number;
  /**
   * Mensilita annue (12, 13, 14)
   * @type {number}
   * @memberof AggregatorOfferRequestProfession
   */
  numbersOfMonthlyPayments?: number;
  /**
   *
   * @type {string}
   * @memberof AggregatorOfferRequestProfession
   */
  hiringDate?: string;
  /**
   * indica se sono presenti altre fonti di reddito
   * @type {boolean}
   * @memberof AggregatorOfferRequestProfession
   */
  otherIncome: boolean;
  /**
   * netto mensile in caso di altre fonti di reddito
   * @type {number}
   * @memberof AggregatorOfferRequestProfession
   */
  otherIncomeNetMonthly?: number;
  /**
   * ### 6.10 Descrizione altre entrate  | ID | Descrizione | | :--- | :--- | | 1 | Pensione di reversibilità | | 2 | Assegno di mantenimento figli | | 3 | Affitto di Immobili | | 4 | Altro |
   * @type {number}
   * @memberof AggregatorOfferRequestProfession
   */
  otherIncomeDescription?: number;
  /**
   *
   * @type {string}
   * @memberof AggregatorOfferRequestProfession
   */
  piva?: string;
}
/**
 *
 * @export
 * @interface AggregatorOfferResponse
 */
export interface AggregatorOfferResponse {
  /**
   *
   * @type {string}
   * @memberof AggregatorOfferResponse
   */
  contractBankId?: string;
  /**
   * Codice stato pratica.  | Codice | Descrizione | | :--- | :--- | | DATI-FIN | Richiesta in corso - Offerta prestito | | DEL-NEG | Pratica deliberata negativamente, per 1 dei seguenti 3 motivi: Controlli pre-bureau / Controlli bureau / KO deliberante | | QUESTIONARI | Richiesta in corso - IBAN e caricamento documentale | | ATT-RICO | Allestimento in corso - In attesa di KYC | | DTA-RDY | Allestimento terminato | | AVV-VAL | Richiesta in corso - In attesa identificazione | | VER-LST | Richiesta completata | | VER-AML | Richiesta completata | | VER-DOC | In valutazione | | RIC-DOC | In valutazione - Richiesta documenti | | DEL-MAN | In valutazione | | RIC-NEW-DOC | In valutazione - Richiesta documenti aggiuntivi | | RILAV | Rilavorazione pratica post valutazione (es. contro-offerta) | | INFO-CLI | Data collection post Rilavorazione - Solo se pratica passa per RILAV | | GEST-IMP | Data collection post Rilavorazione - Solo se pratica passa per RILAV | | DATI-ECO | Data collection post Rilavorazione - Solo se pratica passa per RILAV | | DEL-POS | Delibera positiva | | ATT-FIR | In attesa che il cliente firmi il contratto | | RIC-RIT | Richiesta ritiro | | RIT | Ritirata | | VER-IMP-LIQ | In attesa di liquidazione (verifica impieghi) | | LIQ-MAN | In attesa di liquidazione | | LIQ-POS | Liquidata | | ERR-TEC | Errore tecnico sistema gestionale (può accadere in qualsiasi degli stati) |
   * @type {string}
   * @memberof AggregatorOfferResponse
   */
  contractStatus?: AggregatorOfferResponseContractStatusEnum;
  /**
   *
   * @type {string}
   * @memberof AggregatorOfferResponse
   */
  checkoutUrl?: string;
  /**
   *
   * @type {Pricing}
   * @memberof AggregatorOfferResponse
   */
  pricing?: Pricing;
  /**
   *
   * @type {Outcome}
   * @memberof AggregatorOfferResponse
   */
  outcome?: Outcome;
}

export const AggregatorOfferResponseContractStatusEnum = {
  DatiFin: "DATI-FIN",
  DelNeg: "DEL-NEG",
  Questionari: "QUESTIONARI",
  AttRico: "ATT-RICO",
  DtaRdy: "DTA-RDY",
  AvvVal: "AVV-VAL",
  VerLst: "VER-LST",
  VerAml: "VER-AML",
  VerDoc: "VER-DOC",
  RicDoc: "RIC-DOC",
  DelMan: "DEL-MAN",
  RicNewDoc: "RIC-NEW-DOC",
  Rilav: "RILAV",
  InfoCli: "INFO-CLI",
  GestImp: "GEST-IMP",
  DatiEco: "DATI-ECO",
  DelPos: "DEL-POS",
  AttFir: "ATT-FIR",
  RicRit: "RIC-RIT",
  Rit: "RIT",
  VerImpLiq: "VER-IMP-LIQ",
  LiqMan: "LIQ-MAN",
  LiqPos: "LIQ-POS",
  ErrTec: "ERR-TEC",
} as const;

export type AggregatorOfferResponseContractStatusEnum =
  (typeof AggregatorOfferResponseContractStatusEnum)[keyof typeof AggregatorOfferResponseContractStatusEnum];

/**
 *
 * @export
 * @interface AggregatorPricingListResponse
 */
export interface AggregatorPricingListResponse {
  /**
   *
   * @type {string}
   * @memberof AggregatorPricingListResponse
   */
  updatedAt?: string;
  /**
   *
   * @type {Array<AggregatorPricingRow>}
   * @memberof AggregatorPricingListResponse
   */
  rows?: Array<AggregatorPricingRow>;
  /**
   *
   * @type {string}
   * @memberof AggregatorPricingListResponse
   */
  nextPageToken?: string;
}
/**
 *
 * @export
 * @interface AggregatorPricingRow
 */
export interface AggregatorPricingRow {
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  duration?: number;
  /**
   *
   * @type {boolean}
   * @memberof AggregatorPricingRow
   */
  cpi?: boolean;
  /**
   * Codice finalità. Se null = valido per tutte le finalità.  ### 6.1 Finalità prestito  | ID | Finalità | | :--- | :--- | | 1 | PC ed elettronica | | 2 | Formazione e università | | 4 | Arredamento | | 5 | Ristrutturazione casa | | 15 | Moto nuove/km0 | | 16 | Moto usate | | 24 | Viaggi e vacanze | | 26 | Spese mediche | | 27 | Matrimonio e cerimonie | | 29 | Auto nuove/km0 | | 30 | Auto usate | | 31 | Consolidamento debiti | | 32 | Acquisto immobile | | 33 | Liquidità |
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  purpose?: number;
  /**
   *
   * @type {string}
   * @memberof AggregatorPricingRow
   */
  financialTable?: string;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  installmentAmount?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  tan?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  taeg?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  teg?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  maxTaeg?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  feesCommissions?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  grossFinancing?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  contractStampDuty?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  monthlyPracticeManagementFee?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  annualStatementTax?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  totalAmountDueFromTheConsumer?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  totalCreditAmount?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  totalInterests?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  insuranceAmount?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  financialServices?: number;
  /**
   *
   * @type {number}
   * @memberof AggregatorPricingRow
   */
  grossAmount?: number;
}
/**
 *
 * @export
 * @interface AntifraudRequest
 */
export interface AntifraudRequest {
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  applicationId?: string;
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  channel?: string;
  /**
   *
   * @type {Array<PersonalDataDto>}
   * @memberof AntifraudRequest
   */
  applicants?: Array<PersonalDataDto>;
  /**
   *
   * @type {LoanDataDto}
   * @memberof AntifraudRequest
   */
  loanRequest?: LoanDataDto;
  /**
   *
   * @type {any}
   * @memberof AntifraudRequest
   */
  deviceTransactionId?: any;
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  ipAddress?: string;
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  loanApr?: string;
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  loanMontlyPayment?: string;
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  nationalID?: string;
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  nationalIDType?: string;
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  iban?: string;
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  idDateFrom?: string;
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  idDateTo?: string;
  /**
   *
   * @type {string}
   * @memberof AntifraudRequest
   */
  idEnterilascio?: string;
  /**
   *
   * @type {HealthCardData}
   * @memberof AntifraudRequest
   */
  hcData?: HealthCardData;
  /**
   *
   * @type {ResidencePermitData}
   * @memberof AntifraudRequest
   */
  permitData?: ResidencePermitData;
  /**
   *
   * @type {InpsData}
   * @memberof AntifraudRequest
   */
  inps?: InpsData;
  /**
   *
   * @type {InailData}
   * @memberof AntifraudRequest
   */
  inail?: InailData;
  /**
   *
   * @type {TaxDeclarationData}
   * @memberof AntifraudRequest
   */
  taxDeclaration?: TaxDeclarationData;
}
/**
 *
 * @export
 * @interface AvailableResponse
 */
export interface AvailableResponse {
  /**
   *
   * @type {string}
   * @memberof AvailableResponse
   */
  label?: string;
  /**
   *
   * @type {string}
   * @memberof AvailableResponse
   */
  value?: string;
}
/**
 *
 * @export
 * @interface BaseActivityIODto
 */
export interface BaseActivityIODto {
  /**
   *
   * @type {string}
   * @memberof BaseActivityIODto
   */
  orReqId?: string;
  /**
   *
   * @type {string}
   * @memberof BaseActivityIODto
   */
  activityId?: string;
  /**
   *
   * @type {string}
   * @memberof BaseActivityIODto
   */
  workflowId?: string;
}
/**
 *
 * @export
 * @interface Birth
 */
export interface Birth {
  /**
   *
   * @type {BirthDate}
   * @memberof Birth
   */
  birthDate?: BirthDate;
  /**
   *
   * @type {string}
   * @memberof Birth
   */
  birthCountry?: string;
  /**
   *
   * @type {string}
   * @memberof Birth
   */
  birthProvince?: string;
  /**
   *
   * @type {string}
   * @memberof Birth
   */
  birthCity?: string;
}
/**
 *
 * @export
 * @interface BirthDate
 */
export interface BirthDate {
  /**
   *
   * @type {number}
   * @memberof BirthDate
   */
  birthDay?: number;
  /**
   *
   * @type {number}
   * @memberof BirthDate
   */
  birthMonth?: number;
  /**
   *
   * @type {number}
   * @memberof BirthDate
   */
  birthYear?: number;
}
/**
 *
 * @export
 * @interface BirthRequest
 */
export interface BirthRequest {
  /**
   *
   * @type {string}
   * @memberof BirthRequest
   */
  birthDate?: string;
  /**
   *
   * @type {string}
   * @memberof BirthRequest
   */
  birthCity?: string;
  /**
   *
   * @type {string}
   * @memberof BirthRequest
   */
  birthProvince?: string;
  /**
   *
   * @type {string}
   * @memberof BirthRequest
   */
  birthCountry?: BirthRequestBirthCountryEnum;
  /**
   *
   * @type {string}
   * @memberof BirthRequest
   */
  nationality?: string;
}

export const BirthRequestBirthCountryEnum = {
  Abw: "ABW",
  Afg: "AFG",
  Ago: "AGO",
  Aia: "AIA",
  Ala: "ALA",
  Alb: "ALB",
  And: "AND",
  Are: "ARE",
  Arg: "ARG",
  Arm: "ARM",
  Asm: "ASM",
  Ata: "ATA",
  Atf: "ATF",
  Atg: "ATG",
  Aus: "AUS",
  Aut: "AUT",
  Aze: "AZE",
  Bdi: "BDI",
  Bel: "BEL",
  Ben: "BEN",
  Bes: "BES",
  Bfa: "BFA",
  Bgd: "BGD",
  Bgr: "BGR",
  Bhr: "BHR",
  Bhs: "BHS",
  Bih: "BIH",
  Blm: "BLM",
  Blr: "BLR",
  Blz: "BLZ",
  Bmu: "BMU",
  Bol: "BOL",
  Bra: "BRA",
  Brb: "BRB",
  Brn: "BRN",
  Btn: "BTN",
  Bvt: "BVT",
  Bwa: "BWA",
  Caf: "CAF",
  Can: "CAN",
  Cck: "CCK",
  Che: "CHE",
  Chl: "CHL",
  Chn: "CHN",
  Civ: "CIV",
  Cmr: "CMR",
  Cod: "COD",
  Cog: "COG",
  Cok: "COK",
  Col: "COL",
  Com: "COM",
  Cpv: "CPV",
  Cri: "CRI",
  Cub: "CUB",
  Cuw: "CUW",
  Cxr: "CXR",
  Cym: "CYM",
  Cyp: "CYP",
  Cze: "CZE",
  Deu: "DEU",
  Dji: "DJI",
  Dma: "DMA",
  Dnk: "DNK",
  Dom: "DOM",
  Dza: "DZA",
  Ecu: "ECU",
  Egy: "EGY",
  Eri: "ERI",
  Esh: "ESH",
  Esp: "ESP",
  Est: "EST",
  Eth: "ETH",
  Fin: "FIN",
  Fji: "FJI",
  Flk: "FLK",
  Fra: "FRA",
  Fro: "FRO",
  Fsm: "FSM",
  Gab: "GAB",
  Gbr: "GBR",
  Geo: "GEO",
  Ggy: "GGY",
  Gha: "GHA",
  Gib: "GIB",
  Gin: "GIN",
  Glp: "GLP",
  Gmb: "GMB",
  Gnb: "GNB",
  Gnq: "GNQ",
  Grc: "GRC",
  Grd: "GRD",
  Grl: "GRL",
  Gtm: "GTM",
  Guf: "GUF",
  Gum: "GUM",
  Guy: "GUY",
  Hkg: "HKG",
  Hmd: "HMD",
  Hnd: "HND",
  Hrv: "HRV",
  Hti: "HTI",
  Hun: "HUN",
  Idn: "IDN",
  Imn: "IMN",
  Ind: "IND",
  Iot: "IOT",
  Irl: "IRL",
  Irn: "IRN",
  Irq: "IRQ",
  Isl: "ISL",
  Isr: "ISR",
  Ita: "ITA",
  Jam: "JAM",
  Jey: "JEY",
  Jor: "JOR",
  Jpn: "JPN",
  Kaz: "KAZ",
  Ken: "KEN",
  Kgz: "KGZ",
  Khm: "KHM",
  Kir: "KIR",
  Kna: "KNA",
  Kor: "KOR",
  Kwt: "KWT",
  Lao: "LAO",
  Lbn: "LBN",
  Lbr: "LBR",
  Lby: "LBY",
  Lca: "LCA",
  Lie: "LIE",
  Lka: "LKA",
  Lso: "LSO",
  Ltu: "LTU",
  Lux: "LUX",
  Lva: "LVA",
  Mac: "MAC",
  Maf: "MAF",
  Mar: "MAR",
  Mco: "MCO",
  Mda: "MDA",
  Mdg: "MDG",
  Mdv: "MDV",
  Mex: "MEX",
  Mhl: "MHL",
  Mkd: "MKD",
  Mli: "MLI",
  Mlt: "MLT",
  Mmr: "MMR",
  Mne: "MNE",
  Mng: "MNG",
  Mnp: "MNP",
  Moz: "MOZ",
  Mrt: "MRT",
  Msr: "MSR",
  Mtq: "MTQ",
  Mus: "MUS",
  Mwi: "MWI",
  Mys: "MYS",
  Myt: "MYT",
  Nam: "NAM",
  Ncl: "NCL",
  Ner: "NER",
  Nfk: "NFK",
  Nga: "NGA",
  Nic: "NIC",
  Niu: "NIU",
  Nld: "NLD",
  Nor: "NOR",
  Npl: "NPL",
  Nru: "NRU",
  Nzl: "NZL",
  Omn: "OMN",
  Pak: "PAK",
  Pan: "PAN",
  Pcn: "PCN",
  Per: "PER",
  Phl: "PHL",
  Plw: "PLW",
  Png: "PNG",
  Pol: "POL",
  Pri: "PRI",
  Prk: "PRK",
  Prt: "PRT",
  Pry: "PRY",
  Pse: "PSE",
  Pyf: "PYF",
  Qat: "QAT",
  Reu: "REU",
  Rou: "ROU",
  Rus: "RUS",
  Rwa: "RWA",
  Sau: "SAU",
  Sdn: "SDN",
  Sen: "SEN",
  Sgp: "SGP",
  Sgs: "SGS",
  Shn: "SHN",
  Sjm: "SJM",
  Slb: "SLB",
  Sle: "SLE",
  Slv: "SLV",
  Smr: "SMR",
  Som: "SOM",
  Spm: "SPM",
  Srb: "SRB",
  Ssd: "SSD",
  Stp: "STP",
  Sur: "SUR",
  Svk: "SVK",
  Svn: "SVN",
  Swe: "SWE",
  Swz: "SWZ",
  Sxm: "SXM",
  Syc: "SYC",
  Syr: "SYR",
  Tca: "TCA",
  Tcd: "TCD",
  Tgo: "TGO",
  Tha: "THA",
  Tjk: "TJK",
  Tkl: "TKL",
  Tkm: "TKM",
  Tls: "TLS",
  Ton: "TON",
  Tto: "TTO",
  Tun: "TUN",
  Tur: "TUR",
  Tuv: "TUV",
  Twn: "TWN",
  Tza: "TZA",
  Uga: "UGA",
  Ukr: "UKR",
  Umi: "UMI",
  Ury: "URY",
  Usa: "USA",
  Uzb: "UZB",
  Vat: "VAT",
  Vct: "VCT",
  Ven: "VEN",
  Vgb: "VGB",
  Vir: "VIR",
  Vnm: "VNM",
  Vut: "VUT",
  Wlf: "WLF",
  Wsm: "WSM",
  Yem: "YEM",
  Zaf: "ZAF",
  Zmb: "ZMB",
  Zwe: "ZWE",
} as const;

export type BirthRequestBirthCountryEnum =
  (typeof BirthRequestBirthCountryEnum)[keyof typeof BirthRequestBirthCountryEnum];

/**
 *
 * @export
 * @interface CalculateOfferRequest
 */
export interface CalculateOfferRequest {
  /**
   *
   * @type {number}
   * @memberof CalculateOfferRequest
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof CalculateOfferRequest
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof CalculateOfferRequest
   */
  loanPurpose?: CalculateOfferRequestLoanPurposeEnum;
}

export const CalculateOfferRequestLoanPurposeEnum = {
  DebtConsolidation: "DEBT_CONSOLIDATION",
  EstheticsWellbeing: "ESTHETICS_WELLBEING",
  MedicalExpenses: "MEDICAL_EXPENSES",
  StudyingTrainingCourses: "STUDYING_TRAINING_COURSES",
  Wedding: "WEDDING",
  Travels: "TRAVELS",
  Other: "OTHER",
  HomeImprovement: "HOME_IMPROVEMENT",
  Furniture: "FURNITURE",
  RealEstateBoxPurchase: "REAL_ESTATE_BOX_PURCHASE",
  NewUsedMotorbike: "NEW_USED_MOTORBIKE",
  NewCar: "NEW_CAR",
  UsedCar: "USED_CAR",
  Liquidity: "LIQUIDITY",
} as const;

export type CalculateOfferRequestLoanPurposeEnum =
  (typeof CalculateOfferRequestLoanPurposeEnum)[keyof typeof CalculateOfferRequestLoanPurposeEnum];

/**
 *
 * @export
 * @interface CheckIbanResponse
 */
export interface CheckIbanResponse {
  /**
   *
   * @type {string}
   * @memberof CheckIbanResponse
   */
  ibanValidation?: CheckIbanResponseIbanValidationEnum;
}

export const CheckIbanResponseIbanValidationEnum = {
  Success: "SUCCESS",
  Failed: "FAILED",
} as const;

export type CheckIbanResponseIbanValidationEnum =
  (typeof CheckIbanResponseIbanValidationEnum)[keyof typeof CheckIbanResponseIbanValidationEnum];

/**
 *
 * @export
 * @interface ClientInfo
 */
export interface ClientInfo {
  /**
   *
   * @type {string}
   * @memberof ClientInfo
   */
  deviceCountryCode?: string;
  /**
   *
   * @type {string}
   * @memberof ClientInfo
   */
  deviceIpAddress?: string;
  /**
   *
   * @type {DeviceInfo}
   * @memberof ClientInfo
   */
  deviceInfo?: DeviceInfo;
  /**
   *
   * @type {string}
   * @memberof ClientInfo
   */
  browserNavigatorName?: string;
  /**
   *
   * @type {string}
   * @memberof ClientInfo
   */
  browserAppName?: string;
  /**
   *
   * @type {string}
   * @memberof ClientInfo
   */
  browserNavigatorVersion?: string;
  /**
   *
   * @type {string}
   * @memberof ClientInfo
   */
  browserNavigatorVendor?: string;
  /**
   *
   * @type {string}
   * @memberof ClientInfo
   */
  browserTimeLocal?: string;
}
/**
 *
 * @export
 * @interface CompanyIndustryRequest
 */
export interface CompanyIndustryRequest {
  /**
   *
   * @type {string}
   * @memberof CompanyIndustryRequest
   */
  companyIndustry?: CompanyIndustryRequestCompanyIndustryEnum;
}

export const CompanyIndustryRequestCompanyIndustryEnum = {
  Transport: "TRANSPORT",
  Tourism: "TOURISM",
  Construction: "CONSTRUCTION",
  RetailCommerce: "RETAIL_COMMERCE",
  PubAndRestaurants: "PUB_AND_RESTAURANTS",
  Other: "OTHER",
  IndustryAndProduction: "INDUSTRY_AND_PRODUCTION",
  PrivateServices: "PRIVATE_SERVICES",
  PublicOwnedCompanies: "PUBLIC_OWNED_COMPANIES",
  PublicSector: "PUBLIC_SECTOR",
  PoliceAndArmedForces: "POLICE_AND_ARMED_FORCES",
} as const;

export type CompanyIndustryRequestCompanyIndustryEnum =
  (typeof CompanyIndustryRequestCompanyIndustryEnum)[keyof typeof CompanyIndustryRequestCompanyIndustryEnum];

/**
 *
 * @export
 * @interface CompanySizeRequest
 */
export interface CompanySizeRequest {
  /**
   *
   * @type {string}
   * @memberof CompanySizeRequest
   */
  companySize?: CompanySizeRequestCompanySizeEnum;
}

export const CompanySizeRequestCompanySizeEnum = {
  Micro: "MICRO",
  Small: "SMALL",
  Medium: "MEDIUM",
  Large: "LARGE",
} as const;

export type CompanySizeRequestCompanySizeEnum =
  (typeof CompanySizeRequestCompanySizeEnum)[keyof typeof CompanySizeRequestCompanySizeEnum];

/**
 *
 * @export
 * @interface Config
 */
export interface Config {
  /**
   *
   * @type {string}
   * @memberof Config
   */
  key?: ConfigKeyEnum;
  /**
   *
   * @type {string}
   * @memberof Config
   */
  value?: string;
}

export const ConfigKeyEnum = {
  MinAmount: "MIN_AMOUNT",
  MaxAmount: "MAX_AMOUNT",
  AmountStep: "AMOUNT_STEP",
  MinDuration: "MIN_DURATION",
  MaxDuration: "MAX_DURATION",
  DurationStep: "DURATION_STEP",
} as const;

export type ConfigKeyEnum = (typeof ConfigKeyEnum)[keyof typeof ConfigKeyEnum];

/**
 *
 * @export
 * @interface ConfigResponse
 */
export interface ConfigResponse {
  /**
   *
   * @type {Array<Config>}
   * @memberof ConfigResponse
   */
  configList?: Array<Config>;
}
/**
 *
 * @export
 * @interface ConsentDataDto
 */
export interface ConsentDataDto {
  /**
   *
   * @type {boolean}
   * @memberof ConsentDataDto
   */
  openBankingConsent?: boolean;
  /**
   *
   * @type {string}
   * @memberof ConsentDataDto
   */
  incomeCheckId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ConsentDataDto
   */
  bureausConsent?: boolean;
}
/**
 *
 * @export
 * @interface Contact
 */
export interface Contact {
  /**
   * Id del contatto
   * @type {string}
   * @memberof Contact
   */
  contactId?: string;
  /**
   * Email del soggetto
   * @type {string}
   * @memberof Contact
   */
  email: string;
  /**
   * Numero di telefono del soggetto
   * @type {string}
   * @memberof Contact
   */
  phone?: string;
}
/**
 *
 * @export
 * @interface Contacts
 */
export interface Contacts {
  /**
   *
   * @type {string}
   * @memberof Contacts
   */
  email?: string;
}
/**
 *
 * @export
 * @interface CouponCodeRequest
 */
export interface CouponCodeRequest {
  /**
   *
   * @type {string}
   * @memberof CouponCodeRequest
   */
  couponCode?: string;
}
/**
 *
 * @export
 * @interface CreateContactRequest
 */
export interface CreateContactRequest {
  /**
   *
   * @type {string}
   * @memberof CreateContactRequest
   */
  phone?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContactRequest
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContactRequest
   */
  dealId?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateContactRequest
   */
  privacy?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateContactRequest
   */
  pageUri?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContactRequest
   */
  pageName?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContactRequest
   */
  hutk?: string;
}
/**
 *
 * @export
 * @interface CreateLeadRequest
 */
export interface CreateLeadRequest {
  /**
   * Prodotto del prestito
   * @type {Product}
   * @memberof CreateLeadRequest
   */
  product: Product;
  /**
   * Dati vincolanti del contatto
   * @type {Contact}
   * @memberof CreateLeadRequest
   */
  contact: Contact;
  /**
   * Dati personali del contatto
   * @type {Personal}
   * @memberof CreateLeadRequest
   */
  personal: Personal;
  /**
   *
   * @type {Metadata}
   * @memberof CreateLeadRequest
   */
  metadata: Metadata;
}
/**
 *
 * @export
 * @interface CreateLeadResponse
 */
export interface CreateLeadResponse {
  /**
   * Identificativo della pratica Qinetic
   * @type {string}
   * @memberof CreateLeadResponse
   */
  positionId?: string;
  /**
   * Identificativo del workflow
   * @type {string}
   * @memberof CreateLeadResponse
   */
  workflowId?: string;
  /**
   * Esito dell\'operazione
   * @type {string}
   * @memberof CreateLeadResponse
   */
  outcome?: CreateLeadResponseOutcomeEnum;
  /**
   * Eventuale messaggio d\'errore
   * @type {string}
   * @memberof CreateLeadResponse
   */
  errorMessage?: string;
}

export const CreateLeadResponseOutcomeEnum = {
  Error: "ERROR",
  Success: "SUCCESS",
} as const;

export type CreateLeadResponseOutcomeEnum =
  (typeof CreateLeadResponseOutcomeEnum)[keyof typeof CreateLeadResponseOutcomeEnum];

/**
 *
 * @export
 * @interface CreateQPositionWrapperRequest
 */
export interface CreateQPositionWrapperRequest {
  /**
   *
   * @type {string}
   * @memberof CreateQPositionWrapperRequest
   */
  dealId: string;
  /**
   *
   * @type {string}
   * @memberof CreateQPositionWrapperRequest
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof CreateQPositionWrapperRequest
   */
  qineticCorrelationId?: string;
  /**
   *
   * @type {QCreatePositionRequestV3}
   * @memberof CreateQPositionWrapperRequest
   */
  qineticPayload: QCreatePositionRequestV3;
}
/**
 *
 * @export
 * @interface CreateQPositionWrapperResponse
 */
export interface CreateQPositionWrapperResponse {
  /**
   *
   * @type {string}
   * @memberof CreateQPositionWrapperResponse
   */
  dealId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateQPositionWrapperResponse
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateQPositionWrapperResponse
   */
  workflowId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateQPositionWrapperResponse
   */
  qineticPositionId?: string;
  /**
   *
   * @type {QCreatePositionResponse}
   * @memberof CreateQPositionWrapperResponse
   */
  qineticPayload?: QCreatePositionResponse;
}
/**
 *
 * @export
 * @interface Customer
 */
export interface Customer {
  /**
   *
   * @type {PersonalInfo}
   * @memberof Customer
   */
  personalInfo?: PersonalInfo;
  /**
   *
   * @type {Contacts}
   * @memberof Customer
   */
  contacts?: Contacts;
  /**
   *
   * @type {Birth}
   * @memberof Customer
   */
  birth?: Birth;
  /**
   *
   * @type {Job}
   * @memberof Customer
   */
  job?: Job;
  /**
   *
   * @type {AddressInfo}
   * @memberof Customer
   */
  addressInfo?: AddressInfo;
  /**
   *
   * @type {Family}
   * @memberof Customer
   */
  family?: Family;
  /**
   *
   * @type {Living}
   * @memberof Customer
   */
  living?: Living;
  /**
   *
   * @type {KycTentative}
   * @memberof Customer
   */
  kycTentative?: KycTentative;
}
/**
 *
 * @export
 * @interface DataCollectionWorkflowDto
 */
export interface DataCollectionWorkflowDto {
  /**
   *
   * @type {BaseActivityIODto}
   * @memberof DataCollectionWorkflowDto
   */
  activityInputDto?: BaseActivityIODto;
  /**
   *
   * @type {string}
   * @memberof DataCollectionWorkflowDto
   */
  currentState?: DataCollectionWorkflowDtoCurrentStateEnum;
  /**
   *
   * @type {string}
   * @memberof DataCollectionWorkflowDto
   */
  recoveryBlock?: DataCollectionWorkflowDtoRecoveryBlockEnum;
  /**
   *
   * @type {string}
   * @memberof DataCollectionWorkflowDto
   * @deprecated
   */
  salesMethodPhone?: DataCollectionWorkflowDtoSalesMethodPhoneEnum;
  /**
   *
   * @type {{ [key: string]: boolean; }}
   * @memberof DataCollectionWorkflowDto
   */
  executedStep?: { [key: string]: boolean };
  /**
   *
   * @type {boolean}
   * @memberof DataCollectionWorkflowDto
   */
  backSignal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DataCollectionWorkflowDto
   */
  nextSignal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DataCollectionWorkflowDto
   */
  reloadSignal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DataCollectionWorkflowDto
   */
  dataCollectionCompleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof DataCollectionWorkflowDto
   */
  signalState?: DataCollectionWorkflowDtoSignalStateEnum;
  /**
   *
   * @type {string}
   * @memberof DataCollectionWorkflowDto
   */
  employmentSwitch?: DataCollectionWorkflowDtoEmploymentSwitchEnum;
  /**
   *
   * @type {string}
   * @memberof DataCollectionWorkflowDto
   */
  cpiSwitch?: DataCollectionWorkflowDtoCpiSwitchEnum;
  /**
   *
   * @type {string}
   * @memberof DataCollectionWorkflowDto
   */
  cpiQuestionnaireSwitch?: DataCollectionWorkflowDtoCpiQuestionnaireSwitchEnum;
  /**
   *
   * @type {string}
   * @memberof DataCollectionWorkflowDto
   */
  cpiBeneficiarySwitch?: DataCollectionWorkflowDtoCpiBeneficiarySwitchEnum;
}

export const DataCollectionWorkflowDtoCurrentStateEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type DataCollectionWorkflowDtoCurrentStateEnum =
  (typeof DataCollectionWorkflowDtoCurrentStateEnum)[keyof typeof DataCollectionWorkflowDtoCurrentStateEnum];
export const DataCollectionWorkflowDtoRecoveryBlockEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type DataCollectionWorkflowDtoRecoveryBlockEnum =
  (typeof DataCollectionWorkflowDtoRecoveryBlockEnum)[keyof typeof DataCollectionWorkflowDtoRecoveryBlockEnum];
export const DataCollectionWorkflowDtoSalesMethodPhoneEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type DataCollectionWorkflowDtoSalesMethodPhoneEnum =
  (typeof DataCollectionWorkflowDtoSalesMethodPhoneEnum)[keyof typeof DataCollectionWorkflowDtoSalesMethodPhoneEnum];
export const DataCollectionWorkflowDtoSignalStateEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type DataCollectionWorkflowDtoSignalStateEnum =
  (typeof DataCollectionWorkflowDtoSignalStateEnum)[keyof typeof DataCollectionWorkflowDtoSignalStateEnum];
export const DataCollectionWorkflowDtoEmploymentSwitchEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type DataCollectionWorkflowDtoEmploymentSwitchEnum =
  (typeof DataCollectionWorkflowDtoEmploymentSwitchEnum)[keyof typeof DataCollectionWorkflowDtoEmploymentSwitchEnum];
export const DataCollectionWorkflowDtoCpiSwitchEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type DataCollectionWorkflowDtoCpiSwitchEnum =
  (typeof DataCollectionWorkflowDtoCpiSwitchEnum)[keyof typeof DataCollectionWorkflowDtoCpiSwitchEnum];
export const DataCollectionWorkflowDtoCpiQuestionnaireSwitchEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type DataCollectionWorkflowDtoCpiQuestionnaireSwitchEnum =
  (typeof DataCollectionWorkflowDtoCpiQuestionnaireSwitchEnum)[keyof typeof DataCollectionWorkflowDtoCpiQuestionnaireSwitchEnum];
export const DataCollectionWorkflowDtoCpiBeneficiarySwitchEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type DataCollectionWorkflowDtoCpiBeneficiarySwitchEnum =
  (typeof DataCollectionWorkflowDtoCpiBeneficiarySwitchEnum)[keyof typeof DataCollectionWorkflowDtoCpiBeneficiarySwitchEnum];

/**
 *
 * @export
 * @interface DealCreationRequest
 */
export interface DealCreationRequest {
  /**
   *
   * @type {LoanIntent}
   * @memberof DealCreationRequest
   */
  loanIntent?: LoanIntent;
  /**
   *
   * @type {string}
   * @memberof DealCreationRequest
   */
  applicationId?: string;
  /**
   *
   * @type {string}
   * @memberof DealCreationRequest
   */
  channelForm?: string;
  /**
   *
   * @type {string}
   * @memberof DealCreationRequest
   */
  latestSource?: string;
  /**
   *
   * @type {string}
   * @memberof DealCreationRequest
   */
  latestSourceDrillDown?: string;
  /**
   *
   * @type {string}
   * @memberof DealCreationRequest
   */
  originalUtmCampaign?: string;
  /**
   *
   * @type {string}
   * @memberof DealCreationRequest
   */
  originalUtmContent?: string;
  /**
   *
   * @type {string}
   * @memberof DealCreationRequest
   */
  originalUtmMedium?: string;
  /**
   *
   * @type {string}
   * @memberof DealCreationRequest
   */
  originalUtmSource?: string;
  /**
   *
   * @type {string}
   * @memberof DealCreationRequest
   */
  originalUtmTerm?: string;
}
/**
 *
 * @export
 * @interface DealCreationResponse
 */
export interface DealCreationResponse {
  /**
   *
   * @type {string}
   * @memberof DealCreationResponse
   */
  dealHubspotId?: string;
}
/**
 *
 * @export
 * @interface DeliveryRequest
 */
export interface DeliveryRequest {
  /**
   *
   * @type {Header}
   * @memberof DeliveryRequest
   */
  header?: Header;
  /**
   *
   * @type {Info}
   * @memberof DeliveryRequest
   */
  info?: Info;
  /**
   *
   * @type {string}
   * @memberof DeliveryRequest
   */
  body?: string;
}
/**
 *
 * @export
 * @interface DeviceInfo
 */
export interface DeviceInfo {
  /**
   *
   * @type {string}
   * @memberof DeviceInfo
   */
  deviceType?: string;
  /**
   *
   * @type {string}
   * @memberof DeviceInfo
   */
  brand?: string;
  /**
   *
   * @type {string}
   * @memberof DeviceInfo
   */
  screenResolution?: string;
  /**
   *
   * @type {string}
   * @memberof DeviceInfo
   */
  ipAddress?: string;
  /**
   *
   * @type {string}
   * @memberof DeviceInfo
   */
  mac?: string;
}
/**
 *
 * @export
 * @interface DocumentChecklistItemResponse
 */
export interface DocumentChecklistItemResponse {
  /**
   *
   * @type {number}
   * @memberof DocumentChecklistItemResponse
   */
  docId?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentChecklistItemResponse
   */
  documentDescription?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentChecklistItemResponse
   */
  uploadDate?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentChecklistItemResponse
   */
  fileName?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentChecklistItemResponse
   */
  documentCode?: string;
}
/**
 *
 * @export
 * @interface DocumentProperties
 */
export interface DocumentProperties {
  /**
   *
   * @type {string}
   * @memberof DocumentProperties
   */
  docId: string;
  /**
   *
   * @type {string}
   * @memberof DocumentProperties
   */
  documentCode: string;
  /**
   *
   * @type {string}
   * @memberof DocumentProperties
   */
  fileNameExtension: string;
}
/**
 *
 * @export
 * @interface DocumentSecciRequest
 */
export interface DocumentSecciRequest {
  /**
   * Codice Contratto
   * @type {string}
   * @memberof DocumentSecciRequest
   */
  pratNumero?: string;
  /**
   * Limite massimo o somma totale degli importi messi a disposizione del consumatore.
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  impTotaleCredito?: number;
  /**
   * Durata del contratto di credito ; Rate da Pagare; N. rate.
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  nr?: number;
  /**
   * Importo Rata.
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  rata?: number;
  /**
   * Importo del capitale preso in prestito, più gli interessi e i costi connessi al credito.
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  impTotaleDovuto?: number;
  /**
   * TAN.
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  pratTan?: number;
  /**
   * TAEG.
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  pratTaeg?: number;
  /**
   * interessi
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  interessi?: number;
  /**
   * Imposta di bollo iniziale/sostitutiva sul contratto a carico del consumatore: €
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  pratImpBollo?: number;
  /**
   * Imposta di bollo su singola comunicazione periodica annuale e di fine rapporto, se prevista (per importisuperiori ad € 77,47): €
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  trpBolloInvPer?: number;
  /**
   * L’Importo dell’eventuale Premio Assicurativo (già compreso nell’importo totale del credito)
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  cpiImportoServizio?: number;
  /**
   * ove sottoscritta, di seguito si propone l’Importo della rata che si sarebbe avuta in assenza di polizza assicurativa:
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  cpiImpRata?: number;
  /**
   * Spese istruttoria pratica
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  pratImpComm?: number;
  /**
   * Spese di incasso e gestione rata per singolo pagamento: €
   * @type {number}
   * @memberof DocumentSecciRequest
   */
  pratSpeInc?: number;
  /**
   * Data
   * @type {string}
   * @memberof DocumentSecciRequest
   */
  modData?: string;
}
/**
 *
 * @export
 * @interface ELCreateOtpRequest
 */
export interface ELCreateOtpRequest {
  /**
   *
   * @type {string}
   * @memberof ELCreateOtpRequest
   */
  email: string;
}
/**
 *
 * @export
 * @interface EditOfferResponse
 */
export interface EditOfferResponse {
  /**
   *
   * @type {boolean}
   * @memberof EditOfferResponse
   */
  simulationFailed?: boolean;
  /**
   *
   * @type {Array<OfferResponse>}
   * @memberof EditOfferResponse
   */
  offers?: Array<OfferResponse>;
  /**
   *
   * @type {number}
   * @memberof EditOfferResponse
   */
  offersAttempts?: number;
}
/**
 *
 * @export
 * @interface EmploymentStatusRequest
 */
export interface EmploymentStatusRequest {
  /**
   *
   * @type {string}
   * @memberof EmploymentStatusRequest
   */
  employmentStatus?: EmploymentStatusRequestEmploymentStatusEnum;
}

export const EmploymentStatusRequestEmploymentStatusEnum = {
  PermanentEmployeeFt: "PERMANENT_EMPLOYEE_FT",
  FixedTimeEmployeeFt: "FIXED_TIME_EMPLOYEE_FT",
  PermanentEmployeePt: "PERMANENT_EMPLOYEE_PT",
  FixedTimeEmployeePt: "FIXED_TIME_EMPLOYEE_PT",
  SelfEmployed: "SELF_EMPLOYED",
  Student: "STUDENT",
  Pensioner: "PENSIONER",
  Unemployed: "UNEMPLOYED",
  Other: "OTHER",
} as const;

export type EmploymentStatusRequestEmploymentStatusEnum =
  (typeof EmploymentStatusRequestEmploymentStatusEnum)[keyof typeof EmploymentStatusRequestEmploymentStatusEnum];

/**
 *
 * @export
 * @interface Family
 */
export interface Family {
  /**
   *
   * @type {string}
   * @memberof Family
   */
  maritalStatus?: string;
  /**
   *
   * @type {string}
   * @memberof Family
   */
  householdMembers?: string;
  /**
   *
   * @type {string}
   * @memberof Family
   */
  peopleWithIncome?: string;
}
/**
 *
 * @export
 * @interface FamilyRequest
 */
export interface FamilyRequest {
  /**
   *
   * @type {string}
   * @memberof FamilyRequest
   */
  householdMembers?: FamilyRequestHouseholdMembersEnum;
  /**
   *
   * @type {string}
   * @memberof FamilyRequest
   */
  peopleWithIncome?: FamilyRequestPeopleWithIncomeEnum;
}

export const FamilyRequestHouseholdMembersEnum = {
  One: "ONE",
  Two: "TWO",
  Three: "THREE",
  Four: "FOUR",
  More: "MORE",
} as const;

export type FamilyRequestHouseholdMembersEnum =
  (typeof FamilyRequestHouseholdMembersEnum)[keyof typeof FamilyRequestHouseholdMembersEnum];
export const FamilyRequestPeopleWithIncomeEnum = {
  One: "ONE",
  Two: "TWO",
  Three: "THREE",
  Four: "FOUR",
  More: "MORE",
} as const;

export type FamilyRequestPeopleWithIncomeEnum =
  (typeof FamilyRequestPeopleWithIncomeEnum)[keyof typeof FamilyRequestPeopleWithIncomeEnum];

/**
 *
 * @export
 * @interface FinancialDataDto
 */
export interface FinancialDataDto {
  /**
   *
   * @type {string}
   * @memberof FinancialDataDto
   */
  latePayments?: FinancialDataDtoLatePaymentsEnum;
  /**
   *
   * @type {number}
   * @memberof FinancialDataDto
   */
  netMonthlySalaryEur?: number;
  /**
   *
   * @type {number}
   * @memberof FinancialDataDto
   */
  grossYearlySalaryEur?: number;
  /**
   *
   * @type {number}
   * @memberof FinancialDataDto
   */
  salaryMonthsCnt?: number;
  /**
   *
   * @type {boolean}
   * @memberof FinancialDataDto
   */
  hasOtherIncome?: boolean;
  /**
   *
   * @type {number}
   * @memberof FinancialDataDto
   */
  otherNetMonthlyIncomeEur?: number;
  /**
   *
   * @type {string}
   * @memberof FinancialDataDto
   */
  descriptionSourcesIncome?: FinancialDataDtoDescriptionSourcesIncomeEnum;
  /**
   *
   * @type {number}
   * @memberof FinancialDataDto
   */
  totalMonthlyInstallmentsAmountEur?: number;
}

export const FinancialDataDtoLatePaymentsEnum = {
  Never: "NEVER",
  One: "ONE",
  Two: "TWO",
  MoreThanTwo: "MORE_THAN_TWO",
} as const;

export type FinancialDataDtoLatePaymentsEnum =
  (typeof FinancialDataDtoLatePaymentsEnum)[keyof typeof FinancialDataDtoLatePaymentsEnum];
export const FinancialDataDtoDescriptionSourcesIncomeEnum = {
  SurvivorPension: "SURVIVOR_PENSION",
  ChildSupportAllowance: "CHILD_SUPPORT_ALLOWANCE",
  RentingOutProperties: "RENTING_OUT_PROPERTIES",
  Other: "OTHER",
} as const;

export type FinancialDataDtoDescriptionSourcesIncomeEnum =
  (typeof FinancialDataDtoDescriptionSourcesIncomeEnum)[keyof typeof FinancialDataDtoDescriptionSourcesIncomeEnum];

/**
 *
 * @export
 * @interface FiscalCodeRequest
 */
export interface FiscalCodeRequest {
  /**
   *
   * @type {string}
   * @memberof FiscalCodeRequest
   */
  gender?: FiscalCodeRequestGenderEnum;
  /**
   *
   * @type {string}
   * @memberof FiscalCodeRequest
   */
  birthDate?: string;
  /**
   *
   * @type {string}
   * @memberof FiscalCodeRequest
   */
  birthCity?: string;
  /**
   *
   * @type {string}
   * @memberof FiscalCodeRequest
   */
  birthProvince?: string;
  /**
   *
   * @type {string}
   * @memberof FiscalCodeRequest
   */
  birthCountry?: FiscalCodeRequestBirthCountryEnum;
  /**
   *
   * @type {string}
   * @memberof FiscalCodeRequest
   */
  nationality?: string;
  /**
   *
   * @type {string}
   * @memberof FiscalCodeRequest
   */
  fiscalCode?: string;
}

export const FiscalCodeRequestGenderEnum = {
  M: "M",
  F: "F",
} as const;

export type FiscalCodeRequestGenderEnum =
  (typeof FiscalCodeRequestGenderEnum)[keyof typeof FiscalCodeRequestGenderEnum];
export const FiscalCodeRequestBirthCountryEnum = {
  Abw: "ABW",
  Afg: "AFG",
  Ago: "AGO",
  Aia: "AIA",
  Ala: "ALA",
  Alb: "ALB",
  And: "AND",
  Are: "ARE",
  Arg: "ARG",
  Arm: "ARM",
  Asm: "ASM",
  Ata: "ATA",
  Atf: "ATF",
  Atg: "ATG",
  Aus: "AUS",
  Aut: "AUT",
  Aze: "AZE",
  Bdi: "BDI",
  Bel: "BEL",
  Ben: "BEN",
  Bes: "BES",
  Bfa: "BFA",
  Bgd: "BGD",
  Bgr: "BGR",
  Bhr: "BHR",
  Bhs: "BHS",
  Bih: "BIH",
  Blm: "BLM",
  Blr: "BLR",
  Blz: "BLZ",
  Bmu: "BMU",
  Bol: "BOL",
  Bra: "BRA",
  Brb: "BRB",
  Brn: "BRN",
  Btn: "BTN",
  Bvt: "BVT",
  Bwa: "BWA",
  Caf: "CAF",
  Can: "CAN",
  Cck: "CCK",
  Che: "CHE",
  Chl: "CHL",
  Chn: "CHN",
  Civ: "CIV",
  Cmr: "CMR",
  Cod: "COD",
  Cog: "COG",
  Cok: "COK",
  Col: "COL",
  Com: "COM",
  Cpv: "CPV",
  Cri: "CRI",
  Cub: "CUB",
  Cuw: "CUW",
  Cxr: "CXR",
  Cym: "CYM",
  Cyp: "CYP",
  Cze: "CZE",
  Deu: "DEU",
  Dji: "DJI",
  Dma: "DMA",
  Dnk: "DNK",
  Dom: "DOM",
  Dza: "DZA",
  Ecu: "ECU",
  Egy: "EGY",
  Eri: "ERI",
  Esh: "ESH",
  Esp: "ESP",
  Est: "EST",
  Eth: "ETH",
  Fin: "FIN",
  Fji: "FJI",
  Flk: "FLK",
  Fra: "FRA",
  Fro: "FRO",
  Fsm: "FSM",
  Gab: "GAB",
  Gbr: "GBR",
  Geo: "GEO",
  Ggy: "GGY",
  Gha: "GHA",
  Gib: "GIB",
  Gin: "GIN",
  Glp: "GLP",
  Gmb: "GMB",
  Gnb: "GNB",
  Gnq: "GNQ",
  Grc: "GRC",
  Grd: "GRD",
  Grl: "GRL",
  Gtm: "GTM",
  Guf: "GUF",
  Gum: "GUM",
  Guy: "GUY",
  Hkg: "HKG",
  Hmd: "HMD",
  Hnd: "HND",
  Hrv: "HRV",
  Hti: "HTI",
  Hun: "HUN",
  Idn: "IDN",
  Imn: "IMN",
  Ind: "IND",
  Iot: "IOT",
  Irl: "IRL",
  Irn: "IRN",
  Irq: "IRQ",
  Isl: "ISL",
  Isr: "ISR",
  Ita: "ITA",
  Jam: "JAM",
  Jey: "JEY",
  Jor: "JOR",
  Jpn: "JPN",
  Kaz: "KAZ",
  Ken: "KEN",
  Kgz: "KGZ",
  Khm: "KHM",
  Kir: "KIR",
  Kna: "KNA",
  Kor: "KOR",
  Kwt: "KWT",
  Lao: "LAO",
  Lbn: "LBN",
  Lbr: "LBR",
  Lby: "LBY",
  Lca: "LCA",
  Lie: "LIE",
  Lka: "LKA",
  Lso: "LSO",
  Ltu: "LTU",
  Lux: "LUX",
  Lva: "LVA",
  Mac: "MAC",
  Maf: "MAF",
  Mar: "MAR",
  Mco: "MCO",
  Mda: "MDA",
  Mdg: "MDG",
  Mdv: "MDV",
  Mex: "MEX",
  Mhl: "MHL",
  Mkd: "MKD",
  Mli: "MLI",
  Mlt: "MLT",
  Mmr: "MMR",
  Mne: "MNE",
  Mng: "MNG",
  Mnp: "MNP",
  Moz: "MOZ",
  Mrt: "MRT",
  Msr: "MSR",
  Mtq: "MTQ",
  Mus: "MUS",
  Mwi: "MWI",
  Mys: "MYS",
  Myt: "MYT",
  Nam: "NAM",
  Ncl: "NCL",
  Ner: "NER",
  Nfk: "NFK",
  Nga: "NGA",
  Nic: "NIC",
  Niu: "NIU",
  Nld: "NLD",
  Nor: "NOR",
  Npl: "NPL",
  Nru: "NRU",
  Nzl: "NZL",
  Omn: "OMN",
  Pak: "PAK",
  Pan: "PAN",
  Pcn: "PCN",
  Per: "PER",
  Phl: "PHL",
  Plw: "PLW",
  Png: "PNG",
  Pol: "POL",
  Pri: "PRI",
  Prk: "PRK",
  Prt: "PRT",
  Pry: "PRY",
  Pse: "PSE",
  Pyf: "PYF",
  Qat: "QAT",
  Reu: "REU",
  Rou: "ROU",
  Rus: "RUS",
  Rwa: "RWA",
  Sau: "SAU",
  Sdn: "SDN",
  Sen: "SEN",
  Sgp: "SGP",
  Sgs: "SGS",
  Shn: "SHN",
  Sjm: "SJM",
  Slb: "SLB",
  Sle: "SLE",
  Slv: "SLV",
  Smr: "SMR",
  Som: "SOM",
  Spm: "SPM",
  Srb: "SRB",
  Ssd: "SSD",
  Stp: "STP",
  Sur: "SUR",
  Svk: "SVK",
  Svn: "SVN",
  Swe: "SWE",
  Swz: "SWZ",
  Sxm: "SXM",
  Syc: "SYC",
  Syr: "SYR",
  Tca: "TCA",
  Tcd: "TCD",
  Tgo: "TGO",
  Tha: "THA",
  Tjk: "TJK",
  Tkl: "TKL",
  Tkm: "TKM",
  Tls: "TLS",
  Ton: "TON",
  Tto: "TTO",
  Tun: "TUN",
  Tur: "TUR",
  Tuv: "TUV",
  Twn: "TWN",
  Tza: "TZA",
  Uga: "UGA",
  Ukr: "UKR",
  Umi: "UMI",
  Ury: "URY",
  Usa: "USA",
  Uzb: "UZB",
  Vat: "VAT",
  Vct: "VCT",
  Ven: "VEN",
  Vgb: "VGB",
  Vir: "VIR",
  Vnm: "VNM",
  Vut: "VUT",
  Wlf: "WLF",
  Wsm: "WSM",
  Yem: "YEM",
  Zaf: "ZAF",
  Zmb: "ZMB",
  Zwe: "ZWE",
} as const;

export type FiscalCodeRequestBirthCountryEnum =
  (typeof FiscalCodeRequestBirthCountryEnum)[keyof typeof FiscalCodeRequestBirthCountryEnum];

/**
 *
 * @export
 * @interface GetDocumentResponse
 */
export interface GetDocumentResponse {
  /**
   *
   * @type {number}
   * @memberof GetDocumentResponse
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof GetDocumentResponse
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof GetDocumentResponse
   */
  description?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof GetDocumentResponse
   */
  preSignedUrlMap?: { [key: string]: string };
  /**
   *
   * @type {boolean}
   * @memberof GetDocumentResponse
   */
  mandatory?: boolean;
}
/**
 *
 * @export
 * @interface GetOrchSurveyResponse
 */
export interface GetOrchSurveyResponse {
  /**
   *
   * @type {Array<Question>}
   * @memberof GetOrchSurveyResponse
   */
  questions?: Array<Question>;
}
/**
 *
 * @export
 * @interface GrossIncomeRequest
 */
export interface GrossIncomeRequest {
  /**
   *
   * @type {number}
   * @memberof GrossIncomeRequest
   */
  grossAnnualSalary?: number;
}
/**
 *
 * @export
 * @interface Header
 */
export interface Header {
  /**
   *
   * @type {number}
   * @memberof Header
   */
  correlationId?: number;
  /**
   *
   * @type {string}
   * @memberof Header
   */
  conversationId?: string;
  /**
   *
   * @type {string}
   * @memberof Header
   */
  sender?: string;
  /**
   *
   * @type {number}
   * @memberof Header
   */
  requesetdAt?: number;
  /**
   *
   * @type {string}
   * @memberof Header
   */
  eventCod?: HeaderEventCodEnum;
  /**
   *
   * @type {string}
   * @memberof Header
   */
  messageStrategy?: string;
  /**
   *
   * @type {string}
   * @memberof Header
   */
  businessId?: string;
}

export const HeaderEventCodEnum = {
  StatusChange: "STATUS_CHANGE",
  DocumentReceived: "DOCUMENT_RECEIVED",
  Extinguished: "EXTINGUISHED",
  WithdrawalDone: "WITHDRAWAL_DONE",
  TotalEarlyTermDone: "TOTAL_EARLY_TERM_DONE",
  WithdrawalRequested: "WITHDRAWAL_REQUESTED",
  EarlyTermRequested: "EARLY_TERM_REQUESTED",
  LoanDisbursed: "LOAN_DISBURSED",
  RefusedSdd1: "REFUSED_SDD_1",
  RefusedSdd2: "REFUSED_SDD_2",
  CloseTask: "CLOSE_TASK",
} as const;

export type HeaderEventCodEnum =
  (typeof HeaderEventCodEnum)[keyof typeof HeaderEventCodEnum];

/**
 *
 * @export
 * @interface HealthCardData
 */
export interface HealthCardData {
  /**
   *
   * @type {string}
   * @memberof HealthCardData
   */
  number?: string;
  /**
   *
   * @type {string}
   * @memberof HealthCardData
   */
  expirationDate?: string;
}
/**
 *
 * @export
 * @interface HiringRequest
 */
export interface HiringRequest {
  /**
   *
   * @type {string}
   * @memberof HiringRequest
   */
  employer?: string;
  /**
   *
   * @type {number}
   * @memberof HiringRequest
   */
  hireYear?: number;
  /**
   *
   * @type {number}
   * @memberof HiringRequest
   */
  hireMonth?: number;
}
/**
 *
 * @export
 * @interface IbanCheckRequestDto
 */
export interface IbanCheckRequestDto {
  /**
   *
   * @type {string}
   * @memberof IbanCheckRequestDto
   */
  fiscalCode?: string;
  /**
   *
   * @type {string}
   * @memberof IbanCheckRequestDto
   */
  iban?: string;
}
/**
 *
 * @export
 * @interface InailData
 */
export interface InailData {
  /**
   *
   * @type {string}
   * @memberof InailData
   */
  numero?: string;
  /**
   *
   * @type {string}
   * @memberof InailData
   */
  cfDatoreLavoro?: string;
  /**
   *
   * @type {string}
   * @memberof InailData
   */
  codiceControllo?: string;
}
/**
 *
 * @export
 * @interface Income
 */
export interface Income {
  /**
   *
   * @type {number}
   * @memberof Income
   */
  netMonthlySalary?: number;
  /**
   *
   * @type {number}
   * @memberof Income
   */
  monthlySalary?: number;
  /**
   *
   * @type {number}
   * @memberof Income
   */
  grossAnnualSalary?: number;
  /**
   *
   * @type {boolean}
   * @memberof Income
   */
  hasOtherIncome?: boolean;
  /**
   *
   * @type {string}
   * @memberof Income
   */
  otherIncomeDescription?: string;
  /**
   *
   * @type {number}
   * @memberof Income
   */
  otherIncomeNetMonthlySalary?: number;
}
/**
 *
 * @export
 * @interface IncomeMonthlyRequest
 */
export interface IncomeMonthlyRequest {
  /**
   *
   * @type {number}
   * @memberof IncomeMonthlyRequest
   */
  netMonthlySalary?: number;
  /**
   *
   * @type {number}
   * @memberof IncomeMonthlyRequest
   */
  monthsSalary?: number;
}
/**
 *
 * @export
 * @interface IncomeOtherRequest
 */
export interface IncomeOtherRequest {
  /**
   *
   * @type {boolean}
   * @memberof IncomeOtherRequest
   */
  hasOtherIncome?: boolean;
  /**
   *
   * @type {string}
   * @memberof IncomeOtherRequest
   */
  otherIncomeDescription?: IncomeOtherRequestOtherIncomeDescriptionEnum;
  /**
   *
   * @type {number}
   * @memberof IncomeOtherRequest
   */
  otherIncomeNetMonthlySalary?: number;
}

export const IncomeOtherRequestOtherIncomeDescriptionEnum = {
  SurvivorPension: "SURVIVOR_PENSION",
  ChildSupportAllowance: "CHILD_SUPPORT_ALLOWANCE",
  RentingOutProperties: "RENTING_OUT_PROPERTIES",
  Other: "OTHER",
} as const;

export type IncomeOtherRequestOtherIncomeDescriptionEnum =
  (typeof IncomeOtherRequestOtherIncomeDescriptionEnum)[keyof typeof IncomeOtherRequestOtherIncomeDescriptionEnum];

/**
 *
 * @export
 * @interface Info
 */
export interface Info {
  /**
   *
   * @type {number}
   * @memberof Info
   */
  messageId?: number;
  /**
   *
   * @type {string}
   * @memberof Info
   */
  version?: string;
  /**
   *
   * @type {string}
   * @memberof Info
   */
  checkSum?: string;
}
/**
 *
 * @export
 * @interface InitResponse
 */
export interface InitResponse {
  /**
   *
   * @type {string}
   * @memberof InitResponse
   */
  dealId?: string;
  /**
   *
   * @type {string}
   * @memberof InitResponse
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof InitResponse
   */
  workflowId?: string;
  /**
   *
   * @type {boolean}
   * @memberof InitResponse
   */
  newContact?: boolean;
  /**
   *
   * @type {string}
   * @memberof InitResponse
   */
  ctOrchToken?: string;
  /**
   *
   * @type {string}
   * @memberof InitResponse
   */
  state?: InitResponseStateEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof InitResponse
   */
  connectionIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof InitResponse
   */
  channel?: string;
}

export const InitResponseStateEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type InitResponseStateEnum =
  (typeof InitResponseStateEnum)[keyof typeof InitResponseStateEnum];

/**
 *
 * @export
 * @interface InpsData
 */
export interface InpsData {
  /**
   *
   * @type {string}
   * @memberof InpsData
   */
  matricola?: string;
  /**
   *
   * @type {string}
   * @memberof InpsData
   */
  meseCompetenza?: string;
  /**
   *
   * @type {string}
   * @memberof InpsData
   */
  annoCompetenza?: string;
  /**
   *
   * @type {number}
   * @memberof InpsData
   */
  tipologiaContratto?: number;
}
/**
 *
 * @export
 * @interface InsuranceQuestionnaireRequest
 */
export interface InsuranceQuestionnaireRequest {
  /**
   *
   * @type {Array<SurveyRequests>}
   * @memberof InsuranceQuestionnaireRequest
   */
  surveyRequests?: Array<SurveyRequests>;
  /**
   *
   * @type {string}
   * @memberof InsuranceQuestionnaireRequest
   */
  outcome?: string;
}
/**
 *
 * @export
 * @interface Job
 */
export interface Job {
  /**
   *
   * @type {string}
   * @memberof Job
   */
  educationLevel?: JobEducationLevelEnum;
  /**
   *
   * @type {string}
   * @memberof Job
   */
  employmentStatus?: JobEmploymentStatusEnum;
  /**
   *
   * @type {string}
   * @memberof Job
   */
  jobRole?: JobJobRoleEnum;
  /**
   *
   * @type {string}
   * @memberof Job
   */
  hireMonth?: string;
  /**
   *
   * @type {string}
   * @memberof Job
   */
  hireYear?: string;
  /**
   *
   * @type {string}
   * @memberof Job
   */
  vatNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Job
   */
  employerName?: string;
  /**
   *
   * @type {string}
   * @memberof Job
   */
  companyIndustry?: JobCompanyIndustryEnum;
  /**
   *
   * @type {string}
   * @memberof Job
   */
  companySize?: JobCompanySizeEnum;
  /**
   *
   * @type {Income}
   * @memberof Job
   */
  income?: Income;
}

export const JobEducationLevelEnum = {
  Elementary: "ELEMENTARY",
  Secondary: "SECONDARY",
  HighSchoolDiploma: "HIGH_SCHOOL_DIPLOMA",
  BachelorDegree: "BACHELOR_DEGREE",
  MasterDegree: "MASTER_DEGREE",
  Master: "MASTER",
} as const;

export type JobEducationLevelEnum =
  (typeof JobEducationLevelEnum)[keyof typeof JobEducationLevelEnum];
export const JobEmploymentStatusEnum = {
  PermanentEmployeeFt: "PERMANENT_EMPLOYEE_FT",
  FixedTimeEmployeeFt: "FIXED_TIME_EMPLOYEE_FT",
  PermanentEmployeePt: "PERMANENT_EMPLOYEE_PT",
  FixedTimeEmployeePt: "FIXED_TIME_EMPLOYEE_PT",
  SelfEmployed: "SELF_EMPLOYED",
  Student: "STUDENT",
  Pensioner: "PENSIONER",
  Unemployed: "UNEMPLOYED",
  Other: "OTHER",
} as const;

export type JobEmploymentStatusEnum =
  (typeof JobEmploymentStatusEnum)[keyof typeof JobEmploymentStatusEnum];
export const JobJobRoleEnum = {
  Operaio: "OPERAIO",
  Impiegato: "IMPIEGATO",
  QuadroManager: "QUADRO_MANAGER",
  Dirigente: "DIRIGENTE",
  LavoratoreStagionaleAgricolo: "LAVORATORE_STAGIONALE_AGRICOLO",
  ForzeArmate: "FORZE_ARMATE",
  LiberoProfessionistaIscrittoAdAlbo: "LIBERO_PROFESSIONISTA_ISCRITTO_AD_ALBO",
  LiberoProfessionistaNonIscrittoAdAlbo:
    "LIBERO_PROFESSIONISTA_NON_ISCRITTO_AD_ALBO",
  ImprenditoreDittaIndividuale: "IMPRENDITORE_DITTA_INDIVIDUALE",
  Artigiano: "ARTIGIANO",
  Autotrasportatore: "AUTOTRASPORTATORE",
  OperatoreMedicoSanitario: "OPERATORE_MEDICO_SANITARIO",
  Altro: "ALTRO",
} as const;

export type JobJobRoleEnum =
  (typeof JobJobRoleEnum)[keyof typeof JobJobRoleEnum];
export const JobCompanyIndustryEnum = {
  Transport: "TRANSPORT",
  Tourism: "TOURISM",
  Construction: "CONSTRUCTION",
  RetailCommerce: "RETAIL_COMMERCE",
  PubAndRestaurants: "PUB_AND_RESTAURANTS",
  Other: "OTHER",
  IndustryAndProduction: "INDUSTRY_AND_PRODUCTION",
  PrivateServices: "PRIVATE_SERVICES",
  PublicOwnedCompanies: "PUBLIC_OWNED_COMPANIES",
  PublicSector: "PUBLIC_SECTOR",
  PoliceAndArmedForces: "POLICE_AND_ARMED_FORCES",
} as const;

export type JobCompanyIndustryEnum =
  (typeof JobCompanyIndustryEnum)[keyof typeof JobCompanyIndustryEnum];
export const JobCompanySizeEnum = {
  Micro: "MICRO",
  Small: "SMALL",
  Medium: "MEDIUM",
  Large: "LARGE",
} as const;

export type JobCompanySizeEnum =
  (typeof JobCompanySizeEnum)[keyof typeof JobCompanySizeEnum];

/**
 *
 * @export
 * @interface JobDataDto
 */
export interface JobDataDto {
  /**
   *
   * @type {string}
   * @memberof JobDataDto
   */
  employmentStatus?: JobDataDtoEmploymentStatusEnum;
  /**
   *
   * @type {number}
   * @memberof JobDataDto
   */
  jobRole?: JobDataDtoJobRoleEnum;
  /**
   *
   * @type {number}
   * @memberof JobDataDto
   */
  actualJobRole?: JobDataDtoActualJobRoleEnum;
  /**
   *
   * @type {string}
   * @memberof JobDataDto
   */
  hiredOnYear?: string;
  /**
   *
   * @type {string}
   * @memberof JobDataDto
   */
  hiredOnMonth?: string;
  /**
   *
   * @type {string}
   * @memberof JobDataDto
   */
  companyIndustry?: JobDataDtoCompanyIndustryEnum;
  /**
   *
   * @type {string}
   * @memberof JobDataDto
   */
  companySize?: JobDataDtoCompanySizeEnum;
}

export const JobDataDtoEmploymentStatusEnum = {
  PermanentEmployeeFt: "PERMANENT_EMPLOYEE_FT",
  FixedTimeEmployeeFt: "FIXED_TIME_EMPLOYEE_FT",
  PermanentEmployeePt: "PERMANENT_EMPLOYEE_PT",
  FixedTimeEmployeePt: "FIXED_TIME_EMPLOYEE_PT",
  SelfEmployed: "SELF_EMPLOYED",
  Student: "STUDENT",
  Pensioner: "PENSIONER",
  Unemployed: "UNEMPLOYED",
  Other: "OTHER",
} as const;

export type JobDataDtoEmploymentStatusEnum =
  (typeof JobDataDtoEmploymentStatusEnum)[keyof typeof JobDataDtoEmploymentStatusEnum];
export const JobDataDtoJobRoleEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
  NUMBER_10: 10,
  NUMBER_11: 11,
  NUMBER_12: 12,
  NUMBER_13: 13,
  NUMBER_14: 14,
  NUMBER_15: 15,
  NUMBER_16: 16,
  NUMBER_17: 17,
  NUMBER_18: 18,
  NUMBER_19: 19,
  NUMBER_20: 20,
  NUMBER_21: 21,
  NUMBER_22: 22,
  NUMBER_23: 23,
  NUMBER_24: 24,
  NUMBER_25: 25,
  NUMBER_26: 26,
  NUMBER_27: 27,
  NUMBER_28: 28,
  NUMBER_30: 30,
  NUMBER_32: 32,
  NUMBER_31: 31,
  NUMBER_33: 33,
  NUMBER_34: 34,
  NUMBER_35: 35,
  NUMBER_36: 36,
  NUMBER_37: 37,
  NUMBER_38: 38,
  NUMBER_39: 39,
  NUMBER_40: 40,
  NUMBER_41: 41,
  NUMBER_42: 42,
  NUMBER_43: 43,
  NUMBER_44: 44,
  NUMBER_45: 45,
  NUMBER_46: 46,
  NUMBER_47: 47,
  NUMBER_48: 48,
  NUMBER_49: 49,
  NUMBER_50: 50,
  NUMBER_51: 51,
  NUMBER_52: 52,
  NUMBER_53: 53,
  NUMBER_54: 54,
  NUMBER_55: 55,
  NUMBER_56: 56,
  NUMBER_57: 57,
  NUMBER_58: 58,
  NUMBER_59: 59,
  NUMBER_60: 60,
  NUMBER_61: 61,
  NUMBER_62: 62,
  NUMBER_63: 63,
  NUMBER_64: 64,
  NUMBER_65: 65,
  NUMBER_66: 66,
  NUMBER_332: 332,
  NUMBER_333: 333,
  NUMBER_334: 334,
  NUMBER_67: 67,
  NUMBER_68: 68,
  NUMBER_69: 69,
  NUMBER_70: 70,
  NUMBER_71: 71,
  NUMBER_72: 72,
  NUMBER_73: 73,
  NUMBER_74: 74,
  NUMBER_75: 75,
  NUMBER_76: 76,
  NUMBER_78: 78,
  NUMBER_79: 79,
  NUMBER_80: 80,
  NUMBER_81: 81,
  NUMBER_82: 82,
  NUMBER_83: 83,
  NUMBER_84: 84,
  NUMBER_85: 85,
  NUMBER_86: 86,
  NUMBER_87: 87,
  NUMBER_88: 88,
  NUMBER_89: 89,
  NUMBER_91: 91,
  NUMBER_92: 92,
  NUMBER_93: 93,
  NUMBER_94: 94,
  NUMBER_95: 95,
  NUMBER_96: 96,
  NUMBER_97: 97,
  NUMBER_98: 98,
  NUMBER_99: 99,
  NUMBER_100: 100,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_106: 106,
  NUMBER_107: 107,
  NUMBER_108: 108,
  NUMBER_109: 109,
  NUMBER_113: 113,
  NUMBER_114: 114,
  NUMBER_115: 115,
  NUMBER_116: 116,
  NUMBER_117: 117,
  NUMBER_118: 118,
  NUMBER_119: 119,
  NUMBER_120: 120,
  NUMBER_121: 121,
  NUMBER_122: 122,
  NUMBER_123: 123,
  NUMBER_124: 124,
  NUMBER_125: 125,
  NUMBER_127: 127,
  NUMBER_128: 128,
  NUMBER_129: 129,
  NUMBER_130: 130,
  NUMBER_131: 131,
  NUMBER_133: 133,
  NUMBER_134: 134,
  NUMBER_136: 136,
  NUMBER_138: 138,
  NUMBER_139: 139,
  NUMBER_140: 140,
  NUMBER_141: 141,
  NUMBER_142: 142,
  NUMBER_143: 143,
  NUMBER_144: 144,
  NUMBER_145: 145,
  NUMBER_146: 146,
  NUMBER_147: 147,
  NUMBER_148: 148,
  NUMBER_777: 777,
  NUMBER_149: 149,
  NUMBER_150: 150,
  NUMBER_151: 151,
  NUMBER_152: 152,
  NUMBER_154: 154,
  NUMBER_156: 156,
  NUMBER_157: 157,
  NUMBER_158: 158,
  NUMBER_159: 159,
  NUMBER_160: 160,
  NUMBER_161: 161,
  NUMBER_162: 162,
  NUMBER_163: 163,
  NUMBER_176: 176,
  NUMBER_177: 177,
  NUMBER_178: 178,
  NUMBER_179: 179,
  NUMBER_180: 180,
  NUMBER_181: 181,
  NUMBER_182: 182,
  NUMBER_183: 183,
  NUMBER_184: 184,
  NUMBER_185: 185,
  NUMBER_186: 186,
  NUMBER_187: 187,
  NUMBER_188: 188,
  NUMBER_189: 189,
  NUMBER_190: 190,
  NUMBER_191: 191,
  NUMBER_192: 192,
  NUMBER_193: 193,
  NUMBER_194: 194,
  NUMBER_195: 195,
  NUMBER_196: 196,
  NUMBER_197: 197,
  NUMBER_198: 198,
  NUMBER_199: 199,
  NUMBER_200: 200,
  NUMBER_201: 201,
  NUMBER_203: 203,
  NUMBER_204: 204,
  NUMBER_205: 205,
  NUMBER_202: 202,
  NUMBER_206: 206,
  NUMBER_207: 207,
  NUMBER_212: 212,
  NUMBER_208: 208,
  NUMBER_209: 209,
  NUMBER_210: 210,
  NUMBER_211: 211,
  NUMBER_213: 213,
  NUMBER_214: 214,
  NUMBER_215: 215,
  NUMBER_216: 216,
  NUMBER_217: 217,
  NUMBER_218: 218,
  NUMBER_219: 219,
  NUMBER_220: 220,
  NUMBER_221: 221,
  NUMBER_222: 222,
  NUMBER_223: 223,
  NUMBER_224: 224,
  NUMBER_225: 225,
  NUMBER_226: 226,
  NUMBER_227: 227,
  NUMBER_228: 228,
  NUMBER_229: 229,
  NUMBER_230: 230,
  NUMBER_231: 231,
  NUMBER_232: 232,
  NUMBER_233: 233,
  NUMBER_234: 234,
  NUMBER_235: 235,
  NUMBER_236: 236,
  NUMBER_237: 237,
  NUMBER_238: 238,
  NUMBER_239: 239,
  NUMBER_240: 240,
  NUMBER_241: 241,
  NUMBER_242: 242,
  NUMBER_245: 245,
  NUMBER_246: 246,
  NUMBER_247: 247,
  NUMBER_248: 248,
  NUMBER_249: 249,
  NUMBER_250: 250,
  NUMBER_251: 251,
  NUMBER_252: 252,
  NUMBER_253: 253,
  NUMBER_254: 254,
  NUMBER_255: 255,
  NUMBER_256: 256,
  NUMBER_257: 257,
  NUMBER_258: 258,
  NUMBER_259: 259,
  NUMBER_260: 260,
  NUMBER_261: 261,
  NUMBER_262: 262,
  NUMBER_263: 263,
  NUMBER_264: 264,
  NUMBER_265: 265,
  NUMBER_266: 266,
  NUMBER_267: 267,
  NUMBER_268: 268,
  NUMBER_269: 269,
  NUMBER_270: 270,
  NUMBER_271: 271,
  NUMBER_274: 274,
  NUMBER_275: 275,
  NUMBER_276: 276,
  NUMBER_277: 277,
  NUMBER_278: 278,
  NUMBER_279: 279,
  NUMBER_280: 280,
  NUMBER_281: 281,
  NUMBER_283: 283,
  NUMBER_284: 284,
  NUMBER_285: 285,
  NUMBER_286: 286,
  NUMBER_287: 287,
  NUMBER_288: 288,
  NUMBER_289: 289,
  NUMBER_291: 291,
  NUMBER_309: 309,
  NUMBER_310: 310,
  NUMBER_311: 311,
  NUMBER_312: 312,
  NUMBER_313: 313,
  NUMBER_314: 314,
  NUMBER_315: 315,
  NUMBER_316: 316,
  NUMBER_317: 317,
  NUMBER_318: 318,
  NUMBER_319: 319,
  NUMBER_320: 320,
  NUMBER_323: 323,
  NUMBER_324: 324,
  NUMBER_326: 326,
  NUMBER_327: 327,
  NUMBER_328: 328,
  NUMBER_329: 329,
  NUMBER_330: 330,
  NUMBER_331: 331,
  NUMBER_335: 335,
  NUMBER_336: 336,
  NUMBER_337: 337,
  NUMBER_338: 338,
  NUMBER_339: 339,
  NUMBER_340: 340,
  NUMBER_341: 341,
  NUMBER_342: 342,
  NUMBER_343: 343,
  NUMBER_344: 344,
  NUMBER_345: 345,
  NUMBER_346: 346,
  NUMBER_347: 347,
  NUMBER_348: 348,
  NUMBER_349: 349,
  NUMBER_350: 350,
  NUMBER_351: 351,
  NUMBER_352: 352,
  NUMBER_353: 353,
  NUMBER_354: 354,
  NUMBER_355: 355,
  NUMBER_356: 356,
  NUMBER_357: 357,
  NUMBER_358: 358,
  NUMBER_359: 359,
  NUMBER_360: 360,
  NUMBER_361: 361,
  NUMBER_362: 362,
  NUMBER_363: 363,
  NUMBER_364: 364,
  NUMBER_365: 365,
  NUMBER_366: 366,
  NUMBER_367: 367,
  NUMBER_368: 368,
  NUMBER_369: 369,
  NUMBER_370: 370,
  NUMBER_371: 371,
  NUMBER_372: 372,
  NUMBER_373: 373,
  NUMBER_374: 374,
  NUMBER_375: 375,
  NUMBER_376: 376,
  NUMBER_377: 377,
  NUMBER_378: 378,
  NUMBER_379: 379,
  NUMBER_380: 380,
  NUMBER_381: 381,
  NUMBER_382: 382,
  NUMBER_383: 383,
  NUMBER_384: 384,
  NUMBER_385: 385,
  NUMBER_386: 386,
  NUMBER_387: 387,
  NUMBER_388: 388,
  NUMBER_389: 389,
  NUMBER_390: 390,
  NUMBER_391: 391,
  NUMBER_392: 392,
  NUMBER_393: 393,
  NUMBER_394: 394,
  NUMBER_395: 395,
  NUMBER_396: 396,
  NUMBER_397: 397,
  NUMBER_398: 398,
  NUMBER_399: 399,
  NUMBER_400: 400,
  NUMBER_401: 401,
  NUMBER_402: 402,
  NUMBER_403: 403,
  NUMBER_404: 404,
  NUMBER_405: 405,
  NUMBER_406: 406,
  NUMBER_407: 407,
  NUMBER_408: 408,
  NUMBER_409: 409,
  NUMBER_410: 410,
  NUMBER_415: 415,
  NUMBER_416: 416,
  NUMBER_417: 417,
  NUMBER_418: 418,
  NUMBER_419: 419,
  NUMBER_420: 420,
  NUMBER_421: 421,
  NUMBER_422: 422,
  NUMBER_423: 423,
  NUMBER_424: 424,
  NUMBER_425: 425,
  NUMBER_426: 426,
  NUMBER_427: 427,
  NUMBER_428: 428,
  NUMBER_429: 429,
  NUMBER_430: 430,
  NUMBER_431: 431,
  NUMBER_432: 432,
  NUMBER_433: 433,
  NUMBER_434: 434,
  NUMBER_435: 435,
  NUMBER_436: 436,
  NUMBER_437: 437,
  NUMBER_438: 438,
  NUMBER_439: 439,
  NUMBER_440: 440,
  NUMBER_441: 441,
  NUMBER_442: 442,
  NUMBER_443: 443,
  NUMBER_444: 444,
  NUMBER_445: 445,
  NUMBER_446: 446,
  NUMBER_447: 447,
  NUMBER_448: 448,
  NUMBER_449: 449,
  NUMBER_450: 450,
  NUMBER_451: 451,
  NUMBER_452: 452,
  NUMBER_453: 453,
  NUMBER_454: 454,
  NUMBER_455: 455,
  NUMBER_456: 456,
  NUMBER_457: 457,
  NUMBER_458: 458,
  NUMBER_459: 459,
  NUMBER_460: 460,
  NUMBER_461: 461,
  NUMBER_462: 462,
  NUMBER_463: 463,
  NUMBER_464: 464,
  NUMBER_465: 465,
  NUMBER_466: 466,
  NUMBER_467: 467,
  NUMBER_468: 468,
  NUMBER_469: 469,
  NUMBER_470: 470,
  NUMBER_471: 471,
  NUMBER_472: 472,
  NUMBER_473: 473,
  NUMBER_474: 474,
  NUMBER_475: 475,
  NUMBER_476: 476,
  NUMBER_477: 477,
  NUMBER_478: 478,
  NUMBER_479: 479,
  NUMBER_480: 480,
  NUMBER_481: 481,
  NUMBER_482: 482,
  NUMBER_483: 483,
  NUMBER_484: 484,
  NUMBER_485: 485,
  NUMBER_486: 486,
  NUMBER_487: 487,
  NUMBER_488: 488,
  NUMBER_489: 489,
  NUMBER_490: 490,
  NUMBER_491: 491,
  NUMBER_492: 492,
  NUMBER_493: 493,
  NUMBER_494: 494,
  NUMBER_495: 495,
  NUMBER_496: 496,
  NUMBER_497: 497,
  NUMBER_498: 498,
  NUMBER_499: 499,
  NUMBER_500: 500,
  NUMBER_501: 501,
  NUMBER_502: 502,
  NUMBER_503: 503,
  NUMBER_504: 504,
  NUMBER_505: 505,
  NUMBER_506: 506,
  NUMBER_507: 507,
  NUMBER_508: 508,
  NUMBER_509: 509,
  NUMBER_510: 510,
  NUMBER_511: 511,
  NUMBER_512: 512,
  NUMBER_513: 513,
  NUMBER_514: 514,
  NUMBER_515: 515,
  NUMBER_516: 516,
  NUMBER_517: 517,
  NUMBER_518: 518,
  NUMBER_519: 519,
  NUMBER_520: 520,
  NUMBER_521: 521,
  NUMBER_522: 522,
  NUMBER_523: 523,
  NUMBER_524: 524,
  NUMBER_525: 525,
  NUMBER_526: 526,
  NUMBER_527: 527,
  NUMBER_528: 528,
  NUMBER_529: 529,
  NUMBER_530: 530,
  NUMBER_531: 531,
  NUMBER_532: 532,
  NUMBER_533: 533,
  NUMBER_534: 534,
  NUMBER_535: 535,
  NUMBER_536: 536,
  NUMBER_537: 537,
  NUMBER_538: 538,
  NUMBER_541: 541,
  NUMBER_542: 542,
  NUMBER_543: 543,
  NUMBER_544: 544,
  NUMBER_545: 545,
  NUMBER_546: 546,
  NUMBER_547: 547,
  NUMBER_548: 548,
  NUMBER_549: 549,
  NUMBER_550: 550,
  NUMBER_551: 551,
  NUMBER_552: 552,
  NUMBER_553: 553,
  NUMBER_554: 554,
  NUMBER_555: 555,
  NUMBER_556: 556,
  NUMBER_557: 557,
  NUMBER_558: 558,
  NUMBER_559: 559,
  NUMBER_560: 560,
  NUMBER_561: 561,
  NUMBER_562: 562,
  NUMBER_563: 563,
  NUMBER_564: 564,
  NUMBER_565: 565,
  NUMBER_566: 566,
  NUMBER_110: 110,
  NUMBER_111: 111,
  NUMBER_567: 567,
  NUMBER_568: 568,
  NUMBER_569: 569,
  NUMBER_570: 570,
  NUMBER_571: 571,
  NUMBER_573: 573,
  NUMBER_574: 574,
  NUMBER_575: 575,
  NUMBER_576: 576,
  NUMBER_577: 577,
  NUMBER_578: 578,
  NUMBER_579: 579,
  NUMBER_580: 580,
  NUMBER_582: 582,
  NUMBER_584: 584,
  NUMBER_585: 585,
  NUMBER_775: 775,
  NUMBER_586: 586,
  NUMBER_589: 589,
  NUMBER_590: 590,
  NUMBER_594: 594,
  NUMBER_595: 595,
  NUMBER_596: 596,
  NUMBER_597: 597,
  NUMBER_598: 598,
  NUMBER_599: 599,
  NUMBER_600: 600,
  NUMBER_601: 601,
  NUMBER_602: 602,
  NUMBER_603: 603,
  NUMBER_605: 605,
  NUMBER_606: 606,
  NUMBER_607: 607,
  NUMBER_608: 608,
  NUMBER_604: 604,
  NUMBER_609: 609,
  NUMBER_610: 610,
  NUMBER_611: 611,
  NUMBER_613: 613,
  NUMBER_612: 612,
  NUMBER_614: 614,
  NUMBER_615: 615,
  NUMBER_616: 616,
  NUMBER_617: 617,
  NUMBER_618: 618,
  NUMBER_620: 620,
  NUMBER_621: 621,
  NUMBER_622: 622,
  NUMBER_623: 623,
  NUMBER_624: 624,
  NUMBER_776: 776,
  NUMBER_625: 625,
  NUMBER_626: 626,
  NUMBER_627: 627,
  NUMBER_628: 628,
  NUMBER_629: 629,
  NUMBER_630: 630,
  NUMBER_631: 631,
  NUMBER_632: 632,
  NUMBER_633: 633,
  NUMBER_634: 634,
  NUMBER_635: 635,
  NUMBER_637: 637,
  NUMBER_638: 638,
  NUMBER_639: 639,
  NUMBER_640: 640,
  NUMBER_641: 641,
  NUMBER_644: 644,
  NUMBER_642: 642,
  NUMBER_643: 643,
  NUMBER_645: 645,
  NUMBER_646: 646,
  NUMBER_647: 647,
  NUMBER_648: 648,
  NUMBER_650: 650,
  NUMBER_651: 651,
  NUMBER_652: 652,
  NUMBER_653: 653,
  NUMBER_654: 654,
  NUMBER_655: 655,
  NUMBER_656: 656,
  NUMBER_657: 657,
  NUMBER_660: 660,
  NUMBER_658: 658,
  NUMBER_659: 659,
  NUMBER_661: 661,
  NUMBER_662: 662,
  NUMBER_663: 663,
  NUMBER_665: 665,
  NUMBER_664: 664,
  NUMBER_666: 666,
  NUMBER_667: 667,
  NUMBER_668: 668,
  NUMBER_670: 670,
  NUMBER_671: 671,
  NUMBER_672: 672,
  NUMBER_673: 673,
  NUMBER_677: 677,
  NUMBER_678: 678,
  NUMBER_679: 679,
  NUMBER_680: 680,
  NUMBER_681: 681,
  NUMBER_682: 682,
  NUMBER_683: 683,
  NUMBER_684: 684,
  NUMBER_685: 685,
  NUMBER_686: 686,
  NUMBER_687: 687,
  NUMBER_688: 688,
  NUMBER_689: 689,
  NUMBER_690: 690,
  NUMBER_691: 691,
  NUMBER_695: 695,
  NUMBER_692: 692,
  NUMBER_693: 693,
  NUMBER_694: 694,
  NUMBER_696: 696,
  NUMBER_697: 697,
  NUMBER_699: 699,
  NUMBER_700: 700,
  NUMBER_701: 701,
  NUMBER_702: 702,
  NUMBER_703: 703,
  NUMBER_704: 704,
  NUMBER_705: 705,
  NUMBER_706: 706,
  NUMBER_708: 708,
  NUMBER_709: 709,
  NUMBER_710: 710,
  NUMBER_711: 711,
  NUMBER_712: 712,
  NUMBER_713: 713,
  NUMBER_714: 714,
  NUMBER_715: 715,
  NUMBER_716: 716,
  NUMBER_717: 717,
  NUMBER_718: 718,
  NUMBER_719: 719,
  NUMBER_720: 720,
  NUMBER_721: 721,
  NUMBER_722: 722,
  NUMBER_723: 723,
  NUMBER_725: 725,
  NUMBER_726: 726,
  NUMBER_724: 724,
  NUMBER_727: 727,
  NUMBER_728: 728,
  NUMBER_729: 729,
  NUMBER_730: 730,
  NUMBER_731: 731,
  NUMBER_732: 732,
  NUMBER_733: 733,
  NUMBER_734: 734,
  NUMBER_735: 735,
  NUMBER_736: 736,
  NUMBER_737: 737,
  NUMBER_738: 738,
  NUMBER_739: 739,
  NUMBER_740: 740,
  NUMBER_741: 741,
  NUMBER_742: 742,
  NUMBER_743: 743,
  NUMBER_744: 744,
  NUMBER_745: 745,
  NUMBER_746: 746,
  NUMBER_747: 747,
  NUMBER_749: 749,
  NUMBER_753: 753,
  NUMBER_748: 748,
  NUMBER_752: 752,
  NUMBER_750: 750,
  NUMBER_754: 754,
  NUMBER_755: 755,
  NUMBER_756: 756,
  NUMBER_751: 751,
  NUMBER_758: 758,
  NUMBER_759: 759,
  NUMBER_761: 761,
  NUMBER_762: 762,
  NUMBER_763: 763,
  NUMBER_764: 764,
  NUMBER_765: 765,
  NUMBER_766: 766,
  NUMBER_767: 767,
  NUMBER_768: 768,
  NUMBER_769: 769,
  NUMBER_770: 770,
  NUMBER_771: 771,
  NUMBER_772: 772,
  NUMBER_773: 773,
  NUMBER_774: 774,
  NUMBER_778: 778,
  NUMBER_779: 779,
  NUMBER_780: 780,
  NUMBER_781: 781,
  NUMBER_782: 782,
  NUMBER_783: 783,
  NUMBER_784: 784,
  NUMBER_785: 785,
  NUMBER_786: 786,
  NUMBER_787: 787,
  NUMBER_788: 788,
  NUMBER_789: 789,
  NUMBER_790: 790,
  NUMBER_791: 791,
} as const;

export type JobDataDtoJobRoleEnum =
  (typeof JobDataDtoJobRoleEnum)[keyof typeof JobDataDtoJobRoleEnum];
export const JobDataDtoActualJobRoleEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
  NUMBER_10: 10,
  NUMBER_11: 11,
  NUMBER_12: 12,
  NUMBER_13: 13,
  NUMBER_14: 14,
  NUMBER_15: 15,
  NUMBER_16: 16,
  NUMBER_17: 17,
  NUMBER_18: 18,
  NUMBER_19: 19,
  NUMBER_20: 20,
  NUMBER_21: 21,
  NUMBER_22: 22,
  NUMBER_23: 23,
  NUMBER_24: 24,
  NUMBER_25: 25,
  NUMBER_26: 26,
  NUMBER_27: 27,
  NUMBER_28: 28,
  NUMBER_30: 30,
  NUMBER_32: 32,
  NUMBER_31: 31,
  NUMBER_33: 33,
  NUMBER_34: 34,
  NUMBER_35: 35,
  NUMBER_36: 36,
  NUMBER_37: 37,
  NUMBER_38: 38,
  NUMBER_39: 39,
  NUMBER_40: 40,
  NUMBER_41: 41,
  NUMBER_42: 42,
  NUMBER_43: 43,
  NUMBER_44: 44,
  NUMBER_45: 45,
  NUMBER_46: 46,
  NUMBER_47: 47,
  NUMBER_48: 48,
  NUMBER_49: 49,
  NUMBER_50: 50,
  NUMBER_51: 51,
  NUMBER_52: 52,
  NUMBER_53: 53,
  NUMBER_54: 54,
  NUMBER_55: 55,
  NUMBER_56: 56,
  NUMBER_57: 57,
  NUMBER_58: 58,
  NUMBER_59: 59,
  NUMBER_60: 60,
  NUMBER_61: 61,
  NUMBER_62: 62,
  NUMBER_63: 63,
  NUMBER_64: 64,
  NUMBER_65: 65,
  NUMBER_66: 66,
  NUMBER_332: 332,
  NUMBER_333: 333,
  NUMBER_334: 334,
  NUMBER_67: 67,
  NUMBER_68: 68,
  NUMBER_69: 69,
  NUMBER_70: 70,
  NUMBER_71: 71,
  NUMBER_72: 72,
  NUMBER_73: 73,
  NUMBER_74: 74,
  NUMBER_75: 75,
  NUMBER_76: 76,
  NUMBER_78: 78,
  NUMBER_79: 79,
  NUMBER_80: 80,
  NUMBER_81: 81,
  NUMBER_82: 82,
  NUMBER_83: 83,
  NUMBER_84: 84,
  NUMBER_85: 85,
  NUMBER_86: 86,
  NUMBER_87: 87,
  NUMBER_88: 88,
  NUMBER_89: 89,
  NUMBER_91: 91,
  NUMBER_92: 92,
  NUMBER_93: 93,
  NUMBER_94: 94,
  NUMBER_95: 95,
  NUMBER_96: 96,
  NUMBER_97: 97,
  NUMBER_98: 98,
  NUMBER_99: 99,
  NUMBER_100: 100,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_106: 106,
  NUMBER_107: 107,
  NUMBER_108: 108,
  NUMBER_109: 109,
  NUMBER_113: 113,
  NUMBER_114: 114,
  NUMBER_115: 115,
  NUMBER_116: 116,
  NUMBER_117: 117,
  NUMBER_118: 118,
  NUMBER_119: 119,
  NUMBER_120: 120,
  NUMBER_121: 121,
  NUMBER_122: 122,
  NUMBER_123: 123,
  NUMBER_124: 124,
  NUMBER_125: 125,
  NUMBER_127: 127,
  NUMBER_128: 128,
  NUMBER_129: 129,
  NUMBER_130: 130,
  NUMBER_131: 131,
  NUMBER_133: 133,
  NUMBER_134: 134,
  NUMBER_136: 136,
  NUMBER_138: 138,
  NUMBER_139: 139,
  NUMBER_140: 140,
  NUMBER_141: 141,
  NUMBER_142: 142,
  NUMBER_143: 143,
  NUMBER_144: 144,
  NUMBER_145: 145,
  NUMBER_146: 146,
  NUMBER_147: 147,
  NUMBER_148: 148,
  NUMBER_777: 777,
  NUMBER_149: 149,
  NUMBER_150: 150,
  NUMBER_151: 151,
  NUMBER_152: 152,
  NUMBER_154: 154,
  NUMBER_156: 156,
  NUMBER_157: 157,
  NUMBER_158: 158,
  NUMBER_159: 159,
  NUMBER_160: 160,
  NUMBER_161: 161,
  NUMBER_162: 162,
  NUMBER_163: 163,
  NUMBER_176: 176,
  NUMBER_177: 177,
  NUMBER_178: 178,
  NUMBER_179: 179,
  NUMBER_180: 180,
  NUMBER_181: 181,
  NUMBER_182: 182,
  NUMBER_183: 183,
  NUMBER_184: 184,
  NUMBER_185: 185,
  NUMBER_186: 186,
  NUMBER_187: 187,
  NUMBER_188: 188,
  NUMBER_189: 189,
  NUMBER_190: 190,
  NUMBER_191: 191,
  NUMBER_192: 192,
  NUMBER_193: 193,
  NUMBER_194: 194,
  NUMBER_195: 195,
  NUMBER_196: 196,
  NUMBER_197: 197,
  NUMBER_198: 198,
  NUMBER_199: 199,
  NUMBER_200: 200,
  NUMBER_201: 201,
  NUMBER_203: 203,
  NUMBER_204: 204,
  NUMBER_205: 205,
  NUMBER_202: 202,
  NUMBER_206: 206,
  NUMBER_207: 207,
  NUMBER_212: 212,
  NUMBER_208: 208,
  NUMBER_209: 209,
  NUMBER_210: 210,
  NUMBER_211: 211,
  NUMBER_213: 213,
  NUMBER_214: 214,
  NUMBER_215: 215,
  NUMBER_216: 216,
  NUMBER_217: 217,
  NUMBER_218: 218,
  NUMBER_219: 219,
  NUMBER_220: 220,
  NUMBER_221: 221,
  NUMBER_222: 222,
  NUMBER_223: 223,
  NUMBER_224: 224,
  NUMBER_225: 225,
  NUMBER_226: 226,
  NUMBER_227: 227,
  NUMBER_228: 228,
  NUMBER_229: 229,
  NUMBER_230: 230,
  NUMBER_231: 231,
  NUMBER_232: 232,
  NUMBER_233: 233,
  NUMBER_234: 234,
  NUMBER_235: 235,
  NUMBER_236: 236,
  NUMBER_237: 237,
  NUMBER_238: 238,
  NUMBER_239: 239,
  NUMBER_240: 240,
  NUMBER_241: 241,
  NUMBER_242: 242,
  NUMBER_245: 245,
  NUMBER_246: 246,
  NUMBER_247: 247,
  NUMBER_248: 248,
  NUMBER_249: 249,
  NUMBER_250: 250,
  NUMBER_251: 251,
  NUMBER_252: 252,
  NUMBER_253: 253,
  NUMBER_254: 254,
  NUMBER_255: 255,
  NUMBER_256: 256,
  NUMBER_257: 257,
  NUMBER_258: 258,
  NUMBER_259: 259,
  NUMBER_260: 260,
  NUMBER_261: 261,
  NUMBER_262: 262,
  NUMBER_263: 263,
  NUMBER_264: 264,
  NUMBER_265: 265,
  NUMBER_266: 266,
  NUMBER_267: 267,
  NUMBER_268: 268,
  NUMBER_269: 269,
  NUMBER_270: 270,
  NUMBER_271: 271,
  NUMBER_274: 274,
  NUMBER_275: 275,
  NUMBER_276: 276,
  NUMBER_277: 277,
  NUMBER_278: 278,
  NUMBER_279: 279,
  NUMBER_280: 280,
  NUMBER_281: 281,
  NUMBER_283: 283,
  NUMBER_284: 284,
  NUMBER_285: 285,
  NUMBER_286: 286,
  NUMBER_287: 287,
  NUMBER_288: 288,
  NUMBER_289: 289,
  NUMBER_291: 291,
  NUMBER_309: 309,
  NUMBER_310: 310,
  NUMBER_311: 311,
  NUMBER_312: 312,
  NUMBER_313: 313,
  NUMBER_314: 314,
  NUMBER_315: 315,
  NUMBER_316: 316,
  NUMBER_317: 317,
  NUMBER_318: 318,
  NUMBER_319: 319,
  NUMBER_320: 320,
  NUMBER_323: 323,
  NUMBER_324: 324,
  NUMBER_326: 326,
  NUMBER_327: 327,
  NUMBER_328: 328,
  NUMBER_329: 329,
  NUMBER_330: 330,
  NUMBER_331: 331,
  NUMBER_335: 335,
  NUMBER_336: 336,
  NUMBER_337: 337,
  NUMBER_338: 338,
  NUMBER_339: 339,
  NUMBER_340: 340,
  NUMBER_341: 341,
  NUMBER_342: 342,
  NUMBER_343: 343,
  NUMBER_344: 344,
  NUMBER_345: 345,
  NUMBER_346: 346,
  NUMBER_347: 347,
  NUMBER_348: 348,
  NUMBER_349: 349,
  NUMBER_350: 350,
  NUMBER_351: 351,
  NUMBER_352: 352,
  NUMBER_353: 353,
  NUMBER_354: 354,
  NUMBER_355: 355,
  NUMBER_356: 356,
  NUMBER_357: 357,
  NUMBER_358: 358,
  NUMBER_359: 359,
  NUMBER_360: 360,
  NUMBER_361: 361,
  NUMBER_362: 362,
  NUMBER_363: 363,
  NUMBER_364: 364,
  NUMBER_365: 365,
  NUMBER_366: 366,
  NUMBER_367: 367,
  NUMBER_368: 368,
  NUMBER_369: 369,
  NUMBER_370: 370,
  NUMBER_371: 371,
  NUMBER_372: 372,
  NUMBER_373: 373,
  NUMBER_374: 374,
  NUMBER_375: 375,
  NUMBER_376: 376,
  NUMBER_377: 377,
  NUMBER_378: 378,
  NUMBER_379: 379,
  NUMBER_380: 380,
  NUMBER_381: 381,
  NUMBER_382: 382,
  NUMBER_383: 383,
  NUMBER_384: 384,
  NUMBER_385: 385,
  NUMBER_386: 386,
  NUMBER_387: 387,
  NUMBER_388: 388,
  NUMBER_389: 389,
  NUMBER_390: 390,
  NUMBER_391: 391,
  NUMBER_392: 392,
  NUMBER_393: 393,
  NUMBER_394: 394,
  NUMBER_395: 395,
  NUMBER_396: 396,
  NUMBER_397: 397,
  NUMBER_398: 398,
  NUMBER_399: 399,
  NUMBER_400: 400,
  NUMBER_401: 401,
  NUMBER_402: 402,
  NUMBER_403: 403,
  NUMBER_404: 404,
  NUMBER_405: 405,
  NUMBER_406: 406,
  NUMBER_407: 407,
  NUMBER_408: 408,
  NUMBER_409: 409,
  NUMBER_410: 410,
  NUMBER_415: 415,
  NUMBER_416: 416,
  NUMBER_417: 417,
  NUMBER_418: 418,
  NUMBER_419: 419,
  NUMBER_420: 420,
  NUMBER_421: 421,
  NUMBER_422: 422,
  NUMBER_423: 423,
  NUMBER_424: 424,
  NUMBER_425: 425,
  NUMBER_426: 426,
  NUMBER_427: 427,
  NUMBER_428: 428,
  NUMBER_429: 429,
  NUMBER_430: 430,
  NUMBER_431: 431,
  NUMBER_432: 432,
  NUMBER_433: 433,
  NUMBER_434: 434,
  NUMBER_435: 435,
  NUMBER_436: 436,
  NUMBER_437: 437,
  NUMBER_438: 438,
  NUMBER_439: 439,
  NUMBER_440: 440,
  NUMBER_441: 441,
  NUMBER_442: 442,
  NUMBER_443: 443,
  NUMBER_444: 444,
  NUMBER_445: 445,
  NUMBER_446: 446,
  NUMBER_447: 447,
  NUMBER_448: 448,
  NUMBER_449: 449,
  NUMBER_450: 450,
  NUMBER_451: 451,
  NUMBER_452: 452,
  NUMBER_453: 453,
  NUMBER_454: 454,
  NUMBER_455: 455,
  NUMBER_456: 456,
  NUMBER_457: 457,
  NUMBER_458: 458,
  NUMBER_459: 459,
  NUMBER_460: 460,
  NUMBER_461: 461,
  NUMBER_462: 462,
  NUMBER_463: 463,
  NUMBER_464: 464,
  NUMBER_465: 465,
  NUMBER_466: 466,
  NUMBER_467: 467,
  NUMBER_468: 468,
  NUMBER_469: 469,
  NUMBER_470: 470,
  NUMBER_471: 471,
  NUMBER_472: 472,
  NUMBER_473: 473,
  NUMBER_474: 474,
  NUMBER_475: 475,
  NUMBER_476: 476,
  NUMBER_477: 477,
  NUMBER_478: 478,
  NUMBER_479: 479,
  NUMBER_480: 480,
  NUMBER_481: 481,
  NUMBER_482: 482,
  NUMBER_483: 483,
  NUMBER_484: 484,
  NUMBER_485: 485,
  NUMBER_486: 486,
  NUMBER_487: 487,
  NUMBER_488: 488,
  NUMBER_489: 489,
  NUMBER_490: 490,
  NUMBER_491: 491,
  NUMBER_492: 492,
  NUMBER_493: 493,
  NUMBER_494: 494,
  NUMBER_495: 495,
  NUMBER_496: 496,
  NUMBER_497: 497,
  NUMBER_498: 498,
  NUMBER_499: 499,
  NUMBER_500: 500,
  NUMBER_501: 501,
  NUMBER_502: 502,
  NUMBER_503: 503,
  NUMBER_504: 504,
  NUMBER_505: 505,
  NUMBER_506: 506,
  NUMBER_507: 507,
  NUMBER_508: 508,
  NUMBER_509: 509,
  NUMBER_510: 510,
  NUMBER_511: 511,
  NUMBER_512: 512,
  NUMBER_513: 513,
  NUMBER_514: 514,
  NUMBER_515: 515,
  NUMBER_516: 516,
  NUMBER_517: 517,
  NUMBER_518: 518,
  NUMBER_519: 519,
  NUMBER_520: 520,
  NUMBER_521: 521,
  NUMBER_522: 522,
  NUMBER_523: 523,
  NUMBER_524: 524,
  NUMBER_525: 525,
  NUMBER_526: 526,
  NUMBER_527: 527,
  NUMBER_528: 528,
  NUMBER_529: 529,
  NUMBER_530: 530,
  NUMBER_531: 531,
  NUMBER_532: 532,
  NUMBER_533: 533,
  NUMBER_534: 534,
  NUMBER_535: 535,
  NUMBER_536: 536,
  NUMBER_537: 537,
  NUMBER_538: 538,
  NUMBER_541: 541,
  NUMBER_542: 542,
  NUMBER_543: 543,
  NUMBER_544: 544,
  NUMBER_545: 545,
  NUMBER_546: 546,
  NUMBER_547: 547,
  NUMBER_548: 548,
  NUMBER_549: 549,
  NUMBER_550: 550,
  NUMBER_551: 551,
  NUMBER_552: 552,
  NUMBER_553: 553,
  NUMBER_554: 554,
  NUMBER_555: 555,
  NUMBER_556: 556,
  NUMBER_557: 557,
  NUMBER_558: 558,
  NUMBER_559: 559,
  NUMBER_560: 560,
  NUMBER_561: 561,
  NUMBER_562: 562,
  NUMBER_563: 563,
  NUMBER_564: 564,
  NUMBER_565: 565,
  NUMBER_566: 566,
  NUMBER_110: 110,
  NUMBER_111: 111,
  NUMBER_567: 567,
  NUMBER_568: 568,
  NUMBER_569: 569,
  NUMBER_570: 570,
  NUMBER_571: 571,
  NUMBER_573: 573,
  NUMBER_574: 574,
  NUMBER_575: 575,
  NUMBER_576: 576,
  NUMBER_577: 577,
  NUMBER_578: 578,
  NUMBER_579: 579,
  NUMBER_580: 580,
  NUMBER_582: 582,
  NUMBER_584: 584,
  NUMBER_585: 585,
  NUMBER_775: 775,
  NUMBER_586: 586,
  NUMBER_589: 589,
  NUMBER_590: 590,
  NUMBER_594: 594,
  NUMBER_595: 595,
  NUMBER_596: 596,
  NUMBER_597: 597,
  NUMBER_598: 598,
  NUMBER_599: 599,
  NUMBER_600: 600,
  NUMBER_601: 601,
  NUMBER_602: 602,
  NUMBER_603: 603,
  NUMBER_605: 605,
  NUMBER_606: 606,
  NUMBER_607: 607,
  NUMBER_608: 608,
  NUMBER_604: 604,
  NUMBER_609: 609,
  NUMBER_610: 610,
  NUMBER_611: 611,
  NUMBER_613: 613,
  NUMBER_612: 612,
  NUMBER_614: 614,
  NUMBER_615: 615,
  NUMBER_616: 616,
  NUMBER_617: 617,
  NUMBER_618: 618,
  NUMBER_620: 620,
  NUMBER_621: 621,
  NUMBER_622: 622,
  NUMBER_623: 623,
  NUMBER_624: 624,
  NUMBER_776: 776,
  NUMBER_625: 625,
  NUMBER_626: 626,
  NUMBER_627: 627,
  NUMBER_628: 628,
  NUMBER_629: 629,
  NUMBER_630: 630,
  NUMBER_631: 631,
  NUMBER_632: 632,
  NUMBER_633: 633,
  NUMBER_634: 634,
  NUMBER_635: 635,
  NUMBER_637: 637,
  NUMBER_638: 638,
  NUMBER_639: 639,
  NUMBER_640: 640,
  NUMBER_641: 641,
  NUMBER_644: 644,
  NUMBER_642: 642,
  NUMBER_643: 643,
  NUMBER_645: 645,
  NUMBER_646: 646,
  NUMBER_647: 647,
  NUMBER_648: 648,
  NUMBER_650: 650,
  NUMBER_651: 651,
  NUMBER_652: 652,
  NUMBER_653: 653,
  NUMBER_654: 654,
  NUMBER_655: 655,
  NUMBER_656: 656,
  NUMBER_657: 657,
  NUMBER_660: 660,
  NUMBER_658: 658,
  NUMBER_659: 659,
  NUMBER_661: 661,
  NUMBER_662: 662,
  NUMBER_663: 663,
  NUMBER_665: 665,
  NUMBER_664: 664,
  NUMBER_666: 666,
  NUMBER_667: 667,
  NUMBER_668: 668,
  NUMBER_670: 670,
  NUMBER_671: 671,
  NUMBER_672: 672,
  NUMBER_673: 673,
  NUMBER_677: 677,
  NUMBER_678: 678,
  NUMBER_679: 679,
  NUMBER_680: 680,
  NUMBER_681: 681,
  NUMBER_682: 682,
  NUMBER_683: 683,
  NUMBER_684: 684,
  NUMBER_685: 685,
  NUMBER_686: 686,
  NUMBER_687: 687,
  NUMBER_688: 688,
  NUMBER_689: 689,
  NUMBER_690: 690,
  NUMBER_691: 691,
  NUMBER_695: 695,
  NUMBER_692: 692,
  NUMBER_693: 693,
  NUMBER_694: 694,
  NUMBER_696: 696,
  NUMBER_697: 697,
  NUMBER_699: 699,
  NUMBER_700: 700,
  NUMBER_701: 701,
  NUMBER_702: 702,
  NUMBER_703: 703,
  NUMBER_704: 704,
  NUMBER_705: 705,
  NUMBER_706: 706,
  NUMBER_708: 708,
  NUMBER_709: 709,
  NUMBER_710: 710,
  NUMBER_711: 711,
  NUMBER_712: 712,
  NUMBER_713: 713,
  NUMBER_714: 714,
  NUMBER_715: 715,
  NUMBER_716: 716,
  NUMBER_717: 717,
  NUMBER_718: 718,
  NUMBER_719: 719,
  NUMBER_720: 720,
  NUMBER_721: 721,
  NUMBER_722: 722,
  NUMBER_723: 723,
  NUMBER_725: 725,
  NUMBER_726: 726,
  NUMBER_724: 724,
  NUMBER_727: 727,
  NUMBER_728: 728,
  NUMBER_729: 729,
  NUMBER_730: 730,
  NUMBER_731: 731,
  NUMBER_732: 732,
  NUMBER_733: 733,
  NUMBER_734: 734,
  NUMBER_735: 735,
  NUMBER_736: 736,
  NUMBER_737: 737,
  NUMBER_738: 738,
  NUMBER_739: 739,
  NUMBER_740: 740,
  NUMBER_741: 741,
  NUMBER_742: 742,
  NUMBER_743: 743,
  NUMBER_744: 744,
  NUMBER_745: 745,
  NUMBER_746: 746,
  NUMBER_747: 747,
  NUMBER_749: 749,
  NUMBER_753: 753,
  NUMBER_748: 748,
  NUMBER_752: 752,
  NUMBER_750: 750,
  NUMBER_754: 754,
  NUMBER_755: 755,
  NUMBER_756: 756,
  NUMBER_751: 751,
  NUMBER_758: 758,
  NUMBER_759: 759,
  NUMBER_761: 761,
  NUMBER_762: 762,
  NUMBER_763: 763,
  NUMBER_764: 764,
  NUMBER_765: 765,
  NUMBER_766: 766,
  NUMBER_767: 767,
  NUMBER_768: 768,
  NUMBER_769: 769,
  NUMBER_770: 770,
  NUMBER_771: 771,
  NUMBER_772: 772,
  NUMBER_773: 773,
  NUMBER_774: 774,
  NUMBER_778: 778,
  NUMBER_779: 779,
  NUMBER_780: 780,
  NUMBER_781: 781,
  NUMBER_782: 782,
  NUMBER_783: 783,
  NUMBER_784: 784,
  NUMBER_785: 785,
  NUMBER_786: 786,
  NUMBER_787: 787,
  NUMBER_788: 788,
  NUMBER_789: 789,
  NUMBER_790: 790,
  NUMBER_791: 791,
} as const;

export type JobDataDtoActualJobRoleEnum =
  (typeof JobDataDtoActualJobRoleEnum)[keyof typeof JobDataDtoActualJobRoleEnum];
export const JobDataDtoCompanyIndustryEnum = {
  Transport: "TRANSPORT",
  Tourism: "TOURISM",
  Construction: "CONSTRUCTION",
  RetailCommerce: "RETAIL_COMMERCE",
  PubAndRestaurants: "PUB_AND_RESTAURANTS",
  Other: "OTHER",
  IndustryAndProduction: "INDUSTRY_AND_PRODUCTION",
  PrivateServices: "PRIVATE_SERVICES",
  PublicOwnedCompanies: "PUBLIC_OWNED_COMPANIES",
  PublicSector: "PUBLIC_SECTOR",
  PoliceAndArmedForces: "POLICE_AND_ARMED_FORCES",
  Empty: "",
} as const;

export type JobDataDtoCompanyIndustryEnum =
  (typeof JobDataDtoCompanyIndustryEnum)[keyof typeof JobDataDtoCompanyIndustryEnum];
export const JobDataDtoCompanySizeEnum = {
  Micro: "MICRO",
  Small: "SMALL",
  Medium: "MEDIUM",
  Large: "LARGE",
  Empty: "",
} as const;

export type JobDataDtoCompanySizeEnum =
  (typeof JobDataDtoCompanySizeEnum)[keyof typeof JobDataDtoCompanySizeEnum];

/**
 *
 * @export
 * @interface JobRoleRequest
 */
export interface JobRoleRequest {
  /**
   *
   * @type {string}
   * @memberof JobRoleRequest
   */
  jobRole?: JobRoleRequestJobRoleEnum;
}

export const JobRoleRequestJobRoleEnum = {
  Operaio: "OPERAIO",
  Impiegato: "IMPIEGATO",
  QuadroManager: "QUADRO_MANAGER",
  Dirigente: "DIRIGENTE",
  LavoratoreStagionaleAgricolo: "LAVORATORE_STAGIONALE_AGRICOLO",
  ForzeArmate: "FORZE_ARMATE",
  LiberoProfessionistaIscrittoAdAlbo: "LIBERO_PROFESSIONISTA_ISCRITTO_AD_ALBO",
  LiberoProfessionistaNonIscrittoAdAlbo:
    "LIBERO_PROFESSIONISTA_NON_ISCRITTO_AD_ALBO",
  ImprenditoreDittaIndividuale: "IMPRENDITORE_DITTA_INDIVIDUALE",
  Artigiano: "ARTIGIANO",
  Autotrasportatore: "AUTOTRASPORTATORE",
  OperatoreMedicoSanitario: "OPERATORE_MEDICO_SANITARIO",
  Altro: "ALTRO",
} as const;

export type JobRoleRequestJobRoleEnum =
  (typeof JobRoleRequestJobRoleEnum)[keyof typeof JobRoleRequestJobRoleEnum];

/**
 *
 * @export
 * @interface KycResponse
 */
export interface KycResponse {
  /**
   *
   * @type {string}
   * @memberof KycResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof KycResponse
   */
  requestTicket?: string;
}
/**
 *
 * @export
 * @interface KycTentative
 */
export interface KycTentative {
  /**
   *
   * @type {number}
   * @memberof KycTentative
   */
  spid?: number;
  /**
   *
   * @type {number}
   * @memberof KycTentative
   */
  videoSelfie?: number;
}
/**
 *
 * @export
 * @interface KycTypeRequest
 */
export interface KycTypeRequest {
  /**
   *
   * @type {string}
   * @memberof KycTypeRequest
   */
  kycType?: KycTypeRequestKycTypeEnum;
}

export const KycTypeRequestKycTypeEnum = {
  Spid: "SPID",
  VideoSelfie: "VIDEO_SELFIE",
} as const;

export type KycTypeRequestKycTypeEnum =
  (typeof KycTypeRequestKycTypeEnum)[keyof typeof KycTypeRequestKycTypeEnum];

/**
 *
 * @export
 * @interface KycWebhookPayload
 */
export interface KycWebhookPayload {
  /**
   *
   * @type {string}
   * @memberof KycWebhookPayload
   */
  message?: string;
  /**
   *
   * @type {WebhookData}
   * @memberof KycWebhookPayload
   */
  data?: WebhookData;
  /**
   *
   * @type {string}
   * @memberof KycWebhookPayload
   */
  notificationCreatedAsDateTime?: string;
  /**
   *
   * @type {string}
   * @memberof KycWebhookPayload
   */
  notification_created?: string;
}
/**
 *
 * @export
 * @interface KycWorkflowContextDto
 */
export interface KycWorkflowContextDto {
  /**
   *
   * @type {string}
   * @memberof KycWorkflowContextDto
   */
  workflowId?: string;
  /**
   *
   * @type {BaseActivityIODto}
   * @memberof KycWorkflowContextDto
   */
  activityInputDto?: BaseActivityIODto;
  /**
   *
   * @type {string}
   * @memberof KycWorkflowContextDto
   */
  currentState?: KycWorkflowContextDtoCurrentStateEnum;
  /**
   *
   * @type {{ [key: string]: boolean; }}
   * @memberof KycWorkflowContextDto
   */
  executedStep?: { [key: string]: boolean };
  /**
   *
   * @type {boolean}
   * @memberof KycWorkflowContextDto
   */
  backSignal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof KycWorkflowContextDto
   */
  nextSignal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof KycWorkflowContextDto
   */
  completed?: boolean;
  /**
   *
   * @type {string}
   * @memberof KycWorkflowContextDto
   */
  signalState?: KycWorkflowContextDtoSignalStateEnum;
}

export const KycWorkflowContextDtoCurrentStateEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type KycWorkflowContextDtoCurrentStateEnum =
  (typeof KycWorkflowContextDtoCurrentStateEnum)[keyof typeof KycWorkflowContextDtoCurrentStateEnum];
export const KycWorkflowContextDtoSignalStateEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type KycWorkflowContextDtoSignalStateEnum =
  (typeof KycWorkflowContextDtoSignalStateEnum)[keyof typeof KycWorkflowContextDtoSignalStateEnum];

/**
 *
 * @export
 * @interface ListDocumentResponse
 */
export interface ListDocumentResponse {
  /**
   *
   * @type {string}
   * @memberof ListDocumentResponse
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof ListDocumentResponse
   */
  subtitle?: string;
  /**
   *
   * @type {Array<GetDocumentResponse>}
   * @memberof ListDocumentResponse
   */
  documents?: Array<GetDocumentResponse>;
}
/**
 *
 * @export
 * @interface Living
 */
export interface Living {
  /**
   *
   * @type {string}
   * @memberof Living
   */
  homeStatus?: LivingHomeStatusEnum;
  /**
   *
   * @type {number}
   * @memberof Living
   */
  mortgageInstallmentAmount?: number;
  /**
   *
   * @type {number}
   * @memberof Living
   */
  rentInstallmentAmount?: number;
}

export const LivingHomeStatusEnum = {
  Owner: "OWNER",
  Rent: "RENT",
  Family: "FAMILY",
  Employer: "EMPLOYER",
  ThirdParties: "THIRD_PARTIES",
  Other: "OTHER",
  Mortgage: "MORTGAGE",
} as const;

export type LivingHomeStatusEnum =
  (typeof LivingHomeStatusEnum)[keyof typeof LivingHomeStatusEnum];

/**
 *
 * @export
 * @interface LivingSituationRequest
 */
export interface LivingSituationRequest {
  /**
   *
   * @type {string}
   * @memberof LivingSituationRequest
   */
  homeStatus?: LivingSituationRequestHomeStatusEnum;
  /**
   *
   * @type {number}
   * @memberof LivingSituationRequest
   */
  rentInstallmentAmount?: number;
  /**
   *
   * @type {number}
   * @memberof LivingSituationRequest
   */
  mortgageInstallmentAmount?: number;
}

export const LivingSituationRequestHomeStatusEnum = {
  Owner: "OWNER",
  Rent: "RENT",
  Family: "FAMILY",
  Employer: "EMPLOYER",
  ThirdParties: "THIRD_PARTIES",
  Other: "OTHER",
  Mortgage: "MORTGAGE",
} as const;

export type LivingSituationRequestHomeStatusEnum =
  (typeof LivingSituationRequestHomeStatusEnum)[keyof typeof LivingSituationRequestHomeStatusEnum];

/**
 *
 * @export
 * @interface Loan
 */
export interface Loan {
  /**
   *
   * @type {string}
   * @memberof Loan
   */
  workflowId?: string;
  /**
   *
   * @type {string}
   * @memberof Loan
   */
  childWorkflowId?: string;
  /**
   *
   * @type {string}
   * @memberof Loan
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof Loan
   */
  positionId?: string;
  /**
   *
   * @type {string}
   * @memberof Loan
   */
  channel?: string;
  /**
   *
   * @type {string}
   * @memberof Loan
   */
  purpose?: string;
  /**
   *
   * @type {Offer}
   * @memberof Loan
   */
  offer?: Offer;
  /**
   *
   * @type {string}
   * @memberof Loan
   */
  couponCode?: string;
}
/**
 *
 * @export
 * @interface LoanDataDto
 */
export interface LoanDataDto {
  /**
   *
   * @type {string}
   * @memberof LoanDataDto
   */
  ndg?: string;
  /**
   *
   * @type {string}
   * @memberof LoanDataDto
   */
  purpose?: LoanDataDtoPurposeEnum;
  /**
   *
   * @type {number}
   * @memberof LoanDataDto
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof LoanDataDto
   */
  term?: number;
  /**
   *
   * @type {string}
   * @memberof LoanDataDto
   */
  promoCode?: string;
  /**
   *
   * @type {ConsentDataDto}
   * @memberof LoanDataDto
   */
  consents?: ConsentDataDto;
  /**
   *
   * @type {string}
   * @memberof LoanDataDto
   */
  educationLevel?: LoanDataDtoEducationLevelEnum;
  /**
   *
   * @type {JobDataDto}
   * @memberof LoanDataDto
   */
  jobData?: JobDataDto;
  /**
   *
   * @type {FinancialDataDto}
   * @memberof LoanDataDto
   */
  financialData?: FinancialDataDto;
  /**
   *
   * @type {string}
   * @memberof LoanDataDto
   */
  maritalStatus?: LoanDataDtoMaritalStatusEnum;
  /**
   *
   * @type {string}
   * @memberof LoanDataDto
   */
  numHouseholdMembers?: LoanDataDtoNumHouseholdMembersEnum;
  /**
   *
   * @type {string}
   * @memberof LoanDataDto
   */
  peopleWithIncome?: LoanDataDtoPeopleWithIncomeEnum;
  /**
   *
   * @type {OpenBankingDataDto}
   * @memberof LoanDataDto
   */
  openBankingData?: OpenBankingDataDto;
  /**
   *
   * @type {string}
   * @memberof LoanDataDto
   */
  homeStatus?: string;
  /**
   *
   * @type {string}
   * @memberof LoanDataDto
   */
  vatNumber?: string;
  /**
   *
   * @type {string}
   * @memberof LoanDataDto
   */
  employerName?: string;
  /**
   *
   * @type {string}
   * @memberof LoanDataDto
   */
  insurance?: string;
  /**
   *
   * @type {number}
   * @memberof LoanDataDto
   */
  rentMortgageAmount?: number;
}

export const LoanDataDtoPurposeEnum = {
  DebtConsolidation: "DEBT_CONSOLIDATION",
  EstheticsWellbeing: "ESTHETICS_WELLBEING",
  MedicalExpenses: "MEDICAL_EXPENSES",
  StudyingTrainingCourses: "STUDYING_TRAINING_COURSES",
  Wedding: "WEDDING",
  Travels: "TRAVELS",
  Other: "OTHER",
  HomeImprovement: "HOME_IMPROVEMENT",
  Furniture: "FURNITURE",
  RealEstateBoxPurchase: "REAL_ESTATE_BOX_PURCHASE",
  NewUsedMotorbike: "NEW_USED_MOTORBIKE",
  NewCar: "NEW_CAR",
  UsedCar: "USED_CAR",
  Liquidity: "LIQUIDITY",
} as const;

export type LoanDataDtoPurposeEnum =
  (typeof LoanDataDtoPurposeEnum)[keyof typeof LoanDataDtoPurposeEnum];
export const LoanDataDtoEducationLevelEnum = {
  Elementary: "ELEMENTARY",
  Secondary: "SECONDARY",
  HighSchoolDiploma: "HIGH_SCHOOL_DIPLOMA",
  BachelorDegree: "BACHELOR_DEGREE",
  MasterDegree: "MASTER_DEGREE",
  Master: "MASTER",
  Empty: "",
} as const;

export type LoanDataDtoEducationLevelEnum =
  (typeof LoanDataDtoEducationLevelEnum)[keyof typeof LoanDataDtoEducationLevelEnum];
export const LoanDataDtoMaritalStatusEnum = {
  Single: "SINGLE",
  MarriedSeparationProperty: "MARRIED_SEPARATION_PROPERTY",
  MarriedCommunionProperty: "MARRIED_COMMUNION_PROPERTY",
  Cohabiting: "COHABITING",
  Divorced: "DIVORCED",
  Separated: "SEPARATED",
  WidowEr: "WIDOW_ER",
} as const;

export type LoanDataDtoMaritalStatusEnum =
  (typeof LoanDataDtoMaritalStatusEnum)[keyof typeof LoanDataDtoMaritalStatusEnum];
export const LoanDataDtoNumHouseholdMembersEnum = {
  One: "ONE",
  Two: "TWO",
  Three: "THREE",
  Four: "FOUR",
  More: "MORE",
  Empty: "",
} as const;

export type LoanDataDtoNumHouseholdMembersEnum =
  (typeof LoanDataDtoNumHouseholdMembersEnum)[keyof typeof LoanDataDtoNumHouseholdMembersEnum];
export const LoanDataDtoPeopleWithIncomeEnum = {
  One: "ONE",
  Two: "TWO",
  Three: "THREE",
  Four: "FOUR",
  More: "MORE",
  Empty: "",
} as const;

export type LoanDataDtoPeopleWithIncomeEnum =
  (typeof LoanDataDtoPeopleWithIncomeEnum)[keyof typeof LoanDataDtoPeopleWithIncomeEnum];

/**
 *
 * @export
 * @interface LoanIntent
 */
export interface LoanIntent {
  /**
   *
   * @type {number}
   * @memberof LoanIntent
   */
  amount?: number;
  /**
   *
   * @type {string}
   * @memberof LoanIntent
   */
  purpose?: LoanIntentPurposeEnum;
  /**
   *
   * @type {number}
   * @memberof LoanIntent
   */
  term?: number;
  /**
   *
   * @type {number}
   * @memberof LoanIntent
   */
  tan?: number;
  /**
   *
   * @type {number}
   * @memberof LoanIntent
   */
  taeg?: number;
  /**
   *
   * @type {boolean}
   * @memberof LoanIntent
   */
  insurance?: boolean;
  /**
   *
   * @type {number}
   * @memberof LoanIntent
   */
  installmentsAmount?: number;
}

export const LoanIntentPurposeEnum = {
  DebtConsolidation: "DEBT_CONSOLIDATION",
  EstheticsWellbeing: "ESTHETICS_WELLBEING",
  MedicalExpenses: "MEDICAL_EXPENSES",
  StudyingTrainingCourses: "STUDYING_TRAINING_COURSES",
  Wedding: "WEDDING",
  Travels: "TRAVELS",
  Other: "OTHER",
  HomeImprovement: "HOME_IMPROVEMENT",
  Furniture: "FURNITURE",
  RealEstateBoxPurchase: "REAL_ESTATE_BOX_PURCHASE",
  NewUsedMotorbike: "NEW_USED_MOTORBIKE",
  NewCar: "NEW_CAR",
  UsedCar: "USED_CAR",
  Liquidity: "LIQUIDITY",
} as const;

export type LoanIntentPurposeEnum =
  (typeof LoanIntentPurposeEnum)[keyof typeof LoanIntentPurposeEnum];

/**
 *
 * @export
 * @interface MaritalStatusRequest
 */
export interface MaritalStatusRequest {
  /**
   *
   * @type {string}
   * @memberof MaritalStatusRequest
   */
  maritalStatus?: MaritalStatusRequestMaritalStatusEnum;
}

export const MaritalStatusRequestMaritalStatusEnum = {
  Single: "SINGLE",
  MarriedSeparationProperty: "MARRIED_SEPARATION_PROPERTY",
  MarriedCommunionProperty: "MARRIED_COMMUNION_PROPERTY",
  Cohabiting: "COHABITING",
  Divorced: "DIVORCED",
  Separated: "SEPARATED",
  WidowEr: "WIDOW_ER",
} as const;

export type MaritalStatusRequestMaritalStatusEnum =
  (typeof MaritalStatusRequestMaritalStatusEnum)[keyof typeof MaritalStatusRequestMaritalStatusEnum];

/**
 *
 * @export
 * @interface Metadata
 */
export interface Metadata {
  /**
   *
   * @type {string}
   * @memberof Metadata
   */
  channel: MetadataChannelEnum;
  /**
   * Id del operatore
   * @type {string}
   * @memberof Metadata
   */
  operatorId?: string;
}

export const MetadataChannelEnum = {
  Conte: "CONTE",
  Pol: "POL",
  Facile: "FACILE",
  Lead: "LEAD",
} as const;

export type MetadataChannelEnum =
  (typeof MetadataChannelEnum)[keyof typeof MetadataChannelEnum];

/**
 *
 * @export
 * @interface NamirialSignUploadResponse
 */
export interface NamirialSignUploadResponse {
  /**
   *
   * @type {string}
   * @memberof NamirialSignUploadResponse
   */
  documentId?: string;
}
/**
 *
 * @export
 * @interface NamirialStartSessionRequest
 */
export interface NamirialStartSessionRequest {
  /**
   *
   * @type {Array<SignSessionDocuments>}
   * @memberof NamirialStartSessionRequest
   */
  documents?: Array<SignSessionDocuments>;
  /**
   *
   * @type {Array<Signers>}
   * @memberof NamirialStartSessionRequest
   */
  signers?: Array<Signers>;
  /**
   *
   * @type {string}
   * @memberof NamirialStartSessionRequest
   */
  positionId?: string;
}
/**
 *
 * @export
 * @interface NamirialStartSessionResponse
 */
export interface NamirialStartSessionResponse {
  /**
   *
   * @type {string}
   * @memberof NamirialStartSessionResponse
   */
  envelopeId?: string;
}
/**
 *
 * @export
 * @interface NegotiationBeneficiaryRequest
 */
export interface NegotiationBeneficiaryRequest {
  /**
   *
   * @type {boolean}
   * @memberof NegotiationBeneficiaryRequest
   */
  heir?: boolean;
  /**
   *
   * @type {Array<Specific>}
   * @memberof NegotiationBeneficiaryRequest
   */
  specific?: Array<Specific>;
  /**
   *
   * @type {ThirdParty}
   * @memberof NegotiationBeneficiaryRequest
   */
  thirdParty?: ThirdParty;
}
/**
 *
 * @export
 * @interface NegotiationIbanRequest
 */
export interface NegotiationIbanRequest {
  /**
   *
   * @type {string}
   * @memberof NegotiationIbanRequest
   */
  iban?: string;
}
/**
 *
 * @export
 * @interface NegotiationInsuranceRequest
 */
export interface NegotiationInsuranceRequest {
  /**
   *
   * @type {boolean}
   * @memberof NegotiationInsuranceRequest
   */
  insurance?: boolean;
}
/**
 *
 * @export
 * @interface NotificationResponse
 */
export interface NotificationResponse {
  /**
   *
   * @type {number}
   * @memberof NotificationResponse
   */
  semaphore?: number;
  /**
   *
   * @type {string}
   * @memberof NotificationResponse
   */
  message?: string;
}
/**
 *
 * @export
 * @interface Offer
 */
export interface Offer {
  /**
   *
   * @type {number}
   * @memberof Offer
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof Offer
   */
  tan?: number;
  /**
   *
   * @type {number}
   * @memberof Offer
   */
  taeg?: number;
  /**
   *
   * @type {number}
   * @memberof Offer
   */
  installmentsAmount?: number;
  /**
   *
   * @type {number}
   * @memberof Offer
   */
  financedAmount?: number;
}
/**
 *
 * @export
 * @interface OfferListResponse
 */
export interface OfferListResponse {
  /**
   *
   * @type {Array<OfferResponse>}
   * @memberof OfferListResponse
   */
  offers?: Array<OfferResponse>;
  /**
   *
   * @type {number}
   * @memberof OfferListResponse
   */
  offersAttempts?: number;
}
/**
 * Dati anagrafici base - sempre presenti al momento dell\'invio
 * @export
 * @interface OfferRequestCustomer
 */
export interface OfferRequestCustomer {
  /**
   *
   * @type {string}
   * @memberof OfferRequestCustomer
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof OfferRequestCustomer
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof OfferRequestCustomer
   */
  fiscalCode: string;
  /**
   *
   * @type {string}
   * @memberof OfferRequestCustomer
   */
  birthDate: string;
  /**
   *
   * @type {string}
   * @memberof OfferRequestCustomer
   */
  gender: OfferRequestCustomerGenderEnum;
  /**
   *
   * @type {string}
   * @memberof OfferRequestCustomer
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof OfferRequestCustomer
   */
  phoneNumber: string;
  /**
   * (opzionale)
   * @type {string}
   * @memberof OfferRequestCustomer
   */
  birthCity?: string;
  /**
   * Sigla provincia di nascita. Indicare sempre EE in caso di cliente nato all\'estero
   * @type {string}
   * @memberof OfferRequestCustomer
   */
  birthProvince?: string;
  /**
   * Paese di nascita in formato ISO 3166-1 alpha-3
   * @type {string}
   * @memberof OfferRequestCustomer
   */
  birthCountry: string;
  /**
   * Nazionalita in formato ISO 3166-1 alpha-3
   * @type {string}
   * @memberof OfferRequestCustomer
   */
  nationality: string;
  /**
   * ### 6.3 Stato civile  | ID | Stato civile | | :--- | :--- | | 1 | Celibe/Nubile | | 2 | Coniugato/a | | 3 | Divorziato/a | | 4 | Separato/a | | 5 | Vedovo/a | | 6 | Convivente |
   * @type {number}
   * @memberof OfferRequestCustomer
   */
  maritalStatus: number;
  /**
   * numero componenti nucleo familiare
   * @type {number}
   * @memberof OfferRequestCustomer
   */
  numFamilyMembers: number;
  /**
   * numero componenti nucleo familiare con reddito
   * @type {number}
   * @memberof OfferRequestCustomer
   */
  numFamilyMembersWithIncome: number;
  /**
   * ### 6.11 Titolo di Studio  | ID | Titolo di Studio | | :--- | :--- | | 1 | Scuole elementari | | 2 | Scuole medie | | 3 | Diploma liceo/ Istituto tecnico | | 4 | Laurea Triennale | | 5 | Laurea Magistrale | | 6 | Master/ Dottorato di ricerca |
   * @type {number}
   * @memberof OfferRequestCustomer
   */
  degree?: number;
  /**
   * informazioni relative al device e browser del cliente
   * @type {ClientInfo}
   * @memberof OfferRequestCustomer
   */
  clientInfo?: ClientInfo;
}

export const OfferRequestCustomerGenderEnum = {
  M: "M",
  F: "F",
} as const;

export type OfferRequestCustomerGenderEnum =
  (typeof OfferRequestCustomerGenderEnum)[keyof typeof OfferRequestCustomerGenderEnum];

/**
 *
 * @export
 * @interface OfferResponse
 */
export interface OfferResponse {
  /**
   *
   * @type {string}
   * @memberof OfferResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof OfferResponse
   */
  groupId?: string;
  /**
   *
   * @type {number}
   * @memberof OfferResponse
   */
  requestedAmount?: number;
  /**
   *
   * @type {number}
   * @memberof OfferResponse
   */
  installmentsAmount?: number;
  /**
   *
   * @type {number}
   * @memberof OfferResponse
   */
  installmentsCount?: number;
  /**
   *
   * @type {number}
   * @memberof OfferResponse
   */
  tan?: number;
  /**
   *
   * @type {number}
   * @memberof OfferResponse
   */
  taeg?: number;
  /**
   *
   * @type {number}
   * @memberof OfferResponse
   */
  interests?: number;
  /**
   *
   * @type {string}
   * @memberof OfferResponse
   */
  insurance?: string;
  /**
   *
   * @type {boolean}
   * @memberof OfferResponse
   */
  isDiscounted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OfferResponse
   */
  isSelected?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OfferResponse
   */
  isFastQuotation?: boolean;
  /**
   *
   * @type {number}
   * @memberof OfferResponse
   */
  totalAmount?: number;
}
/**
 *
 * @export
 * @interface OpenBankingDataDto
 */
export interface OpenBankingDataDto {
  /**
   *
   * @type {Array<any>}
   * @memberof OpenBankingDataDto
   */
  listAccounts?: Array<any>;
  /**
   *
   * @type {Array<any>}
   * @memberof OpenBankingDataDto
   */
  incomeChecks?: Array<any>;
  /**
   *
   * @type {Array<any>}
   * @memberof OpenBankingDataDto
   */
  transactions?: Array<any>;
  /**
   *
   * @type {string}
   * @memberof OpenBankingDataDto
   */
  applicationId?: string;
}
/**
 *
 * @export
 * @interface OrchSurveyRequest
 */
export interface OrchSurveyRequest {
  /**
   *
   * @type {Array<SurveyRequests>}
   * @memberof OrchSurveyRequest
   */
  surveyRequests?: Array<SurveyRequests>;
  /**
   *
   * @type {string}
   * @memberof OrchSurveyRequest
   */
  outcome?: string;
}
/**
 *
 * @export
 * @interface Outcome
 */
export interface Outcome {
  /**
   *
   * @type {string}
   * @memberof Outcome
   */
  status?: OutcomeStatusEnum;
  /**
   * Outcome code.  | Code | Description | | :--- | :--- | | AGGREGATOR_SUCCESS | Redirect URL generated successfully | | ERR-GEN | Unexpected generic error | | ERR-PR-1 | Active / in-evaluation practice already exists | | ERR-REQ-1 | Request already exists | | ERR-ANA-1 | Personal data incorrect or incomplete | | ERR-IND-1 | Address incorrect or incomplete | | ERR-FAM-1 | Inconsistent family members data | | ERR-DATE-1 | Invalid date format | | ERR-DATE-2 | Hiring date and birth date are inconsistent | | ERR-CF-1 | Invalid fiscal code | | ERR-GEND-1 | Invalid gender value (expected M or F) | | ERR-PRE-OFF-1 | Error processing pre-offer information | | ERR-OFF-1 | Error during offer calculation | | ERR-OFF-2 | Error during offer calculation with CPI | | DECLINE-1 | Offer not available for the customer\'s profile |
   * @type {string}
   * @memberof Outcome
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof Outcome
   */
  message?: string;
}

export const OutcomeStatusEnum = {
  Ok: "OK",
  Ko: "KO",
} as const;

export type OutcomeStatusEnum =
  (typeof OutcomeStatusEnum)[keyof typeof OutcomeStatusEnum];

/**
 *
 * @export
 * @interface PBAffordability
 */
export interface PBAffordability {
  /**
   *
   * @type {string}
   * @memberof PBAffordability
   */
  mdi?: PBAffordabilityMdiEnum;
  /**
   *
   * @type {string}
   * @memberof PBAffordability
   */
  dti?: PBAffordabilityDtiEnum;
  /**
   *
   * @type {string}
   * @memberof PBAffordability
   */
  dd?: PBAffordabilityDdEnum;
  /**
   *
   * @type {string}
   * @memberof PBAffordability
   */
  dtiDd?: PBAffordabilityDtiDdEnum;
  /**
   *
   * @type {string}
   * @memberof PBAffordability
   */
  affordability?: PBAffordabilityAffordabilityEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  houseexpensesSameAddressCombinata?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  houseexpensesIstat?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  houseexpensesIstatCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  livingExpenses?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  livingExpensesCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  monthlyDisposableincome?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  debtToIncome?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  debtDuration?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  unsecuredebts?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  mortgageInstallment?: number;
  /**
   *
   * @type {boolean}
   * @memberof PBAffordability
   */
  homeowner?: boolean;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  revolvingProducts?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  totalExposure?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  unsecuredebtsCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  mortgageInstallmentCoobligato?: number;
  /**
   *
   * @type {boolean}
   * @memberof PBAffordability
   */
  homeownerCoobligato?: boolean;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  revolvingProductsCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordability
   */
  totalExposureCoobligato?: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordability
   */
  idPratica?: string;
}

export const PBAffordabilityMdiEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBAffordabilityMdiEnum =
  (typeof PBAffordabilityMdiEnum)[keyof typeof PBAffordabilityMdiEnum];
export const PBAffordabilityDtiEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBAffordabilityDtiEnum =
  (typeof PBAffordabilityDtiEnum)[keyof typeof PBAffordabilityDtiEnum];
export const PBAffordabilityDdEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBAffordabilityDdEnum =
  (typeof PBAffordabilityDdEnum)[keyof typeof PBAffordabilityDdEnum];
export const PBAffordabilityDtiDdEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBAffordabilityDtiDdEnum =
  (typeof PBAffordabilityDtiDdEnum)[keyof typeof PBAffordabilityDtiDdEnum];
export const PBAffordabilityAffordabilityEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBAffordabilityAffordabilityEnum =
  (typeof PBAffordabilityAffordabilityEnum)[keyof typeof PBAffordabilityAffordabilityEnum];

/**
 *
 * @export
 * @interface PBAffordabilityAggregated
 */
export interface PBAffordabilityAggregated {
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityAggregated
   */
  mdi?: PBAffordabilityAggregatedMdiEnum;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityAggregated
   */
  dti?: PBAffordabilityAggregatedDtiEnum;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityAggregated
   */
  dd?: PBAffordabilityAggregatedDdEnum;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityAggregated
   */
  dtiDd?: PBAffordabilityAggregatedDtiDdEnum;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityAggregated
   */
  affordability?: PBAffordabilityAggregatedAffordabilityEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  houseexpensesSameAddressCombinata?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  houseexpensesIstat?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  houseexpensesIstatCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  livingExpenses?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  livingExpensesCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  monthlyDisposableincome?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  debtToIncome?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  debtDuration?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  unsecuredebts?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  mortgageInstallment?: number;
  /**
   *
   * @type {boolean}
   * @memberof PBAffordabilityAggregated
   */
  homeowner?: boolean;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  revolvingProducts?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  totalExposure?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  unsecuredebtsCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  mortgageInstallmentCoobligato?: number;
  /**
   *
   * @type {boolean}
   * @memberof PBAffordabilityAggregated
   */
  homeownerCoobligato?: boolean;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  revolvingProductsCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityAggregated
   */
  totalExposureCoobligato?: number;
}

export const PBAffordabilityAggregatedMdiEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBAffordabilityAggregatedMdiEnum =
  (typeof PBAffordabilityAggregatedMdiEnum)[keyof typeof PBAffordabilityAggregatedMdiEnum];
export const PBAffordabilityAggregatedDtiEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBAffordabilityAggregatedDtiEnum =
  (typeof PBAffordabilityAggregatedDtiEnum)[keyof typeof PBAffordabilityAggregatedDtiEnum];
export const PBAffordabilityAggregatedDdEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBAffordabilityAggregatedDdEnum =
  (typeof PBAffordabilityAggregatedDdEnum)[keyof typeof PBAffordabilityAggregatedDdEnum];
export const PBAffordabilityAggregatedDtiDdEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBAffordabilityAggregatedDtiDdEnum =
  (typeof PBAffordabilityAggregatedDtiDdEnum)[keyof typeof PBAffordabilityAggregatedDtiDdEnum];
export const PBAffordabilityAggregatedAffordabilityEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBAffordabilityAggregatedAffordabilityEnum =
  (typeof PBAffordabilityAggregatedAffordabilityEnum)[keyof typeof PBAffordabilityAggregatedAffordabilityEnum];

/**
 *
 * @export
 * @interface PBAffordabilityInput
 */
export interface PBAffordabilityInput {
  /**
   *
   * @type {boolean}
   * @memberof PBAffordabilityInput
   */
  richiestaCoobbligata?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PBAffordabilityInput
   */
  sameAddress?: boolean;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInput
   */
  rapportocoobligato?: string;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  netmonthlyIncome: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  requestedLoanAmount: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  netmonthlyIncomeCoobligato?: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInput
   */
  maritalStatusCoobligato?: PBAffordabilityInputMaritalStatusCoobligatoEnum;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInput
   */
  maritalStatus: PBAffordabilityInputMaritalStatusEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  numHouseholdMembers: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  peopleWithIncome: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInput
   */
  italianProvince: PBAffordabilityInputItalianProvinceEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  zipCode: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  age: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInput
   */
  homeStatus: PBAffordabilityInputHomeStatusEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  totalMonthlyInstallmentsAmountEur?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  numHouseholdMembersCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  peopleWithIncomeCoobligato?: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInput
   */
  italianProvinceCoobligato?: PBAffordabilityInputItalianProvinceCoobligatoEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  zipCodeCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  ageCoobligato?: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInput
   */
  homeStatusCoobligato?: PBAffordabilityInputHomeStatusCoobligatoEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInput
   */
  totalMonthlyInstallmentsAmountEurCoobligato?: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInput
   */
  otherExpensesMonthly?: string;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInput
   */
  otherExpensesMonthlyCoobligato?: string;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInput
   */
  employmentStatus?: string;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesCrifInner>}
   * @memberof PBAffordabilityInput
   */
  externalValuesCrif?: Array<PBAffordabilityInputExternalValuesCrifInner>;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesCtcInner>}
   * @memberof PBAffordabilityInput
   */
  externalValuesCtc?: Array<PBAffordabilityInputExternalValuesCtcInner>;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesExperianInner>}
   * @memberof PBAffordabilityInput
   */
  externalValuesExperian?: Array<PBAffordabilityInputExternalValuesExperianInner>;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesCrifInner>}
   * @memberof PBAffordabilityInput
   */
  externalValuesCrifCoobligato?: Array<PBAffordabilityInputExternalValuesCrifInner>;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesCtcInner>}
   * @memberof PBAffordabilityInput
   */
  externalValuesCtcCoobligato?: Array<PBAffordabilityInputExternalValuesCtcInner>;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesExperianInner>}
   * @memberof PBAffordabilityInput
   */
  externalValuesExperianCoobligato?: Array<PBAffordabilityInputExternalValuesExperianInner>;
}

export const PBAffordabilityInputMaritalStatusCoobligatoEnum = {
  Single: "SINGLE",
  MarriedCommunionProperty: "MARRIED_COMMUNION_PROPERTY",
  MarriedSeparationProperty: "MARRIED_SEPARATION_PROPERTY",
  Cohabiting: "COHABITING",
  Divorced: "DIVORCED",
  Separated: "SEPARATED",
  WidowEr: "WIDOW_ER",
} as const;

export type PBAffordabilityInputMaritalStatusCoobligatoEnum =
  (typeof PBAffordabilityInputMaritalStatusCoobligatoEnum)[keyof typeof PBAffordabilityInputMaritalStatusCoobligatoEnum];
export const PBAffordabilityInputMaritalStatusEnum = {
  Single: "SINGLE",
  MarriedCommunionProperty: "MARRIED_COMMUNION_PROPERTY",
  MarriedSeparationProperty: "MARRIED_SEPARATION_PROPERTY",
  Cohabiting: "COHABITING",
  Divorced: "DIVORCED",
  Separated: "SEPARATED",
  WidowEr: "WIDOW_ER",
} as const;

export type PBAffordabilityInputMaritalStatusEnum =
  (typeof PBAffordabilityInputMaritalStatusEnum)[keyof typeof PBAffordabilityInputMaritalStatusEnum];
export const PBAffordabilityInputItalianProvinceEnum = {
  Mo: "MO",
  Tn: "TN",
  Mb: "MB",
  Bi: "BI",
  Bz: "BZ",
  Re: "RE",
  Vr: "VR",
  Pi: "PI",
  Vi: "VI",
  Va: "VA",
  Pd: "PD",
  Po: "PO",
  Pr: "PR",
  Cr: "CR",
  Lu: "LU",
  Lo: "LO",
  Bo: "BO",
  Co: "CO",
  Si: "SI",
  Tv: "TV",
  Pt: "PT",
  Ao: "AO",
  Pc: "PC",
  No: "NO",
  Ra: "RA",
  Lc: "LC",
  Cn: "CN",
  Pv: "PV",
  Vc: "VC",
  Bl: "BL",
  Ar: "AR",
  Ud: "UD",
  Fe: "FE",
  Ro: "RO",
  Fi: "FI",
  Fc: "FC",
  Pg: "PG",
  Mn: "MN",
  Al: "AL",
  Bs: "BS",
  Vb: "VB",
  Pn: "PN",
  To: "TO",
  At: "AT",
  Mi: "MI",
  Bg: "BG",
  Pu: "PU",
  An: "AN",
  Ms: "MS",
  Li: "LI",
  Mc: "MC",
  Ve: "VE",
  Ts: "TS",
  So: "SO",
  Ap: "AP",
  Go: "GO",
  Tr: "TR",
  Gr: "GR",
  Rn: "RN",
  Sp: "SP",
  Rm: "RM",
  Fm: "FM",
  Sv: "SV",
  Ge: "GE",
  Is: "IS",
  Te: "TE",
  Pe: "PE",
  Aq: "AQ",
  Ch: "CH",
  Cb: "CB",
  Im: "IM",
  Fr: "FR",
  Vt: "VT",
  Ca: "CA",
  Ri: "RI",
  Lt: "LT",
  Ba: "BA",
  Ct: "CT",
  Sr: "SR",
  Br: "BR",
  Pa: "PA",
  Ta: "TA",
  Pz: "PZ",
  Fg: "FG",
  Mt: "MT",
  Su: "SU",
  Cz: "CZ",
  Rc: "RC",
  Le: "LE",
  Av: "AV",
  Nu: "NU",
  Vv: "VV",
  Or: "OR",
  Bt: "BT",
  Sa: "SA",
  Rg: "RG",
  Na: "NA",
  Tp: "TP",
  Me: "ME",
  Bn: "BN",
  Ss: "SS",
  Cs: "CS",
  Cl: "CL",
  Ce: "CE",
  Ag: "AG",
  En: "EN",
  Kr: "KR",
} as const;

export type PBAffordabilityInputItalianProvinceEnum =
  (typeof PBAffordabilityInputItalianProvinceEnum)[keyof typeof PBAffordabilityInputItalianProvinceEnum];
export const PBAffordabilityInputHomeStatusEnum = {
  Owner: "OWNER",
  Mortgage: "MORTGAGE",
  Rent: "RENT",
  Other: "OTHER",
  Family: "FAMILY",
  Employer: "EMPLOYER",
  ThirdParties: "THIRD_PARTIES",
} as const;

export type PBAffordabilityInputHomeStatusEnum =
  (typeof PBAffordabilityInputHomeStatusEnum)[keyof typeof PBAffordabilityInputHomeStatusEnum];
export const PBAffordabilityInputItalianProvinceCoobligatoEnum = {
  Mo: "MO",
  Tn: "TN",
  Mb: "MB",
  Bi: "BI",
  Bz: "BZ",
  Re: "RE",
  Vr: "VR",
  Pi: "PI",
  Vi: "VI",
  Va: "VA",
  Pd: "PD",
  Po: "PO",
  Pr: "PR",
  Cr: "CR",
  Lu: "LU",
  Lo: "LO",
  Bo: "BO",
  Co: "CO",
  Si: "SI",
  Tv: "TV",
  Pt: "PT",
  Ao: "AO",
  Pc: "PC",
  No: "NO",
  Ra: "RA",
  Lc: "LC",
  Cn: "CN",
  Pv: "PV",
  Vc: "VC",
  Bl: "BL",
  Ar: "AR",
  Ud: "UD",
  Fe: "FE",
  Ro: "RO",
  Fi: "FI",
  Fc: "FC",
  Pg: "PG",
  Mn: "MN",
  Al: "AL",
  Bs: "BS",
  Vb: "VB",
  Pn: "PN",
  To: "TO",
  At: "AT",
  Mi: "MI",
  Bg: "BG",
  Pu: "PU",
  An: "AN",
  Ms: "MS",
  Li: "LI",
  Mc: "MC",
  Ve: "VE",
  Ts: "TS",
  So: "SO",
  Ap: "AP",
  Go: "GO",
  Tr: "TR",
  Gr: "GR",
  Rn: "RN",
  Sp: "SP",
  Rm: "RM",
  Fm: "FM",
  Sv: "SV",
  Ge: "GE",
  Is: "IS",
  Te: "TE",
  Pe: "PE",
  Aq: "AQ",
  Ch: "CH",
  Cb: "CB",
  Im: "IM",
  Fr: "FR",
  Vt: "VT",
  Ca: "CA",
  Ri: "RI",
  Lt: "LT",
  Ba: "BA",
  Ct: "CT",
  Sr: "SR",
  Br: "BR",
  Pa: "PA",
  Ta: "TA",
  Pz: "PZ",
  Fg: "FG",
  Mt: "MT",
  Su: "SU",
  Cz: "CZ",
  Rc: "RC",
  Le: "LE",
  Av: "AV",
  Nu: "NU",
  Vv: "VV",
  Or: "OR",
  Bt: "BT",
  Sa: "SA",
  Rg: "RG",
  Na: "NA",
  Tp: "TP",
  Me: "ME",
  Bn: "BN",
  Ss: "SS",
  Cs: "CS",
  Cl: "CL",
  Ce: "CE",
  Ag: "AG",
  En: "EN",
  Kr: "KR",
} as const;

export type PBAffordabilityInputItalianProvinceCoobligatoEnum =
  (typeof PBAffordabilityInputItalianProvinceCoobligatoEnum)[keyof typeof PBAffordabilityInputItalianProvinceCoobligatoEnum];
export const PBAffordabilityInputHomeStatusCoobligatoEnum = {
  Owner: "OWNER",
  Mortgage: "MORTGAGE",
  Rent: "RENT",
  Other: "OTHER",
  Family: "FAMILY",
  Employer: "EMPLOYER",
  ThirdParties: "THIRD_PARTIES",
} as const;

export type PBAffordabilityInputHomeStatusCoobligatoEnum =
  (typeof PBAffordabilityInputHomeStatusCoobligatoEnum)[keyof typeof PBAffordabilityInputHomeStatusCoobligatoEnum];

/**
 *
 * @export
 * @interface PBAffordabilityInputExternalValuesCrifInner
 */
export interface PBAffordabilityInputExternalValuesCrifInner {
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputExternalValuesCrifInner
   */
  id: string;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesCrifInnerFieldsInner>}
   * @memberof PBAffordabilityInputExternalValuesCrifInner
   */
  fields: Array<PBAffordabilityInputExternalValuesCrifInnerFieldsInner>;
}
/**
 *
 * @export
 * @interface PBAffordabilityInputExternalValuesCrifInnerFieldsInner
 */
export interface PBAffordabilityInputExternalValuesCrifInnerFieldsInner {
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputExternalValuesCrifInnerFieldsInner
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputExternalValuesCrifInnerFieldsInner
   */
  value: string;
}
/**
 *
 * @export
 * @interface PBAffordabilityInputExternalValuesCtcInner
 */
export interface PBAffordabilityInputExternalValuesCtcInner {
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputExternalValuesCtcInner
   */
  id: string;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesCtcInnerFieldsInner>}
   * @memberof PBAffordabilityInputExternalValuesCtcInner
   */
  fields: Array<PBAffordabilityInputExternalValuesCtcInnerFieldsInner>;
}
/**
 *
 * @export
 * @interface PBAffordabilityInputExternalValuesCtcInnerFieldsInner
 */
export interface PBAffordabilityInputExternalValuesCtcInnerFieldsInner {
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputExternalValuesCtcInnerFieldsInner
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputExternalValuesCtcInnerFieldsInner
   */
  value: string;
}
/**
 *
 * @export
 * @interface PBAffordabilityInputExternalValuesExperianInner
 */
export interface PBAffordabilityInputExternalValuesExperianInner {
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputExternalValuesExperianInner
   */
  id: string;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesExperianInnerFieldsInner>}
   * @memberof PBAffordabilityInputExternalValuesExperianInner
   */
  fields: Array<PBAffordabilityInputExternalValuesExperianInnerFieldsInner>;
}
/**
 *
 * @export
 * @interface PBAffordabilityInputExternalValuesExperianInnerFieldsInner
 */
export interface PBAffordabilityInputExternalValuesExperianInnerFieldsInner {
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputExternalValuesExperianInnerFieldsInner
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputExternalValuesExperianInnerFieldsInner
   */
  value: string;
}
/**
 *
 * @export
 * @interface PBAffordabilityInputWithAddictionValues
 */
export interface PBAffordabilityInputWithAddictionValues {
  /**
   *
   * @type {boolean}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  richiestaCoobbligata?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  sameAddress?: boolean;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  rapportocoobligato?: string;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  netmonthlyIncome: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  requestedLoanAmount: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  netmonthlyIncomeCoobligato?: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  maritalStatusCoobligato?: PBAffordabilityInputWithAddictionValuesMaritalStatusCoobligatoEnum;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  maritalStatus: PBAffordabilityInputWithAddictionValuesMaritalStatusEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  numHouseholdMembers: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  peopleWithIncome: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  italianProvince: PBAffordabilityInputWithAddictionValuesItalianProvinceEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  zipCode: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  age: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  homeStatus: PBAffordabilityInputWithAddictionValuesHomeStatusEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  totalMonthlyInstallmentsAmountEur?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  numHouseholdMembersCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  peopleWithIncomeCoobligato?: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  italianProvinceCoobligato?: PBAffordabilityInputWithAddictionValuesItalianProvinceCoobligatoEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  zipCodeCoobligato?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  ageCoobligato?: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  homeStatusCoobligato?: PBAffordabilityInputWithAddictionValuesHomeStatusCoobligatoEnum;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  totalMonthlyInstallmentsAmountEurCoobligato?: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  otherExpensesMonthly?: string;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  otherExpensesMonthlyCoobligato?: string;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  employmentStatus?: string;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesCrifInner>}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  externalValuesCrif?: Array<PBAffordabilityInputExternalValuesCrifInner>;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesCtcInner>}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  externalValuesCtc?: Array<PBAffordabilityInputExternalValuesCtcInner>;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesExperianInner>}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  externalValuesExperian?: Array<PBAffordabilityInputExternalValuesExperianInner>;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesCrifInner>}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  externalValuesCrifCoobligato?: Array<PBAffordabilityInputExternalValuesCrifInner>;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesCtcInner>}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  externalValuesCtcCoobligato?: Array<PBAffordabilityInputExternalValuesCtcInner>;
  /**
   *
   * @type {Array<PBAffordabilityInputExternalValuesExperianInner>}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  externalValuesExperianCoobligato?: Array<PBAffordabilityInputExternalValuesExperianInner>;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  monthlyInstallment: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  purpose?: PBAffordabilityInputWithAddictionValuesPurposeEnum;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  idPratica: string;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  pdClass?: number;
  /**
   *
   * @type {number}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  pdClassCoobligato?: number;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  channel?: string;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  managmentChannel?: string;
  /**
   *
   * @type {string}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  loanTerm?: string;
  /**
   *
   * @type {Array<PBAggregateAllServiceRequestObbligationInner>}
   * @memberof PBAffordabilityInputWithAddictionValues
   */
  obbligation?: Array<PBAggregateAllServiceRequestObbligationInner>;
}

export const PBAffordabilityInputWithAddictionValuesMaritalStatusCoobligatoEnum =
  {
    Single: "SINGLE",
    MarriedCommunionProperty: "MARRIED_COMMUNION_PROPERTY",
    MarriedSeparationProperty: "MARRIED_SEPARATION_PROPERTY",
    Cohabiting: "COHABITING",
    Divorced: "DIVORCED",
    Separated: "SEPARATED",
    WidowEr: "WIDOW_ER",
  } as const;

export type PBAffordabilityInputWithAddictionValuesMaritalStatusCoobligatoEnum =
  (typeof PBAffordabilityInputWithAddictionValuesMaritalStatusCoobligatoEnum)[keyof typeof PBAffordabilityInputWithAddictionValuesMaritalStatusCoobligatoEnum];
export const PBAffordabilityInputWithAddictionValuesMaritalStatusEnum = {
  Single: "SINGLE",
  MarriedCommunionProperty: "MARRIED_COMMUNION_PROPERTY",
  MarriedSeparationProperty: "MARRIED_SEPARATION_PROPERTY",
  Cohabiting: "COHABITING",
  Divorced: "DIVORCED",
  Separated: "SEPARATED",
  WidowEr: "WIDOW_ER",
} as const;

export type PBAffordabilityInputWithAddictionValuesMaritalStatusEnum =
  (typeof PBAffordabilityInputWithAddictionValuesMaritalStatusEnum)[keyof typeof PBAffordabilityInputWithAddictionValuesMaritalStatusEnum];
export const PBAffordabilityInputWithAddictionValuesItalianProvinceEnum = {
  Mo: "MO",
  Tn: "TN",
  Mb: "MB",
  Bi: "BI",
  Bz: "BZ",
  Re: "RE",
  Vr: "VR",
  Pi: "PI",
  Vi: "VI",
  Va: "VA",
  Pd: "PD",
  Po: "PO",
  Pr: "PR",
  Cr: "CR",
  Lu: "LU",
  Lo: "LO",
  Bo: "BO",
  Co: "CO",
  Si: "SI",
  Tv: "TV",
  Pt: "PT",
  Ao: "AO",
  Pc: "PC",
  No: "NO",
  Ra: "RA",
  Lc: "LC",
  Cn: "CN",
  Pv: "PV",
  Vc: "VC",
  Bl: "BL",
  Ar: "AR",
  Ud: "UD",
  Fe: "FE",
  Ro: "RO",
  Fi: "FI",
  Fc: "FC",
  Pg: "PG",
  Mn: "MN",
  Al: "AL",
  Bs: "BS",
  Vb: "VB",
  Pn: "PN",
  To: "TO",
  At: "AT",
  Mi: "MI",
  Bg: "BG",
  Pu: "PU",
  An: "AN",
  Ms: "MS",
  Li: "LI",
  Mc: "MC",
  Ve: "VE",
  Ts: "TS",
  So: "SO",
  Ap: "AP",
  Go: "GO",
  Tr: "TR",
  Gr: "GR",
  Rn: "RN",
  Sp: "SP",
  Rm: "RM",
  Fm: "FM",
  Sv: "SV",
  Ge: "GE",
  Is: "IS",
  Te: "TE",
  Pe: "PE",
  Aq: "AQ",
  Ch: "CH",
  Cb: "CB",
  Im: "IM",
  Fr: "FR",
  Vt: "VT",
  Ca: "CA",
  Ri: "RI",
  Lt: "LT",
  Ba: "BA",
  Ct: "CT",
  Sr: "SR",
  Br: "BR",
  Pa: "PA",
  Ta: "TA",
  Pz: "PZ",
  Fg: "FG",
  Mt: "MT",
  Su: "SU",
  Cz: "CZ",
  Rc: "RC",
  Le: "LE",
  Av: "AV",
  Nu: "NU",
  Vv: "VV",
  Or: "OR",
  Bt: "BT",
  Sa: "SA",
  Rg: "RG",
  Na: "NA",
  Tp: "TP",
  Me: "ME",
  Bn: "BN",
  Ss: "SS",
  Cs: "CS",
  Cl: "CL",
  Ce: "CE",
  Ag: "AG",
  En: "EN",
  Kr: "KR",
} as const;

export type PBAffordabilityInputWithAddictionValuesItalianProvinceEnum =
  (typeof PBAffordabilityInputWithAddictionValuesItalianProvinceEnum)[keyof typeof PBAffordabilityInputWithAddictionValuesItalianProvinceEnum];
export const PBAffordabilityInputWithAddictionValuesHomeStatusEnum = {
  Owner: "OWNER",
  Mortgage: "MORTGAGE",
  Rent: "RENT",
  Other: "OTHER",
  Family: "FAMILY",
  Employer: "EMPLOYER",
  ThirdParties: "THIRD_PARTIES",
} as const;

export type PBAffordabilityInputWithAddictionValuesHomeStatusEnum =
  (typeof PBAffordabilityInputWithAddictionValuesHomeStatusEnum)[keyof typeof PBAffordabilityInputWithAddictionValuesHomeStatusEnum];
export const PBAffordabilityInputWithAddictionValuesItalianProvinceCoobligatoEnum =
  {
    Mo: "MO",
    Tn: "TN",
    Mb: "MB",
    Bi: "BI",
    Bz: "BZ",
    Re: "RE",
    Vr: "VR",
    Pi: "PI",
    Vi: "VI",
    Va: "VA",
    Pd: "PD",
    Po: "PO",
    Pr: "PR",
    Cr: "CR",
    Lu: "LU",
    Lo: "LO",
    Bo: "BO",
    Co: "CO",
    Si: "SI",
    Tv: "TV",
    Pt: "PT",
    Ao: "AO",
    Pc: "PC",
    No: "NO",
    Ra: "RA",
    Lc: "LC",
    Cn: "CN",
    Pv: "PV",
    Vc: "VC",
    Bl: "BL",
    Ar: "AR",
    Ud: "UD",
    Fe: "FE",
    Ro: "RO",
    Fi: "FI",
    Fc: "FC",
    Pg: "PG",
    Mn: "MN",
    Al: "AL",
    Bs: "BS",
    Vb: "VB",
    Pn: "PN",
    To: "TO",
    At: "AT",
    Mi: "MI",
    Bg: "BG",
    Pu: "PU",
    An: "AN",
    Ms: "MS",
    Li: "LI",
    Mc: "MC",
    Ve: "VE",
    Ts: "TS",
    So: "SO",
    Ap: "AP",
    Go: "GO",
    Tr: "TR",
    Gr: "GR",
    Rn: "RN",
    Sp: "SP",
    Rm: "RM",
    Fm: "FM",
    Sv: "SV",
    Ge: "GE",
    Is: "IS",
    Te: "TE",
    Pe: "PE",
    Aq: "AQ",
    Ch: "CH",
    Cb: "CB",
    Im: "IM",
    Fr: "FR",
    Vt: "VT",
    Ca: "CA",
    Ri: "RI",
    Lt: "LT",
    Ba: "BA",
    Ct: "CT",
    Sr: "SR",
    Br: "BR",
    Pa: "PA",
    Ta: "TA",
    Pz: "PZ",
    Fg: "FG",
    Mt: "MT",
    Su: "SU",
    Cz: "CZ",
    Rc: "RC",
    Le: "LE",
    Av: "AV",
    Nu: "NU",
    Vv: "VV",
    Or: "OR",
    Bt: "BT",
    Sa: "SA",
    Rg: "RG",
    Na: "NA",
    Tp: "TP",
    Me: "ME",
    Bn: "BN",
    Ss: "SS",
    Cs: "CS",
    Cl: "CL",
    Ce: "CE",
    Ag: "AG",
    En: "EN",
    Kr: "KR",
  } as const;

export type PBAffordabilityInputWithAddictionValuesItalianProvinceCoobligatoEnum =
  (typeof PBAffordabilityInputWithAddictionValuesItalianProvinceCoobligatoEnum)[keyof typeof PBAffordabilityInputWithAddictionValuesItalianProvinceCoobligatoEnum];
export const PBAffordabilityInputWithAddictionValuesHomeStatusCoobligatoEnum = {
  Owner: "OWNER",
  Mortgage: "MORTGAGE",
  Rent: "RENT",
  Other: "OTHER",
  Family: "FAMILY",
  Employer: "EMPLOYER",
  ThirdParties: "THIRD_PARTIES",
} as const;

export type PBAffordabilityInputWithAddictionValuesHomeStatusCoobligatoEnum =
  (typeof PBAffordabilityInputWithAddictionValuesHomeStatusCoobligatoEnum)[keyof typeof PBAffordabilityInputWithAddictionValuesHomeStatusCoobligatoEnum];
export const PBAffordabilityInputWithAddictionValuesPurposeEnum = {
  DebtConsolidation: "DEBT_CONSOLIDATION",
  EstheticsWellbeing: "ESTHETICS_WELLBEING",
  MedicalExpenses: "MEDICAL_EXPENSES",
  StudyingTrainingCourses: "STUDYING_TRAINING_COURSES",
  Wedding: "WEDDING",
  Travels: "TRAVELS",
  Other: "OTHER",
  HomeImprovement: "HOME_IMPROVEMENT",
  Furniture: "FURNITURE",
  RealEstateBoxPurchase: "REAL_ESTATE_BOX_PURCHASE",
  NewUsedMotorbike: "NEW_USED_MOTORBIKE",
  NewCar: "NEW_CAR",
  UsedCar: "USED_CAR",
  Liquidity: "LIQUIDITY",
} as const;

export type PBAffordabilityInputWithAddictionValuesPurposeEnum =
  (typeof PBAffordabilityInputWithAddictionValuesPurposeEnum)[keyof typeof PBAffordabilityInputWithAddictionValuesPurposeEnum];

/**
 *
 * @export
 * @interface PBAggregateAllService200Response
 */
export interface PBAggregateAllService200Response {
  /**
   *
   * @type {Array<PBScoreCardAggregated>}
   * @memberof PBAggregateAllService200Response
   */
  scoreCard?: Array<PBScoreCardAggregated>;
  /**
   *
   * @type {Array<PBPricingAggregated>}
   * @memberof PBAggregateAllService200Response
   */
  pricing?: Array<PBPricingAggregated>;
  /**
   *
   * @type {PBAffordabilityAggregated}
   * @memberof PBAggregateAllService200Response
   */
  affordability?: PBAffordabilityAggregated;
  /**
   *
   * @type {boolean}
   * @memberof PBAggregateAllService200Response
   */
  pricingBoxKO?: boolean;
  /**
   *
   * @type {number}
   * @memberof PBAggregateAllService200Response
   */
  count?: number;
  /**
   *
   * @type {boolean}
   * @memberof PBAggregateAllService200Response
   */
  delNeg?: boolean;
  /**
   *
   * @type {string}
   * @memberof PBAggregateAllService200Response
   */
  idPratica?: string;
}
/**
 *
 * @export
 * @interface PBAggregateAllServiceRequest
 */
export interface PBAggregateAllServiceRequest {
  /**
   *
   * @type {Array<PBScoreCardInput>}
   * @memberof PBAggregateAllServiceRequest
   */
  scoreCard: Array<PBScoreCardInput>;
  /**
   *
   * @type {PBPricingInput}
   * @memberof PBAggregateAllServiceRequest
   */
  pricing: PBPricingInput;
  /**
   *
   * @type {PBAffordabilityInput}
   * @memberof PBAggregateAllServiceRequest
   */
  affordability: PBAffordabilityInput;
  /**
   *
   * @type {boolean}
   * @memberof PBAggregateAllServiceRequest
   */
  qineticCall?: boolean;
  /**
   *
   * @type {string}
   * @memberof PBAggregateAllServiceRequest
   */
  idPratica: string;
  /**
   *
   * @type {Array<PBAggregateAllServiceRequestObbligationInner>}
   * @memberof PBAggregateAllServiceRequest
   */
  obbligation?: Array<PBAggregateAllServiceRequestObbligationInner>;
}
/**
 *
 * @export
 * @interface PBAggregateAllServiceRequestObbligationInner
 */
export interface PBAggregateAllServiceRequestObbligationInner {
  /**
   *
   * @type {string}
   * @memberof PBAggregateAllServiceRequestObbligationInner
   */
  financialCode?: string;
  /**
   *
   * @type {number}
   * @memberof PBAggregateAllServiceRequestObbligationInner
   */
  installmentAmount?: number;
  /**
   *
   * @type {number}
   * @memberof PBAggregateAllServiceRequestObbligationInner
   */
  residualDebt?: number;
}
/**
 *
 * @export
 * @interface PBPricing
 */
export interface PBPricing {
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  tan?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  teg?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  taeg?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  monthlyInstallmentAmount?: number;
  /**
   *
   * @type {boolean}
   * @memberof PBPricing
   */
  koUsury?: boolean;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  roaCluster?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  roaExpected?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  lifetimePd?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  totalCreditLossesUndiscounted?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  totalInterestIncomeUndiscounted?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  ultimateLossRatio?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  totalCreditAmount?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  interestTotalSum?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  expensesTotalSum?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  expensesRate?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  initialFeeAmount?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  periodicFeeAmount?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  contractualProfit?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  capitalCreditLosses?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  lostFutureProfits?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  attritionCharges?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricing
   */
  rod?: number;
  /**
   *
   * @type {string}
   * @memberof PBPricing
   */
  pricingLabel?: string;
  /**
   *
   * @type {boolean}
   * @memberof PBPricing
   */
  override?: boolean;
  /**
   *
   * @type {Array<PBPricingOffertTypeInner>}
   * @memberof PBPricing
   */
  offertType?: Array<PBPricingOffertTypeInner>;
  /**
   *
   * @type {string}
   * @memberof PBPricing
   */
  idPratica?: string;
  /**
   *
   * @type {string}
   * @memberof PBPricing
   */
  pdOrigination?: string;
}
/**
 *
 * @export
 * @interface PBPricingAggregated
 */
export interface PBPricingAggregated {
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  tan?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  teg?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  taeg?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  monthlyInstallmentAmount?: number;
  /**
   *
   * @type {boolean}
   * @memberof PBPricingAggregated
   */
  koUsury?: boolean;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  roaCluster?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  roaExpected?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  lifetimePd?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  totalCreditLossesUndiscounted?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  totalInterestIncomeUndiscounted?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  ultimateLossRatio?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  totalCreditAmount?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  interestTotalSum?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  expensesTotalSum?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  expensesRate?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  initialFeeAmount?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  periodicFeeAmount?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  contractualProfit?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  capitalCreditLosses?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  lostFutureProfits?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  attritionCharges?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingAggregated
   */
  rod?: number;
  /**
   *
   * @type {boolean}
   * @memberof PBPricingAggregated
   */
  override?: boolean;
  /**
   *
   * @type {string}
   * @memberof PBPricingAggregated
   */
  pricingLabel?: string;
  /**
   *
   * @type {Array<PBPricingOffertTypeInner>}
   * @memberof PBPricingAggregated
   */
  offertType?: Array<PBPricingOffertTypeInner>;
  /**
   *
   * @type {string}
   * @memberof PBPricingAggregated
   */
  pdOrigination?: string;
}
/**
 *
 * @export
 * @interface PBPricingInput
 */
export interface PBPricingInput {
  /**
   *
   * @type {string}
   * @memberof PBPricingInput
   */
  discountCode?: string;
  /**
   *
   * @type {string}
   * @memberof PBPricingInput
   */
  loanPurpose: PBPricingInputLoanPurposeEnum;
  /**
   *
   * @type {number}
   * @memberof PBPricingInput
   */
  loanAmount: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingInput
   */
  loanTerm: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingInput
   */
  crifScore: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingInput
   */
  tegInternalThreshold: number;
  /**
   *
   * @type {string}
   * @memberof PBPricingInput
   */
  dayOfBirth: string;
  /**
   *
   * @type {number}
   * @memberof PBPricingInput
   */
  tanOverride?: number;
  /**
   *
   * @type {string}
   * @memberof PBPricingInput
   */
  managementChannel: string;
  /**
   *
   * @type {string}
   * @memberof PBPricingInput
   */
  channel?: string;
  /**
   *
   * @type {number}
   * @memberof PBPricingInput
   */
  registrationFee?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingInput
   */
  instalmentCollectionCosts?: number;
  /**
   *
   * @type {boolean}
   * @memberof PBPricingInput
   */
  singleOffer?: boolean;
  /**
   *
   * @type {number}
   * @memberof PBPricingInput
   */
  netMonthlyIncome?: number;
  /**
   *
   * @type {string}
   * @memberof PBPricingInput
   */
  employmentStatus?: string;
}

export const PBPricingInputLoanPurposeEnum = {
  DebtConsolidation: "DEBT_CONSOLIDATION",
  EstheticsWellbeing: "ESTHETICS_WELLBEING",
  MedicalExpenses: "MEDICAL_EXPENSES",
  StudyingTrainingCourses: "STUDYING_TRAINING_COURSES",
  Wedding: "WEDDING",
  Travels: "TRAVELS",
  Other: "OTHER",
  HomeImprovement: "HOME_IMPROVEMENT",
  Furniture: "FURNITURE",
  RealEstateBoxPurchase: "REAL_ESTATE_BOX_PURCHASE",
  NewUsedMotorbike: "NEW_USED_MOTORBIKE",
  NewCar: "NEW_CAR",
  UsedCar: "USED_CAR",
  Liquidity: "LIQUIDITY",
} as const;

export type PBPricingInputLoanPurposeEnum =
  (typeof PBPricingInputLoanPurposeEnum)[keyof typeof PBPricingInputLoanPurposeEnum];

/**
 *
 * @export
 * @interface PBPricingInputWithPdAndIdPratica
 */
export interface PBPricingInputWithPdAndIdPratica {
  /**
   *
   * @type {string}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  discountCode?: string;
  /**
   *
   * @type {string}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  loanPurpose: PBPricingInputWithPdAndIdPraticaLoanPurposeEnum;
  /**
   *
   * @type {number}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  loanAmount: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  loanTerm: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  crifScore: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  tegInternalThreshold: number;
  /**
   *
   * @type {string}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  dayOfBirth: string;
  /**
   *
   * @type {number}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  tanOverride?: number;
  /**
   *
   * @type {string}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  managementChannel: string;
  /**
   *
   * @type {string}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  channel?: string;
  /**
   *
   * @type {number}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  registrationFee?: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  instalmentCollectionCosts?: number;
  /**
   *
   * @type {boolean}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  singleOffer?: boolean;
  /**
   *
   * @type {number}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  netMonthlyIncome?: number;
  /**
   *
   * @type {string}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  employmentStatus?: string;
  /**
   *
   * @type {number}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  pd: number;
  /**
   *
   * @type {number}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  pdClass?: number;
  /**
   *
   * @type {boolean}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  qineticCall?: boolean;
  /**
   *
   * @type {string}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  idPratica: string;
  /**
   *
   * @type {Array<PBAggregateAllServiceRequestObbligationInner>}
   * @memberof PBPricingInputWithPdAndIdPratica
   */
  obbligation?: Array<PBAggregateAllServiceRequestObbligationInner>;
}

export const PBPricingInputWithPdAndIdPraticaLoanPurposeEnum = {
  DebtConsolidation: "DEBT_CONSOLIDATION",
  EstheticsWellbeing: "ESTHETICS_WELLBEING",
  MedicalExpenses: "MEDICAL_EXPENSES",
  StudyingTrainingCourses: "STUDYING_TRAINING_COURSES",
  Wedding: "WEDDING",
  Travels: "TRAVELS",
  Other: "OTHER",
  HomeImprovement: "HOME_IMPROVEMENT",
  Furniture: "FURNITURE",
  RealEstateBoxPurchase: "REAL_ESTATE_BOX_PURCHASE",
  NewUsedMotorbike: "NEW_USED_MOTORBIKE",
  NewCar: "NEW_CAR",
  UsedCar: "USED_CAR",
  Liquidity: "LIQUIDITY",
} as const;

export type PBPricingInputWithPdAndIdPraticaLoanPurposeEnum =
  (typeof PBPricingInputWithPdAndIdPraticaLoanPurposeEnum)[keyof typeof PBPricingInputWithPdAndIdPraticaLoanPurposeEnum];

/**
 *
 * @export
 * @interface PBPricingOffertTypeInner
 */
export interface PBPricingOffertTypeInner {
  /**
   *
   * @type {number}
   * @memberof PBPricingOffertTypeInner
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof PBPricingOffertTypeInner
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof PBPricingOffertTypeInner
   */
  key?: string;
  /**
   *
   * @type {string}
   * @memberof PBPricingOffertTypeInner
   */
  value?: string;
}
/**
 *
 * @export
 * @interface PBScoreCard
 */
export interface PBScoreCard {
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  pd?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  pdClass?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  flagsOffPerDrcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  importoFinanziatoBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  itfNumTrendDecr24MBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  maxInsCurrcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  maxMonthAnzCntrRcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  numCntrPpClass2RcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  numCntrRicRcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  numCntrRifRinRcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  pctEsposizioneResRcPreStattBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  totMesiRegolari6MBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  trancheGeoindexCliBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCard
   */
  trancheP2NohitCliBin?: number;
  /**
   *
   * @type {string}
   * @memberof PBScoreCard
   */
  tipoDocumento?: string;
  /**
   *
   * @type {string}
   * @memberof PBScoreCard
   */
  scorecardOutcome?: PBScoreCardScorecardOutcomeEnum;
  /**
   *
   * @type {string}
   * @memberof PBScoreCard
   */
  idPratica?: string;
}

export const PBScoreCardScorecardOutcomeEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBScoreCardScorecardOutcomeEnum =
  (typeof PBScoreCardScorecardOutcomeEnum)[keyof typeof PBScoreCardScorecardOutcomeEnum];

/**
 *
 * @export
 * @interface PBScoreCardAggregated
 */
export interface PBScoreCardAggregated {
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  pd?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  pdClass?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  flagsOffPerDrcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  importoFinanziatoBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  itfNumTrendDecr24MBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  maxInsCurrcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  maxMonthAnzCntrRcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  numCntrPpClass2RcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  numCntrRicRcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  numCntrRifRinRcBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  pctEsposizioneResRcPreStattBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  totMesiRegolari6MBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  trancheGeoindexCliBin?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardAggregated
   */
  trancheP2NohitCliBin?: number;
  /**
   *
   * @type {string}
   * @memberof PBScoreCardAggregated
   */
  tipoDocumento?: string;
  /**
   *
   * @type {string}
   * @memberof PBScoreCardAggregated
   */
  scorecardOutcome?: PBScoreCardAggregatedScorecardOutcomeEnum;
}

export const PBScoreCardAggregatedScorecardOutcomeEnum = {
  Red: "RED",
  Yellow: "YELLOW",
  Green: "GREEN",
} as const;

export type PBScoreCardAggregatedScorecardOutcomeEnum =
  (typeof PBScoreCardAggregatedScorecardOutcomeEnum)[keyof typeof PBScoreCardAggregatedScorecardOutcomeEnum];

/**
 *
 * @export
 * @interface PBScoreCardInput
 */
export interface PBScoreCardInput {
  /**
   *
   * @type {string}
   * @memberof PBScoreCardInput
   */
  tipoDocumento: PBScoreCardInputTipoDocumentoEnum;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInput
   */
  flagsOffPerdrc?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInput
   */
  importoFinanziato: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInput
   */
  itfnumtrenddecr24M?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInput
   */
  maxInscurrc?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInput
   */
  maxMonthANZCNTRRC?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInput
   */
  numcntrppclass2Rc?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInput
   */
  numcntrricrc?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInput
   */
  numcntrrifrinrc?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInput
   */
  pctesposizioneresrcprestatt?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInput
   */
  totmesiregolari6M?: number;
  /**
   *
   * @type {string}
   * @memberof PBScoreCardInput
   */
  trancheGeoIndexCli?: string;
  /**
   *
   * @type {string}
   * @memberof PBScoreCardInput
   */
  trancheP2Cli?: string;
  /**
   *
   * @type {string}
   * @memberof PBScoreCardInput
   */
  trancheNohitCli?: string;
  /**
   *
   * @type {string}
   * @memberof PBScoreCardInput
   */
  channel?: string;
}

export const PBScoreCardInputTipoDocumentoEnum = {
  Richiedente: "RICHIEDENTE",
  Coobligato: "COOBLIGATO",
} as const;

export type PBScoreCardInputTipoDocumentoEnum =
  (typeof PBScoreCardInputTipoDocumentoEnum)[keyof typeof PBScoreCardInputTipoDocumentoEnum];

/**
 *
 * @export
 * @interface PBScoreCardInputWithIdPratica
 */
export interface PBScoreCardInputWithIdPratica {
  /**
   *
   * @type {string}
   * @memberof PBScoreCardInputWithIdPratica
   */
  tipoDocumento: PBScoreCardInputWithIdPraticaTipoDocumentoEnum;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInputWithIdPratica
   */
  flagsOffPerdrc?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInputWithIdPratica
   */
  importoFinanziato: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInputWithIdPratica
   */
  itfnumtrenddecr24M?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInputWithIdPratica
   */
  maxInscurrc?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInputWithIdPratica
   */
  maxMonthANZCNTRRC?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInputWithIdPratica
   */
  numcntrppclass2Rc?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInputWithIdPratica
   */
  numcntrricrc?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInputWithIdPratica
   */
  numcntrrifrinrc?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInputWithIdPratica
   */
  pctesposizioneresrcprestatt?: number;
  /**
   *
   * @type {number}
   * @memberof PBScoreCardInputWithIdPratica
   */
  totmesiregolari6M?: number;
  /**
   *
   * @type {string}
   * @memberof PBScoreCardInputWithIdPratica
   */
  trancheGeoIndexCli?: string;
  /**
   *
   * @type {string}
   * @memberof PBScoreCardInputWithIdPratica
   */
  trancheP2Cli?: string;
  /**
   *
   * @type {string}
   * @memberof PBScoreCardInputWithIdPratica
   */
  trancheNohitCli?: string;
  /**
   *
   * @type {string}
   * @memberof PBScoreCardInputWithIdPratica
   */
  channel?: string;
  /**
   *
   * @type {string}
   * @memberof PBScoreCardInputWithIdPratica
   */
  idPratica: string;
}

export const PBScoreCardInputWithIdPraticaTipoDocumentoEnum = {
  Richiedente: "RICHIEDENTE",
  Coobligato: "COOBLIGATO",
} as const;

export type PBScoreCardInputWithIdPraticaTipoDocumentoEnum =
  (typeof PBScoreCardInputWithIdPraticaTipoDocumentoEnum)[keyof typeof PBScoreCardInputWithIdPraticaTipoDocumentoEnum];

/**
 *
 * @export
 * @interface PagePositionRequest
 */
export interface PagePositionRequest {
  /**
   *
   * @type {string}
   * @memberof PagePositionRequest
   */
  slideId?: string;
}
/**
 *
 * @export
 * @interface PensionerIncomeRequest
 */
export interface PensionerIncomeRequest {
  /**
   *
   * @type {number}
   * @memberof PensionerIncomeRequest
   */
  netMonthlySalary?: number;
  /**
   *
   * @type {number}
   * @memberof PensionerIncomeRequest
   */
  monthsSalary?: number;
}
/**
 *
 * @export
 * @interface Personal
 */
export interface Personal {
  /**
   *
   * @type {string}
   * @memberof Personal
   */
  firstname: string;
  /**
   *
   * @type {string}
   * @memberof Personal
   */
  lastname: string;
  /**
   *
   * @type {string}
   * @memberof Personal
   */
  gender?: PersonalGenderEnum;
  /**
   *
   * @type {string}
   * @memberof Personal
   */
  birthDate: string;
  /**
   *
   * @type {string}
   * @memberof Personal
   */
  nationality?: string;
  /**
   *
   * @type {string}
   * @memberof Personal
   */
  birthCountry?: PersonalBirthCountryEnum;
  /**
   *
   * @type {string}
   * @memberof Personal
   */
  birthProvince?: string;
  /**
   *
   * @type {string}
   * @memberof Personal
   */
  birthCity?: string;
  /**
   *
   * @type {string}
   * @memberof Personal
   */
  fiscalCode?: string;
}

export const PersonalGenderEnum = {
  M: "M",
  F: "F",
} as const;

export type PersonalGenderEnum =
  (typeof PersonalGenderEnum)[keyof typeof PersonalGenderEnum];
export const PersonalBirthCountryEnum = {
  Abw: "ABW",
  Afg: "AFG",
  Ago: "AGO",
  Aia: "AIA",
  Ala: "ALA",
  Alb: "ALB",
  And: "AND",
  Are: "ARE",
  Arg: "ARG",
  Arm: "ARM",
  Asm: "ASM",
  Ata: "ATA",
  Atf: "ATF",
  Atg: "ATG",
  Aus: "AUS",
  Aut: "AUT",
  Aze: "AZE",
  Bdi: "BDI",
  Bel: "BEL",
  Ben: "BEN",
  Bes: "BES",
  Bfa: "BFA",
  Bgd: "BGD",
  Bgr: "BGR",
  Bhr: "BHR",
  Bhs: "BHS",
  Bih: "BIH",
  Blm: "BLM",
  Blr: "BLR",
  Blz: "BLZ",
  Bmu: "BMU",
  Bol: "BOL",
  Bra: "BRA",
  Brb: "BRB",
  Brn: "BRN",
  Btn: "BTN",
  Bvt: "BVT",
  Bwa: "BWA",
  Caf: "CAF",
  Can: "CAN",
  Cck: "CCK",
  Che: "CHE",
  Chl: "CHL",
  Chn: "CHN",
  Civ: "CIV",
  Cmr: "CMR",
  Cod: "COD",
  Cog: "COG",
  Cok: "COK",
  Col: "COL",
  Com: "COM",
  Cpv: "CPV",
  Cri: "CRI",
  Cub: "CUB",
  Cuw: "CUW",
  Cxr: "CXR",
  Cym: "CYM",
  Cyp: "CYP",
  Cze: "CZE",
  Deu: "DEU",
  Dji: "DJI",
  Dma: "DMA",
  Dnk: "DNK",
  Dom: "DOM",
  Dza: "DZA",
  Ecu: "ECU",
  Egy: "EGY",
  Eri: "ERI",
  Esh: "ESH",
  Esp: "ESP",
  Est: "EST",
  Eth: "ETH",
  Fin: "FIN",
  Fji: "FJI",
  Flk: "FLK",
  Fra: "FRA",
  Fro: "FRO",
  Fsm: "FSM",
  Gab: "GAB",
  Gbr: "GBR",
  Geo: "GEO",
  Ggy: "GGY",
  Gha: "GHA",
  Gib: "GIB",
  Gin: "GIN",
  Glp: "GLP",
  Gmb: "GMB",
  Gnb: "GNB",
  Gnq: "GNQ",
  Grc: "GRC",
  Grd: "GRD",
  Grl: "GRL",
  Gtm: "GTM",
  Guf: "GUF",
  Gum: "GUM",
  Guy: "GUY",
  Hkg: "HKG",
  Hmd: "HMD",
  Hnd: "HND",
  Hrv: "HRV",
  Hti: "HTI",
  Hun: "HUN",
  Idn: "IDN",
  Imn: "IMN",
  Ind: "IND",
  Iot: "IOT",
  Irl: "IRL",
  Irn: "IRN",
  Irq: "IRQ",
  Isl: "ISL",
  Isr: "ISR",
  Ita: "ITA",
  Jam: "JAM",
  Jey: "JEY",
  Jor: "JOR",
  Jpn: "JPN",
  Kaz: "KAZ",
  Ken: "KEN",
  Kgz: "KGZ",
  Khm: "KHM",
  Kir: "KIR",
  Kna: "KNA",
  Kor: "KOR",
  Kwt: "KWT",
  Lao: "LAO",
  Lbn: "LBN",
  Lbr: "LBR",
  Lby: "LBY",
  Lca: "LCA",
  Lie: "LIE",
  Lka: "LKA",
  Lso: "LSO",
  Ltu: "LTU",
  Lux: "LUX",
  Lva: "LVA",
  Mac: "MAC",
  Maf: "MAF",
  Mar: "MAR",
  Mco: "MCO",
  Mda: "MDA",
  Mdg: "MDG",
  Mdv: "MDV",
  Mex: "MEX",
  Mhl: "MHL",
  Mkd: "MKD",
  Mli: "MLI",
  Mlt: "MLT",
  Mmr: "MMR",
  Mne: "MNE",
  Mng: "MNG",
  Mnp: "MNP",
  Moz: "MOZ",
  Mrt: "MRT",
  Msr: "MSR",
  Mtq: "MTQ",
  Mus: "MUS",
  Mwi: "MWI",
  Mys: "MYS",
  Myt: "MYT",
  Nam: "NAM",
  Ncl: "NCL",
  Ner: "NER",
  Nfk: "NFK",
  Nga: "NGA",
  Nic: "NIC",
  Niu: "NIU",
  Nld: "NLD",
  Nor: "NOR",
  Npl: "NPL",
  Nru: "NRU",
  Nzl: "NZL",
  Omn: "OMN",
  Pak: "PAK",
  Pan: "PAN",
  Pcn: "PCN",
  Per: "PER",
  Phl: "PHL",
  Plw: "PLW",
  Png: "PNG",
  Pol: "POL",
  Pri: "PRI",
  Prk: "PRK",
  Prt: "PRT",
  Pry: "PRY",
  Pse: "PSE",
  Pyf: "PYF",
  Qat: "QAT",
  Reu: "REU",
  Rou: "ROU",
  Rus: "RUS",
  Rwa: "RWA",
  Sau: "SAU",
  Sdn: "SDN",
  Sen: "SEN",
  Sgp: "SGP",
  Sgs: "SGS",
  Shn: "SHN",
  Sjm: "SJM",
  Slb: "SLB",
  Sle: "SLE",
  Slv: "SLV",
  Smr: "SMR",
  Som: "SOM",
  Spm: "SPM",
  Srb: "SRB",
  Ssd: "SSD",
  Stp: "STP",
  Sur: "SUR",
  Svk: "SVK",
  Svn: "SVN",
  Swe: "SWE",
  Swz: "SWZ",
  Sxm: "SXM",
  Syc: "SYC",
  Syr: "SYR",
  Tca: "TCA",
  Tcd: "TCD",
  Tgo: "TGO",
  Tha: "THA",
  Tjk: "TJK",
  Tkl: "TKL",
  Tkm: "TKM",
  Tls: "TLS",
  Ton: "TON",
  Tto: "TTO",
  Tun: "TUN",
  Tur: "TUR",
  Tuv: "TUV",
  Twn: "TWN",
  Tza: "TZA",
  Uga: "UGA",
  Ukr: "UKR",
  Umi: "UMI",
  Ury: "URY",
  Usa: "USA",
  Uzb: "UZB",
  Vat: "VAT",
  Vct: "VCT",
  Ven: "VEN",
  Vgb: "VGB",
  Vir: "VIR",
  Vnm: "VNM",
  Vut: "VUT",
  Wlf: "WLF",
  Wsm: "WSM",
  Yem: "YEM",
  Zaf: "ZAF",
  Zmb: "ZMB",
  Zwe: "ZWE",
} as const;

export type PersonalBirthCountryEnum =
  (typeof PersonalBirthCountryEnum)[keyof typeof PersonalBirthCountryEnum];

/**
 *
 * @export
 * @interface PersonalDataDto
 */
export interface PersonalDataDto {
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  fiscalCode?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  gender?: PersonalDataDtoGenderEnum;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  status?: PersonalDataDtoStatusEnum;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  recordType?: PersonalDataDtoRecordTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  datePrivacy?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  phone?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  email?: string;
  /**
   *
   * @type {Array<AddressDto>}
   * @memberof PersonalDataDto
   */
  addresses?: Array<AddressDto>;
  /**
   *
   * @type {number}
   * @memberof PersonalDataDto
   */
  yearsInItaly?: number;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  nationality?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  birthCity?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  birthProvince?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  birthCountry?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalDataDto
   */
  birthDate?: string;
}

export const PersonalDataDtoGenderEnum = {
  M: "M",
  F: "F",
} as const;

export type PersonalDataDtoGenderEnum =
  (typeof PersonalDataDtoGenderEnum)[keyof typeof PersonalDataDtoGenderEnum];
export const PersonalDataDtoStatusEnum = {
  Draft: "DRAFT",
  Prospect: "PROSPECT",
} as const;

export type PersonalDataDtoStatusEnum =
  (typeof PersonalDataDtoStatusEnum)[keyof typeof PersonalDataDtoStatusEnum];
export const PersonalDataDtoRecordTypeEnum = {
  NaturalPerson: "NATURAL_PERSON",
  SoleTrader: "SOLE_TRADER",
  LegalPerson: "LEGAL_PERSON",
} as const;

export type PersonalDataDtoRecordTypeEnum =
  (typeof PersonalDataDtoRecordTypeEnum)[keyof typeof PersonalDataDtoRecordTypeEnum];

/**
 *
 * @export
 * @interface PersonalDataRequest
 */
export interface PersonalDataRequest {
  /**
   *
   * @type {string}
   * @memberof PersonalDataRequest
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalDataRequest
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalDataRequest
   */
  gender?: PersonalDataRequestGenderEnum;
}

export const PersonalDataRequestGenderEnum = {
  M: "M",
  F: "F",
} as const;

export type PersonalDataRequestGenderEnum =
  (typeof PersonalDataRequestGenderEnum)[keyof typeof PersonalDataRequestGenderEnum];

/**
 *
 * @export
 * @interface PersonalInfo
 */
export interface PersonalInfo {
  /**
   *
   * @type {string}
   * @memberof PersonalInfo
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalInfo
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalInfo
   */
  gender?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalInfo
   */
  fiscalCode?: string;
  /**
   *
   * @type {string}
   * @memberof PersonalInfo
   */
  nationality?: string;
}
/**
 *
 * @export
 * @interface PolWfContextDto
 */
export interface PolWfContextDto {
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   */
  dealId?: string;
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   */
  qineticId?: string;
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   */
  positionId?: string;
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   */
  workflowId?: string;
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   */
  currentState?: PolWfContextDtoCurrentStateEnum;
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   */
  recoveryBlock?: PolWfContextDtoRecoveryBlockEnum;
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   * @deprecated
   */
  salesMethodPhone?: PolWfContextDtoSalesMethodPhoneEnum;
  /**
   *
   * @type {BaseActivityIODto}
   * @memberof PolWfContextDto
   */
  activityInputDto?: BaseActivityIODto;
  /**
   *
   * @type {{ [key: string]: boolean; }}
   * @memberof PolWfContextDto
   */
  executedStep?: { [key: string]: boolean };
  /**
   *
   * @type {boolean}
   * @memberof PolWfContextDto
   */
  backSignal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PolWfContextDto
   */
  nextSignal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PolWfContextDto
   */
  reloadSignal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PolWfContextDto
   */
  completed?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PolWfContextDto
   */
  shutdownRequested?: boolean;
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   */
  signalState?: PolWfContextDtoSignalStateEnum;
  /**
   *
   * @type {boolean}
   * @memberof PolWfContextDto
   */
  postApprovalStoplight?: boolean;
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   */
  cpiSwitch?: PolWfContextDtoCpiSwitchEnum;
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   */
  cpiQuestionnaireSwitch?: PolWfContextDtoCpiQuestionnaireSwitchEnum;
  /**
   *
   * @type {string}
   * @memberof PolWfContextDto
   */
  cpiBeneficiarySwitch?: PolWfContextDtoCpiBeneficiarySwitchEnum;
  /**
   *
   * @type {QineticMetadata}
   * @memberof PolWfContextDto
   */
  qineticMetadata?: QineticMetadata;
  /**
   *
   * @type {boolean}
   * @memberof PolWfContextDto
   */
  aggregatorFlow?: boolean;
}

export const PolWfContextDtoCurrentStateEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type PolWfContextDtoCurrentStateEnum =
  (typeof PolWfContextDtoCurrentStateEnum)[keyof typeof PolWfContextDtoCurrentStateEnum];
export const PolWfContextDtoRecoveryBlockEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type PolWfContextDtoRecoveryBlockEnum =
  (typeof PolWfContextDtoRecoveryBlockEnum)[keyof typeof PolWfContextDtoRecoveryBlockEnum];
export const PolWfContextDtoSalesMethodPhoneEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type PolWfContextDtoSalesMethodPhoneEnum =
  (typeof PolWfContextDtoSalesMethodPhoneEnum)[keyof typeof PolWfContextDtoSalesMethodPhoneEnum];
export const PolWfContextDtoSignalStateEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type PolWfContextDtoSignalStateEnum =
  (typeof PolWfContextDtoSignalStateEnum)[keyof typeof PolWfContextDtoSignalStateEnum];
export const PolWfContextDtoCpiSwitchEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type PolWfContextDtoCpiSwitchEnum =
  (typeof PolWfContextDtoCpiSwitchEnum)[keyof typeof PolWfContextDtoCpiSwitchEnum];
export const PolWfContextDtoCpiQuestionnaireSwitchEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type PolWfContextDtoCpiQuestionnaireSwitchEnum =
  (typeof PolWfContextDtoCpiQuestionnaireSwitchEnum)[keyof typeof PolWfContextDtoCpiQuestionnaireSwitchEnum];
export const PolWfContextDtoCpiBeneficiarySwitchEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type PolWfContextDtoCpiBeneficiarySwitchEnum =
  (typeof PolWfContextDtoCpiBeneficiarySwitchEnum)[keyof typeof PolWfContextDtoCpiBeneficiarySwitchEnum];

/**
 *
 * @export
 * @interface PositionSummaryResponse
 */
export interface PositionSummaryResponse {
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  fiscalCode?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  birthCity?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  birthDate?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  streetName?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  streetNumber?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  qineticStatus?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  stepCheckpoint?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  purpose?: string;
  /**
   *
   * @type {number}
   * @memberof PositionSummaryResponse
   */
  totalAmount?: number;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  endDate?: string;
  /**
   *
   * @type {number}
   * @memberof PositionSummaryResponse
   */
  remainingCapital?: number;
  /**
   *
   * @type {number}
   * @memberof PositionSummaryResponse
   */
  nextInstalmentAmount?: number;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  nextInstalmentDate?: string;
  /**
   *
   * @type {number}
   * @memberof PositionSummaryResponse
   */
  paidInstalmentCount?: number;
  /**
   *
   * @type {number}
   * @memberof PositionSummaryResponse
   */
  totalInstalmentCount?: number;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  tan?: string;
  /**
   *
   * @type {string}
   * @memberof PositionSummaryResponse
   */
  taeg?: string;
}
/**
 *
 * @export
 * @interface PreApprovalRequest
 */
export interface PreApprovalRequest {
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  numeroPreventivo?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  applicationId: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  channel?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  nome?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  cognome?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  telefono?: string;
  /**
   *
   * @type {boolean}
   * @memberof PreApprovalRequest
   */
  privacy?: boolean;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  dataInoltro?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  dataNascita?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  codiceFiscale?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  comuneNascita?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  sesso?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  indirizzoResidenza?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  nazioneResidenza?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  comuneResidenza?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  capResidenza?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  provinciaResidenza?: string;
  /**
   *
   * @type {number}
   * @memberof PreApprovalRequest
   */
  numeroComponentiNucleoFamiliare?: number;
  /**
   *
   * @type {number}
   * @memberof PreApprovalRequest
   */
  numeroComponentiNucleoFamiliareConReddito?: number;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  nazioneNascita?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  provinciaNascita?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  nazioneCittadinanza?: string;
  /**
   *
   * @type {number}
   * @memberof PreApprovalRequest
   */
  statoCivile?: number;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  indirizzoDomicilio?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  comuneDomicilio?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  capDomicilio?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  provinciaDomicilio?: string;
  /**
   *
   * @type {number}
   * @memberof PreApprovalRequest
   */
  statoAbitazione?: number;
  /**
   *
   * @type {number}
   * @memberof PreApprovalRequest
   */
  importoaffittomutuo?: number;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  nomeDatoreLavoro?: string;
  /**
   *
   * @type {number}
   * @memberof PreApprovalRequest
   */
  titoloStudio?: number;
  /**
   *
   * @type {boolean}
   * @memberof PreApprovalRequest
   */
  altreFontiReddito?: boolean;
  /**
   *
   * @type {number}
   * @memberof PreApprovalRequest
   */
  altreEntrateMensili?: number;
  /**
   *
   * @type {number}
   * @memberof PreApprovalRequest
   */
  descrizioneFontiReddito?: number;
  /**
   *
   * @type {number}
   * @memberof PreApprovalRequest
   */
  ritardoConPagamenti?: number;
  /**
   *
   * @type {number}
   * @memberof PreApprovalRequest
   */
  settoreAttivita?: number;
  /**
   *
   * @type {number}
   * @memberof PreApprovalRequest
   */
  ruoloAttuale?: number;
  /**
   *
   * @type {string}
   * @memberof PreApprovalRequest
   */
  pIva?: string;
}
/**
 *
 * @export
 * @interface PreApprovalResponse
 */
export interface PreApprovalResponse {
  /**
   *
   * @type {string}
   * @memberof PreApprovalResponse
   */
  numeroPreventivo?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalResponse
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof PreApprovalResponse
   */
  workflowId?: string;
  /**
   *
   * @type {boolean}
   * @memberof PreApprovalResponse
   */
  otp?: boolean;
}
/**
 *
 * @export
 * @interface Pricing
 */
export interface Pricing {
  /**
   *
   * @type {number}
   * @memberof Pricing
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof Pricing
   */
  duration?: number;
  /**
   *
   * @type {number}
   * @memberof Pricing
   */
  installment?: number;
  /**
   *
   * @type {number}
   * @memberof Pricing
   */
  amountDisbursed?: number;
  /**
   *
   * @type {number}
   * @memberof Pricing
   */
  applicationFeeAmount?: number;
  /**
   *
   * @type {number}
   * @memberof Pricing
   */
  creditTotalAmount?: number;
  /**
   *
   * @type {number}
   * @memberof Pricing
   */
  totalAmountDueFromTheConsumer?: number;
  /**
   *
   * @type {number}
   * @memberof Pricing
   */
  grossFinancing?: number;
  /**
   *
   * @type {boolean}
   * @memberof Pricing
   */
  cpi?: boolean;
  /**
   *
   * @type {number}
   * @memberof Pricing
   */
  tan?: number;
  /**
   *
   * @type {number}
   * @memberof Pricing
   */
  taeg?: number;
  /**
   *
   * @type {string}
   * @memberof Pricing
   */
  estimatedFundTransferDate?: string;
}
/**
 *
 * @export
 * @interface PrivacyConsentsRequest
 */
export interface PrivacyConsentsRequest {
  /**
   *
   * @type {boolean}
   * @memberof PrivacyConsentsRequest
   */
  consensoComunicazioniCommerciali?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrivacyConsentsRequest
   */
  consensoComunicazioniTerzi?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrivacyConsentsRequest
   */
  consensoCessioneDati?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrivacyConsentsRequest
   */
  consensoProfilazione?: boolean;
}
/**
 *
 * @export
 * @interface Product
 */
export interface Product {
  /**
   * Id del deal
   * @type {string}
   * @memberof Product
   */
  dealId: string;
  /**
   * Ammontare del prestito
   * @type {number}
   * @memberof Product
   */
  loanIntentAmount: number;
  /**
   * Durata del prestito
   * @type {number}
   * @memberof Product
   */
  loanIntentInstallmentsAmount: number;
  /**
   * Ragione del prestito
   * @type {string}
   * @memberof Product
   */
  loanIntentPurpose: ProductLoanIntentPurposeEnum;
  /**
   * Aggiunta di una assicurazione
   * @type {boolean}
   * @memberof Product
   */
  loanIntentInsurance?: boolean;
}

export const ProductLoanIntentPurposeEnum = {
  DebtConsolidation: "DEBT_CONSOLIDATION",
  EstheticsWellbeing: "ESTHETICS_WELLBEING",
  MedicalExpenses: "MEDICAL_EXPENSES",
  StudyingTrainingCourses: "STUDYING_TRAINING_COURSES",
  Wedding: "WEDDING",
  Travels: "TRAVELS",
  Other: "OTHER",
  HomeImprovement: "HOME_IMPROVEMENT",
  Furniture: "FURNITURE",
  RealEstateBoxPurchase: "REAL_ESTATE_BOX_PURCHASE",
  NewUsedMotorbike: "NEW_USED_MOTORBIKE",
  NewCar: "NEW_CAR",
  UsedCar: "USED_CAR",
  Liquidity: "LIQUIDITY",
} as const;

export type ProductLoanIntentPurposeEnum =
  (typeof ProductLoanIntentPurposeEnum)[keyof typeof ProductLoanIntentPurposeEnum];

/**
 *
 * @export
 * @interface QAmortizationSchedule
 */
export interface QAmortizationSchedule {
  /**
   *
   * @type {Array<QAmortizationScheduleDetail>}
   * @memberof QAmortizationSchedule
   */
  details?: Array<QAmortizationScheduleDetail>;
}
/**
 *
 * @export
 * @interface QAmortizationScheduleDetail
 */
export interface QAmortizationScheduleDetail {
  /**
   *
   * @type {string}
   * @memberof QAmortizationScheduleDetail
   */
  number?: string;
  /**
   *
   * @type {string}
   * @memberof QAmortizationScheduleDetail
   */
  status?: string;
  /**
   *
   * @type {number}
   * @memberof QAmortizationScheduleDetail
   */
  amount?: number;
  /**
   *
   * @type {string}
   * @memberof QAmortizationScheduleDetail
   */
  dueDate?: string;
  /**
   *
   * @type {number}
   * @memberof QAmortizationScheduleDetail
   */
  principalAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QAmortizationScheduleDetail
   */
  interestsAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QAmortizationScheduleDetail
   */
  residualPrincipalAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QAmortizationScheduleDetail
   */
  residualDebitAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QAmortizationScheduleDetail
   */
  otherExpenses?: number;
  /**
   *
   * @type {number}
   * @memberof QAmortizationScheduleDetail
   */
  paymentFees?: number;
  /**
   *
   * @type {number}
   * @memberof QAmortizationScheduleDetail
   */
  totalCommunicationCost?: number;
  /**
   *
   * @type {number}
   * @memberof QAmortizationScheduleDetail
   */
  installmentStamp?: number;
  /**
   *
   * @type {number}
   * @memberof QAmortizationScheduleDetail
   */
  balance?: number;
}
/**
 *
 * @export
 * @interface QBeneficiary
 */
export interface QBeneficiary {
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  beneficiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  beneficiaryType?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  relationWithCustomer?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  birthPlace?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  birthDate?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  taxNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  vatNumber?: string;
  /**
   *
   * @type {number}
   * @memberof QBeneficiary
   */
  beneficiaryPercentual?: number;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  gender?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  birthCountry?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  nationality?: string;
  /**
   *
   * @type {boolean}
   * @memberof QBeneficiary
   */
  politicallyExposed?: boolean;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  politExposedDesc?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  residencyCountry?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  residencyCity?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  residencyProvince?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  residencyZipCode?: string;
  /**
   *
   * @type {string}
   * @memberof QBeneficiary
   */
  isHeir?: string;
}
/**
 *
 * @export
 * @interface QCfFormRequest
 */
export interface QCfFormRequest {
  /**
   *
   * @type {number}
   * @memberof QCfFormRequest
   */
  payslip1Amount?: number;
  /**
   *
   * @type {number}
   * @memberof QCfFormRequest
   */
  payslip2Amount?: number;
  /**
   *
   * @type {number}
   * @memberof QCfFormRequest
   */
  payslip3Amount?: number;
  /**
   *
   * @type {number}
   * @memberof QCfFormRequest
   */
  requiredIncome?: number;
  /**
   *
   * @type {string}
   * @memberof QCfFormRequest
   */
  requiredIncomeMet?: string;
}
/**
 *
 * @export
 * @interface QChecklist
 */
export interface QChecklist {
  /**
   *
   * @type {string}
   * @memberof QChecklist
   */
  businessId?: string;
  /**
   *
   * @type {string}
   * @memberof QChecklist
   */
  applicationId?: string;
  /**
   *
   * @type {Array<QChecklistEntity>}
   * @memberof QChecklist
   */
  entities?: Array<QChecklistEntity>;
  /**
   *
   * @type {number}
   * @memberof QChecklist
   */
  checkListId?: number;
  /**
   *
   * @type {boolean}
   * @memberof QChecklist
   */
  hawkConfirmFlag?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QChecklist
   */
  hawkInProcessFlag?: boolean;
}
/**
 *
 * @export
 * @interface QChecklistEntity
 */
export interface QChecklistEntity {
  /**
   *
   * @type {string}
   * @memberof QChecklistEntity
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof QChecklistEntity
   */
  entityType?: string;
  /**
   *
   * @type {string}
   * @memberof QChecklistEntity
   */
  typeTranslation?: string;
  /**
   *
   * @type {string}
   * @memberof QChecklistEntity
   */
  ndg?: string;
  /**
   *
   * @type {string}
   * @memberof QChecklistEntity
   */
  offerId?: string;
  /**
   *
   * @type {string}
   * @memberof QChecklistEntity
   */
  heading?: string;
  /**
   *
   * @type {Array<QDocumentEntity>}
   * @memberof QChecklistEntity
   */
  documents?: Array<QDocumentEntity>;
}
/**
 *
 * @export
 * @interface QCreatePositionRequestV3
 */
export interface QCreatePositionRequestV3 {
  /**
   *
   * @type {string}
   * @memberof QCreatePositionRequestV3
   */
  productCode?: string;
  /**
   *
   * @type {number}
   * @memberof QCreatePositionRequestV3
   */
  process?: QCreatePositionRequestV3ProcessEnum;
  /**
   *
   * @type {string}
   * @memberof QCreatePositionRequestV3
   */
  processVersion?: string;
  /**
   *
   * @type {string}
   * @memberof QCreatePositionRequestV3
   */
  externalReferenceId?: string;
  /**
   *
   * @type {QQuotationBaseDataSetV2}
   * @memberof QCreatePositionRequestV3
   */
  quotationData?: QQuotationBaseDataSetV2;
  /**
   *
   * @type {Array<QCustomerRequestV3>}
   * @memberof QCreatePositionRequestV3
   */
  customers?: Array<QCustomerRequestV3>;
  /**
   *
   * @type {string}
   * @memberof QCreatePositionRequestV3
   */
  bankAccount?: string;
  /**
   *
   * @type {string}
   * @memberof QCreatePositionRequestV3
   */
  chargementMethod?: string;
  /**
   *
   * @type {string}
   * @memberof QCreatePositionRequestV3
   */
  paymentMethod?: string;
  /**
   *
   * @type {string}
   * @memberof QCreatePositionRequestV3
   */
  creationTool?: string;
  /**
   *
   * @type {Array<QIntermediationChainPosition>}
   * @memberof QCreatePositionRequestV3
   */
  additionalIntermediationChains?: Array<QIntermediationChainPosition>;
}

export const QCreatePositionRequestV3ProcessEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

export type QCreatePositionRequestV3ProcessEnum =
  (typeof QCreatePositionRequestV3ProcessEnum)[keyof typeof QCreatePositionRequestV3ProcessEnum];

/**
 *
 * @export
 * @interface QCreatePositionResponse
 */
export interface QCreatePositionResponse {
  /**
   *
   * @type {QGeneralResponse}
   * @memberof QCreatePositionResponse
   */
  generalResponse?: QGeneralResponse;
  /**
   *
   * @type {string}
   * @memberof QCreatePositionResponse
   */
  expectedExpiration?: string;
  /**
   *
   * @type {string}
   * @memberof QCreatePositionResponse
   */
  positionId?: string;
}
/**
 *
 * @export
 * @interface QCustomerPersonalInfo
 */
export interface QCustomerPersonalInfo {
  /**
   *
   * @type {string}
   * @memberof QCustomerPersonalInfo
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerPersonalInfo
   */
  lastname?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerPersonalInfo
   */
  taxNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerPersonalInfo
   */
  birthDate?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerPersonalInfo
   */
  birthPlaceProvince?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerPersonalInfo
   */
  birthPlace?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerPersonalInfo
   */
  birthCountry?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerPersonalInfo
   */
  gender?: QCustomerPersonalInfoGenderEnum;
}

export const QCustomerPersonalInfoGenderEnum = {
  M: "M",
  F: "F",
} as const;

export type QCustomerPersonalInfoGenderEnum =
  (typeof QCustomerPersonalInfoGenderEnum)[keyof typeof QCustomerPersonalInfoGenderEnum];

/**
 *
 * @export
 * @interface QCustomerPrivacyRequest
 */
export interface QCustomerPrivacyRequest {
  /**
   *
   * @type {string}
   * @memberof QCustomerPrivacyRequest
   */
  flagPrivacy1: QCustomerPrivacyRequestFlagPrivacy1Enum;
  /**
   *
   * @type {string}
   * @memberof QCustomerPrivacyRequest
   */
  flagPrivacy2: QCustomerPrivacyRequestFlagPrivacy2Enum;
  /**
   *
   * @type {string}
   * @memberof QCustomerPrivacyRequest
   */
  flagPrivacy3: QCustomerPrivacyRequestFlagPrivacy3Enum;
  /**
   *
   * @type {string}
   * @memberof QCustomerPrivacyRequest
   */
  flagPrivacy4: QCustomerPrivacyRequestFlagPrivacy4Enum;
}

export const QCustomerPrivacyRequestFlagPrivacy1Enum = {
  Y: "Y",
  N: "N",
} as const;

export type QCustomerPrivacyRequestFlagPrivacy1Enum =
  (typeof QCustomerPrivacyRequestFlagPrivacy1Enum)[keyof typeof QCustomerPrivacyRequestFlagPrivacy1Enum];
export const QCustomerPrivacyRequestFlagPrivacy2Enum = {
  Y: "Y",
  N: "N",
} as const;

export type QCustomerPrivacyRequestFlagPrivacy2Enum =
  (typeof QCustomerPrivacyRequestFlagPrivacy2Enum)[keyof typeof QCustomerPrivacyRequestFlagPrivacy2Enum];
export const QCustomerPrivacyRequestFlagPrivacy3Enum = {
  Y: "Y",
  N: "N",
} as const;

export type QCustomerPrivacyRequestFlagPrivacy3Enum =
  (typeof QCustomerPrivacyRequestFlagPrivacy3Enum)[keyof typeof QCustomerPrivacyRequestFlagPrivacy3Enum];
export const QCustomerPrivacyRequestFlagPrivacy4Enum = {
  Y: "Y",
  N: "N",
} as const;

export type QCustomerPrivacyRequestFlagPrivacy4Enum =
  (typeof QCustomerPrivacyRequestFlagPrivacy4Enum)[keyof typeof QCustomerPrivacyRequestFlagPrivacy4Enum];

/**
 *
 * @export
 * @interface QCustomerRequest
 */
export interface QCustomerRequest {
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  ndg?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  ndgType?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  bankAccount?: string;
  /**
   *
   * @type {number}
   * @memberof QCustomerRequest
   */
  income?: number;
  /**
   *
   * @type {number}
   * @memberof QCustomerRequest
   */
  monthlySalaryNumber?: number;
  /**
   *
   * @type {number}
   * @memberof QCustomerRequest
   */
  incomeGrossAmount?: number;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  profession?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  businessSector?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  currentOccupation?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  contractExpirationDate?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  qualification?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  residencePermitExpiration?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  residencePermitType?: QCustomerRequestResidencePermitTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof QCustomerRequest
   */
  notItalianCitizenship?: boolean;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  contractType?: string;
  /**
   *
   * @type {boolean}
   * @memberof QCustomerRequest
   */
  contractInSpecificCategory?: boolean;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  dateOfEntryInItaly?: string;
  /**
   *
   * @type {boolean}
   * @memberof QCustomerRequest
   */
  nonFinancialCommitment?: boolean;
  /**
   *
   * @type {number}
   * @memberof QCustomerRequest
   */
  amountOfNonFinancialCommitment?: number;
  /**
   *
   * @type {boolean}
   * @memberof QCustomerRequest
   */
  regularContract?: boolean;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  externalReferenceId?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  paymentMethod?: string;
  /**
   *
   * @type {number}
   * @memberof QCustomerRequest
   */
  installmentPayment?: number;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  chargementMethod?: string;
  /**
   *
   * @type {QCustomerPrivacyRequest}
   * @memberof QCustomerRequest
   */
  customerPrivacy?: QCustomerPrivacyRequest;
  /**
   *
   * @type {QFamilyInfoDataRequest}
   * @memberof QCustomerRequest
   */
  familyInfoData?: QFamilyInfoDataRequest;
  /**
   *
   * @type {QOtherIncomesRequest}
   * @memberof QCustomerRequest
   */
  otherIncomesRequest?: QOtherIncomesRequest;
  /**
   *
   * @type {QInsuranceInfoRequest}
   * @memberof QCustomerRequest
   */
  insuranceInfo?: QInsuranceInfoRequest;
  /**
   *
   * @type {QCustomerScoreRequest}
   * @memberof QCustomerRequest
   */
  score?: QCustomerScoreRequest;
  /**
   *
   * @type {number}
   * @memberof QCustomerRequest
   */
  yearsInAddress?: number;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  residenceSince?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  housing?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  jobType?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  digitalStatus?: QCustomerRequestDigitalStatusEnum;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  maritalStatus?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  email?: string;
  /**
   *
   * @type {QResidencyAddress}
   * @memberof QCustomerRequest
   */
  residencyAddress?: QResidencyAddress;
  /**
   *
   * @type {QDomicileAddress}
   * @memberof QCustomerRequest
   */
  domicileAddress?: QDomicileAddress;
  /**
   *
   * @type {QResidencyAddress}
   * @memberof QCustomerRequest
   */
  previousResidencyAddress?: QResidencyAddress;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  academicTitleBefore?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  academicTitleAfter?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  mobilePhoneInterPrefix?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  citizenship?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  hiryDate?: string;
  /**
   *
   * @type {QCustomerPersonalInfo}
   * @memberof QCustomerRequest
   */
  personalInfo?: QCustomerPersonalInfo;
  /**
   *
   * @type {QEmployerData}
   * @memberof QCustomerRequest
   */
  employer?: QEmployerData;
  /**
   *
   * @type {QIdentityDocument}
   * @memberof QCustomerRequest
   */
  personalId?: QIdentityDocument;
  /**
   *
   * @type {number}
   * @memberof QCustomerRequest
   */
  fixedTan?: number;
  /**
   *
   * @type {QCfFormRequest}
   * @memberof QCustomerRequest
   */
  cfFormRequest?: QCfFormRequest;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  recognitionType?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequest
   */
  companyEmployeesBracket?: string;
}

export const QCustomerRequestResidencePermitTypeEnum = {
  Car: "CAR",
  Per: "PER",
} as const;

export type QCustomerRequestResidencePermitTypeEnum =
  (typeof QCustomerRequestResidencePermitTypeEnum)[keyof typeof QCustomerRequestResidencePermitTypeEnum];
export const QCustomerRequestDigitalStatusEnum = {
  Enabled: "enabled",
  Disabled: "disabled",
} as const;

export type QCustomerRequestDigitalStatusEnum =
  (typeof QCustomerRequestDigitalStatusEnum)[keyof typeof QCustomerRequestDigitalStatusEnum];

/**
 *
 * @export
 * @interface QCustomerRequestV3
 */
export interface QCustomerRequestV3 {
  /**
   *
   * @type {string}
   * @memberof QCustomerRequestV3
   */
  ndg?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequestV3
   */
  ndgType?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequestV3
   */
  taxNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequestV3
   */
  firstname?: string;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequestV3
   */
  lastname?: string;
  /**
   *
   * @type {boolean}
   * @memberof QCustomerRequestV3
   */
  scoreEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof QCustomerRequestV3
   */
  recognitionType?: string;
}
/**
 *
 * @export
 * @interface QCustomerScoreRequest
 */
export interface QCustomerScoreRequest {
  /**
   *
   * @type {boolean}
   * @memberof QCustomerScoreRequest
   */
  scoreEnabled: boolean;
}
/**
 *
 * @export
 * @interface QDocumentAttribute
 */
export interface QDocumentAttribute {
  /**
   *
   * @type {boolean}
   * @memberof QDocumentAttribute
   */
  mandatory?: boolean;
  /**
   *
   * @type {string}
   * @memberof QDocumentAttribute
   */
  validFromStatus?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentAttribute
   */
  validToStatus?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentAttribute
   */
  attributeCode?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentAttribute
   */
  operation?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentAttribute
   */
  attributeValue?: string;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentAttribute
   */
  done?: boolean;
  /**
   *
   * @type {string}
   * @memberof QDocumentAttribute
   */
  doneTs?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentAttribute
   */
  doneUser?: string;
}
/**
 *
 * @export
 * @interface QDocumentEntity
 */
export interface QDocumentEntity {
  /**
   *
   * @type {number}
   * @memberof QDocumentEntity
   */
  docId?: number;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  offerId?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  entityType?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  ndg?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  categoryCode?: string;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagToValidate?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  validated?: boolean;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  origin?: string;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagVisible?: boolean;
  /**
   *
   * @type {Array<QFileEntity>}
   * @memberof QDocumentEntity
   */
  files?: Array<QFileEntity>;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  desc?: string;
  /**
   *
   * @type {Array<QDocumentAttribute>}
   * @memberof QDocumentEntity
   */
  attributes?: Array<QDocumentAttribute>;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  documentCode?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  channel?: string;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagAcquiredOrigin?: boolean;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  mandatoryFor?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  mandatoryForValidation?: string;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagMandatory?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagRetroCancel?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagToPrint?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  printed?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagForce?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  forced?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagFromChecklist?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagDeferred?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagToSign?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  signed?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagAcquire?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  acquired?: boolean;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  categoryDescritpion?: string;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  documentDescritpion?: string;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagMandatoryFor?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  flagMandatoryForValidation?: boolean;
  /**
   *
   * @type {number}
   * @memberof QDocumentEntity
   */
  status?: number;
  /**
   *
   * @type {string}
   * @memberof QDocumentEntity
   */
  signatureMethod?: string;
  /**
   *
   * @type {boolean}
   * @memberof QDocumentEntity
   */
  digitalSignature?: boolean;
}
/**
 *
 * @export
 * @interface QDomicileAddress
 */
export interface QDomicileAddress {
  /**
   *
   * @type {string}
   * @memberof QDomicileAddress
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof QDomicileAddress
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof QDomicileAddress
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof QDomicileAddress
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof QDomicileAddress
   */
  hamlet?: string;
  /**
   *
   * @type {string}
   * @memberof QDomicileAddress
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof QDomicileAddress
   */
  streetNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QDomicileAddress
   */
  zipCode?: string;
  /**
   *
   * @type {string}
   * @memberof QDomicileAddress
   */
  doorNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QDomicileAddress
   */
  careOf?: string;
}
/**
 *
 * @export
 * @interface QEmployerData
 */
export interface QEmployerData {
  /**
   *
   * @type {string}
   * @memberof QEmployerData
   */
  employerName?: string;
  /**
   *
   * @type {string}
   * @memberof QEmployerData
   */
  employerTaxNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QEmployerData
   */
  employerVatNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QEmployerData
   */
  employerPhone?: string;
  /**
   *
   * @type {string}
   * @memberof QEmployerData
   */
  employerCity?: string;
  /**
   *
   * @type {string}
   * @memberof QEmployerData
   */
  employerAddress?: string;
  /**
   *
   * @type {string}
   * @memberof QEmployerData
   */
  employerProvince?: string;
  /**
   *
   * @type {string}
   * @memberof QEmployerData
   */
  employerCountry?: string;
  /**
   *
   * @type {string}
   * @memberof QEmployerData
   */
  employerStreetNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QEmployerData
   */
  employerZipCode?: string;
}
/**
 *
 * @export
 * @interface QFamilyInfoDataRequest
 */
export interface QFamilyInfoDataRequest {
  /**
   *
   * @type {number}
   * @memberof QFamilyInfoDataRequest
   */
  numberOfFamilyMembers?: number;
  /**
   *
   * @type {number}
   * @memberof QFamilyInfoDataRequest
   */
  numberOfFamilyMembersWithIncome?: number;
  /**
   *
   * @type {boolean}
   * @memberof QFamilyInfoDataRequest
   */
  childMember?: boolean;
  /**
   *
   * @type {number}
   * @memberof QFamilyInfoDataRequest
   */
  numChildMemberUnderAge?: number;
  /**
   *
   * @type {number}
   * @memberof QFamilyInfoDataRequest
   */
  numChildMemberOverAge?: number;
  /**
   *
   * @type {number}
   * @memberof QFamilyInfoDataRequest
   */
  totFamilyIncome?: number;
  /**
   *
   * @type {number}
   * @memberof QFamilyInfoDataRequest
   */
  familyFinancialCommitment?: number;
  /**
   *
   * @type {boolean}
   * @memberof QFamilyInfoDataRequest
   */
  cohabitWithCustomer?: boolean;
  /**
   *
   * @type {number}
   * @memberof QFamilyInfoDataRequest
   */
  monthlyMortgages?: number;
  /**
   *
   * @type {number}
   * @memberof QFamilyInfoDataRequest
   */
  monthlyLoans?: number;
  /**
   *
   * @type {number}
   * @memberof QFamilyInfoDataRequest
   */
  monthlyLeasings?: number;
}
/**
 *
 * @export
 * @interface QFileEntity
 */
export interface QFileEntity {
  /**
   *
   * @type {number}
   * @memberof QFileEntity
   */
  fileId?: number;
  /**
   *
   * @type {number}
   * @memberof QFileEntity
   */
  versionId?: number;
  /**
   *
   * @type {number}
   * @memberof QFileEntity
   */
  docId?: number;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  docCod?: string;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  storageId?: string;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  uploadTs?: string;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  uploadUser?: string;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  fileName?: string;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  fileType?: string;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  channel?: string;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  note?: string;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  deletionFlag?: string;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  deletionTs?: string;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  deletionUser?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof QFileEntity
   */
  file?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof QFileEntity
   */
  partId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof QFileEntity
   */
  partList?: Array<string>;
  /**
   *
   * @type {Array<Array<string>>}
   * @memberof QFileEntity
   */
  contentList?: Array<Array<string>>;
}
/**
 *
 * @export
 * @interface QGeneralMessage
 */
export interface QGeneralMessage {
  /**
   *
   * @type {string}
   * @memberof QGeneralMessage
   */
  msgCode?: string;
  /**
   *
   * @type {string}
   * @memberof QGeneralMessage
   */
  msgDescription?: string;
  /**
   *
   * @type {string}
   * @memberof QGeneralMessage
   */
  level?: QGeneralMessageLevelEnum;
  /**
   *
   * @type {string}
   * @memberof QGeneralMessage
   */
  field?: string;
}

export const QGeneralMessageLevelEnum = {
  Info: "INFO",
  Warning: "WARNING",
  Error: "ERROR",
} as const;

export type QGeneralMessageLevelEnum =
  (typeof QGeneralMessageLevelEnum)[keyof typeof QGeneralMessageLevelEnum];

/**
 *
 * @export
 * @interface QGeneralResponse
 */
export interface QGeneralResponse {
  /**
   *
   * @type {string}
   * @memberof QGeneralResponse
   */
  messageDescription?: string;
  /**
   *
   * @type {Array<QGeneralMessage>}
   * @memberof QGeneralResponse
   */
  msgs?: Array<QGeneralMessage>;
  /**
   *
   * @type {string}
   * @memberof QGeneralResponse
   */
  outcome?: string;
}
/**
 *
 * @export
 * @interface QIdentityDocument
 */
export interface QIdentityDocument {
  /**
   *
   * @type {string}
   * @memberof QIdentityDocument
   */
  issuingAuthority?: string;
  /**
   *
   * @type {string}
   * @memberof QIdentityDocument
   */
  issuePlace?: string;
  /**
   *
   * @type {string}
   * @memberof QIdentityDocument
   */
  issueCountry?: string;
  /**
   *
   * @type {string}
   * @memberof QIdentityDocument
   */
  documentNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QIdentityDocument
   */
  issueProvince?: string;
  /**
   *
   * @type {string}
   * @memberof QIdentityDocument
   */
  documentType?: string;
  /**
   *
   * @type {string}
   * @memberof QIdentityDocument
   */
  issueDate?: string;
  /**
   *
   * @type {string}
   * @memberof QIdentityDocument
   */
  expiringDate?: string;
}
/**
 *
 * @export
 * @interface QInsuranceInfoRequest
 */
export interface QInsuranceInfoRequest {
  /**
   *
   * @type {string}
   * @memberof QInsuranceInfoRequest
   */
  insuranceType?: string;
  /**
   *
   * @type {string}
   * @memberof QInsuranceInfoRequest
   */
  insuranceInPlace?: string;
}
/**
 *
 * @export
 * @interface QIntermediationChainPosition
 */
export interface QIntermediationChainPosition {
  /**
   *
   * @type {number}
   * @memberof QIntermediationChainPosition
   */
  priority?: number;
  /**
   *
   * @type {number}
   * @memberof QIntermediationChainPosition
   */
  agente?: number;
  /**
   *
   * @type {number}
   * @memberof QIntermediationChainPosition
   */
  convenzionato?: number;
  /**
   *
   * @type {number}
   * @memberof QIntermediationChainPosition
   */
  puntoVendita?: number;
  /**
   *
   * @type {number}
   * @memberof QIntermediationChainPosition
   */
  reteVendita?: number;
  /**
   *
   * @type {number}
   * @memberof QIntermediationChainPosition
   */
  subAgente?: number;
  /**
   *
   * @type {number}
   * @memberof QIntermediationChainPosition
   */
  venditore?: number;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  nazionale?: string;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  territorio?: string;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  agenziaMadre?: string;
  /**
   *
   * @type {number}
   * @memberof QIntermediationChainPosition
   */
  agenziaWeb?: number;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  competenza?: string;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  middleOffice?: string;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  codiceAnagrafico?: string;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  tipologiaAgente?: string;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  canale?: string;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  stato?: string;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  attributo?: string;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  accessType?: string;
  /**
   *
   * @type {string}
   * @memberof QIntermediationChainPosition
   */
  tipologia?: string;
}
/**
 *
 * @export
 * @interface QOtherIncomesRequest
 */
export interface QOtherIncomesRequest {
  /**
   *
   * @type {number}
   * @memberof QOtherIncomesRequest
   */
  incomeAlimenti?: number;
  /**
   *
   * @type {number}
   * @memberof QOtherIncomesRequest
   */
  incomeAffittoImmobili?: number;
  /**
   *
   * @type {number}
   * @memberof QOtherIncomesRequest
   */
  incomeAltro?: number;
  /**
   *
   * @type {number}
   * @memberof QOtherIncomesRequest
   */
  incomePensione?: number;
  /**
   *
   * @type {number}
   * @memberof QOtherIncomesRequest
   */
  numberOfMonths?: number;
  /**
   *
   * @type {number}
   * @memberof QOtherIncomesRequest
   */
  outIncomeAffito?: number;
  /**
   *
   * @type {number}
   * @memberof QOtherIncomesRequest
   */
  outIncomeMutuo?: number;
  /**
   *
   * @type {number}
   * @memberof QOtherIncomesRequest
   */
  outIncomeAltro?: number;
}
/**
 *
 * @export
 * @interface QQuotationBaseDataSetV2
 */
export interface QQuotationBaseDataSetV2 {
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  loanDuration?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  requestedAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  loanFees?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  financedAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  loanInstallment?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  tan?: number;
  /**
   *
   * @type {string}
   * @memberof QQuotationBaseDataSetV2
   */
  loanPurpose?: string;
  /**
   *
   * @type {string}
   * @memberof QQuotationBaseDataSetV2
   */
  financialProduct?: string;
  /**
   *
   * @type {string}
   * @memberof QQuotationBaseDataSetV2
   */
  financialTable?: string;
  /**
   *
   * @type {Array<QQuotationInsurancesTupleServiceRequest>}
   * @memberof QQuotationBaseDataSetV2
   */
  insurancesData?: Array<QQuotationInsurancesTupleServiceRequest>;
  /**
   *
   * @type {boolean}
   * @memberof QQuotationBaseDataSetV2
   */
  derogated?: boolean;
  /**
   *
   * @type {string}
   * @memberof QQuotationBaseDataSetV2
   */
  promotionalCode?: string;
  /**
   *
   * @type {boolean}
   * @memberof QQuotationBaseDataSetV2
   */
  toppedProposal?: boolean;
  /**
   *
   * @type {string}
   * @memberof QQuotationBaseDataSetV2
   */
  toppedProposalType?: string;
  /**
   *
   * @type {string}
   * @memberof QQuotationBaseDataSetV2
   */
  agreementCode?: string;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  disbursedAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  netDisbursedAmountObligations?: number;
  /**
   *
   * @type {string}
   * @memberof QQuotationBaseDataSetV2
   */
  firstInstallmentDate?: string;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  impostaSost?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  taeg?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  teg?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  dueAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  interest?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  principalInterest?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationBaseDataSetV2
   */
  installmentFee?: number;
}
/**
 *
 * @export
 * @interface QQuotationInsurancesTupleServiceRequest
 */
export interface QQuotationInsurancesTupleServiceRequest {
  /**
   *
   * @type {string}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  code?: string;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  cost?: number;
  /**
   *
   * @type {string}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  ownerType?: string;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  externalProductCode?: string;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  lifeCoverageAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  nonLifeCoverageAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  costWithoutTaxes?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  taxesAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  markupAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  markupPercentage?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  markupLife?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  markupNonLife?: number;
  /**
   *
   * @type {string}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  totalLifeAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QQuotationInsurancesTupleServiceRequest
   */
  totalNonLifeAmount?: number;
}
/**
 *
 * @export
 * @interface QReferent
 */
export interface QReferent {
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  referentId?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  referentType?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  relationWithCustomer?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  birthPlace?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  birthDate?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  taxNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  vatNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  gender?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  birthCountry?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  nationality?: string;
  /**
   *
   * @type {boolean}
   * @memberof QReferent
   */
  politicallyExposed?: boolean;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  politExposedDesc?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  residencyCountry?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  residencyCity?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  residencyProvince?: string;
  /**
   *
   * @type {string}
   * @memberof QReferent
   */
  residencyZipCode?: string;
}
/**
 *
 * @export
 * @interface QResidencyAddress
 */
export interface QResidencyAddress {
  /**
   *
   * @type {string}
   * @memberof QResidencyAddress
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof QResidencyAddress
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof QResidencyAddress
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof QResidencyAddress
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof QResidencyAddress
   */
  hamlet?: string;
  /**
   *
   * @type {string}
   * @memberof QResidencyAddress
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof QResidencyAddress
   */
  streetNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QResidencyAddress
   */
  zipCode?: string;
  /**
   *
   * @type {string}
   * @memberof QResidencyAddress
   */
  doorNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QResidencyAddress
   */
  careOf?: string;
}
/**
 *
 * @export
 * @interface QUpdatePositionRequestV2
 */
export interface QUpdatePositionRequestV2 {
  /**
   *
   * @type {QBeneficiary}
   * @memberof QUpdatePositionRequestV2
   */
  beneficiary?: QBeneficiary;
  /**
   *
   * @type {QReferent}
   * @memberof QUpdatePositionRequestV2
   */
  referent?: QReferent;
  /**
   *
   * @type {string}
   * @memberof QUpdatePositionRequestV2
   */
  externalReferenceId?: string;
  /**
   *
   * @type {string}
   * @memberof QUpdatePositionRequestV2
   */
  process?: QUpdatePositionRequestV2ProcessEnum;
  /**
   *
   * @type {string}
   * @memberof QUpdatePositionRequestV2
   */
  productCode?: string;
  /**
   *
   * @type {string}
   * @memberof QUpdatePositionRequestV2
   */
  finalOfferChannel?: string;
  /**
   *
   * @type {string}
   * @memberof QUpdatePositionRequestV2
   */
  riskClass?: string;
  /**
   *
   * @type {string}
   * @memberof QUpdatePositionRequestV2
   */
  expirationDate?: string;
  /**
   *
   * @type {QQuotationBaseDataSetV2}
   * @memberof QUpdatePositionRequestV2
   */
  quotationData?: QQuotationBaseDataSetV2;
  /**
   *
   * @type {Array<QCustomerRequest>}
   * @memberof QUpdatePositionRequestV2
   */
  customers?: Array<QCustomerRequest>;
  /**
   *
   * @type {number}
   * @memberof QUpdatePositionRequestV2
   */
  fixedTan?: number;
}

export const QUpdatePositionRequestV2ProcessEnum = {
  _1: "1",
  _2: "2",
  _3: "3",
} as const;

export type QUpdatePositionRequestV2ProcessEnum =
  (typeof QUpdatePositionRequestV2ProcessEnum)[keyof typeof QUpdatePositionRequestV2ProcessEnum];

/**
 *
 * @export
 * @interface QUpdatePositionResponse
 */
export interface QUpdatePositionResponse {
  /**
   *
   * @type {QGeneralResponse}
   * @memberof QUpdatePositionResponse
   */
  generalResponse?: QGeneralResponse;
  /**
   *
   * @type {string}
   * @memberof QUpdatePositionResponse
   */
  positionState?: string;
}
/**
 *
 * @export
 * @interface QineticAggregatorCallbackRequest
 */
export interface QineticAggregatorCallbackRequest {
  /**
   *
   * @type {Result}
   * @memberof QineticAggregatorCallbackRequest
   */
  result?: Result;
  /**
   *
   * @type {string}
   * @memberof QineticAggregatorCallbackRequest
   */
  status?: string;
  /**
   *
   * @type {Array<QineticQuotationExtendedDataSetRequest>}
   * @memberof QineticAggregatorCallbackRequest
   */
  quotationData?: Array<QineticQuotationExtendedDataSetRequest>;
}
/**
 *
 * @export
 * @interface QineticAttributeRequest
 */
export interface QineticAttributeRequest {
  /**
   *
   * @type {string}
   * @memberof QineticAttributeRequest
   */
  key?: string;
  /**
   *
   * @type {string}
   * @memberof QineticAttributeRequest
   */
  value?: string;
}
/**
 *
 * @export
 * @interface QineticBeneficiaryResponseReadRequest
 */
export interface QineticBeneficiaryResponseReadRequest {
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  beneficiaryId?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  beneficiaryType?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  relationWithCustomer?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  birthPlace?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  birthDate?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  taxNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  vatNumber?: string;
  /**
   *
   * @type {number}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  beneficiaryPercentual?: number;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  gender?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  birthCountry?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  nationality?: string;
  /**
   *
   * @type {boolean}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  politicallyExposed?: boolean;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  politExposedDesc?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  residencyCountry?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  residencyCity?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  residencyProvince?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  residencyZipCode?: string;
  /**
   *
   * @type {string}
   * @memberof QineticBeneficiaryResponseReadRequest
   */
  isHeir?: string;
}
/**
 *
 * @export
 * @interface QineticCallbackRequest
 */
export interface QineticCallbackRequest {
  /**
   * Esito della callback
   * @type {string}
   * @memberof QineticCallbackRequest
   */
  outcome?: QineticCallbackRequestOutcomeEnum;
  /**
   * Descrizione dell\'esito
   * @type {string}
   * @memberof QineticCallbackRequest
   */
  reason?: string;
}

export const QineticCallbackRequestOutcomeEnum = {
  Ok: "OK",
  Ko: "KO",
  Te: "TE",
} as const;

export type QineticCallbackRequestOutcomeEnum =
  (typeof QineticCallbackRequestOutcomeEnum)[keyof typeof QineticCallbackRequestOutcomeEnum];

/**
 *
 * @export
 * @interface QineticCallbackResponse
 */
export interface QineticCallbackResponse {
  /**
   * Esito della ricezione della callback
   * @type {boolean}
   * @memberof QineticCallbackResponse
   */
  receive?: boolean;
}
/**
 *
 * @export
 * @interface QineticDealCreationRequest
 */
export interface QineticDealCreationRequest {
  /**
   *
   * @type {LoanIntent}
   * @memberof QineticDealCreationRequest
   */
  loanIntent?: LoanIntent;
  /**
   *
   * @type {string}
   * @memberof QineticDealCreationRequest
   */
  applicationId?: string;
  /**
   *
   * @type {string}
   * @memberof QineticDealCreationRequest
   */
  channelForm?: QineticDealCreationRequestChannelFormEnum;
  /**
   *
   * @type {string}
   * @memberof QineticDealCreationRequest
   */
  creationTool?: string;
  /**
   *
   * @type {string}
   * @memberof QineticDealCreationRequest
   */
  phone?: string;
  /**
   *
   * @type {string}
   * @memberof QineticDealCreationRequest
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof QineticDealCreationRequest
   */
  positionId?: string;
  /**
   *
   * @type {string}
   * @memberof QineticDealCreationRequest
   */
  role?: QineticDealCreationRequestRoleEnum;
}

export const QineticDealCreationRequestChannelFormEnum = {
  Rf: "RF",
} as const;

export type QineticDealCreationRequestChannelFormEnum =
  (typeof QineticDealCreationRequestChannelFormEnum)[keyof typeof QineticDealCreationRequestChannelFormEnum];
export const QineticDealCreationRequestRoleEnum = {
  R: "R",
  C: "C",
} as const;

export type QineticDealCreationRequestRoleEnum =
  (typeof QineticDealCreationRequestRoleEnum)[keyof typeof QineticDealCreationRequestRoleEnum];

/**
 *
 * @export
 * @interface QineticDealCreationResponse
 */
export interface QineticDealCreationResponse {
  /**
   *
   * @type {string}
   * @memberof QineticDealCreationResponse
   */
  dealId?: string;
  /**
   *
   * @type {string}
   * @memberof QineticDealCreationResponse
   */
  contactId?: string;
}
/**
 *
 * @export
 * @interface QineticDocument
 */
export interface QineticDocument {
  /**
   *
   * @type {string}
   * @memberof QineticDocument
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof QineticDocument
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof QineticDocument
   */
  type?: QineticDocumentTypeEnum;
}

export const QineticDocumentTypeEnum = {
  Pdf: "PDF",
  Jpg: "JPG",
  Jpeg: "JPEG",
  Png: "PNG",
} as const;

export type QineticDocumentTypeEnum =
  (typeof QineticDocumentTypeEnum)[keyof typeof QineticDocumentTypeEnum];

/**
 *
 * @export
 * @interface QineticDocumentListRequest
 */
export interface QineticDocumentListRequest {
  /**
   *
   * @type {Array<QineticDocument>}
   * @memberof QineticDocumentListRequest
   */
  documents?: Array<QineticDocument>;
}
/**
 *
 * @export
 * @interface QineticMetadata
 */
export interface QineticMetadata {
  /**
   *
   * @type {string}
   * @memberof QineticMetadata
   */
  stateEnum?: string;
}
/**
 *
 * @export
 * @interface QineticQuotationBaseDataSetRequest
 */
export interface QineticQuotationBaseDataSetRequest {
  /**
   *
   * @type {number}
   * @memberof QineticQuotationBaseDataSetRequest
   */
  loanDuration?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationBaseDataSetRequest
   */
  requestedAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationBaseDataSetRequest
   */
  loanFees?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationBaseDataSetRequest
   */
  financedAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationBaseDataSetRequest
   */
  loanInstallment?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationBaseDataSetRequest
   */
  tan?: number;
  /**
   *
   * @type {string}
   * @memberof QineticQuotationBaseDataSetRequest
   */
  loanPurpose?: string;
  /**
   *
   * @type {string}
   * @memberof QineticQuotationBaseDataSetRequest
   */
  financialProduct?: string;
  /**
   *
   * @type {string}
   * @memberof QineticQuotationBaseDataSetRequest
   */
  financialTable?: string;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationBaseDataSetRequest
   */
  disbursedAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationBaseDataSetRequest
   */
  netDisbursedAmountObligations?: number;
}
/**
 *
 * @export
 * @interface QineticQuotationExtendedDataSetRequest
 */
export interface QineticQuotationExtendedDataSetRequest {
  /**
   *
   * @type {QineticQuotationBaseDataSetRequest}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  quotationBaseData?: QineticQuotationBaseDataSetRequest;
  /**
   *
   * @type {Array<QineticQuotationInsurancesTupleServiceResponseRequest>}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  insurancesData?: Array<QineticQuotationInsurancesTupleServiceResponseRequest>;
  /**
   *
   * @type {string}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  firstInstallmentDate?: string;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  debitDate?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  impostaSost?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  preTechnicalAmmortization?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  insuranceCost?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  taeg?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  teg?: number;
  /**
   *
   * @type {string}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  insuranceServiceCode?: string;
  /**
   *
   * @type {string}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  insuranceServiceDescription?: string;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  indiceAssofin?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  postelBankReportingCost?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  totalBankReportingStamp?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  guaranteeFee?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  dueAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  managementFees?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  interests?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  principalInterest?: number;
  /**
   *
   * @type {string}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  promotionalCode?: string;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  installmentFee?: number;
  /**
   *
   * @type {Array<QineticAttributeRequest>}
   * @memberof QineticQuotationExtendedDataSetRequest
   */
  attributes?: Array<QineticAttributeRequest>;
}
/**
 *
 * @export
 * @interface QineticQuotationInsurancesTupleServiceResponseRequest
 */
export interface QineticQuotationInsurancesTupleServiceResponseRequest {
  /**
   *
   * @type {string}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  code?: string;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  cost?: number;
  /**
   *
   * @type {string}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  ownerType?: string;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  externalProductCode?: string;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  lifeCoverageAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  nonLifeCoverageAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  costWithoutTaxes?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  taxesAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  markupAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  markupPercentage?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  markupLife?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  markupNonLife?: number;
  /**
   *
   * @type {string}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  totalLifeAmount?: number;
  /**
   *
   * @type {number}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  totalNonLifeAmount?: number;
  /**
   *
   * @type {Array<QineticBeneficiaryResponseReadRequest>}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  beneficiaries?: Array<QineticBeneficiaryResponseReadRequest>;
  /**
   *
   * @type {Array<QineticReferentResponseReadRequest>}
   * @memberof QineticQuotationInsurancesTupleServiceResponseRequest
   */
  referents?: Array<QineticReferentResponseReadRequest>;
}
/**
 *
 * @export
 * @interface QineticReferentResponseReadRequest
 */
export interface QineticReferentResponseReadRequest {
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  referentId?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  referentType?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  relationWithCustomer?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  birthPlace?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  birthDate?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  taxNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  vatNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  gender?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  birthCountry?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  nationality?: string;
  /**
   *
   * @type {boolean}
   * @memberof QineticReferentResponseReadRequest
   */
  politicallyExposed?: boolean;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  politExposedDesc?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  residencyCountry?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  residencyCity?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  residencyProvince?: string;
  /**
   *
   * @type {string}
   * @memberof QineticReferentResponseReadRequest
   */
  residencyZipCode?: string;
}
/**
 *
 * @export
 * @interface Question
 */
export interface Question {
  /**
   *
   * @type {string}
   * @memberof Question
   */
  questionId?: string;
  /**
   *
   * @type {string}
   * @memberof Question
   */
  text?: string;
  /**
   *
   * @type {Array<AvailableResponse>}
   * @memberof Question
   */
  availableResponse?: Array<AvailableResponse>;
  /**
   *
   * @type {string}
   * @memberof Question
   */
  conditionValue?: string;
  /**
   *
   * @type {Array<Question>}
   * @memberof Question
   */
  children?: Array<Question>;
}
/**
 *
 * @export
 * @interface QuotationRequest
 */
export interface QuotationRequest {
  /**
   * Da utilizzare per popolare il campo requestId in OfferRequest
   * @type {string}
   * @memberof QuotationRequest
   */
  requestId: string;
  /**
   * Importo richiesto (€)
   * @type {number}
   * @memberof QuotationRequest
   */
  importo: number;
  /**
   * Codice finalita (tabella 6.1).  ### 6.1 Finalità prestito  | ID | Finalità | | :--- | :--- | | 1 | PC ed elettronica | | 2 | Formazione e università | | 4 | Arredamento | | 5 | Ristrutturazione casa | | 15 | Moto nuove/km0 | | 16 | Moto usate | | 24 | Viaggi e vacanze | | 26 | Spese mediche | | 27 | Matrimonio e cerimonie | | 29 | Auto nuove/km0 | | 30 | Auto usate | | 31 | Consolidamento debiti | | 32 | Acquisto immobile | | 33 | Liquidità |
   * @type {number}
   * @memberof QuotationRequest
   */
  finalita: number;
  /**
   * Durata in mesi
   * @type {number}
   * @memberof QuotationRequest
   */
  durata: number;
  /**
   * Con assicurazione CPI
   * @type {boolean}
   * @memberof QuotationRequest
   */
  assicurazione?: boolean;
  /**
   *
   * @type {string}
   * @memberof QuotationRequest
   */
  dataNascita: string;
  /**
   * Utilizzare la tabella dei codici istat aggiornata a gennaio 2026 prendendo il Codice Comune formato alfanumerico
   * @type {string}
   * @memberof QuotationRequest
   */
  comuneDomicilio: string;
  /**
   * ### 6.2 Tipo contratto  | ID | Tipo contratto | | :--- | :--- | | 1 | Dipendente a tempo determinato | | 2 | Dipendente a tempo indeterminato | | 3 | Lavoratore autonomo | | 4 | Reddito non dimostrabile | | 5 | Studente | | 6 | Casalinga | | 7 | Pensionato | | 9 | Libero professionista | | 12 | Disoccupato |
   * @type {number}
   * @memberof QuotationRequest
   */
  tipoContratto?: number;
  /**
   * ### 6.5 Tipo impiego  | ID | Tipo Impiego | | :--- | :--- | | 1 | Dirigente | | 2 | Quadro | | 3 | Impiegato | | 4 | Operaio | | 14 | Militare | | 24 | Architetto | | 25 | Avvocato | | 26 | Commercialista | | 27 | Ingegnere | | 28 | Medico | | 29 | Notaio | | 30 | Agente | | 34 | Autotrasportatore | | 35 | Artigiano | | 36 | Agricoltore/Allevatore | | 39 | Commerciante | | 40 | Geometra | | 41 | Imprenditore | | 48 | Pensione di anzianità | | 49 | Pensione sociale | | 51 | Contratto di inserimento | | 52 | Apprendista | | 53 | Insegnante non di ruolo | | 55 | Altro | | 56 | Dipendente Statale | | 57 | Dipendente Pubblico |
   * @type {number}
   * @memberof QuotationRequest
   */
  tipoImpiego?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationRequest
   */
  numDipendentiAzienda?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationRequest
   */
  dataInizioImpiego?: string;
  /**
   * Reddito mensile netto (€)
   * @type {number}
   * @memberof QuotationRequest
   */
  redditoMensile?: number;
  /**
   * Mensilita annue (12, 13, 14)
   * @type {number}
   * @memberof QuotationRequest
   */
  numMensilita?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationRequest
   */
  channel?: QuotationRequestChannelEnum;
  /**
   *
   * @type {ClientInfo}
   * @memberof QuotationRequest
   */
  clientInfo?: ClientInfo;
}

export const QuotationRequestChannelEnum = {
  Conte: "CONTE",
  PolWebA: "POL-WEB-A",
  PolWebB: "POL-WEB-B",
  PolCrm: "POL-CRM",
  SegWebA: "SEG-WEB-A",
  SegWebB: "SEG-WEB-B",
  SegCrm: "SEG-CRM",
  SegWeb: "SEG-WEB",
  S24WebA: "S24-WEB-A",
  S24WebB: "S24-WEB-B",
  S24Crm: "S24-CRM",
  PolWeb: "POL-WEB",
  Autouncle: "AUTOUNCLE",
  Cofidis: "COFIDIS",
  Mutuiamo: "MUTUIAMO",
  CtMotor: "CT_MOTOR",
  CtPet: "CT_PET",
  CtPetCl: "CT_PET_CL",
  Easypol: "EASYPOL",
  Supermoney: "SUPERMONEY",
  TogetherPrice: "TOGETHER_PRICE",
  Windtre: "WINDTRE",
} as const;

export type QuotationRequestChannelEnum =
  (typeof QuotationRequestChannelEnum)[keyof typeof QuotationRequestChannelEnum];

/**
 *
 * @export
 * @interface QuotationResponse
 */
export interface QuotationResponse {
  /**
   * Da utilizzare per popolare il campo requestId in OfferRequest
   * @type {string}
   * @memberof QuotationResponse
   */
  applicationId?: string;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  rata?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  taeg?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  tan?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  importoErogato?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  importoFinanziato?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  importoTotaleDaRimborsare?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  imposta?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  speseIniziali?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  speseMensili?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  speseAnnuali?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  speseAssicurative?: number;
  /**
   *
   * @type {number}
   * @memberof QuotationResponse
   */
  simulazioneValida?: number;
  /**
   *
   * @type {string}
   * @memberof QuotationResponse
   */
  descrizioneErrore?: string;
}
/**
 *
 * @export
 * @interface RedirectOtpRequest
 */
export interface RedirectOtpRequest {
  /**
   *
   * @type {string}
   * @memberof RedirectOtpRequest
   */
  email?: string;
}
/**
 *
 * @export
 * @interface RedirectPersonalAreaRequest
 */
export interface RedirectPersonalAreaRequest {
  /**
   *
   * @type {string}
   * @memberof RedirectPersonalAreaRequest
   */
  positionId?: string;
}
/**
 *
 * @export
 * @interface RedirectResponse
 */
export interface RedirectResponse {
  /**
   *
   * @type {string}
   * @memberof RedirectResponse
   */
  url?: string;
}
/**
 *
 * @export
 * @interface RedirectWelcomeRequest
 */
export interface RedirectWelcomeRequest {
  /**
   *
   * @type {string}
   * @memberof RedirectWelcomeRequest
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof RedirectWelcomeRequest
   */
  channel?: RedirectWelcomeRequestChannelEnum;
}

export const RedirectWelcomeRequestChannelEnum = {
  Conte: "CONTE",
  Pol: "POL",
  Facile: "FACILE",
  Lead: "LEAD",
} as const;

export type RedirectWelcomeRequestChannelEnum =
  (typeof RedirectWelcomeRequestChannelEnum)[keyof typeof RedirectWelcomeRequestChannelEnum];

/**
 *
 * @export
 * @interface ResidencePermitData
 */
export interface ResidencePermitData {
  /**
   *
   * @type {string}
   * @memberof ResidencePermitData
   */
  number?: string;
  /**
   *
   * @type {string}
   * @memberof ResidencePermitData
   */
  expirationDate?: string;
  /**
   *
   * @type {string}
   * @memberof ResidencePermitData
   */
  releaseDate?: string;
}
/**
 *
 * @export
 * @interface Result
 */
export interface Result {
  /**
   *
   * @type {string}
   * @memberof Result
   */
  outcome?: ResultOutcomeEnum;
  /**
   *
   * @type {string}
   * @memberof Result
   */
  reason?: string;
}

export const ResultOutcomeEnum = {
  Ok: "OK",
  Ko: "KO",
  Te: "TE",
} as const;

export type ResultOutcomeEnum =
  (typeof ResultOutcomeEnum)[keyof typeof ResultOutcomeEnum];

/**
 *
 * @export
 * @interface ScipafiResponse
 */
export interface ScipafiResponse {
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  homeProvince?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  homeCity?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  homeZipCode?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  homeStreetNameAndNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkFiscalCode?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkAlive?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkFirstName?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkLastName?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkGender?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkBirthCity?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkBirthProvince?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkBirthCountry?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkBirthDate?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkTaxCity?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkTaxProvince?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkTaxZipcode?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkTaxStreetNameAndNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkHCNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkHCExpiration?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkDriveLicNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkDriveLicStolenLost?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkDriveLicAuth?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkDriveLicRelease?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkDriveLicExpiration?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkDriveLicBadgeNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkPassportNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkPassportStolenLost?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkPassportAuth?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkPassportRelease?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkPassportExpiration?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkResPermitNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkResPermitStolenLost?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkResPermitCitizenshipResult?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkResPermitRelease?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkResPermitExpiration?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkIDCardNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkIDCardExpiration?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkOtherDocStolenLost?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkVatNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkInpsTipologiaContratto?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkInailNumero?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkInailCfDatoreLavoro?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkInailCodiceControllo?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkTaxDeclarationFiscalCodeReplacement?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkTaxDeclarationdeclarationYear?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkTaxDeclarationtotalIncome?: string;
  /**
   *
   * @type {string}
   * @memberof ScipafiResponse
   */
  checkTaxDeclarationType?: string;
  /**
   *
   * @type {number}
   * @memberof ScipafiResponse
   */
  check_step?: number;
}
/**
 *
 * @export
 * @interface Session
 */
export interface Session {
  /**
   *
   * @type {string}
   * @memberof Session
   */
  token?: string;
  /**
   *
   * @type {string}
   * @memberof Session
   */
  state?: SessionStateEnum;
}

export const SessionStateEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type SessionStateEnum =
  (typeof SessionStateEnum)[keyof typeof SessionStateEnum];

/**
 *
 * @export
 * @interface SessionInfoResponse
 */
export interface SessionInfoResponse {
  /**
   *
   * @type {Session}
   * @memberof SessionInfoResponse
   */
  session?: Session;
  /**
   *
   * @type {Loan}
   * @memberof SessionInfoResponse
   */
  loan?: Loan;
  /**
   *
   * @type {Customer}
   * @memberof SessionInfoResponse
   */
  customer?: Customer;
}
/**
 *
 * @export
 * @interface SignSessionDocuments
 */
export interface SignSessionDocuments {
  /**
   *
   * @type {string}
   * @memberof SignSessionDocuments
   */
  documentId?: string;
  /**
   *
   * @type {number}
   * @memberof SignSessionDocuments
   */
  documentNumber?: number;
}
/**
 *
 * @export
 * @interface Signers
 */
export interface Signers {
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  surname?: string;
  /**
   *
   * @type {Array<StartSessionDocumentDetail>}
   * @memberof Signers
   */
  documentsDetail?: Array<StartSessionDocumentDetail>;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  languageCode?: SignersLanguageCodeEnum;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  countryResidence?: string;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  documentIssuingCountry?: string;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  identificationCountry?: string;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  identificationType?: SignersIdentificationTypeEnum;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  phoneMobile?: string;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  documentType?: SignersDocumentTypeEnum;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  documentIssuedBy?: string;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  documentIssuedOn?: string;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  documentExpiryDate?: string;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  serialNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Signers
   */
  documentNumber?: string;
}

export const SignersLanguageCodeEnum = {
  Af: "AF",
  AfZa: "AF_ZA",
  Ar: "AR",
  ArAe: "AR_AE",
  ArBh: "AR_BH",
  ArDz: "AR_DZ",
  ArEg: "AR_EG",
  ArIq: "AR_IQ",
  ArJo: "AR_JO",
  ArKw: "AR_KW",
  ArLb: "AR_LB",
  ArLy: "AR_LY",
  ArMa: "AR_MA",
  ArOm: "AR_OM",
  ArQa: "AR_QA",
  ArSa: "AR_SA",
  ArSy: "AR_SY",
  ArTn: "AR_TN",
  ArYe: "AR_YE",
  Az: "AZ",
  AzAz: "AZ_AZ",
  Be: "BE",
  BeBy: "BE_BY",
  Bg: "BG",
  BgBg: "BG_BG",
  BsBa: "BS_BA",
  Ca: "CA",
  CaEs: "CA_ES",
  Cs: "CS",
  CsCz: "CS_CZ",
  Cy: "CY",
  CyGb: "CY_GB",
  Da: "DA",
  DaDk: "DA_DK",
  De: "DE",
  DeAt: "DE_AT",
  DeCh: "DE_CH",
  DeDe: "DE_DE",
  DeLi: "DE_LI",
  DeLu: "DE_LU",
  Dv: "DV",
  DvMv: "DV_MV",
  El: "EL",
  ElGr: "EL_GR",
  En: "EN",
  EnAu: "EN_AU",
  EnBz: "EN_BZ",
  EnCa: "EN_CA",
  EnCb: "EN_CB",
  EnGb: "EN_GB",
  EnIe: "EN_IE",
  EnJm: "EN_JM",
  EnNz: "EN_NZ",
  EnPh: "EN_PH",
  EnTt: "EN_TT",
  EnUs: "EN_US",
  EnZa: "EN_ZA",
  EnZw: "EN_ZW",
  Eo: "EO",
  Es: "ES",
  EsAr: "ES_AR",
  EsBo: "ES_BO",
  EsCl: "ES_CL",
  EsCo: "ES_CO",
  EsCr: "ES_CR",
  EsDo: "ES_DO",
  EsEc: "ES_EC",
  EsEs: "ES_ES",
  EsGt: "ES_GT",
  EsHn: "ES_HN",
  EsMx: "ES_MX",
  EsNi: "ES_NI",
  EsPa: "ES_PA",
  EsPe: "ES_PE",
  EsPr: "ES_PR",
  EsPy: "ES_PY",
  EsSv: "ES_SV",
  EsUy: "ES_UY",
  EsVe: "ES_VE",
  Et: "ET",
  EtEe: "ET_EE",
  Eu: "EU",
  EuEs: "EU_ES",
  Fa: "FA",
  FaIr: "FA_IR",
  Fi: "FI",
  FiFi: "FI_FI",
  Fo: "FO",
  FoFo: "FO_FO",
  Fr: "FR",
  FrBe: "FR_BE",
  FrCa: "FR_CA",
  FrCh: "FR_CH",
  FrFr: "FR_FR",
  FrLu: "FR_LU",
  FrMc: "FR_MC",
  Gl: "GL",
  GlEs: "GL_ES",
  Gu: "GU",
  GuIn: "GU_IN",
  He: "HE",
  HeIl: "HE_IL",
  Hi: "HI",
  HiIn: "HI_IN",
  Hr: "HR",
  HrBa: "HR_BA",
  HrHr: "HR_HR",
  Hu: "HU",
  HuHu: "HU_HU",
  Hy: "HY",
  HyAm: "HY_AM",
  Id: "ID",
  IdId: "ID_ID",
  Is: "IS",
  IsIs: "IS_IS",
  It: "IT",
  ItCh: "IT_CH",
  ItIt: "IT_IT",
  Ja: "JA",
  JaJp: "JA_JP",
  Ka: "KA",
  KaGe: "KA_GE",
  Kk: "KK",
  KkKz: "KK_KZ",
  Kn: "KN",
  KnIn: "KN_IN",
  Ko: "KO",
  KoKr: "KO_KR",
  Kok: "KOK",
  KokIn: "KOK_IN",
  Ky: "KY",
  KyKg: "KY_KG",
  Lt: "LT",
  LtLt: "LT_LT",
  Lv: "LV",
  LvLv: "LV_LV",
  Mi: "MI",
  MiNz: "MI_NZ",
  Mk: "MK",
  MkMk: "MK_MK",
  Mn: "MN",
  MnMn: "MN_MN",
  Mr: "MR",
  MrIn: "MR_IN",
  Ms: "MS",
  MsBn: "MS_BN",
  MsMy: "MS_MY",
  Mt: "MT",
  MtMt: "MT_MT",
  Nb: "NB",
  NbNo: "NB_NO",
  Nl: "NL",
  NlBe: "NL_BE",
  NlNl: "NL_NL",
  NnNo: "NN_NO",
  Ns: "NS",
  NsZa: "NS_ZA",
  Pa: "PA",
  PaIn: "PA_IN",
  Pl: "PL",
  PlPl: "PL_PL",
  Ps: "PS",
  PsAr: "PS_AR",
  Pt: "PT",
  PtBr: "PT_BR",
  PtPt: "PT_PT",
  Qu: "QU",
  QuBo: "QU_BO",
  QuEc: "QU_EC",
  QuPe: "QU_PE",
  Ro: "RO",
  RoRo: "RO_RO",
  Ru: "RU",
  RuRu: "RU_RU",
  Sa: "SA",
  SaIn: "SA_IN",
  Se: "SE",
  SeFi: "SE_FI",
  SeNo: "SE_NO",
  SeSe: "SE_SE",
  Sk: "SK",
  SkSk: "SK_SK",
  Sl: "SL",
  SlSi: "SL_SI",
  Sq: "SQ",
  SqAl: "SQ_AL",
  SrBa: "SR_BA",
  SrSp: "SR_SP",
  Sv: "SV",
  SvFi: "SV_FI",
  SvSe: "SV_SE",
  Sw: "SW",
  SwKe: "SW_KE",
  Syr: "SYR",
  SyrSy: "SYR_SY",
  Ta: "TA",
  TaIn: "TA_IN",
  Te: "TE",
  TeIn: "TE_IN",
  Th: "TH",
  ThTh: "TH_TH",
  Tl: "TL",
  TlPh: "TL_PH",
  Tn: "TN",
  TnZa: "TN_ZA",
  Tr: "TR",
  TrTr: "TR_TR",
  Tt: "TT",
  TtRu: "TT_RU",
  Ts: "TS",
  Uk: "UK",
  UkUa: "UK_UA",
  Ur: "UR",
  UrPk: "UR_PK",
  Uz: "UZ",
  UzUz: "UZ_UZ",
  Vi: "VI",
  ViVn: "VI_VN",
  Xh: "XH",
  XhZa: "XH_ZA",
  Zh: "ZH",
  ZhCn: "ZH_CN",
  ZhHk: "ZH_HK",
  ZhMo: "ZH_MO",
  ZhSg: "ZH_SG",
  ZhTw: "ZH_TW",
  Zu: "ZU",
  ZuZa: "ZU_ZA",
} as const;

export type SignersLanguageCodeEnum =
  (typeof SignersLanguageCodeEnum)[keyof typeof SignersLanguageCodeEnum];
export const SignersIdentificationTypeEnum = {
  None: "None",
  ForeignTaxCode: "ForeignTaxCode",
  PersonalNumber: "PersonalNumber",
  Passport: "Passport",
  NationalIdentityCard: "NationalIdentityCard",
  ItalianTaxCode: "ItalianTaxCode",
  NoSerialNumber: "NoSerialNumber",
  DrivingLicense: "DrivingLicense",
  ResidencePermit: "ResidencePermit",
  TemporaryResidencePermit: "TemporaryResidencePermit",
  EmbassyDocument: "EmbassyDocument",
  Aml: "AML",
} as const;

export type SignersIdentificationTypeEnum =
  (typeof SignersIdentificationTypeEnum)[keyof typeof SignersIdentificationTypeEnum];
export const SignersDocumentTypeEnum = {
  IdentityCard: "IdentityCard",
  DriverLicense: "DriverLicense",
  Passport: "Passport",
  ResidencePermit: "ResidencePermit",
  NationalElectronicIdentityCard: "NationalElectronicIdentityCard",
  TemporaryResidencePermit: "TemporaryResidencePermit",
  EmbassyDocument: "EmbassyDocument",
} as const;

export type SignersDocumentTypeEnum =
  (typeof SignersDocumentTypeEnum)[keyof typeof SignersDocumentTypeEnum];

/**
 *
 * @export
 * @interface SocketMessageDtoV2
 */
export interface SocketMessageDtoV2 {
  /**
   *
   * @type {string}
   * @memberof SocketMessageDtoV2
   */
  ack?: string;
  /**
   *
   * @type {string}
   * @memberof SocketMessageDtoV2
   */
  version?: string;
  /**
   *
   * @type {number}
   * @memberof SocketMessageDtoV2
   */
  sentAt?: number;
  /**
   *
   * @type {string}
   * @memberof SocketMessageDtoV2
   */
  eventType?: SocketMessageDtoV2EventTypeEnum;
  /**
   *
   * @type {SocketMessagePayloadV2}
   * @memberof SocketMessageDtoV2
   */
  payload?: SocketMessagePayloadV2;
}

export const SocketMessageDtoV2EventTypeEnum = {
  Connect: "CONNECT",
  Disconnect: "DISCONNECT",
  GoToNextState: "GO_TO_NEXT_STATE",
  GetCurrentStatus: "GET_CURRENT_STATUS",
  Error: "ERROR",
  Ping: "PING",
  Pong: "PONG",
  Metric: "METRIC",
} as const;

export type SocketMessageDtoV2EventTypeEnum =
  (typeof SocketMessageDtoV2EventTypeEnum)[keyof typeof SocketMessageDtoV2EventTypeEnum];

/**
 *
 * @export
 * @interface SocketMessageMetric
 */
export interface SocketMessageMetric {
  /**
   *
   * @type {string}
   * @memberof SocketMessageMetric
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof SocketMessageMetric
   */
  value?: number;
  /**
   *
   * @type {string}
   * @memberof SocketMessageMetric
   */
  unit?: SocketMessageMetricUnitEnum;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof SocketMessageMetric
   */
  dimensions?: { [key: string]: string };
}

export const SocketMessageMetricUnitEnum = {
  Seconds: "Seconds",
  Microseconds: "Microseconds",
  Milliseconds: "Milliseconds",
  Bytes: "Bytes",
  Kilobytes: "Kilobytes",
  Megabytes: "Megabytes",
  Gigabytes: "Gigabytes",
  Terabytes: "Terabytes",
  Bits: "Bits",
  Kilobits: "Kilobits",
  Megabits: "Megabits",
  Gigabits: "Gigabits",
  Terabits: "Terabits",
  Percent: "Percent",
  Count: "Count",
  BytesSecond: "Bytes/Second",
  KilobytesSecond: "Kilobytes/Second",
  MegabytesSecond: "Megabytes/Second",
  GigabytesSecond: "Gigabytes/Second",
  TerabytesSecond: "Terabytes/Second",
  BitsSecond: "Bits/Second",
  KilobitsSecond: "Kilobits/Second",
  MegabitsSecond: "Megabits/Second",
  GigabitsSecond: "Gigabits/Second",
  TerabitsSecond: "Terabits/Second",
  CountSecond: "Count/Second",
  None: "None",
  Null: "null",
} as const;

export type SocketMessageMetricUnitEnum =
  (typeof SocketMessageMetricUnitEnum)[keyof typeof SocketMessageMetricUnitEnum];

/**
 *
 * @export
 * @interface SocketMessagePayloadV2
 */
export interface SocketMessagePayloadV2 {
  /**
   *
   * @type {string}
   * @memberof SocketMessagePayloadV2
   */
  state?: SocketMessagePayloadV2StateEnum;
  /**
   *
   * @type {boolean}
   * @memberof SocketMessagePayloadV2
   */
  busy?: boolean;
  /**
   *
   * @type {string}
   * @memberof SocketMessagePayloadV2
   */
  bodyResponse?: string;
  /**
   *
   * @type {SocketMessageMetric}
   * @memberof SocketMessagePayloadV2
   */
  metric?: SocketMessageMetric;
}

export const SocketMessagePayloadV2StateEnum = {
  Init: "INIT",
  Privacy: "PRIVACY",
  Personal: "PERSONAL",
  Birth: "BIRTH",
  FiscalCode: "FISCAL_CODE",
  DeadlockFiscalCode: "DEADLOCK_FISCAL_CODE",
  RecoveryBlock: "RECOVERY_BLOCK",
  MultiDealSelected: "MULTI_DEAL_SELECTED",
  DeclinedByUw: "DECLINED_BY_UW",
  PostApproval: "POST_APPROVAL",
  Employment: "EMPLOYMENT",
  VatNumber: "VAT_NUMBER",
  Hiring: "HIRING",
  PensionerIncome: "PENSIONER_INCOME",
  CompanyIndustry: "COMPANY_INDUSTRY",
  CompanySize: "COMPANY_SIZE",
  Income: "INCOME",
  GrossIncome: "GROSS_INCOME",
  OtherIncome: "OTHER_INCOME",
  PensionerOtherIncome: "PENSIONER_OTHER_INCOME",
  Address: "ADDRESS",
  Marital: "MARITAL",
  Family: "FAMILY",
  Living: "LIVING",
  Coupon: "COUPON",
  SelfOtherIncome: "SELF_OTHER_INCOME",
  DataCollectionCompleted: "DATA_COLLECTION_COMPLETED",
  Bureau: "BUREAU",
  BureauKo: "BUREAU_KO",
  BureauTe: "BUREAU_TE",
  DeclinedByRules: "DECLINED_BY_RULES",
  Offer: "OFFER",
  Cpi: "CPI",
  OfferKo: "OFFER_KO",
  ConfirmOffer: "CONFIRM_OFFER",
  RevertCpi: "REVERT_CPI",
  CpiQuestionnaire: "CPI_QUESTIONNAIRE",
  CpiBeneficiary: "CPI_BENEFICIARY",
  Iban: "IBAN",
  Adv: "ADV",
  Payroll: "PAYROLL",
  AccountStatement: "ACCOUNT_STATEMENT",
  Identification: "IDENTIFICATION",
  Pending: "PENDING",
  SpidCompleted: "SPID_COMPLETED",
  VideoSelfieCompleted: "VIDEO_SELFIE_COMPLETED",
  KycCompleted: "KYC_COMPLETED",
  NamirialNotifications: "NAMIRIAL_NOTIFICATIONS",
  KycFailed: "KYC_FAILED",
  KycInProgress: "KYC_IN_PROGRESS",
  IncomeDocumentationCompleted: "INCOME_DOCUMENTATION_COMPLETED",
  UnemplyedOtherIncome: "UNEMPLYED_OTHER_INCOME",
  Back: "BACK",
  Pcw: "PCW",
  Leads: "LEADS",
  ParsecOcrCompleted: "PARSEC_OCR_COMPLETED",
  ParsecOcrError: "PARSEC_OCR_ERROR",
  QineticCallback: "QINETIC_CALLBACK",
} as const;

export type SocketMessagePayloadV2StateEnum =
  (typeof SocketMessagePayloadV2StateEnum)[keyof typeof SocketMessagePayloadV2StateEnum];

/**
 *
 * @export
 * @interface Specific
 */
export interface Specific {
  /**
   *
   * @type {string}
   * @memberof Specific
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof Specific
   */
  surname?: string;
  /**
   *
   * @type {string}
   * @memberof Specific
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof Specific
   */
  phone?: string;
  /**
   *
   * @type {Address}
   * @memberof Specific
   */
  address?: Address;
}
/**
 *
 * @export
 * @interface StartSessionDocumentDetail
 */
export interface StartSessionDocumentDetail {
  /**
   *
   * @type {number}
   * @memberof StartSessionDocumentDetail
   */
  documentNumber?: number;
  /**
   *
   * @type {string}
   * @memberof StartSessionDocumentDetail
   */
  signingGroup?: string;
}
/**
 *
 * @export
 * @interface StrongdoxDto
 */
export interface StrongdoxDto {
  /**
   *
   * @type {string}
   * @memberof StrongdoxDto
   */
  repositoryId?: string;
  /**
   *
   * @type {string}
   * @memberof StrongdoxDto
   */
  documentId?: string;
  /**
   *
   * @type {string}
   * @memberof StrongdoxDto
   */
  content?: string;
  /**
   *
   * @type {string}
   * @memberof StrongdoxDto
   */
  dataConttrato?: string;
  /**
   *
   * @type {string}
   * @memberof StrongdoxDto
   */
  codiceContratto?: string;
  /**
   *
   * @type {string}
   * @memberof StrongdoxDto
   */
  oggetoContratto?: string;
  /**
   *
   * @type {string}
   * @memberof StrongdoxDto
   */
  denominazioneContraente?: string;
  /**
   *
   * @type {string}
   * @memberof StrongdoxDto
   */
  codiceFiscaleContraente?: string;
  /**
   *
   * @type {string}
   * @memberof StrongdoxDto
   */
  orReqId?: string;
}
/**
 *
 * @export
 * @interface SurveyRequests
 */
export interface SurveyRequests {
  /**
   * Survey question
   * @type {string}
   * @memberof SurveyRequests
   */
  surveyQuestion?: string;
  /**
   * Survey answer
   * @type {string}
   * @memberof SurveyRequests
   */
  surveyAnswer?: string;
}
/**
 *
 * @export
 * @interface TaxDeclarationData
 */
export interface TaxDeclarationData {
  /**
   *
   * @type {string}
   * @memberof TaxDeclarationData
   */
  fiscalCodeReplacement?: string;
  /**
   *
   * @type {string}
   * @memberof TaxDeclarationData
   */
  declarationYear?: string;
  /**
   *
   * @type {string}
   * @memberof TaxDeclarationData
   */
  totalIncome?: string;
  /**
   *
   * @type {number}
   * @memberof TaxDeclarationData
   */
  declarationType?: number;
}
/**
 *
 * @export
 * @interface TelesellingDocumentDownloadAsyncRequest
 */
export interface TelesellingDocumentDownloadAsyncRequest {
  /**
   *
   * @type {string}
   * @memberof TelesellingDocumentDownloadAsyncRequest
   */
  positionId: string;
  /**
   *
   * @type {string}
   * @memberof TelesellingDocumentDownloadAsyncRequest
   */
  documentType: TelesellingDocumentDownloadAsyncRequestDocumentTypeEnum;
}

export const TelesellingDocumentDownloadAsyncRequestDocumentTypeEnum = {
  Secci: "SECCI",
  DeliberaNegativa: "DELIBERA_NEGATIVA",
} as const;

export type TelesellingDocumentDownloadAsyncRequestDocumentTypeEnum =
  (typeof TelesellingDocumentDownloadAsyncRequestDocumentTypeEnum)[keyof typeof TelesellingDocumentDownloadAsyncRequestDocumentTypeEnum];

/**
 *
 * @export
 * @interface TelesellingDocumentPresignedUrlResponse
 */
export interface TelesellingDocumentPresignedUrlResponse {
  /**
   *
   * @type {string}
   * @memberof TelesellingDocumentPresignedUrlResponse
   */
  presignedUrl?: string;
}
/**
 *
 * @export
 * @interface TelesellingDocumentUploadRequest
 */
export interface TelesellingDocumentUploadRequest {
  /**
   *
   * @type {string}
   * @memberof TelesellingDocumentUploadRequest
   */
  dealId: string;
  /**
   *
   * @type {string}
   * @memberof TelesellingDocumentUploadRequest
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof TelesellingDocumentUploadRequest
   */
  qineticCorrelationId?: string;
  /**
   *
   * @type {string}
   * @memberof TelesellingDocumentUploadRequest
   */
  qineticPositionId: string;
  /**
   *
   * @type {DocumentProperties}
   * @memberof TelesellingDocumentUploadRequest
   */
  documentProperties: DocumentProperties;
}
/**
 *
 * @export
 * @interface TerminateNonDeterministicWfRequest
 */
export interface TerminateNonDeterministicWfRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof TerminateNonDeterministicWfRequest
   */
  workflowIds?: Array<string>;
}
/**
 *
 * @export
 * @interface ThirdParty
 */
export interface ThirdParty {
  /**
   *
   * @type {string}
   * @memberof ThirdParty
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ThirdParty
   */
  surname?: string;
  /**
   *
   * @type {string}
   * @memberof ThirdParty
   */
  fiscalCode?: string;
  /**
   *
   * @type {string}
   * @memberof ThirdParty
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof ThirdParty
   */
  phone?: string;
  /**
   *
   * @type {Address}
   * @memberof ThirdParty
   */
  address?: Address;
}
/**
 *
 * @export
 * @interface UpdateQPositionWrapperRequest
 */
export interface UpdateQPositionWrapperRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateQPositionWrapperRequest
   */
  dealId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateQPositionWrapperRequest
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateQPositionWrapperRequest
   */
  qineticCorrelationId?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateQPositionWrapperRequest
   */
  qineticPositionId: string;
  /**
   *
   * @type {QUpdatePositionRequestV2}
   * @memberof UpdateQPositionWrapperRequest
   */
  qineticPayload: QUpdatePositionRequestV2;
}
/**
 *
 * @export
 * @interface UpdateQPositionWrapperResponse
 */
export interface UpdateQPositionWrapperResponse {
  /**
   *
   * @type {string}
   * @memberof UpdateQPositionWrapperResponse
   */
  dealId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateQPositionWrapperResponse
   */
  contactId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateQPositionWrapperResponse
   */
  qineticCorrelationId?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateQPositionWrapperResponse
   */
  qineticPositionId: string;
  /**
   *
   * @type {QUpdatePositionResponse}
   * @memberof UpdateQPositionWrapperResponse
   */
  qineticPayload: QUpdatePositionResponse;
}
/**
 *
 * @export
 * @interface VatNumberRequest
 */
export interface VatNumberRequest {
  /**
   *
   * @type {string}
   * @memberof VatNumberRequest
   */
  vatNumber?: string;
}
/**
 *
 * @export
 * @interface VerifyOtpRequest
 */
export interface VerifyOtpRequest {
  /**
   *
   * @type {string}
   * @memberof VerifyOtpRequest
   */
  otpCode?: string;
  /**
   *
   * @type {string}
   * @memberof VerifyOtpRequest
   */
  email?: string;
}
/**
 *
 * @export
 * @interface WebhookData
 */
export interface WebhookData {
  /**
   *
   * @type {string}
   * @memberof WebhookData
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof WebhookData
   */
  action?: string;
  /**
   *
   * @type {string}
   * @memberof WebhookData
   */
  timestamp?: string;
  /**
   *
   * @type {string}
   * @memberof WebhookData
   */
  previous_status?: string;
  /**
   *
   * @type {string}
   * @memberof WebhookData
   */
  current_status?: string;
  /**
   *
   * @type {ActionMadeBy}
   * @memberof WebhookData
   */
  action_made_by?: ActionMadeBy;
  /**
   *
   * @type {any}
   * @memberof WebhookData
   */
  request_type?: any;
  /**
   *
   * @type {string}
   * @memberof WebhookData
   */
  metric_type?: string;
}
/**
 *
 * @export
 * @interface WorkflowDataResponse
 */
export interface WorkflowDataResponse {
  /**
   *
   * @type {string}
   * @memberof WorkflowDataResponse
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof WorkflowDataResponse
   */
  dealId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkflowDataResponse
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkflowDataResponse
   */
  positionId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkflowDataResponse
   */
  fiscalCode?: string;
  /**
   *
   * @type {string}
   * @memberof WorkflowDataResponse
   */
  workflowId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkflowDataResponse
   */
  insertTime?: string;
  /**
   *
   * @type {string}
   * @memberof WorkflowDataResponse
   */
  updatedAt?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof WorkflowDataResponse
   */
  connectionIds?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof WorkflowDataResponse
   */
  expireTime?: number;
  /**
   *
   * @type {boolean}
   * @memberof WorkflowDataResponse
   */
  completed?: boolean;
  /**
   *
   * @type {string}
   * @memberof WorkflowDataResponse
   */
  workflowType?: string;
  /**
   *
   * @type {number}
   * @memberof WorkflowDataResponse
   */
  offersAttemptsCount?: number;
  /**
   *
   * @type {DataCollectionWorkflowDto}
   * @memberof WorkflowDataResponse
   */
  contextDataCollection?: DataCollectionWorkflowDto;
  /**
   *
   * @type {PolWfContextDto}
   * @memberof WorkflowDataResponse
   */
  contextPol?: PolWfContextDto;
  /**
   *
   * @type {KycWorkflowContextDto}
   * @memberof WorkflowDataResponse
   */
  contextKyc?: KycWorkflowContextDto;
  /**
   *
   * @type {string}
   * @memberof WorkflowDataResponse
   */
  offerOrReqId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkflowDataResponse
   */
  kycInitiateOrReqId?: string;
}

/**
 * AntifraudApi - axios parameter creator
 * @export
 */
export const AntifraudApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {AntifraudRequest} antifraudRequest
     * @param {boolean} [fullChecks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    antifraudChecks: async (
      antifraudRequest: AntifraudRequest,
      fullChecks?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'antifraudRequest' is not null or undefined
      assertParamExists(
        "antifraudChecks",
        "antifraudRequest",
        antifraudRequest,
      );
      const localVarPath = `/antifraud`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (fullChecks !== undefined) {
        localVarQueryParameter["fullChecks"] = fullChecks;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        antifraudRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AntifraudRequest} antifraudRequest
     * @param {boolean} [fullChecks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScipafi: async (
      antifraudRequest: AntifraudRequest,
      fullChecks?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'antifraudRequest' is not null or undefined
      assertParamExists("getScipafi", "antifraudRequest", antifraudRequest);
      const localVarPath = `/antifraud/scipafi`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (fullChecks !== undefined) {
        localVarQueryParameter["fullChecks"] = fullChecks;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        antifraudRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AntifraudApi - functional programming interface
 * @export
 */
export const AntifraudApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    AntifraudApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AntifraudRequest} antifraudRequest
     * @param {boolean} [fullChecks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async antifraudChecks(
      antifraudRequest: AntifraudRequest,
      fullChecks?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AccertifyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.antifraudChecks(
        antifraudRequest,
        fullChecks,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AntifraudApi.antifraudChecks"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {AntifraudRequest} antifraudRequest
     * @param {boolean} [fullChecks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getScipafi(
      antifraudRequest: AntifraudRequest,
      fullChecks?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ScipafiResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getScipafi(
        antifraudRequest,
        fullChecks,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AntifraudApi.getScipafi"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AntifraudApi - factory interface
 * @export
 */
export const AntifraudApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AntifraudApiFp(configuration);
  return {
    /**
     *
     * @param {AntifraudRequest} antifraudRequest
     * @param {boolean} [fullChecks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    antifraudChecks(
      antifraudRequest: AntifraudRequest,
      fullChecks?: boolean,
      options?: any,
    ): AxiosPromise<AccertifyResponse> {
      return localVarFp
        .antifraudChecks(antifraudRequest, fullChecks, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AntifraudRequest} antifraudRequest
     * @param {boolean} [fullChecks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScipafi(
      antifraudRequest: AntifraudRequest,
      fullChecks?: boolean,
      options?: any,
    ): AxiosPromise<ScipafiResponse> {
      return localVarFp
        .getScipafi(antifraudRequest, fullChecks, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AntifraudApi - object-oriented interface
 * @export
 * @class AntifraudApi
 * @extends {BaseAPI}
 */
export class AntifraudApi extends BaseAPI {
  /**
   *
   * @param {AntifraudRequest} antifraudRequest
   * @param {boolean} [fullChecks]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AntifraudApi
   */
  public antifraudChecks(
    antifraudRequest: AntifraudRequest,
    fullChecks?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return AntifraudApiFp(this.configuration)
      .antifraudChecks(antifraudRequest, fullChecks, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AntifraudRequest} antifraudRequest
   * @param {boolean} [fullChecks]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AntifraudApi
   */
  public getScipafi(
    antifraudRequest: AntifraudRequest,
    fullChecks?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return AntifraudApiFp(this.configuration)
      .getScipafi(antifraudRequest, fullChecks, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ConfigPublicAPIsForDynamicConfigurationApi - axios parameter creator
 * @export
 */
export const ConfigPublicAPIsForDynamicConfigurationApiAxiosParamCreator =
  function (configuration?: Configuration) {
    return {
      /**
       * Returns the full list of dynamic configuration entries (e.g. loan amount/duration constraints). A valid JWT bearer token must be present in the orchestrator cookie.
       * @summary Retrieve dynamic configuration
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      getConfiguration: async (
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        const localVarPath = `/config`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    };
  };

/**
 * ConfigPublicAPIsForDynamicConfigurationApi - functional programming interface
 * @export
 */
export const ConfigPublicAPIsForDynamicConfigurationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    ConfigPublicAPIsForDynamicConfigurationApiAxiosParamCreator(configuration);
  return {
    /**
     * Returns the full list of dynamic configuration entries (e.g. loan amount/duration constraints). A valid JWT bearer token must be present in the orchestrator cookie.
     * @summary Retrieve dynamic configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getConfiguration(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getConfiguration(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ConfigPublicAPIsForDynamicConfigurationApi.getConfiguration"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ConfigPublicAPIsForDynamicConfigurationApi - factory interface
 * @export
 */
export const ConfigPublicAPIsForDynamicConfigurationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp =
    ConfigPublicAPIsForDynamicConfigurationApiFp(configuration);
  return {
    /**
     * Returns the full list of dynamic configuration entries (e.g. loan amount/duration constraints). A valid JWT bearer token must be present in the orchestrator cookie.
     * @summary Retrieve dynamic configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConfiguration(options?: any): AxiosPromise<ConfigResponse> {
      return localVarFp
        .getConfiguration(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ConfigPublicAPIsForDynamicConfigurationApi - object-oriented interface
 * @export
 * @class ConfigPublicAPIsForDynamicConfigurationApi
 * @extends {BaseAPI}
 */
export class ConfigPublicAPIsForDynamicConfigurationApi extends BaseAPI {
  /**
   * Returns the full list of dynamic configuration entries (e.g. loan amount/duration constraints). A valid JWT bearer token must be present in the orchestrator cookie.
   * @summary Retrieve dynamic configuration
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigPublicAPIsForDynamicConfigurationApi
   */
  public getConfiguration(options?: RawAxiosRequestConfig) {
    return ConfigPublicAPIsForDynamicConfigurationApiFp(this.configuration)
      .getConfiguration(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DataCollectionApi - axios parameter creator
 * @export
 */
export const DataCollectionApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {AddressRequest} addressRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addAddress: async (
      addressRequest: AddressRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addressRequest' is not null or undefined
      assertParamExists("addAddress", "addressRequest", addressRequest);
      const localVarPath = `/data-collection/address`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addressRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {BirthRequest} birthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addBirth: async (
      birthRequest: BirthRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'birthRequest' is not null or undefined
      assertParamExists("addBirth", "birthRequest", birthRequest);
      const localVarPath = `/data-collection/birth`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        birthRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CompanyIndustryRequest} companyIndustryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCompanyIndustry: async (
      companyIndustryRequest: CompanyIndustryRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyIndustryRequest' is not null or undefined
      assertParamExists(
        "addCompanyIndustry",
        "companyIndustryRequest",
        companyIndustryRequest,
      );
      const localVarPath = `/data-collection/company-industry`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        companyIndustryRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CompanySizeRequest} companySizeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCompanySize: async (
      companySizeRequest: CompanySizeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companySizeRequest' is not null or undefined
      assertParamExists(
        "addCompanySize",
        "companySizeRequest",
        companySizeRequest,
      );
      const localVarPath = `/data-collection/company-size`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        companySizeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CouponCodeRequest} couponCodeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCouponCode: async (
      couponCodeRequest: CouponCodeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'couponCodeRequest' is not null or undefined
      assertParamExists(
        "addCouponCode",
        "couponCodeRequest",
        couponCodeRequest,
      );
      const localVarPath = `/data-collection/coupon-code`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        couponCodeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EmploymentStatusRequest} employmentStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addEmploymentStatus: async (
      employmentStatusRequest: EmploymentStatusRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'employmentStatusRequest' is not null or undefined
      assertParamExists(
        "addEmploymentStatus",
        "employmentStatusRequest",
        employmentStatusRequest,
      );
      const localVarPath = `/data-collection/employment-status`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        employmentStatusRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {FamilyRequest} familyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFamily: async (
      familyRequest: FamilyRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'familyRequest' is not null or undefined
      assertParamExists("addFamily", "familyRequest", familyRequest);
      const localVarPath = `/data-collection/family`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        familyRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {FiscalCodeRequest} fiscalCodeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFiscalCode: async (
      fiscalCodeRequest: FiscalCodeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fiscalCodeRequest' is not null or undefined
      assertParamExists(
        "addFiscalCode",
        "fiscalCodeRequest",
        fiscalCodeRequest,
      );
      const localVarPath = `/data-collection/fiscal-code`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        fiscalCodeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GrossIncomeRequest} grossIncomeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addGrossIncome: async (
      grossIncomeRequest: GrossIncomeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'grossIncomeRequest' is not null or undefined
      assertParamExists(
        "addGrossIncome",
        "grossIncomeRequest",
        grossIncomeRequest,
      );
      const localVarPath = `/data-collection/gross-income`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        grossIncomeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {HiringRequest} hiringRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addHiring: async (
      hiringRequest: HiringRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'hiringRequest' is not null or undefined
      assertParamExists("addHiring", "hiringRequest", hiringRequest);
      const localVarPath = `/data-collection/hiring`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        hiringRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {IncomeMonthlyRequest} incomeMonthlyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addIncome: async (
      incomeMonthlyRequest: IncomeMonthlyRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomeMonthlyRequest' is not null or undefined
      assertParamExists(
        "addIncome",
        "incomeMonthlyRequest",
        incomeMonthlyRequest,
      );
      const localVarPath = `/data-collection/income`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomeMonthlyRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {IncomeOtherRequest} incomeOtherRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addIncomeOther: async (
      incomeOtherRequest: IncomeOtherRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomeOtherRequest' is not null or undefined
      assertParamExists(
        "addIncomeOther",
        "incomeOtherRequest",
        incomeOtherRequest,
      );
      const localVarPath = `/data-collection/other-income`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomeOtherRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {JobRoleRequest} jobRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addJobRole: async (
      jobRoleRequest: JobRoleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'jobRoleRequest' is not null or undefined
      assertParamExists("addJobRole", "jobRoleRequest", jobRoleRequest);
      const localVarPath = `/data-collection/job-role`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        jobRoleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {LivingSituationRequest} livingSituationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addLivingSituation: async (
      livingSituationRequest: LivingSituationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'livingSituationRequest' is not null or undefined
      assertParamExists(
        "addLivingSituation",
        "livingSituationRequest",
        livingSituationRequest,
      );
      const localVarPath = `/data-collection/living-situation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        livingSituationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {MaritalStatusRequest} maritalStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addMaritalStatus: async (
      maritalStatusRequest: MaritalStatusRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'maritalStatusRequest' is not null or undefined
      assertParamExists(
        "addMaritalStatus",
        "maritalStatusRequest",
        maritalStatusRequest,
      );
      const localVarPath = `/data-collection/marital-status`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        maritalStatusRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PensionerIncomeRequest} pensionerIncomeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPensionerIncome: async (
      pensionerIncomeRequest: PensionerIncomeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pensionerIncomeRequest' is not null or undefined
      assertParamExists(
        "addPensionerIncome",
        "pensionerIncomeRequest",
        pensionerIncomeRequest,
      );
      const localVarPath = `/data-collection/pensioner-income`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pensionerIncomeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PersonalDataRequest} personalDataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPersonalInfo: async (
      personalDataRequest: PersonalDataRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'personalDataRequest' is not null or undefined
      assertParamExists(
        "addPersonalInfo",
        "personalDataRequest",
        personalDataRequest,
      );
      const localVarPath = `/data-collection/personal-info`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        personalDataRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PrivacyConsentsRequest} privacyConsentsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPrivacy: async (
      privacyConsentsRequest: PrivacyConsentsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'privacyConsentsRequest' is not null or undefined
      assertParamExists(
        "addPrivacy",
        "privacyConsentsRequest",
        privacyConsentsRequest,
      );
      const localVarPath = `/data-collection/privacy`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        privacyConsentsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {VatNumberRequest} vatNumberRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addVatNumber: async (
      vatNumberRequest: VatNumberRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'vatNumberRequest' is not null or undefined
      assertParamExists("addVatNumber", "vatNumberRequest", vatNumberRequest);
      const localVarPath = `/data-collection/vat-number`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        vatNumberRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DataCollectionApi - functional programming interface
 * @export
 */
export const DataCollectionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    DataCollectionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AddressRequest} addressRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addAddress(
      addressRequest: AddressRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addAddress(
        addressRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addAddress"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {BirthRequest} birthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addBirth(
      birthRequest: BirthRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addBirth(
        birthRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addBirth"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CompanyIndustryRequest} companyIndustryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addCompanyIndustry(
      companyIndustryRequest: CompanyIndustryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.addCompanyIndustry(
          companyIndustryRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addCompanyIndustry"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CompanySizeRequest} companySizeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addCompanySize(
      companySizeRequest: CompanySizeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addCompanySize(
        companySizeRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addCompanySize"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CouponCodeRequest} couponCodeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addCouponCode(
      couponCodeRequest: CouponCodeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addCouponCode(
        couponCodeRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addCouponCode"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EmploymentStatusRequest} employmentStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addEmploymentStatus(
      employmentStatusRequest: EmploymentStatusRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.addEmploymentStatus(
          employmentStatusRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addEmploymentStatus"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {FamilyRequest} familyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addFamily(
      familyRequest: FamilyRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addFamily(
        familyRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addFamily"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {FiscalCodeRequest} fiscalCodeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addFiscalCode(
      fiscalCodeRequest: FiscalCodeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addFiscalCode(
        fiscalCodeRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addFiscalCode"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {GrossIncomeRequest} grossIncomeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addGrossIncome(
      grossIncomeRequest: GrossIncomeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addGrossIncome(
        grossIncomeRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addGrossIncome"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {HiringRequest} hiringRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addHiring(
      hiringRequest: HiringRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addHiring(
        hiringRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addHiring"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {IncomeMonthlyRequest} incomeMonthlyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addIncome(
      incomeMonthlyRequest: IncomeMonthlyRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addIncome(
        incomeMonthlyRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addIncome"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {IncomeOtherRequest} incomeOtherRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addIncomeOther(
      incomeOtherRequest: IncomeOtherRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addIncomeOther(
        incomeOtherRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addIncomeOther"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {JobRoleRequest} jobRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addJobRole(
      jobRoleRequest: JobRoleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addJobRole(
        jobRoleRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addJobRole"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {LivingSituationRequest} livingSituationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addLivingSituation(
      livingSituationRequest: LivingSituationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.addLivingSituation(
          livingSituationRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addLivingSituation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {MaritalStatusRequest} maritalStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addMaritalStatus(
      maritalStatusRequest: MaritalStatusRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.addMaritalStatus(
          maritalStatusRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addMaritalStatus"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {PensionerIncomeRequest} pensionerIncomeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addPensionerIncome(
      pensionerIncomeRequest: PensionerIncomeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.addPensionerIncome(
          pensionerIncomeRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addPensionerIncome"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {PersonalDataRequest} personalDataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addPersonalInfo(
      personalDataRequest: PersonalDataRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addPersonalInfo(
        personalDataRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addPersonalInfo"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {PrivacyConsentsRequest} privacyConsentsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addPrivacy(
      privacyConsentsRequest: PrivacyConsentsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addPrivacy(
        privacyConsentsRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addPrivacy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {VatNumberRequest} vatNumberRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addVatNumber(
      vatNumberRequest: VatNumberRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addVatNumber(
        vatNumberRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DataCollectionApi.addVatNumber"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DataCollectionApi - factory interface
 * @export
 */
export const DataCollectionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DataCollectionApiFp(configuration);
  return {
    /**
     *
     * @param {AddressRequest} addressRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addAddress(
      addressRequest: AddressRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addAddress(addressRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {BirthRequest} birthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addBirth(birthRequest: BirthRequest, options?: any): AxiosPromise<void> {
      return localVarFp
        .addBirth(birthRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CompanyIndustryRequest} companyIndustryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCompanyIndustry(
      companyIndustryRequest: CompanyIndustryRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addCompanyIndustry(companyIndustryRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CompanySizeRequest} companySizeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCompanySize(
      companySizeRequest: CompanySizeRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addCompanySize(companySizeRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CouponCodeRequest} couponCodeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCouponCode(
      couponCodeRequest: CouponCodeRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addCouponCode(couponCodeRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EmploymentStatusRequest} employmentStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addEmploymentStatus(
      employmentStatusRequest: EmploymentStatusRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addEmploymentStatus(employmentStatusRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {FamilyRequest} familyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFamily(familyRequest: FamilyRequest, options?: any): AxiosPromise<void> {
      return localVarFp
        .addFamily(familyRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {FiscalCodeRequest} fiscalCodeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFiscalCode(
      fiscalCodeRequest: FiscalCodeRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addFiscalCode(fiscalCodeRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GrossIncomeRequest} grossIncomeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addGrossIncome(
      grossIncomeRequest: GrossIncomeRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addGrossIncome(grossIncomeRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {HiringRequest} hiringRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addHiring(hiringRequest: HiringRequest, options?: any): AxiosPromise<void> {
      return localVarFp
        .addHiring(hiringRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {IncomeMonthlyRequest} incomeMonthlyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addIncome(
      incomeMonthlyRequest: IncomeMonthlyRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addIncome(incomeMonthlyRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {IncomeOtherRequest} incomeOtherRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addIncomeOther(
      incomeOtherRequest: IncomeOtherRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addIncomeOther(incomeOtherRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {JobRoleRequest} jobRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addJobRole(
      jobRoleRequest: JobRoleRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addJobRole(jobRoleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {LivingSituationRequest} livingSituationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addLivingSituation(
      livingSituationRequest: LivingSituationRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addLivingSituation(livingSituationRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {MaritalStatusRequest} maritalStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addMaritalStatus(
      maritalStatusRequest: MaritalStatusRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addMaritalStatus(maritalStatusRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PensionerIncomeRequest} pensionerIncomeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPensionerIncome(
      pensionerIncomeRequest: PensionerIncomeRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addPensionerIncome(pensionerIncomeRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PersonalDataRequest} personalDataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPersonalInfo(
      personalDataRequest: PersonalDataRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addPersonalInfo(personalDataRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PrivacyConsentsRequest} privacyConsentsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPrivacy(
      privacyConsentsRequest: PrivacyConsentsRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addPrivacy(privacyConsentsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {VatNumberRequest} vatNumberRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addVatNumber(
      vatNumberRequest: VatNumberRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addVatNumber(vatNumberRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DataCollectionApi - object-oriented interface
 * @export
 * @class DataCollectionApi
 * @extends {BaseAPI}
 */
export class DataCollectionApi extends BaseAPI {
  /**
   *
   * @param {AddressRequest} addressRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addAddress(
    addressRequest: AddressRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addAddress(addressRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {BirthRequest} birthRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addBirth(birthRequest: BirthRequest, options?: RawAxiosRequestConfig) {
    return DataCollectionApiFp(this.configuration)
      .addBirth(birthRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CompanyIndustryRequest} companyIndustryRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addCompanyIndustry(
    companyIndustryRequest: CompanyIndustryRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addCompanyIndustry(companyIndustryRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CompanySizeRequest} companySizeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addCompanySize(
    companySizeRequest: CompanySizeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addCompanySize(companySizeRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CouponCodeRequest} couponCodeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addCouponCode(
    couponCodeRequest: CouponCodeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addCouponCode(couponCodeRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EmploymentStatusRequest} employmentStatusRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addEmploymentStatus(
    employmentStatusRequest: EmploymentStatusRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addEmploymentStatus(employmentStatusRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {FamilyRequest} familyRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addFamily(
    familyRequest: FamilyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addFamily(familyRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {FiscalCodeRequest} fiscalCodeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addFiscalCode(
    fiscalCodeRequest: FiscalCodeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addFiscalCode(fiscalCodeRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GrossIncomeRequest} grossIncomeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addGrossIncome(
    grossIncomeRequest: GrossIncomeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addGrossIncome(grossIncomeRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {HiringRequest} hiringRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addHiring(
    hiringRequest: HiringRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addHiring(hiringRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {IncomeMonthlyRequest} incomeMonthlyRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addIncome(
    incomeMonthlyRequest: IncomeMonthlyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addIncome(incomeMonthlyRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {IncomeOtherRequest} incomeOtherRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addIncomeOther(
    incomeOtherRequest: IncomeOtherRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addIncomeOther(incomeOtherRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {JobRoleRequest} jobRoleRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addJobRole(
    jobRoleRequest: JobRoleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addJobRole(jobRoleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {LivingSituationRequest} livingSituationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addLivingSituation(
    livingSituationRequest: LivingSituationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addLivingSituation(livingSituationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MaritalStatusRequest} maritalStatusRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addMaritalStatus(
    maritalStatusRequest: MaritalStatusRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addMaritalStatus(maritalStatusRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PensionerIncomeRequest} pensionerIncomeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addPensionerIncome(
    pensionerIncomeRequest: PensionerIncomeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addPensionerIncome(pensionerIncomeRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PersonalDataRequest} personalDataRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addPersonalInfo(
    personalDataRequest: PersonalDataRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addPersonalInfo(personalDataRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PrivacyConsentsRequest} privacyConsentsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addPrivacy(
    privacyConsentsRequest: PrivacyConsentsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addPrivacy(privacyConsentsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {VatNumberRequest} vatNumberRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataCollectionApi
   */
  public addVatNumber(
    vatNumberRequest: VatNumberRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataCollectionApiFp(this.configuration)
      .addVatNumber(vatNumberRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DocumentCollectionApi - axios parameter creator
 * @export
 */
export const DocumentCollectionApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {string} workflowId
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generatePreview: async (
      workflowId: string,
      offerId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'workflowId' is not null or undefined
      assertParamExists("generatePreview", "workflowId", workflowId);
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists("generatePreview", "offerId", offerId);
      const localVarPath = `/documents/secci/{workflowId}/{offerId}`
        .replace(`{${"workflowId"}}`, encodeURIComponent(String(workflowId)))
        .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GetDocumentsDocTypeEnum} docType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocuments: async (
      docType: GetDocumentsDocTypeEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'docType' is not null or undefined
      assertParamExists("getDocuments", "docType", docType);
      const localVarPath = `/documents/{docType}`.replace(
        `{${"docType"}}`,
        encodeURIComponent(String(docType)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SendDocumentByTypeDocumentTypeEnum} documentType
     * @param {QineticDocumentListRequest} qineticDocumentListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendDocumentByType: async (
      documentType: SendDocumentByTypeDocumentTypeEnum,
      qineticDocumentListRequest: QineticDocumentListRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'documentType' is not null or undefined
      assertParamExists("sendDocumentByType", "documentType", documentType);
      // verify required parameter 'qineticDocumentListRequest' is not null or undefined
      assertParamExists(
        "sendDocumentByType",
        "qineticDocumentListRequest",
        qineticDocumentListRequest,
      );
      const localVarPath = `/documents/{documentType}`.replace(
        `{${"documentType"}}`,
        encodeURIComponent(String(documentType)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        qineticDocumentListRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DocumentCollectionApi - functional programming interface
 * @export
 */
export const DocumentCollectionApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    DocumentCollectionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} workflowId
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generatePreview(
      workflowId: string,
      offerId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.generatePreview(
        workflowId,
        offerId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DocumentCollectionApi.generatePreview"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {GetDocumentsDocTypeEnum} docType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDocuments(
      docType: GetDocumentsDocTypeEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ListDocumentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getDocuments(
        docType,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DocumentCollectionApi.getDocuments"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SendDocumentByTypeDocumentTypeEnum} documentType
     * @param {QineticDocumentListRequest} qineticDocumentListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendDocumentByType(
      documentType: SendDocumentByTypeDocumentTypeEnum,
      qineticDocumentListRequest: QineticDocumentListRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.sendDocumentByType(
          documentType,
          qineticDocumentListRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DocumentCollectionApi.sendDocumentByType"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DocumentCollectionApi - factory interface
 * @export
 */
export const DocumentCollectionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DocumentCollectionApiFp(configuration);
  return {
    /**
     *
     * @param {string} workflowId
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generatePreview(
      workflowId: string,
      offerId: string,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .generatePreview(workflowId, offerId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GetDocumentsDocTypeEnum} docType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocuments(
      docType: GetDocumentsDocTypeEnum,
      options?: any,
    ): AxiosPromise<ListDocumentResponse> {
      return localVarFp
        .getDocuments(docType, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SendDocumentByTypeDocumentTypeEnum} documentType
     * @param {QineticDocumentListRequest} qineticDocumentListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendDocumentByType(
      documentType: SendDocumentByTypeDocumentTypeEnum,
      qineticDocumentListRequest: QineticDocumentListRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .sendDocumentByType(documentType, qineticDocumentListRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DocumentCollectionApi - object-oriented interface
 * @export
 * @class DocumentCollectionApi
 * @extends {BaseAPI}
 */
export class DocumentCollectionApi extends BaseAPI {
  /**
   *
   * @param {string} workflowId
   * @param {string} offerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentCollectionApi
   */
  public generatePreview(
    workflowId: string,
    offerId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentCollectionApiFp(this.configuration)
      .generatePreview(workflowId, offerId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GetDocumentsDocTypeEnum} docType
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentCollectionApi
   */
  public getDocuments(
    docType: GetDocumentsDocTypeEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentCollectionApiFp(this.configuration)
      .getDocuments(docType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SendDocumentByTypeDocumentTypeEnum} documentType
   * @param {QineticDocumentListRequest} qineticDocumentListRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentCollectionApi
   */
  public sendDocumentByType(
    documentType: SendDocumentByTypeDocumentTypeEnum,
    qineticDocumentListRequest: QineticDocumentListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentCollectionApiFp(this.configuration)
      .sendDocumentByType(documentType, qineticDocumentListRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GetDocumentsDocTypeEnum = {
  Payrolls: "PAYROLLS",
  AccountStatement: "ACCOUNT_STATEMENT",
} as const;
export type GetDocumentsDocTypeEnum =
  (typeof GetDocumentsDocTypeEnum)[keyof typeof GetDocumentsDocTypeEnum];
/**
 * @export
 */
export const SendDocumentByTypeDocumentTypeEnum = {
  Payrolls: "PAYROLLS",
  AccountStatement: "ACCOUNT_STATEMENT",
} as const;
export type SendDocumentByTypeDocumentTypeEnum =
  (typeof SendDocumentByTypeDocumentTypeEnum)[keyof typeof SendDocumentByTypeDocumentTypeEnum];

/**
 * ExelabDocumentControllerApi - axios parameter creator
 * @export
 */
export const ExelabDocumentControllerApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * This api will provide the secci template.
     * @summary Download the secci template
     * @param {DocumentSecciRequest} documentSecciRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generate: async (
      documentSecciRequest: DocumentSecciRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'documentSecciRequest' is not null or undefined
      assertParamExists(
        "generate",
        "documentSecciRequest",
        documentSecciRequest,
      );
      const localVarPath = `/templateSecci/generate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        documentSecciRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExelabDocumentControllerApi - functional programming interface
 * @export
 */
export const ExelabDocumentControllerApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    ExelabDocumentControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * This api will provide the secci template.
     * @summary Download the secci template
     * @param {DocumentSecciRequest} documentSecciRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generate(
      documentSecciRequest: DocumentSecciRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.generate(
        documentSecciRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExelabDocumentControllerApi.generate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ExelabDocumentControllerApi - factory interface
 * @export
 */
export const ExelabDocumentControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ExelabDocumentControllerApiFp(configuration);
  return {
    /**
     * This api will provide the secci template.
     * @summary Download the secci template
     * @param {DocumentSecciRequest} documentSecciRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generate(
      documentSecciRequest: DocumentSecciRequest,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .generate(documentSecciRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ExelabDocumentControllerApi - object-oriented interface
 * @export
 * @class ExelabDocumentControllerApi
 * @extends {BaseAPI}
 */
export class ExelabDocumentControllerApi extends BaseAPI {
  /**
   * This api will provide the secci template.
   * @summary Download the secci template
   * @param {DocumentSecciRequest} documentSecciRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExelabDocumentControllerApi
   */
  public generate(
    documentSecciRequest: DocumentSecciRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ExelabDocumentControllerApiFp(this.configuration)
      .generate(documentSecciRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ExelabLeadApi - axios parameter creator
 * @export
 */
export const ExelabLeadApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Presa in carico della richiesta di lead proveniente dal CRM Exelab e avvio del relativo flusso KYC. Se per la coppia dealId/contactId esiste già un workflow, l\'API restituisce direttamente al client i dati già disponibili (positionId e workflowId) senza creare nulla di nuovo. Se invece il workflow non esiste, il flusso procede come segue: 1) creazione della pratica su Qinetic; 2) aggiornamento del CRM Exelab con il positionId e il canale della pratica appena creata; 3) recupero dei dati di procedure dal CRM Exelab e aggiornamento della pratica Qinetic con tali dati; 4) avanzamento del wizard Qinetic allo step INFO_CLI; 5) inizializzazione del workflow KYC associato alla pratica; 6) risposta al client con l\'esito dell\'operazione e i dati di positionId e workflowId. In caso di errore in una qualsiasi delle fasi verso Qinetic, viene restituito un errore al client senza proseguire con i passi successivi.
     * @summary Creazione di un lead e avvio del flusso di teleselling
     * @param {CreateLeadRequest} createLeadRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLead: async (
      createLeadRequest: CreateLeadRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createLeadRequest' is not null or undefined
      assertParamExists("createLead", "createLeadRequest", createLeadRequest);
      const localVarPath = `/lead/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createLeadRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExelabLeadApi - functional programming interface
 * @export
 */
export const ExelabLeadApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ExelabLeadApiAxiosParamCreator(configuration);
  return {
    /**
     * Presa in carico della richiesta di lead proveniente dal CRM Exelab e avvio del relativo flusso KYC. Se per la coppia dealId/contactId esiste già un workflow, l\'API restituisce direttamente al client i dati già disponibili (positionId e workflowId) senza creare nulla di nuovo. Se invece il workflow non esiste, il flusso procede come segue: 1) creazione della pratica su Qinetic; 2) aggiornamento del CRM Exelab con il positionId e il canale della pratica appena creata; 3) recupero dei dati di procedure dal CRM Exelab e aggiornamento della pratica Qinetic con tali dati; 4) avanzamento del wizard Qinetic allo step INFO_CLI; 5) inizializzazione del workflow KYC associato alla pratica; 6) risposta al client con l\'esito dell\'operazione e i dati di positionId e workflowId. In caso di errore in una qualsiasi delle fasi verso Qinetic, viene restituito un errore al client senza proseguire con i passi successivi.
     * @summary Creazione di un lead e avvio del flusso di teleselling
     * @param {CreateLeadRequest} createLeadRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createLead(
      createLeadRequest: CreateLeadRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateLeadResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createLead(
        createLeadRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExelabLeadApi.createLead"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ExelabLeadApi - factory interface
 * @export
 */
export const ExelabLeadApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ExelabLeadApiFp(configuration);
  return {
    /**
     * Presa in carico della richiesta di lead proveniente dal CRM Exelab e avvio del relativo flusso KYC. Se per la coppia dealId/contactId esiste già un workflow, l\'API restituisce direttamente al client i dati già disponibili (positionId e workflowId) senza creare nulla di nuovo. Se invece il workflow non esiste, il flusso procede come segue: 1) creazione della pratica su Qinetic; 2) aggiornamento del CRM Exelab con il positionId e il canale della pratica appena creata; 3) recupero dei dati di procedure dal CRM Exelab e aggiornamento della pratica Qinetic con tali dati; 4) avanzamento del wizard Qinetic allo step INFO_CLI; 5) inizializzazione del workflow KYC associato alla pratica; 6) risposta al client con l\'esito dell\'operazione e i dati di positionId e workflowId. In caso di errore in una qualsiasi delle fasi verso Qinetic, viene restituito un errore al client senza proseguire con i passi successivi.
     * @summary Creazione di un lead e avvio del flusso di teleselling
     * @param {CreateLeadRequest} createLeadRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLead(
      createLeadRequest: CreateLeadRequest,
      options?: any,
    ): AxiosPromise<CreateLeadResponse> {
      return localVarFp
        .createLead(createLeadRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ExelabLeadApi - object-oriented interface
 * @export
 * @class ExelabLeadApi
 * @extends {BaseAPI}
 */
export class ExelabLeadApi extends BaseAPI {
  /**
   * Presa in carico della richiesta di lead proveniente dal CRM Exelab e avvio del relativo flusso KYC. Se per la coppia dealId/contactId esiste già un workflow, l\'API restituisce direttamente al client i dati già disponibili (positionId e workflowId) senza creare nulla di nuovo. Se invece il workflow non esiste, il flusso procede come segue: 1) creazione della pratica su Qinetic; 2) aggiornamento del CRM Exelab con il positionId e il canale della pratica appena creata; 3) recupero dei dati di procedure dal CRM Exelab e aggiornamento della pratica Qinetic con tali dati; 4) avanzamento del wizard Qinetic allo step INFO_CLI; 5) inizializzazione del workflow KYC associato alla pratica; 6) risposta al client con l\'esito dell\'operazione e i dati di positionId e workflowId. In caso di errore in una qualsiasi delle fasi verso Qinetic, viene restituito un errore al client senza proseguire con i passi successivi.
   * @summary Creazione di un lead e avvio del flusso di teleselling
   * @param {CreateLeadRequest} createLeadRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExelabLeadApi
   */
  public createLead(
    createLeadRequest: CreateLeadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ExelabLeadApiFp(this.configuration)
      .createLead(createLeadRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ExelabTelesellingProxyToQineticApi - axios parameter creator
 * @export
 */
export const ExelabTelesellingProxyToQineticApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {UpdateQPositionWrapperRequest} updateQPositionWrapperRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPosition: async (
      updateQPositionWrapperRequest: UpdateQPositionWrapperRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'updateQPositionWrapperRequest' is not null or undefined
      assertParamExists(
        "createPosition",
        "updateQPositionWrapperRequest",
        updateQPositionWrapperRequest,
      );
      const localVarPath = `/exelab/teleselling/update-position`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateQPositionWrapperRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateQPositionWrapperRequest} createQPositionWrapperRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPosition1: async (
      createQPositionWrapperRequest: CreateQPositionWrapperRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createQPositionWrapperRequest' is not null or undefined
      assertParamExists(
        "createPosition1",
        "createQPositionWrapperRequest",
        createQPositionWrapperRequest,
      );
      const localVarPath = `/exelab/teleselling/create-position`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createQPositionWrapperRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Will require to next call trigger-upload.
     * @summary Generate a presigned URL for documents to upload
     * @param {TelesellingDocumentUploadRequest} telesellingDocumentUploadRequest Teleselling document request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generatePresignedUrl: async (
      telesellingDocumentUploadRequest: TelesellingDocumentUploadRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'telesellingDocumentUploadRequest' is not null or undefined
      assertParamExists(
        "generatePresignedUrl",
        "telesellingDocumentUploadRequest",
        telesellingDocumentUploadRequest,
      );
      const localVarPath = `/exelab/teleselling/documents/generate-presigned-url`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        telesellingDocumentUploadRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCheckList1: async (
      positionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getCheckList1", "positionId", positionId);
      const localVarPath =
        `/exelab/qinetic/v1/checklists/position/{positionId}`.replace(
          `{${"positionId"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} positionId
     * @param {GetDocumentDocumentTypeEnum} documentType
     * @param {string} taxNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocument: async (
      positionId: string,
      documentType: GetDocumentDocumentTypeEnum,
      taxNumber: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getDocument", "positionId", positionId);
      // verify required parameter 'documentType' is not null or undefined
      assertParamExists("getDocument", "documentType", documentType);
      // verify required parameter 'taxNumber' is not null or undefined
      assertParamExists("getDocument", "taxNumber", taxNumber);
      const localVarPath =
        `/exelab/qinetic/v2/positions/{positionId}/documents/{documentType}`
          .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"documentType"}}`,
            encodeURIComponent(String(documentType)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      if (taxNumber !== undefined) {
        localVarQueryParameter["taxNumber"] = taxNumber;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Will require to next call trigger-upload.
     * @summary Generate a presigned URL for documents to upload
     * @param {TelesellingDocumentDownloadAsyncRequest} telesellingDocumentDownloadAsyncRequest Teleselling document request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    startDocumentDownload: async (
      telesellingDocumentDownloadAsyncRequest: TelesellingDocumentDownloadAsyncRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'telesellingDocumentDownloadAsyncRequest' is not null or undefined
      assertParamExists(
        "startDocumentDownload",
        "telesellingDocumentDownloadAsyncRequest",
        telesellingDocumentDownloadAsyncRequest,
      );
      const localVarPath = `/exelab/teleselling/start-download-doc`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        telesellingDocumentDownloadAsyncRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Downloads from S3 with specified IDs and will upload file to Qinetic.
     * @summary Trigger file upload to Qinetic
     * @param {TelesellingDocumentUploadRequest} telesellingDocumentUploadRequest Teleselling document request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerUploadToQinetic: async (
      telesellingDocumentUploadRequest: TelesellingDocumentUploadRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'telesellingDocumentUploadRequest' is not null or undefined
      assertParamExists(
        "triggerUploadToQinetic",
        "telesellingDocumentUploadRequest",
        telesellingDocumentUploadRequest,
      );
      const localVarPath = `/exelab/teleselling/documents/trigger-upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        telesellingDocumentUploadRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExelabTelesellingProxyToQineticApi - functional programming interface
 * @export
 */
export const ExelabTelesellingProxyToQineticApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    ExelabTelesellingProxyToQineticApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {UpdateQPositionWrapperRequest} updateQPositionWrapperRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPosition(
      updateQPositionWrapperRequest: UpdateQPositionWrapperRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UpdateQPositionWrapperResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createPosition(
        updateQPositionWrapperRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ExelabTelesellingProxyToQineticApi.createPosition"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateQPositionWrapperRequest} createQPositionWrapperRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPosition1(
      createQPositionWrapperRequest: CreateQPositionWrapperRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateQPositionWrapperResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createPosition1(
        createQPositionWrapperRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ExelabTelesellingProxyToQineticApi.createPosition1"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Will require to next call trigger-upload.
     * @summary Generate a presigned URL for documents to upload
     * @param {TelesellingDocumentUploadRequest} telesellingDocumentUploadRequest Teleselling document request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generatePresignedUrl(
      telesellingDocumentUploadRequest: TelesellingDocumentUploadRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<TelesellingDocumentPresignedUrlResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.generatePresignedUrl(
          telesellingDocumentUploadRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ExelabTelesellingProxyToQineticApi.generatePresignedUrl"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCheckList1(
      positionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QChecklist>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckList1(
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ExelabTelesellingProxyToQineticApi.getCheckList1"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} positionId
     * @param {GetDocumentDocumentTypeEnum} documentType
     * @param {string} taxNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDocument(
      positionId: string,
      documentType: GetDocumentDocumentTypeEnum,
      taxNumber: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getDocument(
        positionId,
        documentType,
        taxNumber,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExelabTelesellingProxyToQineticApi.getDocument"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Will require to next call trigger-upload.
     * @summary Generate a presigned URL for documents to upload
     * @param {TelesellingDocumentDownloadAsyncRequest} telesellingDocumentDownloadAsyncRequest Teleselling document request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async startDocumentDownload(
      telesellingDocumentDownloadAsyncRequest: TelesellingDocumentDownloadAsyncRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.startDocumentDownload(
          telesellingDocumentDownloadAsyncRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ExelabTelesellingProxyToQineticApi.startDocumentDownload"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Downloads from S3 with specified IDs and will upload file to Qinetic.
     * @summary Trigger file upload to Qinetic
     * @param {TelesellingDocumentUploadRequest} telesellingDocumentUploadRequest Teleselling document request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async triggerUploadToQinetic(
      telesellingDocumentUploadRequest: TelesellingDocumentUploadRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.triggerUploadToQinetic(
          telesellingDocumentUploadRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ExelabTelesellingProxyToQineticApi.triggerUploadToQinetic"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ExelabTelesellingProxyToQineticApi - factory interface
 * @export
 */
export const ExelabTelesellingProxyToQineticApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ExelabTelesellingProxyToQineticApiFp(configuration);
  return {
    /**
     *
     * @param {UpdateQPositionWrapperRequest} updateQPositionWrapperRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPosition(
      updateQPositionWrapperRequest: UpdateQPositionWrapperRequest,
      options?: any,
    ): AxiosPromise<UpdateQPositionWrapperResponse> {
      return localVarFp
        .createPosition(updateQPositionWrapperRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateQPositionWrapperRequest} createQPositionWrapperRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPosition1(
      createQPositionWrapperRequest: CreateQPositionWrapperRequest,
      options?: any,
    ): AxiosPromise<CreateQPositionWrapperResponse> {
      return localVarFp
        .createPosition1(createQPositionWrapperRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Will require to next call trigger-upload.
     * @summary Generate a presigned URL for documents to upload
     * @param {TelesellingDocumentUploadRequest} telesellingDocumentUploadRequest Teleselling document request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generatePresignedUrl(
      telesellingDocumentUploadRequest: TelesellingDocumentUploadRequest,
      options?: any,
    ): AxiosPromise<TelesellingDocumentPresignedUrlResponse> {
      return localVarFp
        .generatePresignedUrl(telesellingDocumentUploadRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCheckList1(positionId: string, options?: any): AxiosPromise<QChecklist> {
      return localVarFp
        .getCheckList1(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} positionId
     * @param {GetDocumentDocumentTypeEnum} documentType
     * @param {string} taxNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocument(
      positionId: string,
      documentType: GetDocumentDocumentTypeEnum,
      taxNumber: string,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .getDocument(positionId, documentType, taxNumber, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Will require to next call trigger-upload.
     * @summary Generate a presigned URL for documents to upload
     * @param {TelesellingDocumentDownloadAsyncRequest} telesellingDocumentDownloadAsyncRequest Teleselling document request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    startDocumentDownload(
      telesellingDocumentDownloadAsyncRequest: TelesellingDocumentDownloadAsyncRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .startDocumentDownload(telesellingDocumentDownloadAsyncRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Downloads from S3 with specified IDs and will upload file to Qinetic.
     * @summary Trigger file upload to Qinetic
     * @param {TelesellingDocumentUploadRequest} telesellingDocumentUploadRequest Teleselling document request data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerUploadToQinetic(
      telesellingDocumentUploadRequest: TelesellingDocumentUploadRequest,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .triggerUploadToQinetic(telesellingDocumentUploadRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ExelabTelesellingProxyToQineticApi - object-oriented interface
 * @export
 * @class ExelabTelesellingProxyToQineticApi
 * @extends {BaseAPI}
 */
export class ExelabTelesellingProxyToQineticApi extends BaseAPI {
  /**
   *
   * @param {UpdateQPositionWrapperRequest} updateQPositionWrapperRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExelabTelesellingProxyToQineticApi
   */
  public createPosition(
    updateQPositionWrapperRequest: UpdateQPositionWrapperRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ExelabTelesellingProxyToQineticApiFp(this.configuration)
      .createPosition(updateQPositionWrapperRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateQPositionWrapperRequest} createQPositionWrapperRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExelabTelesellingProxyToQineticApi
   */
  public createPosition1(
    createQPositionWrapperRequest: CreateQPositionWrapperRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ExelabTelesellingProxyToQineticApiFp(this.configuration)
      .createPosition1(createQPositionWrapperRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Will require to next call trigger-upload.
   * @summary Generate a presigned URL for documents to upload
   * @param {TelesellingDocumentUploadRequest} telesellingDocumentUploadRequest Teleselling document request data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExelabTelesellingProxyToQineticApi
   */
  public generatePresignedUrl(
    telesellingDocumentUploadRequest: TelesellingDocumentUploadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ExelabTelesellingProxyToQineticApiFp(this.configuration)
      .generatePresignedUrl(telesellingDocumentUploadRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExelabTelesellingProxyToQineticApi
   */
  public getCheckList1(positionId: string, options?: RawAxiosRequestConfig) {
    return ExelabTelesellingProxyToQineticApiFp(this.configuration)
      .getCheckList1(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} positionId
   * @param {GetDocumentDocumentTypeEnum} documentType
   * @param {string} taxNumber
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExelabTelesellingProxyToQineticApi
   */
  public getDocument(
    positionId: string,
    documentType: GetDocumentDocumentTypeEnum,
    taxNumber: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ExelabTelesellingProxyToQineticApiFp(this.configuration)
      .getDocument(positionId, documentType, taxNumber, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Will require to next call trigger-upload.
   * @summary Generate a presigned URL for documents to upload
   * @param {TelesellingDocumentDownloadAsyncRequest} telesellingDocumentDownloadAsyncRequest Teleselling document request data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExelabTelesellingProxyToQineticApi
   */
  public startDocumentDownload(
    telesellingDocumentDownloadAsyncRequest: TelesellingDocumentDownloadAsyncRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ExelabTelesellingProxyToQineticApiFp(this.configuration)
      .startDocumentDownload(telesellingDocumentDownloadAsyncRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Downloads from S3 with specified IDs and will upload file to Qinetic.
   * @summary Trigger file upload to Qinetic
   * @param {TelesellingDocumentUploadRequest} telesellingDocumentUploadRequest Teleselling document request data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExelabTelesellingProxyToQineticApi
   */
  public triggerUploadToQinetic(
    telesellingDocumentUploadRequest: TelesellingDocumentUploadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ExelabTelesellingProxyToQineticApiFp(this.configuration)
      .triggerUploadToQinetic(telesellingDocumentUploadRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GetDocumentDocumentTypeEnum = {
  Secci: "SECCI",
  DeliberaNegativa: "DELIBERA_NEGATIVA",
} as const;
export type GetDocumentDocumentTypeEnum =
  (typeof GetDocumentDocumentTypeEnum)[keyof typeof GetDocumentDocumentTypeEnum];

/**
 * ExperianApi - axios parameter creator
 * @export
 */
export const ExperianApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {IbanCheckRequestDto} ibanCheckRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIbanCheck: async (
      ibanCheckRequestDto: IbanCheckRequestDto,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ibanCheckRequestDto' is not null or undefined
      assertParamExists(
        "getIbanCheck",
        "ibanCheckRequestDto",
        ibanCheckRequestDto,
      );
      const localVarPath = `/experian/iban-checks`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        ibanCheckRequestDto,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExperianApi - functional programming interface
 * @export
 */
export const ExperianApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ExperianApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {IbanCheckRequestDto} ibanCheckRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIbanCheck(
      ibanCheckRequestDto: IbanCheckRequestDto,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getIbanCheck(
        ibanCheckRequestDto,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExperianApi.getIbanCheck"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ExperianApi - factory interface
 * @export
 */
export const ExperianApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ExperianApiFp(configuration);
  return {
    /**
     *
     * @param {IbanCheckRequestDto} ibanCheckRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIbanCheck(
      ibanCheckRequestDto: IbanCheckRequestDto,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .getIbanCheck(ibanCheckRequestDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ExperianApi - object-oriented interface
 * @export
 * @class ExperianApi
 * @extends {BaseAPI}
 */
export class ExperianApi extends BaseAPI {
  /**
   *
   * @param {IbanCheckRequestDto} ibanCheckRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExperianApi
   */
  public getIbanCheck(
    ibanCheckRequestDto: IbanCheckRequestDto,
    options?: RawAxiosRequestConfig,
  ) {
    return ExperianApiFp(this.configuration)
      .getIbanCheck(ibanCheckRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * FacileItCollectionApi - axios parameter creator
 * @export
 */
export const FacileItCollectionApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Ricezione richiesta di finanziamento
     * @param {AggregatorOfferRequest} aggregatorOfferRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    offer1: async (
      aggregatorOfferRequest: AggregatorOfferRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'aggregatorOfferRequest' is not null or undefined
      assertParamExists(
        "offer1",
        "aggregatorOfferRequest",
        aggregatorOfferRequest,
      );
      const localVarPath = `/v1/facile/offer`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        aggregatorOfferRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Download prontuario con data aggiornamento. Matrice che contiene tante righe quanti prezzi disponibili data una combinazione di <amount,duration,cpi,purpose>. Se il purpose è null allora il prezzo restituito per quella combinazione di <amount,duration,cpi> vale per tutti i purpose. Servizio paginato, occorre chiamarlo tante volte fintanto che il valore del campo nextPageToken è null per ottenere l\'intera matrice
     * @param {string} [pageToken] Token che indica la successiva pagina della matrice (valore ottenuto nel campo nextPageToken della response alla precedente chiamata di questo servizio)
     * @param {Array<number>} [amount]
     * @param {Array<number>} [term]
     * @param {string} [purpose] ### 6.1 Finalita prestito  | ID | Finalita | | :--- | :--- | | 1 | PC ed elettronica | | 2 | Formazione e universita | | 4 | Arredamento | | 5 | Ristrutturazione casa | | 15 | Moto nuove/km0 | | 16 | Moto usate | | 24 | Viaggi e vacanze | | 26 | Spese mediche | | 27 | Matrimonio e cerimonie | | 29 | Auto nuove/km0 | | 30 | Auto usate | | 31 | Consolidamento debiti | | 32 | Acquisto immobile | | 33 | Liquidita |
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    pricingMatrix1: async (
      pageToken?: string,
      amount?: Array<number>,
      term?: Array<number>,
      purpose?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/facile/pricingMatrix`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (pageToken !== undefined) {
        localVarQueryParameter["pageToken"] = pageToken;
      }

      if (amount) {
        localVarQueryParameter["amount"] = amount;
      }

      if (term) {
        localVarQueryParameter["term"] = term;
      }

      if (purpose !== undefined) {
        localVarQueryParameter["purpose"] = purpose;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FacileItCollectionApi - functional programming interface
 * @export
 */
export const FacileItCollectionApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    FacileItCollectionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Ricezione richiesta di finanziamento
     * @param {AggregatorOfferRequest} aggregatorOfferRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async offer1(
      aggregatorOfferRequest: AggregatorOfferRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AggregatorOfferResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.offer1(
        aggregatorOfferRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["FacileItCollectionApi.offer1"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Download prontuario con data aggiornamento. Matrice che contiene tante righe quanti prezzi disponibili data una combinazione di <amount,duration,cpi,purpose>. Se il purpose è null allora il prezzo restituito per quella combinazione di <amount,duration,cpi> vale per tutti i purpose. Servizio paginato, occorre chiamarlo tante volte fintanto che il valore del campo nextPageToken è null per ottenere l\'intera matrice
     * @param {string} [pageToken] Token che indica la successiva pagina della matrice (valore ottenuto nel campo nextPageToken della response alla precedente chiamata di questo servizio)
     * @param {Array<number>} [amount]
     * @param {Array<number>} [term]
     * @param {string} [purpose] ### 6.1 Finalita prestito  | ID | Finalita | | :--- | :--- | | 1 | PC ed elettronica | | 2 | Formazione e universita | | 4 | Arredamento | | 5 | Ristrutturazione casa | | 15 | Moto nuove/km0 | | 16 | Moto usate | | 24 | Viaggi e vacanze | | 26 | Spese mediche | | 27 | Matrimonio e cerimonie | | 29 | Auto nuove/km0 | | 30 | Auto usate | | 31 | Consolidamento debiti | | 32 | Acquisto immobile | | 33 | Liquidita |
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async pricingMatrix1(
      pageToken?: string,
      amount?: Array<number>,
      term?: Array<number>,
      purpose?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AggregatorPricingListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pricingMatrix1(
        pageToken,
        amount,
        term,
        purpose,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["FacileItCollectionApi.pricingMatrix1"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * FacileItCollectionApi - factory interface
 * @export
 */
export const FacileItCollectionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = FacileItCollectionApiFp(configuration);
  return {
    /**
     *
     * @summary Ricezione richiesta di finanziamento
     * @param {AggregatorOfferRequest} aggregatorOfferRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    offer1(
      aggregatorOfferRequest: AggregatorOfferRequest,
      options?: any,
    ): AxiosPromise<AggregatorOfferResponse> {
      return localVarFp
        .offer1(aggregatorOfferRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Download prontuario con data aggiornamento. Matrice che contiene tante righe quanti prezzi disponibili data una combinazione di <amount,duration,cpi,purpose>. Se il purpose è null allora il prezzo restituito per quella combinazione di <amount,duration,cpi> vale per tutti i purpose. Servizio paginato, occorre chiamarlo tante volte fintanto che il valore del campo nextPageToken è null per ottenere l\'intera matrice
     * @param {string} [pageToken] Token che indica la successiva pagina della matrice (valore ottenuto nel campo nextPageToken della response alla precedente chiamata di questo servizio)
     * @param {Array<number>} [amount]
     * @param {Array<number>} [term]
     * @param {string} [purpose] ### 6.1 Finalita prestito  | ID | Finalita | | :--- | :--- | | 1 | PC ed elettronica | | 2 | Formazione e universita | | 4 | Arredamento | | 5 | Ristrutturazione casa | | 15 | Moto nuove/km0 | | 16 | Moto usate | | 24 | Viaggi e vacanze | | 26 | Spese mediche | | 27 | Matrimonio e cerimonie | | 29 | Auto nuove/km0 | | 30 | Auto usate | | 31 | Consolidamento debiti | | 32 | Acquisto immobile | | 33 | Liquidita |
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    pricingMatrix1(
      pageToken?: string,
      amount?: Array<number>,
      term?: Array<number>,
      purpose?: string,
      options?: any,
    ): AxiosPromise<AggregatorPricingListResponse> {
      return localVarFp
        .pricingMatrix1(pageToken, amount, term, purpose, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * FacileItCollectionApi - object-oriented interface
 * @export
 * @class FacileItCollectionApi
 * @extends {BaseAPI}
 */
export class FacileItCollectionApi extends BaseAPI {
  /**
   *
   * @summary Ricezione richiesta di finanziamento
   * @param {AggregatorOfferRequest} aggregatorOfferRequest
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof FacileItCollectionApi
   */
  public offer1(
    aggregatorOfferRequest: AggregatorOfferRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FacileItCollectionApiFp(this.configuration)
      .offer1(aggregatorOfferRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Download prontuario con data aggiornamento. Matrice che contiene tante righe quanti prezzi disponibili data una combinazione di <amount,duration,cpi,purpose>. Se il purpose è null allora il prezzo restituito per quella combinazione di <amount,duration,cpi> vale per tutti i purpose. Servizio paginato, occorre chiamarlo tante volte fintanto che il valore del campo nextPageToken è null per ottenere l\'intera matrice
   * @param {string} [pageToken] Token che indica la successiva pagina della matrice (valore ottenuto nel campo nextPageToken della response alla precedente chiamata di questo servizio)
   * @param {Array<number>} [amount]
   * @param {Array<number>} [term]
   * @param {string} [purpose] ### 6.1 Finalita prestito  | ID | Finalita | | :--- | :--- | | 1 | PC ed elettronica | | 2 | Formazione e universita | | 4 | Arredamento | | 5 | Ristrutturazione casa | | 15 | Moto nuove/km0 | | 16 | Moto usate | | 24 | Viaggi e vacanze | | 26 | Spese mediche | | 27 | Matrimonio e cerimonie | | 29 | Auto nuove/km0 | | 30 | Auto usate | | 31 | Consolidamento debiti | | 32 | Acquisto immobile | | 33 | Liquidita |
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof FacileItCollectionApi
   */
  public pricingMatrix1(
    pageToken?: string,
    amount?: Array<number>,
    term?: Array<number>,
    purpose?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return FacileItCollectionApiFp(this.configuration)
      .pricingMatrix1(pageToken, amount, term, purpose, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * KYCOperationsApi - axios parameter creator
 * @export
 */
export const KYCOperationsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {KycWebhookPayload} kycWebhookPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    handleKycWebhook: async (
      kycWebhookPayload: KycWebhookPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'kycWebhookPayload' is not null or undefined
      assertParamExists(
        "handleKycWebhook",
        "kycWebhookPayload",
        kycWebhookPayload,
      );
      const localVarPath = `/kyc/webhook`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        kycWebhookPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {KycTypeRequest} kycTypeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initiateKyc: async (
      kycTypeRequest: KycTypeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'kycTypeRequest' is not null or undefined
      assertParamExists("initiateKyc", "kycTypeRequest", kycTypeRequest);
      const localVarPath = `/kyc/initiate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        kycTypeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * KYCOperationsApi - functional programming interface
 * @export
 */
export const KYCOperationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    KYCOperationsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {KycWebhookPayload} kycWebhookPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async handleKycWebhook(
      kycWebhookPayload: KycWebhookPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.handleKycWebhook(
          kycWebhookPayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["KYCOperationsApi.handleKycWebhook"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {KycTypeRequest} kycTypeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initiateKyc(
      kycTypeRequest: KycTypeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KycResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.initiateKyc(
        kycTypeRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["KYCOperationsApi.initiateKyc"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * KYCOperationsApi - factory interface
 * @export
 */
export const KYCOperationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = KYCOperationsApiFp(configuration);
  return {
    /**
     *
     * @param {KycWebhookPayload} kycWebhookPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    handleKycWebhook(
      kycWebhookPayload: KycWebhookPayload,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .handleKycWebhook(kycWebhookPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {KycTypeRequest} kycTypeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initiateKyc(
      kycTypeRequest: KycTypeRequest,
      options?: any,
    ): AxiosPromise<KycResponse> {
      return localVarFp
        .initiateKyc(kycTypeRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * KYCOperationsApi - object-oriented interface
 * @export
 * @class KYCOperationsApi
 * @extends {BaseAPI}
 */
export class KYCOperationsApi extends BaseAPI {
  /**
   *
   * @param {KycWebhookPayload} kycWebhookPayload
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KYCOperationsApi
   */
  public handleKycWebhook(
    kycWebhookPayload: KycWebhookPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return KYCOperationsApiFp(this.configuration)
      .handleKycWebhook(kycWebhookPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {KycTypeRequest} kycTypeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KYCOperationsApi
   */
  public initiateKyc(
    kycTypeRequest: KycTypeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return KYCOperationsApiFp(this.configuration)
      .initiateKyc(kycTypeRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * NamirialStrongdoxFastAccessPrivateAPIsApi - axios parameter creator
 * @export
 */
export const NamirialStrongdoxFastAccessPrivateAPIsApiAxiosParamCreator =
  function (configuration?: Configuration) {
    return {
      /**
       *
       * @param {StrongdoxDto} strongdoxDto
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      createStrongdoxOtp: async (
        strongdoxDto: StrongdoxDto,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'strongdoxDto' is not null or undefined
        assertParamExists("createStrongdoxOtp", "strongdoxDto", strongdoxDto);
        const localVarPath = `/strongdox/publish-message`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          strongdoxDto,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    };
  };

/**
 * NamirialStrongdoxFastAccessPrivateAPIsApi - functional programming interface
 * @export
 */
export const NamirialStrongdoxFastAccessPrivateAPIsApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    NamirialStrongdoxFastAccessPrivateAPIsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {StrongdoxDto} strongdoxDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createStrongdoxOtp(
      strongdoxDto: StrongdoxDto,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createStrongdoxOtp(
          strongdoxDto,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "NamirialStrongdoxFastAccessPrivateAPIsApi.createStrongdoxOtp"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * NamirialStrongdoxFastAccessPrivateAPIsApi - factory interface
 * @export
 */
export const NamirialStrongdoxFastAccessPrivateAPIsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = NamirialStrongdoxFastAccessPrivateAPIsApiFp(configuration);
  return {
    /**
     *
     * @param {StrongdoxDto} strongdoxDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStrongdoxOtp(
      strongdoxDto: StrongdoxDto,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .createStrongdoxOtp(strongdoxDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * NamirialStrongdoxFastAccessPrivateAPIsApi - object-oriented interface
 * @export
 * @class NamirialStrongdoxFastAccessPrivateAPIsApi
 * @extends {BaseAPI}
 */
export class NamirialStrongdoxFastAccessPrivateAPIsApi extends BaseAPI {
  /**
   *
   * @param {StrongdoxDto} strongdoxDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NamirialStrongdoxFastAccessPrivateAPIsApi
   */
  public createStrongdoxOtp(
    strongdoxDto: StrongdoxDto,
    options?: RawAxiosRequestConfig,
  ) {
    return NamirialStrongdoxFastAccessPrivateAPIsApiFp(this.configuration)
      .createStrongdoxOtp(strongdoxDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PCWCollectionApi - axios parameter creator
 * @export
 */
export const PCWCollectionApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Ricezione richiesta di finanziamento
     * @param {OfferChannelEnum} channel
     * @param {AggregatorOfferRequest} aggregatorOfferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    offer: async (
      channel: OfferChannelEnum,
      aggregatorOfferRequest: AggregatorOfferRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'channel' is not null or undefined
      assertParamExists("offer", "channel", channel);
      // verify required parameter 'aggregatorOfferRequest' is not null or undefined
      assertParamExists(
        "offer",
        "aggregatorOfferRequest",
        aggregatorOfferRequest,
      );
      const localVarPath = `/v1/pcw/{channel}/offer`.replace(
        `{${"channel"}}`,
        encodeURIComponent(String(channel)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        aggregatorOfferRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Download prontuario con data aggiornamento. Matrice che contiene tante righe quanti prezzi disponibili data una combinazione di <amount,duration,cpi,purpose>. Se il purpose è null allora il prezzo restituito per quella combinazione di <amount,duration,cpi> vale per tutti i purpose. Servizio paginato, occorre chiamarlo tante volte fintanto che il valore del campo nextPageToken è null per ottenere l\'intera matrice
     * @param {PricingMatrixChannelEnum} channel
     * @param {string} [pageToken] Token che indica la successiva pagina della matrice (valore ottenuto nel campo nextPageToken della response alla precedente chiamata di questo servizio)
     * @param {Array<number>} [amount]
     * @param {Array<number>} [term]
     * @param {string} [purpose] ### 6.1 Finalita prestito  | ID | Finalita | | :--- | :--- | | 1 | PC ed elettronica | | 2 | Formazione e universita | | 4 | Arredamento | | 5 | Ristrutturazione casa | | 15 | Moto nuove/km0 | | 16 | Moto usate | | 24 | Viaggi e vacanze | | 26 | Spese mediche | | 27 | Matrimonio e cerimonie | | 29 | Auto nuove/km0 | | 30 | Auto usate | | 31 | Consolidamento debiti | | 32 | Acquisto immobile | | 33 | Liquidita |
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pricingMatrix: async (
      channel: PricingMatrixChannelEnum,
      pageToken?: string,
      amount?: Array<number>,
      term?: Array<number>,
      purpose?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'channel' is not null or undefined
      assertParamExists("pricingMatrix", "channel", channel);
      const localVarPath = `/v1/pcw/{channel}/pricingMatrix`.replace(
        `{${"channel"}}`,
        encodeURIComponent(String(channel)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (pageToken !== undefined) {
        localVarQueryParameter["pageToken"] = pageToken;
      }

      if (amount) {
        localVarQueryParameter["amount"] = amount;
      }

      if (term) {
        localVarQueryParameter["term"] = term;
      }

      if (purpose !== undefined) {
        localVarQueryParameter["purpose"] = purpose;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Ricezione richiesta di preventivo
     * @param {QuotationChannelEnum} channel
     * @param {QuotationRequest} quotationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quotation: async (
      channel: QuotationChannelEnum,
      quotationRequest: QuotationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'channel' is not null or undefined
      assertParamExists("quotation", "channel", channel);
      // verify required parameter 'quotationRequest' is not null or undefined
      assertParamExists("quotation", "quotationRequest", quotationRequest);
      const localVarPath = `/v1/pcw/{channel}/quotation`.replace(
        `{${"channel"}}`,
        encodeURIComponent(String(channel)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        quotationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PCWCollectionApi - functional programming interface
 * @export
 */
export const PCWCollectionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    PCWCollectionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Ricezione richiesta di finanziamento
     * @param {OfferChannelEnum} channel
     * @param {AggregatorOfferRequest} aggregatorOfferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async offer(
      channel: OfferChannelEnum,
      aggregatorOfferRequest: AggregatorOfferRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AggregatorOfferResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.offer(
        channel,
        aggregatorOfferRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PCWCollectionApi.offer"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Download prontuario con data aggiornamento. Matrice che contiene tante righe quanti prezzi disponibili data una combinazione di <amount,duration,cpi,purpose>. Se il purpose è null allora il prezzo restituito per quella combinazione di <amount,duration,cpi> vale per tutti i purpose. Servizio paginato, occorre chiamarlo tante volte fintanto che il valore del campo nextPageToken è null per ottenere l\'intera matrice
     * @param {PricingMatrixChannelEnum} channel
     * @param {string} [pageToken] Token che indica la successiva pagina della matrice (valore ottenuto nel campo nextPageToken della response alla precedente chiamata di questo servizio)
     * @param {Array<number>} [amount]
     * @param {Array<number>} [term]
     * @param {string} [purpose] ### 6.1 Finalita prestito  | ID | Finalita | | :--- | :--- | | 1 | PC ed elettronica | | 2 | Formazione e universita | | 4 | Arredamento | | 5 | Ristrutturazione casa | | 15 | Moto nuove/km0 | | 16 | Moto usate | | 24 | Viaggi e vacanze | | 26 | Spese mediche | | 27 | Matrimonio e cerimonie | | 29 | Auto nuove/km0 | | 30 | Auto usate | | 31 | Consolidamento debiti | | 32 | Acquisto immobile | | 33 | Liquidita |
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pricingMatrix(
      channel: PricingMatrixChannelEnum,
      pageToken?: string,
      amount?: Array<number>,
      term?: Array<number>,
      purpose?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AggregatorPricingListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pricingMatrix(
        channel,
        pageToken,
        amount,
        term,
        purpose,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PCWCollectionApi.pricingMatrix"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Ricezione richiesta di preventivo
     * @param {QuotationChannelEnum} channel
     * @param {QuotationRequest} quotationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async quotation(
      channel: QuotationChannelEnum,
      quotationRequest: QuotationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<QuotationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.quotation(
        channel,
        quotationRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PCWCollectionApi.quotation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PCWCollectionApi - factory interface
 * @export
 */
export const PCWCollectionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PCWCollectionApiFp(configuration);
  return {
    /**
     *
     * @summary Ricezione richiesta di finanziamento
     * @param {OfferChannelEnum} channel
     * @param {AggregatorOfferRequest} aggregatorOfferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    offer(
      channel: OfferChannelEnum,
      aggregatorOfferRequest: AggregatorOfferRequest,
      options?: any,
    ): AxiosPromise<AggregatorOfferResponse> {
      return localVarFp
        .offer(channel, aggregatorOfferRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Download prontuario con data aggiornamento. Matrice che contiene tante righe quanti prezzi disponibili data una combinazione di <amount,duration,cpi,purpose>. Se il purpose è null allora il prezzo restituito per quella combinazione di <amount,duration,cpi> vale per tutti i purpose. Servizio paginato, occorre chiamarlo tante volte fintanto che il valore del campo nextPageToken è null per ottenere l\'intera matrice
     * @param {PricingMatrixChannelEnum} channel
     * @param {string} [pageToken] Token che indica la successiva pagina della matrice (valore ottenuto nel campo nextPageToken della response alla precedente chiamata di questo servizio)
     * @param {Array<number>} [amount]
     * @param {Array<number>} [term]
     * @param {string} [purpose] ### 6.1 Finalita prestito  | ID | Finalita | | :--- | :--- | | 1 | PC ed elettronica | | 2 | Formazione e universita | | 4 | Arredamento | | 5 | Ristrutturazione casa | | 15 | Moto nuove/km0 | | 16 | Moto usate | | 24 | Viaggi e vacanze | | 26 | Spese mediche | | 27 | Matrimonio e cerimonie | | 29 | Auto nuove/km0 | | 30 | Auto usate | | 31 | Consolidamento debiti | | 32 | Acquisto immobile | | 33 | Liquidita |
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pricingMatrix(
      channel: PricingMatrixChannelEnum,
      pageToken?: string,
      amount?: Array<number>,
      term?: Array<number>,
      purpose?: string,
      options?: any,
    ): AxiosPromise<AggregatorPricingListResponse> {
      return localVarFp
        .pricingMatrix(channel, pageToken, amount, term, purpose, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Ricezione richiesta di preventivo
     * @param {QuotationChannelEnum} channel
     * @param {QuotationRequest} quotationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quotation(
      channel: QuotationChannelEnum,
      quotationRequest: QuotationRequest,
      options?: any,
    ): AxiosPromise<QuotationResponse> {
      return localVarFp
        .quotation(channel, quotationRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PCWCollectionApi - object-oriented interface
 * @export
 * @class PCWCollectionApi
 * @extends {BaseAPI}
 */
export class PCWCollectionApi extends BaseAPI {
  /**
   *
   * @summary Ricezione richiesta di finanziamento
   * @param {OfferChannelEnum} channel
   * @param {AggregatorOfferRequest} aggregatorOfferRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PCWCollectionApi
   */
  public offer(
    channel: OfferChannelEnum,
    aggregatorOfferRequest: AggregatorOfferRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PCWCollectionApiFp(this.configuration)
      .offer(channel, aggregatorOfferRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Download prontuario con data aggiornamento. Matrice che contiene tante righe quanti prezzi disponibili data una combinazione di <amount,duration,cpi,purpose>. Se il purpose è null allora il prezzo restituito per quella combinazione di <amount,duration,cpi> vale per tutti i purpose. Servizio paginato, occorre chiamarlo tante volte fintanto che il valore del campo nextPageToken è null per ottenere l\'intera matrice
   * @param {PricingMatrixChannelEnum} channel
   * @param {string} [pageToken] Token che indica la successiva pagina della matrice (valore ottenuto nel campo nextPageToken della response alla precedente chiamata di questo servizio)
   * @param {Array<number>} [amount]
   * @param {Array<number>} [term]
   * @param {string} [purpose] ### 6.1 Finalita prestito  | ID | Finalita | | :--- | :--- | | 1 | PC ed elettronica | | 2 | Formazione e universita | | 4 | Arredamento | | 5 | Ristrutturazione casa | | 15 | Moto nuove/km0 | | 16 | Moto usate | | 24 | Viaggi e vacanze | | 26 | Spese mediche | | 27 | Matrimonio e cerimonie | | 29 | Auto nuove/km0 | | 30 | Auto usate | | 31 | Consolidamento debiti | | 32 | Acquisto immobile | | 33 | Liquidita |
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PCWCollectionApi
   */
  public pricingMatrix(
    channel: PricingMatrixChannelEnum,
    pageToken?: string,
    amount?: Array<number>,
    term?: Array<number>,
    purpose?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PCWCollectionApiFp(this.configuration)
      .pricingMatrix(channel, pageToken, amount, term, purpose, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Ricezione richiesta di preventivo
   * @param {QuotationChannelEnum} channel
   * @param {QuotationRequest} quotationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PCWCollectionApi
   */
  public quotation(
    channel: QuotationChannelEnum,
    quotationRequest: QuotationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PCWCollectionApiFp(this.configuration)
      .quotation(channel, quotationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const OfferChannelEnum = {
  Conte: "CONTE",
  Pol: "POL",
  Facile: "FACILE",
  Lead: "LEAD",
} as const;
export type OfferChannelEnum =
  (typeof OfferChannelEnum)[keyof typeof OfferChannelEnum];
/**
 * @export
 */
export const PricingMatrixChannelEnum = {
  Conte: "CONTE",
  Pol: "POL",
  Facile: "FACILE",
  Lead: "LEAD",
} as const;
export type PricingMatrixChannelEnum =
  (typeof PricingMatrixChannelEnum)[keyof typeof PricingMatrixChannelEnum];
/**
 * @export
 */
export const QuotationChannelEnum = {
  Conte: "CONTE",
  Pol: "POL",
  Facile: "FACILE",
  Lead: "LEAD",
} as const;
export type QuotationChannelEnum =
  (typeof QuotationChannelEnum)[keyof typeof QuotationChannelEnum];

/**
 * PagePositionApi - axios parameter creator
 * @export
 */
export const PagePositionApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {PagePositionRequest} pagePositionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPagePosition: async (
      pagePositionRequest: PagePositionRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pagePositionRequest' is not null or undefined
      assertParamExists(
        "addPagePosition",
        "pagePositionRequest",
        pagePositionRequest,
      );
      const localVarPath = `/page-position`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pagePositionRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PagePositionApi - functional programming interface
 * @export
 */
export const PagePositionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    PagePositionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {PagePositionRequest} pagePositionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addPagePosition(
      pagePositionRequest: PagePositionRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addPagePosition(
        pagePositionRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PagePositionApi.addPagePosition"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PagePositionApi - factory interface
 * @export
 */
export const PagePositionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PagePositionApiFp(configuration);
  return {
    /**
     *
     * @param {PagePositionRequest} pagePositionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPagePosition(
      pagePositionRequest: PagePositionRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addPagePosition(pagePositionRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PagePositionApi - object-oriented interface
 * @export
 * @class PagePositionApi
 * @extends {BaseAPI}
 */
export class PagePositionApi extends BaseAPI {
  /**
   *
   * @param {PagePositionRequest} pagePositionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PagePositionApi
   */
  public addPagePosition(
    pagePositionRequest: PagePositionRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PagePositionApiFp(this.configuration)
      .addPagePosition(pagePositionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PrestitiOnlineCollectionApi - axios parameter creator
 * @export
 */
export const PrestitiOnlineCollectionApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {PreApprovalRequest} preApprovalRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    preApproval: async (
      preApprovalRequest: PreApprovalRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'preApprovalRequest' is not null or undefined
      assertParamExists(
        "preApproval",
        "preApprovalRequest",
        preApprovalRequest,
      );
      const localVarPath = `/pol/preapproval`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        preApprovalRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {QuotationRequest} quotationRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    quotation1: async (
      quotationRequest: QuotationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'quotationRequest' is not null or undefined
      assertParamExists("quotation1", "quotationRequest", quotationRequest);
      const localVarPath = `/pol/quotation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        quotationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PrestitiOnlineCollectionApi - functional programming interface
 * @export
 */
export const PrestitiOnlineCollectionApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    PrestitiOnlineCollectionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {PreApprovalRequest} preApprovalRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async preApproval(
      preApprovalRequest: PreApprovalRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PreApprovalResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.preApproval(
        preApprovalRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PrestitiOnlineCollectionApi.preApproval"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {QuotationRequest} quotationRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async quotation1(
      quotationRequest: QuotationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<QuotationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.quotation1(
        quotationRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PrestitiOnlineCollectionApi.quotation1"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PrestitiOnlineCollectionApi - factory interface
 * @export
 */
export const PrestitiOnlineCollectionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PrestitiOnlineCollectionApiFp(configuration);
  return {
    /**
     *
     * @param {PreApprovalRequest} preApprovalRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    preApproval(
      preApprovalRequest: PreApprovalRequest,
      options?: any,
    ): AxiosPromise<PreApprovalResponse> {
      return localVarFp
        .preApproval(preApprovalRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QuotationRequest} quotationRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    quotation1(
      quotationRequest: QuotationRequest,
      options?: any,
    ): AxiosPromise<QuotationResponse> {
      return localVarFp
        .quotation1(quotationRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PrestitiOnlineCollectionApi - object-oriented interface
 * @export
 * @class PrestitiOnlineCollectionApi
 * @extends {BaseAPI}
 */
export class PrestitiOnlineCollectionApi extends BaseAPI {
  /**
   *
   * @param {PreApprovalRequest} preApprovalRequest
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof PrestitiOnlineCollectionApi
   */
  public preApproval(
    preApprovalRequest: PreApprovalRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PrestitiOnlineCollectionApiFp(this.configuration)
      .preApproval(preApprovalRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QuotationRequest} quotationRequest
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof PrestitiOnlineCollectionApi
   */
  public quotation1(
    quotationRequest: QuotationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PrestitiOnlineCollectionApiFp(this.configuration)
      .quotation1(quotationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PriceBoxQineticBeSharpProxyApi - axios parameter creator
 * @export
 */
export const PriceBoxQineticBeSharpProxyApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {PBAffordabilityInputWithAddictionValues} pBAffordabilityInputWithAddictionValues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    affordability: async (
      pBAffordabilityInputWithAddictionValues: PBAffordabilityInputWithAddictionValues,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pBAffordabilityInputWithAddictionValues' is not null or undefined
      assertParamExists(
        "affordability",
        "pBAffordabilityInputWithAddictionValues",
        pBAffordabilityInputWithAddictionValues,
      );
      const localVarPath = `/qinetic/price-box/affordability`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pBAffordabilityInputWithAddictionValues,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PBAggregateAllServiceRequest} pBAggregateAllServiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aggregated: async (
      pBAggregateAllServiceRequest: PBAggregateAllServiceRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pBAggregateAllServiceRequest' is not null or undefined
      assertParamExists(
        "aggregated",
        "pBAggregateAllServiceRequest",
        pBAggregateAllServiceRequest,
      );
      const localVarPath = `/qinetic/price-box/aggregated`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pBAggregateAllServiceRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PBPricingInputWithPdAndIdPratica} pBPricingInputWithPdAndIdPratica
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pricing: async (
      pBPricingInputWithPdAndIdPratica: PBPricingInputWithPdAndIdPratica,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pBPricingInputWithPdAndIdPratica' is not null or undefined
      assertParamExists(
        "pricing",
        "pBPricingInputWithPdAndIdPratica",
        pBPricingInputWithPdAndIdPratica,
      );
      const localVarPath = `/qinetic/price-box/pricing`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pBPricingInputWithPdAndIdPratica,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<PBScoreCardInputWithIdPratica>} pBScoreCardInputWithIdPratica
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scoreCard: async (
      pBScoreCardInputWithIdPratica: Array<PBScoreCardInputWithIdPratica>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pBScoreCardInputWithIdPratica' is not null or undefined
      assertParamExists(
        "scoreCard",
        "pBScoreCardInputWithIdPratica",
        pBScoreCardInputWithIdPratica,
      );
      const localVarPath = `/qinetic/price-box/scoreCard`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pBScoreCardInputWithIdPratica,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PriceBoxQineticBeSharpProxyApi - functional programming interface
 * @export
 */
export const PriceBoxQineticBeSharpProxyApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    PriceBoxQineticBeSharpProxyApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {PBAffordabilityInputWithAddictionValues} pBAffordabilityInputWithAddictionValues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async affordability(
      pBAffordabilityInputWithAddictionValues: PBAffordabilityInputWithAddictionValues,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PBAffordability>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.affordability(
        pBAffordabilityInputWithAddictionValues,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PriceBoxQineticBeSharpProxyApi.affordability"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {PBAggregateAllServiceRequest} pBAggregateAllServiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async aggregated(
      pBAggregateAllServiceRequest: PBAggregateAllServiceRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PBAggregateAllService200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.aggregated(
        pBAggregateAllServiceRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PriceBoxQineticBeSharpProxyApi.aggregated"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {PBPricingInputWithPdAndIdPratica} pBPricingInputWithPdAndIdPratica
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pricing(
      pBPricingInputWithPdAndIdPratica: PBPricingInputWithPdAndIdPratica,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PBPricing>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pricing(
        pBPricingInputWithPdAndIdPratica,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PriceBoxQineticBeSharpProxyApi.pricing"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Array<PBScoreCardInputWithIdPratica>} pBScoreCardInputWithIdPratica
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async scoreCard(
      pBScoreCardInputWithIdPratica: Array<PBScoreCardInputWithIdPratica>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PBScoreCard>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.scoreCard(
        pBScoreCardInputWithIdPratica,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PriceBoxQineticBeSharpProxyApi.scoreCard"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PriceBoxQineticBeSharpProxyApi - factory interface
 * @export
 */
export const PriceBoxQineticBeSharpProxyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PriceBoxQineticBeSharpProxyApiFp(configuration);
  return {
    /**
     *
     * @param {PBAffordabilityInputWithAddictionValues} pBAffordabilityInputWithAddictionValues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    affordability(
      pBAffordabilityInputWithAddictionValues: PBAffordabilityInputWithAddictionValues,
      options?: any,
    ): AxiosPromise<Array<PBAffordability>> {
      return localVarFp
        .affordability(pBAffordabilityInputWithAddictionValues, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PBAggregateAllServiceRequest} pBAggregateAllServiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aggregated(
      pBAggregateAllServiceRequest: PBAggregateAllServiceRequest,
      options?: any,
    ): AxiosPromise<PBAggregateAllService200Response> {
      return localVarFp
        .aggregated(pBAggregateAllServiceRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PBPricingInputWithPdAndIdPratica} pBPricingInputWithPdAndIdPratica
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pricing(
      pBPricingInputWithPdAndIdPratica: PBPricingInputWithPdAndIdPratica,
      options?: any,
    ): AxiosPromise<Array<PBPricing>> {
      return localVarFp
        .pricing(pBPricingInputWithPdAndIdPratica, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<PBScoreCardInputWithIdPratica>} pBScoreCardInputWithIdPratica
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scoreCard(
      pBScoreCardInputWithIdPratica: Array<PBScoreCardInputWithIdPratica>,
      options?: any,
    ): AxiosPromise<Array<PBScoreCard>> {
      return localVarFp
        .scoreCard(pBScoreCardInputWithIdPratica, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PriceBoxQineticBeSharpProxyApi - object-oriented interface
 * @export
 * @class PriceBoxQineticBeSharpProxyApi
 * @extends {BaseAPI}
 */
export class PriceBoxQineticBeSharpProxyApi extends BaseAPI {
  /**
   *
   * @param {PBAffordabilityInputWithAddictionValues} pBAffordabilityInputWithAddictionValues
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PriceBoxQineticBeSharpProxyApi
   */
  public affordability(
    pBAffordabilityInputWithAddictionValues: PBAffordabilityInputWithAddictionValues,
    options?: RawAxiosRequestConfig,
  ) {
    return PriceBoxQineticBeSharpProxyApiFp(this.configuration)
      .affordability(pBAffordabilityInputWithAddictionValues, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PBAggregateAllServiceRequest} pBAggregateAllServiceRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PriceBoxQineticBeSharpProxyApi
   */
  public aggregated(
    pBAggregateAllServiceRequest: PBAggregateAllServiceRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PriceBoxQineticBeSharpProxyApiFp(this.configuration)
      .aggregated(pBAggregateAllServiceRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PBPricingInputWithPdAndIdPratica} pBPricingInputWithPdAndIdPratica
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PriceBoxQineticBeSharpProxyApi
   */
  public pricing(
    pBPricingInputWithPdAndIdPratica: PBPricingInputWithPdAndIdPratica,
    options?: RawAxiosRequestConfig,
  ) {
    return PriceBoxQineticBeSharpProxyApiFp(this.configuration)
      .pricing(pBPricingInputWithPdAndIdPratica, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<PBScoreCardInputWithIdPratica>} pBScoreCardInputWithIdPratica
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PriceBoxQineticBeSharpProxyApi
   */
  public scoreCard(
    pBScoreCardInputWithIdPratica: Array<PBScoreCardInputWithIdPratica>,
    options?: RawAxiosRequestConfig,
  ) {
    return PriceBoxQineticBeSharpProxyApiFp(this.configuration)
      .scoreCard(pBScoreCardInputWithIdPratica, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * QineticAvailabilityApi - axios parameter creator
 * @export
 */
export const QineticAvailabilityApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkQinetic: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/availability/qinetic`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QineticAvailabilityApi - functional programming interface
 * @export
 */
export const QineticAvailabilityApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    QineticAvailabilityApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkQinetic(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.checkQinetic(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticAvailabilityApi.checkQinetic"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * QineticAvailabilityApi - factory interface
 * @export
 */
export const QineticAvailabilityApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = QineticAvailabilityApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkQinetic(options?: any): AxiosPromise<string> {
      return localVarFp
        .checkQinetic(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * QineticAvailabilityApi - object-oriented interface
 * @export
 * @class QineticAvailabilityApi
 * @extends {BaseAPI}
 */
export class QineticAvailabilityApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticAvailabilityApi
   */
  public checkQinetic(options?: RawAxiosRequestConfig) {
    return QineticAvailabilityApiFp(this.configuration)
      .checkQinetic(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * QineticCallbackBUREAUApi - axios parameter creator
 * @export
 */
export const QineticCallbackBUREAUApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * This callback API can be called from Qinetic to inform Orch whether the BUREAU result is ready or not
     * @summary Callback api for BUREAU process
     * @param {string} positionId
     * @param {QineticCallbackRequest} qineticCallbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    callbackBureauProcess: async (
      positionId: string,
      qineticCallbackRequest: QineticCallbackRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("callbackBureauProcess", "positionId", positionId);
      // verify required parameter 'qineticCallbackRequest' is not null or undefined
      assertParamExists(
        "callbackBureauProcess",
        "qineticCallbackRequest",
        qineticCallbackRequest,
      );
      const localVarPath = `/positions/{positionId}/callbacks/BUREAU`.replace(
        `{${"positionId"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        qineticCallbackRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * This callback API can be called from Qinetic to return to Orch the quotation result for a workflow
     * @summary Callback api for aggregator process
     * @param {string} positionId
     * @param {QineticAggregatorCallbackRequest} qineticAggregatorCallbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    callbackQineticProcess: async (
      positionId: string,
      qineticAggregatorCallbackRequest: QineticAggregatorCallbackRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("callbackQineticProcess", "positionId", positionId);
      // verify required parameter 'qineticAggregatorCallbackRequest' is not null or undefined
      assertParamExists(
        "callbackQineticProcess",
        "qineticAggregatorCallbackRequest",
        qineticAggregatorCallbackRequest,
      );
      const localVarPath = `/positions/{positionId}/callbacks/offer`.replace(
        `{${"positionId"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        qineticAggregatorCallbackRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QineticCallbackBUREAUApi - functional programming interface
 * @export
 */
export const QineticCallbackBUREAUApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    QineticCallbackBUREAUApiAxiosParamCreator(configuration);
  return {
    /**
     * This callback API can be called from Qinetic to inform Orch whether the BUREAU result is ready or not
     * @summary Callback api for BUREAU process
     * @param {string} positionId
     * @param {QineticCallbackRequest} qineticCallbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async callbackBureauProcess(
      positionId: string,
      qineticCallbackRequest: QineticCallbackRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<QineticCallbackResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.callbackBureauProcess(
          positionId,
          qineticCallbackRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticCallbackBUREAUApi.callbackBureauProcess"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * This callback API can be called from Qinetic to return to Orch the quotation result for a workflow
     * @summary Callback api for aggregator process
     * @param {string} positionId
     * @param {QineticAggregatorCallbackRequest} qineticAggregatorCallbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async callbackQineticProcess(
      positionId: string,
      qineticAggregatorCallbackRequest: QineticAggregatorCallbackRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<QineticCallbackResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.callbackQineticProcess(
          positionId,
          qineticAggregatorCallbackRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticCallbackBUREAUApi.callbackQineticProcess"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * QineticCallbackBUREAUApi - factory interface
 * @export
 */
export const QineticCallbackBUREAUApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = QineticCallbackBUREAUApiFp(configuration);
  return {
    /**
     * This callback API can be called from Qinetic to inform Orch whether the BUREAU result is ready or not
     * @summary Callback api for BUREAU process
     * @param {string} positionId
     * @param {QineticCallbackRequest} qineticCallbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    callbackBureauProcess(
      positionId: string,
      qineticCallbackRequest: QineticCallbackRequest,
      options?: any,
    ): AxiosPromise<QineticCallbackResponse> {
      return localVarFp
        .callbackBureauProcess(positionId, qineticCallbackRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * This callback API can be called from Qinetic to return to Orch the quotation result for a workflow
     * @summary Callback api for aggregator process
     * @param {string} positionId
     * @param {QineticAggregatorCallbackRequest} qineticAggregatorCallbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    callbackQineticProcess(
      positionId: string,
      qineticAggregatorCallbackRequest: QineticAggregatorCallbackRequest,
      options?: any,
    ): AxiosPromise<QineticCallbackResponse> {
      return localVarFp
        .callbackQineticProcess(
          positionId,
          qineticAggregatorCallbackRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * QineticCallbackBUREAUApi - object-oriented interface
 * @export
 * @class QineticCallbackBUREAUApi
 * @extends {BaseAPI}
 */
export class QineticCallbackBUREAUApi extends BaseAPI {
  /**
   * This callback API can be called from Qinetic to inform Orch whether the BUREAU result is ready or not
   * @summary Callback api for BUREAU process
   * @param {string} positionId
   * @param {QineticCallbackRequest} qineticCallbackRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticCallbackBUREAUApi
   */
  public callbackBureauProcess(
    positionId: string,
    qineticCallbackRequest: QineticCallbackRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QineticCallbackBUREAUApiFp(this.configuration)
      .callbackBureauProcess(positionId, qineticCallbackRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * This callback API can be called from Qinetic to return to Orch the quotation result for a workflow
   * @summary Callback api for aggregator process
   * @param {string} positionId
   * @param {QineticAggregatorCallbackRequest} qineticAggregatorCallbackRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticCallbackBUREAUApi
   */
  public callbackQineticProcess(
    positionId: string,
    qineticAggregatorCallbackRequest: QineticAggregatorCallbackRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QineticCallbackBUREAUApiFp(this.configuration)
      .callbackQineticProcess(
        positionId,
        qineticAggregatorCallbackRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * QineticNegotiationApi - axios parameter creator
 * @export
 */
export const QineticNegotiationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {AccertifyDataRequest} [accertifyDataRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calculateOffer: async (
      accertifyDataRequest?: AccertifyDataRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/negotiation/offer`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accertifyDataRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmOffer: async (
      offerId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists("confirmOffer", "offerId", offerId);
      const localVarPath = `/negotiation/offer/{offerId}/confirm`.replace(
        `{${"offerId"}}`,
        encodeURIComponent(String(offerId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deselectInsurance: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/negotiation/insurance/back`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CalculateOfferRequest} calculateOfferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editOffer: async (
      calculateOfferRequest: CalculateOfferRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'calculateOfferRequest' is not null or undefined
      assertParamExists(
        "editOffer",
        "calculateOfferRequest",
        calculateOfferRequest,
      );
      const localVarPath = `/negotiation/offer/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        calculateOfferRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferData: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/negotiation/offer-data`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOffers: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/negotiation/offers`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    preConfirmOffer: async (
      offerId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists("preConfirmOffer", "offerId", offerId);
      const localVarPath = `/negotiation/offer/{offerId}/pre-confirm`.replace(
        `{${"offerId"}}`,
        encodeURIComponent(String(offerId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} offerId
     * @param {NegotiationBeneficiaryRequest} negotiationBeneficiaryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveBeneficiary: async (
      offerId: string,
      negotiationBeneficiaryRequest: NegotiationBeneficiaryRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists("saveBeneficiary", "offerId", offerId);
      // verify required parameter 'negotiationBeneficiaryRequest' is not null or undefined
      assertParamExists(
        "saveBeneficiary",
        "negotiationBeneficiaryRequest",
        negotiationBeneficiaryRequest,
      );
      const localVarPath = `/negotiation/{offerId}/beneficiary`.replace(
        `{${"offerId"}}`,
        encodeURIComponent(String(offerId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        negotiationBeneficiaryRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {NegotiationIbanRequest} negotiationIbanRequest
     * @param {boolean} [ignoreIbanCheck]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveIban: async (
      negotiationIbanRequest: NegotiationIbanRequest,
      ignoreIbanCheck?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'negotiationIbanRequest' is not null or undefined
      assertParamExists(
        "saveIban",
        "negotiationIbanRequest",
        negotiationIbanRequest,
      );
      const localVarPath = `/negotiation/iban`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (ignoreIbanCheck !== undefined) {
        localVarQueryParameter["ignoreIbanCheck"] = ignoreIbanCheck;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        negotiationIbanRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} offerId
     * @param {InsuranceQuestionnaireRequest} insuranceQuestionnaireRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveInsuranceQuestionnaire: async (
      offerId: string,
      insuranceQuestionnaireRequest: InsuranceQuestionnaireRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists("saveInsuranceQuestionnaire", "offerId", offerId);
      // verify required parameter 'insuranceQuestionnaireRequest' is not null or undefined
      assertParamExists(
        "saveInsuranceQuestionnaire",
        "insuranceQuestionnaireRequest",
        insuranceQuestionnaireRequest,
      );
      const localVarPath =
        `/negotiation/offer/{offerId}/insurance/questionnaire`.replace(
          `{${"offerId"}}`,
          encodeURIComponent(String(offerId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        insuranceQuestionnaireRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {NegotiationInsuranceRequest} negotiationInsuranceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    selectInsurance: async (
      negotiationInsuranceRequest: NegotiationInsuranceRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'negotiationInsuranceRequest' is not null or undefined
      assertParamExists(
        "selectInsurance",
        "negotiationInsuranceRequest",
        negotiationInsuranceRequest,
      );
      const localVarPath = `/negotiation/insurance`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        negotiationInsuranceRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QineticNegotiationApi - functional programming interface
 * @export
 */
export const QineticNegotiationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    QineticNegotiationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AccertifyDataRequest} [accertifyDataRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calculateOffer(
      accertifyDataRequest?: AccertifyDataRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calculateOffer(
        accertifyDataRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticNegotiationApi.calculateOffer"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmOffer(
      offerId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.confirmOffer(
        offerId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticNegotiationApi.confirmOffer"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deselectInsurance(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deselectInsurance(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticNegotiationApi.deselectInsurance"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CalculateOfferRequest} calculateOfferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async editOffer(
      calculateOfferRequest: CalculateOfferRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EditOfferResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.editOffer(
        calculateOfferRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticNegotiationApi.editOffer"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOfferData(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getOfferData(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticNegotiationApi.getOfferData"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOffers(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OfferListResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getOffers(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticNegotiationApi.getOffers"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async preConfirmOffer(
      offerId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.preConfirmOffer(
        offerId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticNegotiationApi.preConfirmOffer"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} offerId
     * @param {NegotiationBeneficiaryRequest} negotiationBeneficiaryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saveBeneficiary(
      offerId: string,
      negotiationBeneficiaryRequest: NegotiationBeneficiaryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saveBeneficiary(
        offerId,
        negotiationBeneficiaryRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticNegotiationApi.saveBeneficiary"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {NegotiationIbanRequest} negotiationIbanRequest
     * @param {boolean} [ignoreIbanCheck]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saveIban(
      negotiationIbanRequest: NegotiationIbanRequest,
      ignoreIbanCheck?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CheckIbanResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saveIban(
        negotiationIbanRequest,
        ignoreIbanCheck,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticNegotiationApi.saveIban"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} offerId
     * @param {InsuranceQuestionnaireRequest} insuranceQuestionnaireRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saveInsuranceQuestionnaire(
      offerId: string,
      insuranceQuestionnaireRequest: InsuranceQuestionnaireRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.saveInsuranceQuestionnaire(
          offerId,
          insuranceQuestionnaireRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "QineticNegotiationApi.saveInsuranceQuestionnaire"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {NegotiationInsuranceRequest} negotiationInsuranceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async selectInsurance(
      negotiationInsuranceRequest: NegotiationInsuranceRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.selectInsurance(
        negotiationInsuranceRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticNegotiationApi.selectInsurance"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * QineticNegotiationApi - factory interface
 * @export
 */
export const QineticNegotiationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = QineticNegotiationApiFp(configuration);
  return {
    /**
     *
     * @param {AccertifyDataRequest} [accertifyDataRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calculateOffer(
      accertifyDataRequest?: AccertifyDataRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .calculateOffer(accertifyDataRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmOffer(offerId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .confirmOffer(offerId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deselectInsurance(options?: any): AxiosPromise<void> {
      return localVarFp
        .deselectInsurance(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CalculateOfferRequest} calculateOfferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editOffer(
      calculateOfferRequest: CalculateOfferRequest,
      options?: any,
    ): AxiosPromise<EditOfferResponse> {
      return localVarFp
        .editOffer(calculateOfferRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferData(options?: any): AxiosPromise<OfferResponse> {
      return localVarFp
        .getOfferData(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOffers(options?: any): AxiosPromise<OfferListResponse> {
      return localVarFp
        .getOffers(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    preConfirmOffer(offerId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .preConfirmOffer(offerId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} offerId
     * @param {NegotiationBeneficiaryRequest} negotiationBeneficiaryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveBeneficiary(
      offerId: string,
      negotiationBeneficiaryRequest: NegotiationBeneficiaryRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .saveBeneficiary(offerId, negotiationBeneficiaryRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {NegotiationIbanRequest} negotiationIbanRequest
     * @param {boolean} [ignoreIbanCheck]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveIban(
      negotiationIbanRequest: NegotiationIbanRequest,
      ignoreIbanCheck?: boolean,
      options?: any,
    ): AxiosPromise<CheckIbanResponse> {
      return localVarFp
        .saveIban(negotiationIbanRequest, ignoreIbanCheck, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} offerId
     * @param {InsuranceQuestionnaireRequest} insuranceQuestionnaireRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveInsuranceQuestionnaire(
      offerId: string,
      insuranceQuestionnaireRequest: InsuranceQuestionnaireRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .saveInsuranceQuestionnaire(
          offerId,
          insuranceQuestionnaireRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {NegotiationInsuranceRequest} negotiationInsuranceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    selectInsurance(
      negotiationInsuranceRequest: NegotiationInsuranceRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .selectInsurance(negotiationInsuranceRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * QineticNegotiationApi - object-oriented interface
 * @export
 * @class QineticNegotiationApi
 * @extends {BaseAPI}
 */
export class QineticNegotiationApi extends BaseAPI {
  /**
   *
   * @param {AccertifyDataRequest} [accertifyDataRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticNegotiationApi
   */
  public calculateOffer(
    accertifyDataRequest?: AccertifyDataRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QineticNegotiationApiFp(this.configuration)
      .calculateOffer(accertifyDataRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} offerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticNegotiationApi
   */
  public confirmOffer(offerId: string, options?: RawAxiosRequestConfig) {
    return QineticNegotiationApiFp(this.configuration)
      .confirmOffer(offerId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticNegotiationApi
   */
  public deselectInsurance(options?: RawAxiosRequestConfig) {
    return QineticNegotiationApiFp(this.configuration)
      .deselectInsurance(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CalculateOfferRequest} calculateOfferRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticNegotiationApi
   */
  public editOffer(
    calculateOfferRequest: CalculateOfferRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QineticNegotiationApiFp(this.configuration)
      .editOffer(calculateOfferRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticNegotiationApi
   */
  public getOfferData(options?: RawAxiosRequestConfig) {
    return QineticNegotiationApiFp(this.configuration)
      .getOfferData(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticNegotiationApi
   */
  public getOffers(options?: RawAxiosRequestConfig) {
    return QineticNegotiationApiFp(this.configuration)
      .getOffers(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} offerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticNegotiationApi
   */
  public preConfirmOffer(offerId: string, options?: RawAxiosRequestConfig) {
    return QineticNegotiationApiFp(this.configuration)
      .preConfirmOffer(offerId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} offerId
   * @param {NegotiationBeneficiaryRequest} negotiationBeneficiaryRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticNegotiationApi
   */
  public saveBeneficiary(
    offerId: string,
    negotiationBeneficiaryRequest: NegotiationBeneficiaryRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QineticNegotiationApiFp(this.configuration)
      .saveBeneficiary(offerId, negotiationBeneficiaryRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {NegotiationIbanRequest} negotiationIbanRequest
   * @param {boolean} [ignoreIbanCheck]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticNegotiationApi
   */
  public saveIban(
    negotiationIbanRequest: NegotiationIbanRequest,
    ignoreIbanCheck?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return QineticNegotiationApiFp(this.configuration)
      .saveIban(negotiationIbanRequest, ignoreIbanCheck, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} offerId
   * @param {InsuranceQuestionnaireRequest} insuranceQuestionnaireRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticNegotiationApi
   */
  public saveInsuranceQuestionnaire(
    offerId: string,
    insuranceQuestionnaireRequest: InsuranceQuestionnaireRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QineticNegotiationApiFp(this.configuration)
      .saveInsuranceQuestionnaire(
        offerId,
        insuranceQuestionnaireRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {NegotiationInsuranceRequest} negotiationInsuranceRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticNegotiationApi
   */
  public selectInsurance(
    negotiationInsuranceRequest: NegotiationInsuranceRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QineticNegotiationApiFp(this.configuration)
      .selectInsurance(negotiationInsuranceRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * QineticStatusNotificationApi - axios parameter creator
 * @export
 */
export const QineticStatusNotificationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {DeliveryRequest} deliveryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delivery: async (
      deliveryRequest: DeliveryRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'deliveryRequest' is not null or undefined
      assertParamExists("delivery", "deliveryRequest", deliveryRequest);
      const localVarPath = `/notifications/delivery`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deliveryRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QineticStatusNotificationApi - functional programming interface
 * @export
 */
export const QineticStatusNotificationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    QineticStatusNotificationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {DeliveryRequest} deliveryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async delivery(
      deliveryRequest: DeliveryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<NotificationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.delivery(
        deliveryRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticStatusNotificationApi.delivery"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * QineticStatusNotificationApi - factory interface
 * @export
 */
export const QineticStatusNotificationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = QineticStatusNotificationApiFp(configuration);
  return {
    /**
     *
     * @param {DeliveryRequest} deliveryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delivery(
      deliveryRequest: DeliveryRequest,
      options?: any,
    ): AxiosPromise<NotificationResponse> {
      return localVarFp
        .delivery(deliveryRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * QineticStatusNotificationApi - object-oriented interface
 * @export
 * @class QineticStatusNotificationApi
 * @extends {BaseAPI}
 */
export class QineticStatusNotificationApi extends BaseAPI {
  /**
   *
   * @param {DeliveryRequest} deliveryRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticStatusNotificationApi
   */
  public delivery(
    deliveryRequest: DeliveryRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QineticStatusNotificationApiFp(this.configuration)
      .delivery(deliveryRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * QineticSurveyApi - axios parameter creator
 * @export
 */
export const QineticSurveyApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {string} fiscalCode
     * @param {GetSurveySurveyCodeEnum} surveyCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSurvey: async (
      fiscalCode: string,
      surveyCode: GetSurveySurveyCodeEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fiscalCode' is not null or undefined
      assertParamExists("getSurvey", "fiscalCode", fiscalCode);
      // verify required parameter 'surveyCode' is not null or undefined
      assertParamExists("getSurvey", "surveyCode", surveyCode);
      const localVarPath = `/survey/{surveyCode}/{fiscalCode}`
        .replace(`{${"fiscalCode"}}`, encodeURIComponent(String(fiscalCode)))
        .replace(`{${"surveyCode"}}`, encodeURIComponent(String(surveyCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} fiscalCode
     * @param {SendSurveySurveyCodeEnum} surveyCode
     * @param {OrchSurveyRequest} orchSurveyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendSurvey: async (
      fiscalCode: string,
      surveyCode: SendSurveySurveyCodeEnum,
      orchSurveyRequest: OrchSurveyRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fiscalCode' is not null or undefined
      assertParamExists("sendSurvey", "fiscalCode", fiscalCode);
      // verify required parameter 'surveyCode' is not null or undefined
      assertParamExists("sendSurvey", "surveyCode", surveyCode);
      // verify required parameter 'orchSurveyRequest' is not null or undefined
      assertParamExists("sendSurvey", "orchSurveyRequest", orchSurveyRequest);
      const localVarPath = `/survey/{surveyCode}/{fiscalCode}`
        .replace(`{${"fiscalCode"}}`, encodeURIComponent(String(fiscalCode)))
        .replace(`{${"surveyCode"}}`, encodeURIComponent(String(surveyCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        orchSurveyRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QineticSurveyApi - functional programming interface
 * @export
 */
export const QineticSurveyApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    QineticSurveyApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} fiscalCode
     * @param {GetSurveySurveyCodeEnum} surveyCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSurvey(
      fiscalCode: string,
      surveyCode: GetSurveySurveyCodeEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetOrchSurveyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSurvey(
        fiscalCode,
        surveyCode,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticSurveyApi.getSurvey"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} fiscalCode
     * @param {SendSurveySurveyCodeEnum} surveyCode
     * @param {OrchSurveyRequest} orchSurveyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendSurvey(
      fiscalCode: string,
      surveyCode: SendSurveySurveyCodeEnum,
      orchSurveyRequest: OrchSurveyRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sendSurvey(
        fiscalCode,
        surveyCode,
        orchSurveyRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["QineticSurveyApi.sendSurvey"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * QineticSurveyApi - factory interface
 * @export
 */
export const QineticSurveyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = QineticSurveyApiFp(configuration);
  return {
    /**
     *
     * @param {string} fiscalCode
     * @param {GetSurveySurveyCodeEnum} surveyCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSurvey(
      fiscalCode: string,
      surveyCode: GetSurveySurveyCodeEnum,
      options?: any,
    ): AxiosPromise<GetOrchSurveyResponse> {
      return localVarFp
        .getSurvey(fiscalCode, surveyCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} fiscalCode
     * @param {SendSurveySurveyCodeEnum} surveyCode
     * @param {OrchSurveyRequest} orchSurveyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendSurvey(
      fiscalCode: string,
      surveyCode: SendSurveySurveyCodeEnum,
      orchSurveyRequest: OrchSurveyRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .sendSurvey(fiscalCode, surveyCode, orchSurveyRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * QineticSurveyApi - object-oriented interface
 * @export
 * @class QineticSurveyApi
 * @extends {BaseAPI}
 */
export class QineticSurveyApi extends BaseAPI {
  /**
   *
   * @param {string} fiscalCode
   * @param {GetSurveySurveyCodeEnum} surveyCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticSurveyApi
   */
  public getSurvey(
    fiscalCode: string,
    surveyCode: GetSurveySurveyCodeEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return QineticSurveyApiFp(this.configuration)
      .getSurvey(fiscalCode, surveyCode, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} fiscalCode
   * @param {SendSurveySurveyCodeEnum} surveyCode
   * @param {OrchSurveyRequest} orchSurveyRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QineticSurveyApi
   */
  public sendSurvey(
    fiscalCode: string,
    surveyCode: SendSurveySurveyCodeEnum,
    orchSurveyRequest: OrchSurveyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QineticSurveyApiFp(this.configuration)
      .sendSurvey(fiscalCode, surveyCode, orchSurveyRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GetSurveySurveyCodeEnum = {
  AdegAssic: "ADEG_ASSIC",
  Adeguataverifica: "ADEGUATAVERIFICA",
} as const;
export type GetSurveySurveyCodeEnum =
  (typeof GetSurveySurveyCodeEnum)[keyof typeof GetSurveySurveyCodeEnum];
/**
 * @export
 */
export const SendSurveySurveyCodeEnum = {
  AdegAssic: "ADEG_ASSIC",
  Adeguataverifica: "ADEGUATAVERIFICA",
} as const;
export type SendSurveySurveyCodeEnum =
  (typeof SendSurveySurveyCodeEnum)[keyof typeof SendSurveySurveyCodeEnum];

/**
 * RedirectPublicAPIsToRedirectTheFlowApi - axios parameter creator
 * @export
 */
export const RedirectPublicAPIsToRedirectTheFlowApiAxiosParamCreator =
  function (configuration?: Configuration) {
    return {
      /**
       *
       * @param {RedirectOtpRequest} redirectOtpRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      generateRedirectUrlForOtp: async (
        redirectOtpRequest: RedirectOtpRequest,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'redirectOtpRequest' is not null or undefined
        assertParamExists(
          "generateRedirectUrlForOtp",
          "redirectOtpRequest",
          redirectOtpRequest,
        );
        const localVarPath = `/redirect/otp`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          redirectOtpRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       *
       * @param {RedirectPersonalAreaRequest} redirectPersonalAreaRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      generateRedirectUrlForPersonalArea: async (
        redirectPersonalAreaRequest: RedirectPersonalAreaRequest,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'redirectPersonalAreaRequest' is not null or undefined
        assertParamExists(
          "generateRedirectUrlForPersonalArea",
          "redirectPersonalAreaRequest",
          redirectPersonalAreaRequest,
        );
        const localVarPath = `/redirect/personal-area`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          redirectPersonalAreaRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       *
       * @param {RedirectWelcomeRequest} redirectWelcomeRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      generateRedirectUrlForWelcome: async (
        redirectWelcomeRequest: RedirectWelcomeRequest,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'redirectWelcomeRequest' is not null or undefined
        assertParamExists(
          "generateRedirectUrlForWelcome",
          "redirectWelcomeRequest",
          redirectWelcomeRequest,
        );
        const localVarPath = `/redirect/welcome`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          redirectWelcomeRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       *
       * @param {string} tinyUrlId
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      redirect: async (
        tinyUrlId: string,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'tinyUrlId' is not null or undefined
        assertParamExists("redirect", "tinyUrlId", tinyUrlId);
        const localVarPath = `/redirect/{tinyUrlId}`.replace(
          `{${"tinyUrlId"}}`,
          encodeURIComponent(String(tinyUrlId)),
        );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    };
  };

/**
 * RedirectPublicAPIsToRedirectTheFlowApi - functional programming interface
 * @export
 */
export const RedirectPublicAPIsToRedirectTheFlowApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    RedirectPublicAPIsToRedirectTheFlowApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {RedirectOtpRequest} redirectOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generateRedirectUrlForOtp(
      redirectOtpRequest: RedirectOtpRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RedirectResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.generateRedirectUrlForOtp(
          redirectOtpRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "RedirectPublicAPIsToRedirectTheFlowApi.generateRedirectUrlForOtp"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {RedirectPersonalAreaRequest} redirectPersonalAreaRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generateRedirectUrlForPersonalArea(
      redirectPersonalAreaRequest: RedirectPersonalAreaRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RedirectResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.generateRedirectUrlForPersonalArea(
          redirectPersonalAreaRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "RedirectPublicAPIsToRedirectTheFlowApi.generateRedirectUrlForPersonalArea"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {RedirectWelcomeRequest} redirectWelcomeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generateRedirectUrlForWelcome(
      redirectWelcomeRequest: RedirectWelcomeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RedirectResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.generateRedirectUrlForWelcome(
          redirectWelcomeRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "RedirectPublicAPIsToRedirectTheFlowApi.generateRedirectUrlForWelcome"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} tinyUrlId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async redirect(
      tinyUrlId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.redirect(
        tinyUrlId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RedirectPublicAPIsToRedirectTheFlowApi.redirect"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RedirectPublicAPIsToRedirectTheFlowApi - factory interface
 * @export
 */
export const RedirectPublicAPIsToRedirectTheFlowApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RedirectPublicAPIsToRedirectTheFlowApiFp(configuration);
  return {
    /**
     *
     * @param {RedirectOtpRequest} redirectOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateRedirectUrlForOtp(
      redirectOtpRequest: RedirectOtpRequest,
      options?: any,
    ): AxiosPromise<RedirectResponse> {
      return localVarFp
        .generateRedirectUrlForOtp(redirectOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RedirectPersonalAreaRequest} redirectPersonalAreaRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateRedirectUrlForPersonalArea(
      redirectPersonalAreaRequest: RedirectPersonalAreaRequest,
      options?: any,
    ): AxiosPromise<RedirectResponse> {
      return localVarFp
        .generateRedirectUrlForPersonalArea(
          redirectPersonalAreaRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RedirectWelcomeRequest} redirectWelcomeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateRedirectUrlForWelcome(
      redirectWelcomeRequest: RedirectWelcomeRequest,
      options?: any,
    ): AxiosPromise<RedirectResponse> {
      return localVarFp
        .generateRedirectUrlForWelcome(redirectWelcomeRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} tinyUrlId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    redirect(tinyUrlId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .redirect(tinyUrlId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RedirectPublicAPIsToRedirectTheFlowApi - object-oriented interface
 * @export
 * @class RedirectPublicAPIsToRedirectTheFlowApi
 * @extends {BaseAPI}
 */
export class RedirectPublicAPIsToRedirectTheFlowApi extends BaseAPI {
  /**
   *
   * @param {RedirectOtpRequest} redirectOtpRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedirectPublicAPIsToRedirectTheFlowApi
   */
  public generateRedirectUrlForOtp(
    redirectOtpRequest: RedirectOtpRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RedirectPublicAPIsToRedirectTheFlowApiFp(this.configuration)
      .generateRedirectUrlForOtp(redirectOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {RedirectPersonalAreaRequest} redirectPersonalAreaRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedirectPublicAPIsToRedirectTheFlowApi
   */
  public generateRedirectUrlForPersonalArea(
    redirectPersonalAreaRequest: RedirectPersonalAreaRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RedirectPublicAPIsToRedirectTheFlowApiFp(this.configuration)
      .generateRedirectUrlForPersonalArea(redirectPersonalAreaRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {RedirectWelcomeRequest} redirectWelcomeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedirectPublicAPIsToRedirectTheFlowApi
   */
  public generateRedirectUrlForWelcome(
    redirectWelcomeRequest: RedirectWelcomeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RedirectPublicAPIsToRedirectTheFlowApiFp(this.configuration)
      .generateRedirectUrlForWelcome(redirectWelcomeRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} tinyUrlId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RedirectPublicAPIsToRedirectTheFlowApi
   */
  public redirect(tinyUrlId: string, options?: RawAxiosRequestConfig) {
    return RedirectPublicAPIsToRedirectTheFlowApiFp(this.configuration)
      .redirect(tinyUrlId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ReteFisicaContactOperationsApi - axios parameter creator
 * @export
 */
export const ReteFisicaContactOperationsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {QineticDealCreationRequest} qineticDealCreationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDealAndContact: async (
      qineticDealCreationRequest: QineticDealCreationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'qineticDealCreationRequest' is not null or undefined
      assertParamExists(
        "createDealAndContact",
        "qineticDealCreationRequest",
        qineticDealCreationRequest,
      );
      const localVarPath = `/qinetic/contact`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        qineticDealCreationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ReteFisicaContactOperationsApi - functional programming interface
 * @export
 */
export const ReteFisicaContactOperationsApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    ReteFisicaContactOperationsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {QineticDealCreationRequest} qineticDealCreationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createDealAndContact(
      qineticDealCreationRequest: QineticDealCreationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<QineticDealCreationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createDealAndContact(
          qineticDealCreationRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ReteFisicaContactOperationsApi.createDealAndContact"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ReteFisicaContactOperationsApi - factory interface
 * @export
 */
export const ReteFisicaContactOperationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ReteFisicaContactOperationsApiFp(configuration);
  return {
    /**
     *
     * @param {QineticDealCreationRequest} qineticDealCreationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDealAndContact(
      qineticDealCreationRequest: QineticDealCreationRequest,
      options?: any,
    ): AxiosPromise<QineticDealCreationResponse> {
      return localVarFp
        .createDealAndContact(qineticDealCreationRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ReteFisicaContactOperationsApi - object-oriented interface
 * @export
 * @class ReteFisicaContactOperationsApi
 * @extends {BaseAPI}
 */
export class ReteFisicaContactOperationsApi extends BaseAPI {
  /**
   *
   * @param {QineticDealCreationRequest} qineticDealCreationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReteFisicaContactOperationsApi
   */
  public createDealAndContact(
    qineticDealCreationRequest: QineticDealCreationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ReteFisicaContactOperationsApiFp(this.configuration)
      .createDealAndContact(qineticDealCreationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SessionPublicAPIsForStartFlowApi - axios parameter creator
 * @export
 */
export const SessionPublicAPIsForStartFlowApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    back: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/session/back`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DealCreationRequest} dealCreationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDeal: async (
      dealCreationRequest: DealCreationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealCreationRequest' is not null or undefined
      assertParamExists(
        "createDeal",
        "dealCreationRequest",
        dealCreationRequest,
      );
      const localVarPath = `/session/deal`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        dealCreationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ELCreateOtpRequest} eLCreateOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOtp: async (
      eLCreateOtpRequest: ELCreateOtpRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'eLCreateOtpRequest' is not null or undefined
      assertParamExists("createOtp", "eLCreateOtpRequest", eLCreateOtpRequest);
      const localVarPath = `/session/create-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        eLCreateOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccount: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/session`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getState: async (
      workflowId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'workflowId' is not null or undefined
      assertParamExists("getState", "workflowId", workflowId);
      const localVarPath = `/session/state`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (workflowId !== undefined) {
        localVarQueryParameter["workflowId"] = workflowId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateContactRequest} createContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initFlow: async (
      createContactRequest: CreateContactRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createContactRequest' is not null or undefined
      assertParamExists(
        "initFlow",
        "createContactRequest",
        createContactRequest,
      );
      const localVarPath = `/session/init`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createContactRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    next: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/session/next`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshJwt: async (
      workflowId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'workflowId' is not null or undefined
      assertParamExists("refreshJwt", "workflowId", workflowId);
      const localVarPath = `/session/jwt/refresh`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (workflowId !== undefined) {
        localVarQueryParameter["workflowId"] = workflowId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {VerifyOtpRequest} verifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOtp: async (
      verifyOtpRequest: VerifyOtpRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'verifyOtpRequest' is not null or undefined
      assertParamExists("verifyOtp", "verifyOtpRequest", verifyOtpRequest);
      const localVarPath = `/session/verify-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        verifyOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SessionPublicAPIsForStartFlowApi - functional programming interface
 * @export
 */
export const SessionPublicAPIsForStartFlowApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    SessionPublicAPIsForStartFlowApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async back(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.back(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SessionPublicAPIsForStartFlowApi.back"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DealCreationRequest} dealCreationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createDeal(
      dealCreationRequest: DealCreationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<DealCreationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createDeal(
        dealCreationRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SessionPublicAPIsForStartFlowApi.createDeal"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {ELCreateOtpRequest} eLCreateOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createOtp(
      eLCreateOtpRequest: ELCreateOtpRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createOtp(
        eLCreateOtpRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SessionPublicAPIsForStartFlowApi.createOtp"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAccount(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SessionInfoResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAccount(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SessionPublicAPIsForStartFlowApi.getAccount"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getState(
      workflowId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getState(
        workflowId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SessionPublicAPIsForStartFlowApi.getState"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateContactRequest} createContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initFlow(
      createContactRequest: CreateContactRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.initFlow(
        createContactRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SessionPublicAPIsForStartFlowApi.initFlow"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async next(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.next(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SessionPublicAPIsForStartFlowApi.next"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async refreshJwt(
      workflowId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.refreshJwt(
        workflowId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SessionPublicAPIsForStartFlowApi.refreshJwt"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {VerifyOtpRequest} verifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyOtp(
      verifyOtpRequest: VerifyOtpRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOtp(
        verifyOtpRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SessionPublicAPIsForStartFlowApi.verifyOtp"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SessionPublicAPIsForStartFlowApi - factory interface
 * @export
 */
export const SessionPublicAPIsForStartFlowApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SessionPublicAPIsForStartFlowApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    back(options?: any): AxiosPromise<void> {
      return localVarFp
        .back(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DealCreationRequest} dealCreationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDeal(
      dealCreationRequest: DealCreationRequest,
      options?: any,
    ): AxiosPromise<DealCreationResponse> {
      return localVarFp
        .createDeal(dealCreationRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ELCreateOtpRequest} eLCreateOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOtp(
      eLCreateOtpRequest: ELCreateOtpRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .createOtp(eLCreateOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccount(options?: any): AxiosPromise<SessionInfoResponse> {
      return localVarFp
        .getAccount(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getState(workflowId: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .getState(workflowId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateContactRequest} createContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initFlow(
      createContactRequest: CreateContactRequest,
      options?: any,
    ): AxiosPromise<InitResponse> {
      return localVarFp
        .initFlow(createContactRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    next(options?: any): AxiosPromise<void> {
      return localVarFp
        .next(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshJwt(workflowId: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .refreshJwt(workflowId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {VerifyOtpRequest} verifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOtp(
      verifyOtpRequest: VerifyOtpRequest,
      options?: any,
    ): AxiosPromise<InitResponse> {
      return localVarFp
        .verifyOtp(verifyOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SessionPublicAPIsForStartFlowApi - object-oriented interface
 * @export
 * @class SessionPublicAPIsForStartFlowApi
 * @extends {BaseAPI}
 */
export class SessionPublicAPIsForStartFlowApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionPublicAPIsForStartFlowApi
   */
  public back(options?: RawAxiosRequestConfig) {
    return SessionPublicAPIsForStartFlowApiFp(this.configuration)
      .back(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DealCreationRequest} dealCreationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionPublicAPIsForStartFlowApi
   */
  public createDeal(
    dealCreationRequest: DealCreationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SessionPublicAPIsForStartFlowApiFp(this.configuration)
      .createDeal(dealCreationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ELCreateOtpRequest} eLCreateOtpRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionPublicAPIsForStartFlowApi
   */
  public createOtp(
    eLCreateOtpRequest: ELCreateOtpRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SessionPublicAPIsForStartFlowApiFp(this.configuration)
      .createOtp(eLCreateOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionPublicAPIsForStartFlowApi
   */
  public getAccount(options?: RawAxiosRequestConfig) {
    return SessionPublicAPIsForStartFlowApiFp(this.configuration)
      .getAccount(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} workflowId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionPublicAPIsForStartFlowApi
   */
  public getState(workflowId: string, options?: RawAxiosRequestConfig) {
    return SessionPublicAPIsForStartFlowApiFp(this.configuration)
      .getState(workflowId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateContactRequest} createContactRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionPublicAPIsForStartFlowApi
   */
  public initFlow(
    createContactRequest: CreateContactRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SessionPublicAPIsForStartFlowApiFp(this.configuration)
      .initFlow(createContactRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionPublicAPIsForStartFlowApi
   */
  public next(options?: RawAxiosRequestConfig) {
    return SessionPublicAPIsForStartFlowApiFp(this.configuration)
      .next(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} workflowId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionPublicAPIsForStartFlowApi
   */
  public refreshJwt(workflowId: string, options?: RawAxiosRequestConfig) {
    return SessionPublicAPIsForStartFlowApiFp(this.configuration)
      .refreshJwt(workflowId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {VerifyOtpRequest} verifyOtpRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionPublicAPIsForStartFlowApi
   */
  public verifyOtp(
    verifyOtpRequest: VerifyOtpRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SessionPublicAPIsForStartFlowApiFp(this.configuration)
      .verifyOtp(verifyOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SignPrivateAPIsForNarmirialsSigningIntegrationApi - axios parameter creator
 * @export
 */
export const SignPrivateAPIsForNarmirialsSigningIntegrationApiAxiosParamCreator =
  function (configuration?: Configuration) {
    return {
      /**
       * This service is used by Qinetic when they need to retrieve the signed document, that is an event thrown by orchestrator via XXXXX-(TODO@Elena) call to Qinetic
       * @summary Get the signed document
       * @param {string} envelopeId
       * @param {string} documentId
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      getSignedDocument: async (
        envelopeId: string,
        documentId: string,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'envelopeId' is not null or undefined
        assertParamExists("getSignedDocument", "envelopeId", envelopeId);
        // verify required parameter 'documentId' is not null or undefined
        assertParamExists("getSignedDocument", "documentId", documentId);
        const localVarPath = `/sign/documentSigned/{envelopeId}/{documentId}`
          .replace(`{${"envelopeId"}}`, encodeURIComponent(String(envelopeId)))
          .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       *
       * @param {string} envelopeId
       * @param {string} positionId
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      handleSignWebhook: async (
        envelopeId: string,
        positionId: string,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'envelopeId' is not null or undefined
        assertParamExists("handleSignWebhook", "envelopeId", envelopeId);
        // verify required parameter 'positionId' is not null or undefined
        assertParamExists("handleSignWebhook", "positionId", positionId);
        const localVarPath = `/sign/webhook`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        if (envelopeId !== undefined) {
          localVarQueryParameter["envelopeId"] = envelopeId;
        }

        if (positionId !== undefined) {
          localVarQueryParameter["positionId"] = positionId;
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * This service is used by Qinetic and need some informations about each signer and the list of \'documentId\' uploaded with the /sign/upload call. The response will contain a \'envelopeId\' that is the sign session identifier that is needed when it\'s requested the signed document
       * @summary Start a sign session on Namirial Sign
       * @param {NamirialStartSessionRequest} namirialStartSessionRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      startSession: async (
        namirialStartSessionRequest: NamirialStartSessionRequest,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'namirialStartSessionRequest' is not null or undefined
        assertParamExists(
          "startSession",
          "namirialStartSessionRequest",
          namirialStartSessionRequest,
        );
        const localVarPath = `/sign/startSession`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          namirialStartSessionRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * This service is used by Qinetic. The response will contain a \'documentId\' that is the identifier necessary for /sign/startSession call
       * @summary Upload a document to Namirial Sign
       * @param {string} positionId This is the Qinetic position identifier
       * @param {string} entityId This is the Qinetic identifier of the document that is used into the checklist under entities[0].entityId
       * @param {string} entityType This is the Qinetic identifier of the file that is used into the checklist under entities[0].entityType
       * @param {string} documentCode This is the Qinetic identifier of the document that is used into the checklist under entities[0].documents[0].documentCode
       * @param {string} storageId This is the Qinetic identifier suggested by Qinetic
       * @param {File} file
       * @param {string} [md5] This is the MD5 of the file that is in upload. Eg. 2942bfabb3d05332b66eb128e0842cff
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      upload: async (
        positionId: string,
        entityId: string,
        entityType: string,
        documentCode: string,
        storageId: string,
        file: File,
        md5?: string,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'positionId' is not null or undefined
        assertParamExists("upload", "positionId", positionId);
        // verify required parameter 'entityId' is not null or undefined
        assertParamExists("upload", "entityId", entityId);
        // verify required parameter 'entityType' is not null or undefined
        assertParamExists("upload", "entityType", entityType);
        // verify required parameter 'documentCode' is not null or undefined
        assertParamExists("upload", "documentCode", documentCode);
        // verify required parameter 'storageId' is not null or undefined
        assertParamExists("upload", "storageId", storageId);
        // verify required parameter 'file' is not null or undefined
        assertParamExists("upload", "file", file);
        const localVarPath = `/sign/upload`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;
        const localVarFormParams = new ((configuration &&
          configuration.formDataCtor) ||
          FormData)();

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        if (positionId !== undefined) {
          localVarQueryParameter["positionId"] = positionId;
        }

        if (entityId !== undefined) {
          localVarQueryParameter["entityId"] = entityId;
        }

        if (entityType !== undefined) {
          localVarQueryParameter["entityType"] = entityType;
        }

        if (documentCode !== undefined) {
          localVarQueryParameter["documentCode"] = documentCode;
        }

        if (storageId !== undefined) {
          localVarQueryParameter["storageId"] = storageId;
        }

        if (md5 !== undefined) {
          localVarQueryParameter["md5"] = md5;
        }

        if (file !== undefined) {
          localVarFormParams.append("file", file as any);
        }

        localVarHeaderParameter["Content-Type"] = "multipart/form-data";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = localVarFormParams;

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    };
  };

/**
 * SignPrivateAPIsForNarmirialsSigningIntegrationApi - functional programming interface
 * @export
 */
export const SignPrivateAPIsForNarmirialsSigningIntegrationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    SignPrivateAPIsForNarmirialsSigningIntegrationApiAxiosParamCreator(
      configuration,
    );
  return {
    /**
     * This service is used by Qinetic when they need to retrieve the signed document, that is an event thrown by orchestrator via XXXXX-(TODO@Elena) call to Qinetic
     * @summary Get the signed document
     * @param {string} envelopeId
     * @param {string} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSignedDocument(
      envelopeId: string,
      documentId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getSignedDocument(
          envelopeId,
          documentId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "SignPrivateAPIsForNarmirialsSigningIntegrationApi.getSignedDocument"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} envelopeId
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async handleSignWebhook(
      envelopeId: string,
      positionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.handleSignWebhook(
          envelopeId,
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "SignPrivateAPIsForNarmirialsSigningIntegrationApi.handleSignWebhook"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * This service is used by Qinetic and need some informations about each signer and the list of \'documentId\' uploaded with the /sign/upload call. The response will contain a \'envelopeId\' that is the sign session identifier that is needed when it\'s requested the signed document
     * @summary Start a sign session on Namirial Sign
     * @param {NamirialStartSessionRequest} namirialStartSessionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async startSession(
      namirialStartSessionRequest: NamirialStartSessionRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<NamirialStartSessionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.startSession(
        namirialStartSessionRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "SignPrivateAPIsForNarmirialsSigningIntegrationApi.startSession"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * This service is used by Qinetic. The response will contain a \'documentId\' that is the identifier necessary for /sign/startSession call
     * @summary Upload a document to Namirial Sign
     * @param {string} positionId This is the Qinetic position identifier
     * @param {string} entityId This is the Qinetic identifier of the document that is used into the checklist under entities[0].entityId
     * @param {string} entityType This is the Qinetic identifier of the file that is used into the checklist under entities[0].entityType
     * @param {string} documentCode This is the Qinetic identifier of the document that is used into the checklist under entities[0].documents[0].documentCode
     * @param {string} storageId This is the Qinetic identifier suggested by Qinetic
     * @param {File} file
     * @param {string} [md5] This is the MD5 of the file that is in upload. Eg. 2942bfabb3d05332b66eb128e0842cff
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upload(
      positionId: string,
      entityId: string,
      entityType: string,
      documentCode: string,
      storageId: string,
      file: File,
      md5?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<NamirialSignUploadResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.upload(
        positionId,
        entityId,
        entityType,
        documentCode,
        storageId,
        file,
        md5,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "SignPrivateAPIsForNarmirialsSigningIntegrationApi.upload"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SignPrivateAPIsForNarmirialsSigningIntegrationApi - factory interface
 * @export
 */
export const SignPrivateAPIsForNarmirialsSigningIntegrationApiFactory =
  function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance,
  ) {
    const localVarFp =
      SignPrivateAPIsForNarmirialsSigningIntegrationApiFp(configuration);
    return {
      /**
       * This service is used by Qinetic when they need to retrieve the signed document, that is an event thrown by orchestrator via XXXXX-(TODO@Elena) call to Qinetic
       * @summary Get the signed document
       * @param {string} envelopeId
       * @param {string} documentId
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      getSignedDocument(
        envelopeId: string,
        documentId: string,
        options?: any,
      ): AxiosPromise<string> {
        return localVarFp
          .getSignedDocument(envelopeId, documentId, options)
          .then((request) => request(axios, basePath));
      },
      /**
       *
       * @param {string} envelopeId
       * @param {string} positionId
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      handleSignWebhook(
        envelopeId: string,
        positionId: string,
        options?: any,
      ): AxiosPromise<string> {
        return localVarFp
          .handleSignWebhook(envelopeId, positionId, options)
          .then((request) => request(axios, basePath));
      },
      /**
       * This service is used by Qinetic and need some informations about each signer and the list of \'documentId\' uploaded with the /sign/upload call. The response will contain a \'envelopeId\' that is the sign session identifier that is needed when it\'s requested the signed document
       * @summary Start a sign session on Namirial Sign
       * @param {NamirialStartSessionRequest} namirialStartSessionRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      startSession(
        namirialStartSessionRequest: NamirialStartSessionRequest,
        options?: any,
      ): AxiosPromise<NamirialStartSessionResponse> {
        return localVarFp
          .startSession(namirialStartSessionRequest, options)
          .then((request) => request(axios, basePath));
      },
      /**
       * This service is used by Qinetic. The response will contain a \'documentId\' that is the identifier necessary for /sign/startSession call
       * @summary Upload a document to Namirial Sign
       * @param {string} positionId This is the Qinetic position identifier
       * @param {string} entityId This is the Qinetic identifier of the document that is used into the checklist under entities[0].entityId
       * @param {string} entityType This is the Qinetic identifier of the file that is used into the checklist under entities[0].entityType
       * @param {string} documentCode This is the Qinetic identifier of the document that is used into the checklist under entities[0].documents[0].documentCode
       * @param {string} storageId This is the Qinetic identifier suggested by Qinetic
       * @param {File} file
       * @param {string} [md5] This is the MD5 of the file that is in upload. Eg. 2942bfabb3d05332b66eb128e0842cff
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      upload(
        positionId: string,
        entityId: string,
        entityType: string,
        documentCode: string,
        storageId: string,
        file: File,
        md5?: string,
        options?: any,
      ): AxiosPromise<NamirialSignUploadResponse> {
        return localVarFp
          .upload(
            positionId,
            entityId,
            entityType,
            documentCode,
            storageId,
            file,
            md5,
            options,
          )
          .then((request) => request(axios, basePath));
      },
    };
  };

/**
 * SignPrivateAPIsForNarmirialsSigningIntegrationApi - object-oriented interface
 * @export
 * @class SignPrivateAPIsForNarmirialsSigningIntegrationApi
 * @extends {BaseAPI}
 */
export class SignPrivateAPIsForNarmirialsSigningIntegrationApi extends BaseAPI {
  /**
   * This service is used by Qinetic when they need to retrieve the signed document, that is an event thrown by orchestrator via XXXXX-(TODO@Elena) call to Qinetic
   * @summary Get the signed document
   * @param {string} envelopeId
   * @param {string} documentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SignPrivateAPIsForNarmirialsSigningIntegrationApi
   */
  public getSignedDocument(
    envelopeId: string,
    documentId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return SignPrivateAPIsForNarmirialsSigningIntegrationApiFp(
      this.configuration,
    )
      .getSignedDocument(envelopeId, documentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} envelopeId
   * @param {string} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SignPrivateAPIsForNarmirialsSigningIntegrationApi
   */
  public handleSignWebhook(
    envelopeId: string,
    positionId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return SignPrivateAPIsForNarmirialsSigningIntegrationApiFp(
      this.configuration,
    )
      .handleSignWebhook(envelopeId, positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * This service is used by Qinetic and need some informations about each signer and the list of \'documentId\' uploaded with the /sign/upload call. The response will contain a \'envelopeId\' that is the sign session identifier that is needed when it\'s requested the signed document
   * @summary Start a sign session on Namirial Sign
   * @param {NamirialStartSessionRequest} namirialStartSessionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SignPrivateAPIsForNarmirialsSigningIntegrationApi
   */
  public startSession(
    namirialStartSessionRequest: NamirialStartSessionRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SignPrivateAPIsForNarmirialsSigningIntegrationApiFp(
      this.configuration,
    )
      .startSession(namirialStartSessionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * This service is used by Qinetic. The response will contain a \'documentId\' that is the identifier necessary for /sign/startSession call
   * @summary Upload a document to Namirial Sign
   * @param {string} positionId This is the Qinetic position identifier
   * @param {string} entityId This is the Qinetic identifier of the document that is used into the checklist under entities[0].entityId
   * @param {string} entityType This is the Qinetic identifier of the file that is used into the checklist under entities[0].entityType
   * @param {string} documentCode This is the Qinetic identifier of the document that is used into the checklist under entities[0].documents[0].documentCode
   * @param {string} storageId This is the Qinetic identifier suggested by Qinetic
   * @param {File} file
   * @param {string} [md5] This is the MD5 of the file that is in upload. Eg. 2942bfabb3d05332b66eb128e0842cff
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SignPrivateAPIsForNarmirialsSigningIntegrationApi
   */
  public upload(
    positionId: string,
    entityId: string,
    entityType: string,
    documentCode: string,
    storageId: string,
    file: File,
    md5?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return SignPrivateAPIsForNarmirialsSigningIntegrationApiFp(
      this.configuration,
    )
      .upload(
        positionId,
        entityId,
        entityType,
        documentCode,
        storageId,
        file,
        md5,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SummaryQineticBeSharpProxyApi - axios parameter creator
 * @export
 */
export const SummaryQineticBeSharpProxyApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {string} positionId
     * @param {string} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadDocument: async (
      positionId: string,
      docId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("downloadDocument", "positionId", positionId);
      // verify required parameter 'docId' is not null or undefined
      assertParamExists("downloadDocument", "docId", docId);
      const localVarPath = `/summary/document/{positionId}/document/{docId}`
        .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)))
        .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCheckList: async (
      positionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getCheckList", "positionId", positionId);
      const localVarPath = `/summary/document/{positionId}/checklist`.replace(
        `{${"positionId"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} positionId
     * @param {string} contractType
     * @param {string} taxNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContract: async (
      positionId: string,
      contractType: string,
      taxNumber: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getContract", "positionId", positionId);
      // verify required parameter 'contractType' is not null or undefined
      assertParamExists("getContract", "contractType", contractType);
      // verify required parameter 'taxNumber' is not null or undefined
      assertParamExists("getContract", "taxNumber", taxNumber);
      const localVarPath = `/summary/document/{positionId}/type/{contractType}`
        .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)))
        .replace(
          `{${"contractType"}}`,
          encodeURIComponent(String(contractType)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      if (taxNumber !== undefined) {
        localVarQueryParameter["taxNumber"] = taxNumber;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentAmortization: async (
      positionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getDocumentAmortization", "positionId", positionId);
      const localVarPath =
        `/summary/document/{positionId}/amortization`.replace(
          `{${"positionId"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSummary: async (
      positionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getSummary", "positionId", positionId);
      const localVarPath = `/summary/{positionId}`.replace(
        `{${"positionId"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SummaryQineticBeSharpProxyApi - functional programming interface
 * @export
 */
export const SummaryQineticBeSharpProxyApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    SummaryQineticBeSharpProxyApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} positionId
     * @param {string} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async downloadDocument(
      positionId: string,
      docId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.downloadDocument(
          positionId,
          docId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SummaryQineticBeSharpProxyApi.downloadDocument"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCheckList(
      positionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DocumentChecklistItemResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckList(
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SummaryQineticBeSharpProxyApi.getCheckList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} positionId
     * @param {string} contractType
     * @param {string} taxNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getContract(
      positionId: string,
      contractType: string,
      taxNumber: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getContract(
        positionId,
        contractType,
        taxNumber,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SummaryQineticBeSharpProxyApi.getContract"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDocumentAmortization(
      positionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<QAmortizationSchedule>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getDocumentAmortization(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "SummaryQineticBeSharpProxyApi.getDocumentAmortization"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSummary(
      positionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PositionSummaryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSummary(
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SummaryQineticBeSharpProxyApi.getSummary"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SummaryQineticBeSharpProxyApi - factory interface
 * @export
 */
export const SummaryQineticBeSharpProxyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SummaryQineticBeSharpProxyApiFp(configuration);
  return {
    /**
     *
     * @param {string} positionId
     * @param {string} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadDocument(
      positionId: string,
      docId: string,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .downloadDocument(positionId, docId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCheckList(
      positionId: string,
      options?: any,
    ): AxiosPromise<Array<DocumentChecklistItemResponse>> {
      return localVarFp
        .getCheckList(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} positionId
     * @param {string} contractType
     * @param {string} taxNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContract(
      positionId: string,
      contractType: string,
      taxNumber: string,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .getContract(positionId, contractType, taxNumber, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentAmortization(
      positionId: string,
      options?: any,
    ): AxiosPromise<QAmortizationSchedule> {
      return localVarFp
        .getDocumentAmortization(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSummary(
      positionId: string,
      options?: any,
    ): AxiosPromise<PositionSummaryResponse> {
      return localVarFp
        .getSummary(positionId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SummaryQineticBeSharpProxyApi - object-oriented interface
 * @export
 * @class SummaryQineticBeSharpProxyApi
 * @extends {BaseAPI}
 */
export class SummaryQineticBeSharpProxyApi extends BaseAPI {
  /**
   *
   * @param {string} positionId
   * @param {string} docId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SummaryQineticBeSharpProxyApi
   */
  public downloadDocument(
    positionId: string,
    docId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return SummaryQineticBeSharpProxyApiFp(this.configuration)
      .downloadDocument(positionId, docId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SummaryQineticBeSharpProxyApi
   */
  public getCheckList(positionId: string, options?: RawAxiosRequestConfig) {
    return SummaryQineticBeSharpProxyApiFp(this.configuration)
      .getCheckList(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} positionId
   * @param {string} contractType
   * @param {string} taxNumber
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SummaryQineticBeSharpProxyApi
   */
  public getContract(
    positionId: string,
    contractType: string,
    taxNumber: string,
    options?: RawAxiosRequestConfig,
  ) {
    return SummaryQineticBeSharpProxyApiFp(this.configuration)
      .getContract(positionId, contractType, taxNumber, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SummaryQineticBeSharpProxyApi
   */
  public getDocumentAmortization(
    positionId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return SummaryQineticBeSharpProxyApiFp(this.configuration)
      .getDocumentAmortization(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SummaryQineticBeSharpProxyApi
   */
  public getSummary(positionId: string, options?: RawAxiosRequestConfig) {
    return SummaryQineticBeSharpProxyApiFp(this.configuration)
      .getSummary(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TokenPrivateAPIsForExelabTokenVerificationApi - axios parameter creator
 * @export
 */
export const TokenPrivateAPIsForExelabTokenVerificationApiAxiosParamCreator =
  function (configuration?: Configuration) {
    return {
      /**
       * This service is used by Exelab to verify the validity of the jwt token
       * @summary Verify JWT token
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      verify: async (
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        const localVarPath = `/token/verify`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    };
  };

/**
 * TokenPrivateAPIsForExelabTokenVerificationApi - functional programming interface
 * @export
 */
export const TokenPrivateAPIsForExelabTokenVerificationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    TokenPrivateAPIsForExelabTokenVerificationApiAxiosParamCreator(
      configuration,
    );
  return {
    /**
     * This service is used by Exelab to verify the validity of the jwt token
     * @summary Verify JWT token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verify(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verify(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "TokenPrivateAPIsForExelabTokenVerificationApi.verify"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TokenPrivateAPIsForExelabTokenVerificationApi - factory interface
 * @export
 */
export const TokenPrivateAPIsForExelabTokenVerificationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp =
    TokenPrivateAPIsForExelabTokenVerificationApiFp(configuration);
  return {
    /**
     * This service is used by Exelab to verify the validity of the jwt token
     * @summary Verify JWT token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verify(options?: any): AxiosPromise<void> {
      return localVarFp
        .verify(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TokenPrivateAPIsForExelabTokenVerificationApi - object-oriented interface
 * @export
 * @class TokenPrivateAPIsForExelabTokenVerificationApi
 * @extends {BaseAPI}
 */
export class TokenPrivateAPIsForExelabTokenVerificationApi extends BaseAPI {
  /**
   * This service is used by Exelab to verify the validity of the jwt token
   * @summary Verify JWT token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TokenPrivateAPIsForExelabTokenVerificationApi
   */
  public verify(options?: RawAxiosRequestConfig) {
    return TokenPrivateAPIsForExelabTokenVerificationApiFp(this.configuration)
      .verify(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * VersionApi - axios parameter creator
 * @export
 */
export const VersionApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    version: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/version`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * VersionApi - functional programming interface
 * @export
 */
export const VersionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = VersionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async version(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.version(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["VersionApi.version"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * VersionApi - factory interface
 * @export
 */
export const VersionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = VersionApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    version(options?: any): AxiosPromise<string> {
      return localVarFp
        .version(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * VersionApi - object-oriented interface
 * @export
 * @class VersionApi
 * @extends {BaseAPI}
 */
export class VersionApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VersionApi
   */
  public version(options?: RawAxiosRequestConfig) {
    return VersionApiFp(this.configuration)
      .version(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * WebsocketRoutesApi - axios parameter creator
 * @export
 */
export const WebsocketRoutesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {string} connectionId
     * @param {string} [userEmail]
     * @param {string} [workflowId]
     * @param {string} [creationDate]
     * @param {string} [xAmenApigatewayApiId]
     * @param {string} [xForwardedFor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    connect: async (
      connectionId: string,
      userEmail?: string,
      workflowId?: string,
      creationDate?: string,
      xAmenApigatewayApiId?: string,
      xForwardedFor?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists("connect", "connectionId", connectionId);
      const localVarPath = `/websocket/connect`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (connectionId != null) {
        localVarHeaderParameter["connectionId"] = String(connectionId);
      }

      if (userEmail != null) {
        localVarHeaderParameter["userEmail"] = String(userEmail);
      }

      if (workflowId != null) {
        localVarHeaderParameter["workflowId"] = String(workflowId);
      }

      if (creationDate != null) {
        localVarHeaderParameter["creationDate"] = String(creationDate);
      }

      if (xAmenApigatewayApiId != null) {
        localVarHeaderParameter["x-amen-apigateway-api-id"] =
          String(xAmenApigatewayApiId);
      }

      if (xForwardedFor != null) {
        localVarHeaderParameter["X-Forwarded-For"] = String(xForwardedFor);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} connectionId
     * @param {string} body
     * @param {string} [userEmail]
     * @param {string} [workflowId]
     * @param {string} [creationDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    defaultMessage: async (
      connectionId: string,
      body: string,
      userEmail?: string,
      workflowId?: string,
      creationDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists("defaultMessage", "connectionId", connectionId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists("defaultMessage", "body", body);
      const localVarPath = `/websocket/default`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (connectionId != null) {
        localVarHeaderParameter["connectionId"] = String(connectionId);
      }

      if (userEmail != null) {
        localVarHeaderParameter["userEmail"] = String(userEmail);
      }

      if (workflowId != null) {
        localVarHeaderParameter["workflowId"] = String(workflowId);
      }

      if (creationDate != null) {
        localVarHeaderParameter["creationDate"] = String(creationDate);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} connectionId
     * @param {string} [workflowId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnect: async (
      connectionId: string,
      workflowId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists("disconnect", "connectionId", connectionId);
      const localVarPath = `/websocket/disconnect`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "api-key",
        configuration,
      );

      // authentication cookieAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (connectionId != null) {
        localVarHeaderParameter["connectionId"] = String(connectionId);
      }

      if (workflowId != null) {
        localVarHeaderParameter["workflowId"] = String(workflowId);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * WebsocketRoutesApi - functional programming interface
 * @export
 */
export const WebsocketRoutesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    WebsocketRoutesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} connectionId
     * @param {string} [userEmail]
     * @param {string} [workflowId]
     * @param {string} [creationDate]
     * @param {string} [xAmenApigatewayApiId]
     * @param {string} [xForwardedFor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async connect(
      connectionId: string,
      userEmail?: string,
      workflowId?: string,
      creationDate?: string,
      xAmenApigatewayApiId?: string,
      xForwardedFor?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.connect(
        connectionId,
        userEmail,
        workflowId,
        creationDate,
        xAmenApigatewayApiId,
        xForwardedFor,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WebsocketRoutesApi.connect"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} connectionId
     * @param {string} body
     * @param {string} [userEmail]
     * @param {string} [workflowId]
     * @param {string} [creationDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async defaultMessage(
      connectionId: string,
      body: string,
      userEmail?: string,
      workflowId?: string,
      creationDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SocketMessageDtoV2>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.defaultMessage(
        connectionId,
        body,
        userEmail,
        workflowId,
        creationDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WebsocketRoutesApi.defaultMessage"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} connectionId
     * @param {string} [workflowId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async disconnect(
      connectionId: string,
      workflowId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.disconnect(
        connectionId,
        workflowId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WebsocketRoutesApi.disconnect"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * WebsocketRoutesApi - factory interface
 * @export
 */
export const WebsocketRoutesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = WebsocketRoutesApiFp(configuration);
  return {
    /**
     *
     * @param {string} connectionId
     * @param {string} [userEmail]
     * @param {string} [workflowId]
     * @param {string} [creationDate]
     * @param {string} [xAmenApigatewayApiId]
     * @param {string} [xForwardedFor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    connect(
      connectionId: string,
      userEmail?: string,
      workflowId?: string,
      creationDate?: string,
      xAmenApigatewayApiId?: string,
      xForwardedFor?: string,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .connect(
          connectionId,
          userEmail,
          workflowId,
          creationDate,
          xAmenApigatewayApiId,
          xForwardedFor,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} connectionId
     * @param {string} body
     * @param {string} [userEmail]
     * @param {string} [workflowId]
     * @param {string} [creationDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    defaultMessage(
      connectionId: string,
      body: string,
      userEmail?: string,
      workflowId?: string,
      creationDate?: string,
      options?: any,
    ): AxiosPromise<SocketMessageDtoV2> {
      return localVarFp
        .defaultMessage(
          connectionId,
          body,
          userEmail,
          workflowId,
          creationDate,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} connectionId
     * @param {string} [workflowId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnect(
      connectionId: string,
      workflowId?: string,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .disconnect(connectionId, workflowId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * WebsocketRoutesApi - object-oriented interface
 * @export
 * @class WebsocketRoutesApi
 * @extends {BaseAPI}
 */
export class WebsocketRoutesApi extends BaseAPI {
  /**
   *
   * @param {string} connectionId
   * @param {string} [userEmail]
   * @param {string} [workflowId]
   * @param {string} [creationDate]
   * @param {string} [xAmenApigatewayApiId]
   * @param {string} [xForwardedFor]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebsocketRoutesApi
   */
  public connect(
    connectionId: string,
    userEmail?: string,
    workflowId?: string,
    creationDate?: string,
    xAmenApigatewayApiId?: string,
    xForwardedFor?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return WebsocketRoutesApiFp(this.configuration)
      .connect(
        connectionId,
        userEmail,
        workflowId,
        creationDate,
        xAmenApigatewayApiId,
        xForwardedFor,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} connectionId
   * @param {string} body
   * @param {string} [userEmail]
   * @param {string} [workflowId]
   * @param {string} [creationDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebsocketRoutesApi
   */
  public defaultMessage(
    connectionId: string,
    body: string,
    userEmail?: string,
    workflowId?: string,
    creationDate?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return WebsocketRoutesApiFp(this.configuration)
      .defaultMessage(
        connectionId,
        body,
        userEmail,
        workflowId,
        creationDate,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} connectionId
   * @param {string} [workflowId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebsocketRoutesApi
   */
  public disconnect(
    connectionId: string,
    workflowId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return WebsocketRoutesApiFp(this.configuration)
      .disconnect(connectionId, workflowId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * WorkflowPrivateAPIsToManageTemporalWorkflowApi - axios parameter creator
 * @export
 */
export const WorkflowPrivateAPIsToManageTemporalWorkflowApiAxiosParamCreator =
  function (configuration?: Configuration) {
    return {
      /**
       *
       * @param {string} workflowId
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      getWorkflowInfo: async (
        workflowId: string,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'workflowId' is not null or undefined
        assertParamExists("getWorkflowInfo", "workflowId", workflowId);
        const localVarPath = `/workflow/info/{workflowId}`.replace(
          `{${"workflowId"}}`,
          encodeURIComponent(String(workflowId)),
        );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       *
       * @param {TerminateNonDeterministicWfRequest} terminateNonDeterministicWfRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      terminateWorkflowWithNonDeterministic: async (
        terminateNonDeterministicWfRequest: TerminateNonDeterministicWfRequest,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'terminateNonDeterministicWfRequest' is not null or undefined
        assertParamExists(
          "terminateWorkflowWithNonDeterministic",
          "terminateNonDeterministicWfRequest",
          terminateNonDeterministicWfRequest,
        );
        const localVarPath = `/workflow/terminate-non-deterministic`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKey required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "api-key",
          configuration,
        );

        // authentication cookieAuth required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          terminateNonDeterministicWfRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    };
  };

/**
 * WorkflowPrivateAPIsToManageTemporalWorkflowApi - functional programming interface
 * @export
 */
export const WorkflowPrivateAPIsToManageTemporalWorkflowApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    WorkflowPrivateAPIsToManageTemporalWorkflowApiAxiosParamCreator(
      configuration,
    );
  return {
    /**
     *
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWorkflowInfo(
      workflowId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<WorkflowDataResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowInfo(
        workflowId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "WorkflowPrivateAPIsToManageTemporalWorkflowApi.getWorkflowInfo"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {TerminateNonDeterministicWfRequest} terminateNonDeterministicWfRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async terminateWorkflowWithNonDeterministic(
      terminateNonDeterministicWfRequest: TerminateNonDeterministicWfRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.terminateWorkflowWithNonDeterministic(
          terminateNonDeterministicWfRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "WorkflowPrivateAPIsToManageTemporalWorkflowApi.terminateWorkflowWithNonDeterministic"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * WorkflowPrivateAPIsToManageTemporalWorkflowApi - factory interface
 * @export
 */
export const WorkflowPrivateAPIsToManageTemporalWorkflowApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp =
    WorkflowPrivateAPIsToManageTemporalWorkflowApiFp(configuration);
  return {
    /**
     *
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWorkflowInfo(
      workflowId: string,
      options?: any,
    ): AxiosPromise<WorkflowDataResponse> {
      return localVarFp
        .getWorkflowInfo(workflowId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {TerminateNonDeterministicWfRequest} terminateNonDeterministicWfRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    terminateWorkflowWithNonDeterministic(
      terminateNonDeterministicWfRequest: TerminateNonDeterministicWfRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .terminateWorkflowWithNonDeterministic(
          terminateNonDeterministicWfRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * WorkflowPrivateAPIsToManageTemporalWorkflowApi - object-oriented interface
 * @export
 * @class WorkflowPrivateAPIsToManageTemporalWorkflowApi
 * @extends {BaseAPI}
 */
export class WorkflowPrivateAPIsToManageTemporalWorkflowApi extends BaseAPI {
  /**
   *
   * @param {string} workflowId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WorkflowPrivateAPIsToManageTemporalWorkflowApi
   */
  public getWorkflowInfo(workflowId: string, options?: RawAxiosRequestConfig) {
    return WorkflowPrivateAPIsToManageTemporalWorkflowApiFp(this.configuration)
      .getWorkflowInfo(workflowId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {TerminateNonDeterministicWfRequest} terminateNonDeterministicWfRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WorkflowPrivateAPIsToManageTemporalWorkflowApi
   */
  public terminateWorkflowWithNonDeterministic(
    terminateNonDeterministicWfRequest: TerminateNonDeterministicWfRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkflowPrivateAPIsToManageTemporalWorkflowApiFp(this.configuration)
      .terminateWorkflowWithNonDeterministic(
        terminateNonDeterministicWfRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
